import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** Input type for dynamic zone programmeQuestions of ProgrammeType */
  ProgrammeTypeProgrammeQuestionsDynamicZoneInput: any;
  /** Input type for dynamic zone questions of Section */
  SectionQuestionsDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
};

export type Query = {
   __typename?: 'Query';
  accountChange?: Maybe<AccountChange>;
  accountChanges?: Maybe<Array<Maybe<AccountChange>>>;
  accountChangesConnection?: Maybe<AccountChangeConnection>;
  appointment?: Maybe<Appointments>;
  appointments?: Maybe<Array<Maybe<Appointments>>>;
  appointmentsConnection?: Maybe<AppointmentsConnection>;
  article?: Maybe<Article>;
  articles?: Maybe<Array<Maybe<Article>>>;
  articlesConnection?: Maybe<ArticleConnection>;
  auditTrail?: Maybe<AuditTrail>;
  auditTrails?: Maybe<Array<Maybe<AuditTrail>>>;
  auditTrailsConnection?: Maybe<AuditTrailConnection>;
  booking?: Maybe<Booking>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  bookingsConnection?: Maybe<BookingConnection>;
  coachSession?: Maybe<CoachSession>;
  coachSessions?: Maybe<Array<Maybe<CoachSession>>>;
  coachSessionsConnection?: Maybe<CoachSessionConnection>;
  coachSubmittedReport?: Maybe<CoachSubmittedReports>;
  coachSubmittedReports?: Maybe<Array<Maybe<CoachSubmittedReports>>>;
  coachSubmittedReportsConnection?: Maybe<CoachSubmittedReportsConnection>;
  coach?: Maybe<Coach>;
  coaches?: Maybe<Array<Maybe<Coach>>>;
  coachesConnection?: Maybe<CoachConnection>;
  company?: Maybe<Company>;
  companies?: Maybe<Array<Maybe<Company>>>;
  companiesConnection?: Maybe<CompanyConnection>;
  competencyUrl?: Maybe<CompetencyUrl>;
  competencyUrls?: Maybe<Array<Maybe<CompetencyUrl>>>;
  competencyUrlsConnection?: Maybe<CompetencyUrlConnection>;
  division?: Maybe<Division>;
  divisions?: Maybe<Array<Maybe<Division>>>;
  divisionsConnection?: Maybe<DivisionConnection>;
  emailLog?: Maybe<EmailLog>;
  emailLogs?: Maybe<Array<Maybe<EmailLog>>>;
  emailLogsConnection?: Maybe<EmailLogConnection>;
  emailTemplate?: Maybe<EmailTemplate>;
  emailTemplates?: Maybe<Array<Maybe<EmailTemplate>>>;
  emailTemplatesConnection?: Maybe<EmailTemplateConnection>;
  event?: Maybe<Event>;
  events?: Maybe<Array<Maybe<Event>>>;
  eventsConnection?: Maybe<EventConnection>;
  feedfowardUrl?: Maybe<FeedfowardUrl>;
  feedfowardUrls?: Maybe<Array<Maybe<FeedfowardUrl>>>;
  feedfowardUrlsConnection?: Maybe<FeedfowardUrlConnection>;
  forwardedCard?: Maybe<ForwardedCard>;
  forwardedCards?: Maybe<Array<Maybe<ForwardedCard>>>;
  forwardedCardsConnection?: Maybe<ForwardedCardConnection>;
  invite?: Maybe<Invite>;
  invites?: Maybe<Array<Maybe<Invite>>>;
  invitesConnection?: Maybe<InviteConnection>;
  language?: Maybe<Language>;
  languages?: Maybe<Array<Maybe<Language>>>;
  languagesConnection?: Maybe<LanguageConnection>;
  logo?: Maybe<Logo>;
  logos?: Maybe<Array<Maybe<Logo>>>;
  logosConnection?: Maybe<LogoConnection>;
  modal?: Maybe<Modal>;
  modals?: Maybe<Array<Maybe<Modal>>>;
  modalsConnection?: Maybe<ModalConnection>;
  module?: Maybe<Module>;
  modules?: Maybe<Array<Maybe<Module>>>;
  modulesConnection?: Maybe<ModuleConnection>;
  note?: Maybe<Notes>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  notesConnection?: Maybe<NotesConnection>;
  notification?: Maybe<Notification>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsConnection?: Maybe<NotificationConnection>;
  participant?: Maybe<Participants>;
  participants?: Maybe<Array<Maybe<Participants>>>;
  participantsConnection?: Maybe<ParticipantsConnection>;
  postCardImage?: Maybe<PostCardImage>;
  postCardImages?: Maybe<Array<Maybe<PostCardImage>>>;
  postCardImagesConnection?: Maybe<PostCardImageConnection>;
  postCardSentence?: Maybe<PostCardSentence>;
  postCardSentences?: Maybe<Array<Maybe<PostCardSentence>>>;
  postCardSentencesConnection?: Maybe<PostCardSentenceConnection>;
  postCard?: Maybe<PostCard>;
  postCards?: Maybe<Array<Maybe<PostCard>>>;
  postCardsConnection?: Maybe<PostCardConnection>;
  programmeReport?: Maybe<ProgrammeReport>;
  programmeReports?: Maybe<Array<Maybe<ProgrammeReport>>>;
  programmeReportsConnection?: Maybe<ProgrammeReportConnection>;
  programmeSubmission?: Maybe<ProgrammeSubmission>;
  programmeSubmissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  programmeSubmissionsConnection?: Maybe<ProgrammeSubmissionConnection>;
  programmeType?: Maybe<ProgrammeType>;
  programmeTypes?: Maybe<Array<Maybe<ProgrammeType>>>;
  programmeTypesConnection?: Maybe<ProgrammeTypeConnection>;
  programme?: Maybe<Programmes>;
  programmes?: Maybe<Array<Maybe<Programmes>>>;
  programmesConnection?: Maybe<ProgrammesConnection>;
  region?: Maybe<Region>;
  regions?: Maybe<Array<Maybe<Region>>>;
  regionsConnection?: Maybe<RegionConnection>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
  reportsConnection?: Maybe<ReportConnection>;
  respondentsAnswer?: Maybe<RespondentsAnswers>;
  respondentsAnswers?: Maybe<Array<Maybe<RespondentsAnswers>>>;
  respondentsAnswersConnection?: Maybe<RespondentsAnswersConnection>;
  section?: Maybe<Section>;
  sections?: Maybe<Array<Maybe<Section>>>;
  sectionsConnection?: Maybe<SectionConnection>;
  subModuleSubmission?: Maybe<SubModuleSubmission>;
  subModuleSubmissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
  subModuleSubmissionsConnection?: Maybe<SubModuleSubmissionConnection>;
  subModule?: Maybe<SubModule>;
  subModules?: Maybe<Array<Maybe<SubModule>>>;
  subModulesConnection?: Maybe<SubModuleConnection>;
  submission?: Maybe<Submission>;
  submissions?: Maybe<Array<Maybe<Submission>>>;
  submissionsConnection?: Maybe<SubmissionConnection>;
  submoduleReport?: Maybe<SubmoduleReport>;
  submoduleReports?: Maybe<Array<Maybe<SubmoduleReport>>>;
  submoduleReportsConnection?: Maybe<SubmoduleReportConnection>;
  surveyReport?: Maybe<SurveyReports>;
  surveyReports?: Maybe<Array<Maybe<SurveyReports>>>;
  surveyReportsConnection?: Maybe<SurveyReportsConnection>;
  translation?: Maybe<Translations>;
  typeFormCollection?: Maybe<TypeFormCollection>;
  typeFormCollections?: Maybe<Array<Maybe<TypeFormCollection>>>;
  typeFormCollectionsConnection?: Maybe<TypeFormCollectionConnection>;
  uploadedReport?: Maybe<UploadedReports>;
  uploadedReports?: Maybe<Array<Maybe<UploadedReports>>>;
  uploadedReportsConnection?: Maybe<UploadedReportsConnection>;
  userUploadedDocument?: Maybe<UserUploadedDocument>;
  userUploadedDocuments?: Maybe<Array<Maybe<UserUploadedDocument>>>;
  userUploadedDocumentsConnection?: Maybe<UserUploadedDocumentConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  getMyAppointments: Array<Appointments>;
  getAllBookings?: Maybe<Array<EBooking>>;
  getMyBookings?: Maybe<Array<EBooking>>;
  getFirstTwelveArticles?: Maybe<Array<Maybe<Article>>>;
  getAllEventTypes: Array<EventType>;
  getForwaredCards?: Maybe<Array<Maybe<ForwardedCard>>>;
  getFirstFourNotes?: Maybe<Array<Maybe<Notes>>>;
  getPostCards?: Maybe<Array<Maybe<PostCard>>>;
  getProgammeReportsGrouped?: Maybe<Array<Maybe<ReportsGrouped>>>;
  getMyProgrammeSubmissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  checkResponsesFromTypeFormProgramme?: Maybe<EmailsSent>;
  getSectionReport: Report;
  getAllsectionReport?: Maybe<Array<Maybe<Report>>>;
  getReportsGrouped?: Maybe<Array<Maybe<ReportsGrouped>>>;
  getSubmissionReportGrouped?: Maybe<Array<Maybe<ReportsSubmissionGrouped>>>;
  getMySubModuleSubmissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
  checkResponsesFromTypeForm?: Maybe<Emails>;
  getMySubModuleSubmissionsReports?: Maybe<Array<Maybe<SubModuleSubmissionReport>>>;
  generateMySubModuleSubmissionResponses?: Maybe<Array<Maybe<SubModuleSubmissionReport>>>;
  generateMyMiniSectionSubmissionResponse?: Maybe<Array<Maybe<SubModuleSubmissionReport>>>;
  getNewTypeformFeedResponses?: Maybe<CheckConfirmed>;
  getTypeformCompetencyResponses?: Maybe<CheckConfirmed>;
  getOrderedSubmissions?: Maybe<Array<Maybe<OrderedSubmissions>>>;
  getMySubmissions?: Maybe<Array<Maybe<Submission>>>;
  me?: Maybe<UsersPermissionsMe>;
  self?: Maybe<UsersPermissionsUser>;
};


export type QueryAccountChangeArgs = {
  id: Scalars['ID'];
};


export type QueryAccountChangesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAccountChangesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAppointmentArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAppointmentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryArticleArgs = {
  id: Scalars['ID'];
};


export type QueryArticlesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryArticlesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAuditTrailArgs = {
  id: Scalars['ID'];
};


export type QueryAuditTrailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAuditTrailsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBookingArgs = {
  id: Scalars['ID'];
};


export type QueryBookingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBookingsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCoachSessionArgs = {
  id: Scalars['ID'];
};


export type QueryCoachSessionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCoachSessionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCoachSubmittedReportArgs = {
  id: Scalars['ID'];
};


export type QueryCoachSubmittedReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCoachSubmittedReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCoachArgs = {
  id: Scalars['ID'];
};


export type QueryCoachesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCoachesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCompaniesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCompetencyUrlArgs = {
  id: Scalars['ID'];
};


export type QueryCompetencyUrlsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCompetencyUrlsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDivisionArgs = {
  id: Scalars['ID'];
};


export type QueryDivisionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDivisionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEmailLogArgs = {
  id: Scalars['ID'];
};


export type QueryEmailLogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEmailLogsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryEmailTemplatesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEmailTemplatesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEventArgs = {
  id: Scalars['ID'];
};


export type QueryEventsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEventsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFeedfowardUrlArgs = {
  id: Scalars['ID'];
};


export type QueryFeedfowardUrlsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFeedfowardUrlsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryForwardedCardArgs = {
  id: Scalars['ID'];
};


export type QueryForwardedCardsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryForwardedCardsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryInviteArgs = {
  id: Scalars['ID'];
};


export type QueryInvitesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryInvitesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLanguageArgs = {
  id: Scalars['ID'];
};


export type QueryLanguagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLanguagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLogoArgs = {
  id: Scalars['ID'];
};


export type QueryLogosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLogosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryModalArgs = {
  id: Scalars['ID'];
};


export type QueryModalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryModalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryModuleArgs = {
  id: Scalars['ID'];
};


export type QueryModulesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryModulesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNoteArgs = {
  id: Scalars['ID'];
};


export type QueryNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotificationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryParticipantArgs = {
  id: Scalars['ID'];
};


export type QueryParticipantsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryParticipantsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostCardImageArgs = {
  id: Scalars['ID'];
};


export type QueryPostCardImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostCardImagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostCardSentenceArgs = {
  id: Scalars['ID'];
};


export type QueryPostCardSentencesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostCardSentencesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostCardArgs = {
  id: Scalars['ID'];
};


export type QueryPostCardsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostCardsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeReportArgs = {
  id: Scalars['ID'];
};


export type QueryProgrammeReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeSubmissionArgs = {
  id: Scalars['ID'];
};


export type QueryProgrammeSubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeSubmissionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeTypeArgs = {
  id: Scalars['ID'];
};


export type QueryProgrammeTypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeTypesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammeArgs = {
  id: Scalars['ID'];
};


export type QueryProgrammesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProgrammesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRegionArgs = {
  id: Scalars['ID'];
};


export type QueryRegionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRegionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRespondentsAnswerArgs = {
  id: Scalars['ID'];
};


export type QueryRespondentsAnswersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRespondentsAnswersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySectionArgs = {
  id: Scalars['ID'];
};


export type QuerySectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySectionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubModuleSubmissionArgs = {
  id: Scalars['ID'];
};


export type QuerySubModuleSubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubModuleSubmissionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubModuleArgs = {
  id: Scalars['ID'];
};


export type QuerySubModulesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubModulesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubmissionArgs = {
  id: Scalars['ID'];
};


export type QuerySubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubmissionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubmoduleReportArgs = {
  id: Scalars['ID'];
};


export type QuerySubmoduleReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubmoduleReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySurveyReportArgs = {
  id: Scalars['ID'];
};


export type QuerySurveyReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySurveyReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTypeFormCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryTypeFormCollectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTypeFormCollectionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUploadedReportArgs = {
  id: Scalars['ID'];
};


export type QueryUploadedReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUploadedReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserUploadedDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryUserUploadedDocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserUploadedDocumentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetMyAppointmentsArgs = {
  appointmentScheduleId: Scalars['ID'];
};


export type QueryCheckResponsesFromTypeFormProgrammeArgs = {
  id: Scalars['ID'];
  sectionid?: Maybe<Scalars['Int']>;
};


export type QueryGetSectionReportArgs = {
  id: Scalars['ID'];
};


export type QueryGetAllsectionReportArgs = {
  id: Scalars['ID'];
};


export type QueryCheckResponsesFromTypeFormArgs = {
  id: Scalars['ID'];
  sectionid?: Maybe<Scalars['Int']>;
};


export type QueryGetOrderedSubmissionsArgs = {
  programme: Scalars['ID'];
};

export type AccountChange = {
   __typename?: 'AccountChange';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
  oldDivision?: Maybe<Division>;
  oldRegion?: Maybe<Region>;
  newDivision?: Maybe<Division>;
  newRegion?: Maybe<Region>;
  accept?: Maybe<Scalars['Boolean']>;
  userUpdated?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};


export type UsersPermissionsUser = {
   __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<UploadFile>;
  language?: Maybe<Language>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  modulesRead?: Maybe<Scalars['JSON']>;
  homePromptsRead?: Maybe<Scalars['Boolean']>;
  programmePromptsRead?: Maybe<Scalars['Boolean']>;
  modulePromptsRead?: Maybe<Scalars['Boolean']>;
  bookmarks?: Maybe<Scalars['JSON']>;
  report?: Maybe<UploadFile>;
  company?: Maybe<Company>;
  articlesViewed?: Maybe<Scalars['JSON']>;
  postCard?: Maybe<PostCard>;
  timezone?: Maybe<ComponentOptionTimezone>;
  certificate?: Maybe<UploadFile>;
  loginAttempts?: Maybe<Scalars['Int']>;
  feedForwardUrl?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  region?: Maybe<Region>;
  loginWithSSO?: Maybe<Scalars['Boolean']>;
  programmeEvalutionEmailSent?: Maybe<Scalars['Boolean']>;
  updatedDetails?: Maybe<Scalars['Boolean']>;
  onboarding?: Maybe<Scalars['Boolean']>;
  triggerReport?: Maybe<Scalars['Boolean']>;
  clientId?: Maybe<Scalars['Long']>;
  current_survey?: Maybe<Scalars['JSON']>;
  coach?: Maybe<Coach>;
  three_60_form_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  submissions?: Maybe<Array<Maybe<Submission>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  programme_submissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  sub_module_submissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
  programmes?: Maybe<Array<Maybe<Programmes>>>;
  coach_submitted_reports?: Maybe<Array<Maybe<CoachSubmittedReports>>>;
  account_changes?: Maybe<Array<Maybe<AccountChange>>>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  user_uploaded_documents?: Maybe<Array<Maybe<UserUploadedDocument>>>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  respondents_answers?: Maybe<Array<Maybe<RespondentsAnswers>>>;
  submodule_reports?: Maybe<Array<Maybe<SubmoduleReport>>>;
};


export type UsersPermissionsUserSubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNotificationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserProgramme_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserSub_Module_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserProgrammesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserCoach_Submitted_ReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserAccount_ChangesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserUser_Uploaded_DocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserBookingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserRespondents_AnswersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserSubmodule_ReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRole = {
   __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  companies?: Maybe<Array<Maybe<Company>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type AdminUser = {
   __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};


export type UsersPermissionsPermission = {
   __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type Company = {
   __typename?: 'Company';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  certificateTemplate?: Maybe<UploadFile>;
  welcomeScreen?: Maybe<ComponentTranslationsWelcomeScreen>;
  languageSelection?: Maybe<ComponentTranslationsLanguageSelection>;
  letsGetStartedScreen?: Maybe<ComponentTranslationsLetsGetStartedScreen>;
  whatToExpect?: Maybe<ComponentTranslationsWhatToExpect>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  programmesTitle?: Maybe<Scalars['String']>;
  programmesSubTitle?: Maybe<Scalars['String']>;
  aboutUs?: Maybe<ComponentTranslationsAboutUs>;
  usersConfirmDetails?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  modules?: Maybe<Array<Maybe<Module>>>;
  programmes?: Maybe<Array<Maybe<Programmes>>>;
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  articles?: Maybe<Array<Maybe<Article>>>;
  divisions?: Maybe<Array<Maybe<Division>>>;
  regions?: Maybe<Array<Maybe<Region>>>;
  languages?: Maybe<Array<Maybe<Language>>>;
  email_logs?: Maybe<Array<Maybe<EmailLog>>>;
};


export type CompanyUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyModulesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyProgrammesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyArticlesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyDivisionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyRegionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyLanguagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CompanyEmail_LogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFile = {
   __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Morph = ConfirmAppointmentResponse | EBooking | EventLocation | EventType | ProgrammeSubmissionResponse | EmailsSent | EmailSentProgramme | ReportDetail | SectionReport | ProgrammeTypeReport | ReportsGrouped | ReportsSubmissionGrouped | SubModuleSubmissionReport | SubModuleSubmissionResponse | Emails | EmailSent | CheckConfirmed | OrderedSubmissions | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | AccountChange | AccountChangeConnection | AccountChangeAggregator | AccountChangeGroupBy | AccountChangeConnectionId | AccountChangeConnectionCreated_At | AccountChangeConnectionUpdated_At | AccountChangeConnectionUser | AccountChangeConnectionOldDivision | AccountChangeConnectionOldRegion | AccountChangeConnectionNewDivision | AccountChangeConnectionNewRegion | AccountChangeConnectionAccept | AccountChangeConnectionUserUpdated | AccountChangeConnectionCreated_By | AccountChangeConnectionUpdated_By | CreateAccountChangePayload | UpdateAccountChangePayload | DeleteAccountChangePayload | Appointments | AppointmentsConnection | AppointmentsAggregator | AppointmentsGroupBy | AppointmentsConnectionId | AppointmentsConnectionCreated_At | AppointmentsConnectionUpdated_At | AppointmentsConnectionCalendarId | AppointmentsConnectionBusinessId | AppointmentsConnectionAppointmentTitle | AppointmentsConnectionClientName | AppointmentsConnectionClientEmail | AppointmentsConnectionAppointmentScheduleId | AppointmentsConnectionAppointmentUrl | AppointmentsConnectionAppointmentStartDate | AppointmentsConnectionAppointmentEndDate | AppointmentsConnectionCoach_Session | AppointmentsConnectionStatus | AppointmentsConnectionCreated_By | AppointmentsConnectionUpdated_By | CreateAppointmentPayload | UpdateAppointmentPayload | DeleteAppointmentPayload | Article | ArticleConnection | ArticleAggregator | ArticleAggregatorSum | ArticleAggregatorAvg | ArticleAggregatorMin | ArticleAggregatorMax | ArticleGroupBy | ArticleConnectionId | ArticleConnectionCreated_At | ArticleConnectionUpdated_At | ArticleConnectionTitleEnglish | ArticleConnectionContentEnglish | ArticleConnectionImage | ArticleConnectionDatePublished | ArticleConnectionReadTime | ArticleConnectionTitleFrench | ArticleConnectionTitleGerman | ArticleConnectionTitleSpanish | ArticleConnectionTitleMandarin | ArticleConnectionContentFrench | ArticleConnectionContentGerman | ArticleConnectionContentSpanish | ArticleConnectionContentMandarin | ArticleConnectionLink | ArticleConnectionPosition | ArticleConnectionCreated_By | ArticleConnectionUpdated_By | CreateArticlePayload | UpdateArticlePayload | DeleteArticlePayload | AuditTrail | AuditTrailConnection | AuditTrailAggregator | AuditTrailGroupBy | AuditTrailConnectionId | AuditTrailConnectionCreated_At | AuditTrailConnectionUpdated_At | AuditTrailConnectionDetails | AuditTrailConnectionAction | AuditTrailConnectionSection | AuditTrailConnectionBy | AuditTrailConnectionCreated_By | AuditTrailConnectionUpdated_By | CreateAuditTrailPayload | UpdateAuditTrailPayload | DeleteAuditTrailPayload | Booking | BookingConnection | BookingAggregator | BookingAggregatorSum | BookingAggregatorAvg | BookingAggregatorMin | BookingAggregatorMax | BookingGroupBy | BookingConnectionId | BookingConnectionCreated_At | BookingConnectionUpdated_At | BookingConnectionTitle | BookingConnectionDescription | BookingConnectionDuration | BookingConnectionDate | BookingConnectionUser | BookingConnectionConfirmed | BookingConnectionEventId | BookingConnectionCancelled | BookingConnectionIsUpdated | BookingConnectionEnd | BookingConnectionLocation | BookingConnectionOrganiser | BookingConnectionCreated_By | BookingConnectionUpdated_By | CreateBookingPayload | UpdateBookingPayload | DeleteBookingPayload | CoachSession | CoachSessionConnection | CoachSessionAggregator | CoachSessionGroupBy | CoachSessionConnectionId | CoachSessionConnectionCreated_At | CoachSessionConnectionUpdated_At | CoachSessionConnectionTitle | CoachSessionConnectionStatus | CoachSessionConnectionUser | CoachSessionConnectionProgramme_Submission | CoachSessionConnectionSub_Module_Submission | CoachSessionConnectionAppointment | CoachSessionConnectionCreated_By | CoachSessionConnectionUpdated_By | CreateCoachSessionPayload | UpdateCoachSessionPayload | DeleteCoachSessionPayload | CoachSubmittedReports | CoachSubmittedReportsConnection | CoachSubmittedReportsAggregator | CoachSubmittedReportsGroupBy | CoachSubmittedReportsConnectionId | CoachSubmittedReportsConnectionCreated_At | CoachSubmittedReportsConnectionUpdated_At | CoachSubmittedReportsConnectionName | CoachSubmittedReportsConnectionUser | CoachSubmittedReportsConnectionCreated_By | CoachSubmittedReportsConnectionUpdated_By | CreateCoachSubmittedReportPayload | UpdateCoachSubmittedReportPayload | DeleteCoachSubmittedReportPayload | Coach | CoachConnection | CoachAggregator | CoachGroupBy | CoachConnectionId | CoachConnectionCreated_At | CoachConnectionUpdated_At | CoachConnectionEmail | CoachConnectionFirstname | CoachConnectionLastname | CoachConnectionIsCoachAddedByUser | CoachConnectionCreatedBy | CoachConnectionCreated_By | CoachConnectionUpdated_By | CreateCoachPayload | UpdateCoachPayload | DeleteCoachPayload | Company | CompanyConnection | CompanyAggregator | CompanyGroupBy | CompanyConnectionId | CompanyConnectionCreated_At | CompanyConnectionUpdated_At | CompanyConnectionName | CompanyConnectionLogo | CompanyConnectionCertificateTemplate | CompanyConnectionWelcomeScreen | CompanyConnectionLanguageSelection | CompanyConnectionLetsGetStartedScreen | CompanyConnectionWhatToExpect | CompanyConnectionIsTemplate | CompanyConnectionProgrammesTitle | CompanyConnectionProgrammesSubTitle | CompanyConnectionAboutUs | CompanyConnectionUsersConfirmDetails | CompanyConnectionCreated_By | CompanyConnectionUpdated_By | CreateCompanyPayload | UpdateCompanyPayload | DeleteCompanyPayload | CompetencyUrl | CompetencyUrlConnection | CompetencyUrlAggregator | CompetencyUrlGroupBy | CompetencyUrlConnectionId | CompetencyUrlConnectionCreated_At | CompetencyUrlConnectionUpdated_At | CompetencyUrlConnectionUrl | CompetencyUrlConnectionProgramme_Submission | CompetencyUrlConnectionSubmission | CompetencyUrlConnectionSub_Module_Submission | CompetencyUrlConnectionCoach_Email | CompetencyUrlConnectionCreated_By | CompetencyUrlConnectionUpdated_By | CreateCompetencyUrlPayload | UpdateCompetencyUrlPayload | DeleteCompetencyUrlPayload | Division | DivisionConnection | DivisionAggregator | DivisionGroupBy | DivisionConnectionId | DivisionConnectionCreated_At | DivisionConnectionUpdated_At | DivisionConnectionTitleEnglish | DivisionConnectionTitleFrench | DivisionConnectionTitleGerman | DivisionConnectionTitleSpanish | DivisionConnectionTitleMandarin | DivisionConnectionCreated_By | DivisionConnectionUpdated_By | CreateDivisionPayload | UpdateDivisionPayload | DeleteDivisionPayload | EmailLog | EmailLogConnection | EmailLogAggregator | EmailLogGroupBy | EmailLogConnectionId | EmailLogConnectionCreated_At | EmailLogConnectionUpdated_At | EmailLogConnectionTo | EmailLogConnectionSubject | EmailLogConnectionBody | EmailLogConnectionTimestamp | EmailLogConnectionProgramme | EmailLogConnectionCompany | EmailLogConnectionCreated_By | EmailLogConnectionUpdated_By | CreateEmailLogPayload | UpdateEmailLogPayload | DeleteEmailLogPayload | EmailTemplate | EmailTemplateConnection | EmailTemplateAggregator | EmailTemplateGroupBy | EmailTemplateConnectionId | EmailTemplateConnectionCreated_At | EmailTemplateConnectionUpdated_At | EmailTemplateConnectionSubject | EmailTemplateConnectionBody | EmailTemplateConnectionProgramme | EmailTemplateConnectionCreated_By | EmailTemplateConnectionUpdated_By | CreateEmailTemplatePayload | UpdateEmailTemplatePayload | DeleteEmailTemplatePayload | Event | EventConnection | EventAggregator | EventGroupBy | EventConnectionId | EventConnectionCreated_At | EventConnectionUpdated_At | EventConnectionName | EventConnectionLink | EventConnectionSessionId | EventConnectionDescription | EventConnectionServiceId | EventConnectionClassId | EventConnectionCreated_By | EventConnectionUpdated_By | CreateEventPayload | UpdateEventPayload | DeleteEventPayload | FeedfowardUrl | FeedfowardUrlConnection | FeedfowardUrlAggregator | FeedfowardUrlGroupBy | FeedfowardUrlConnectionId | FeedfowardUrlConnectionCreated_At | FeedfowardUrlConnectionUpdated_At | FeedfowardUrlConnectionUrl | FeedfowardUrlConnectionProgramme_Submission | FeedfowardUrlConnectionSub_Module_Submission | FeedfowardUrlConnectionCoach_Email | FeedfowardUrlConnectionCreated_By | FeedfowardUrlConnectionUpdated_By | CreateFeedfowardUrlPayload | UpdateFeedfowardUrlPayload | DeleteFeedfowardUrlPayload | ForwardedCard | ForwardedCardConnection | ForwardedCardAggregator | ForwardedCardGroupBy | ForwardedCardConnectionId | ForwardedCardConnectionCreated_At | ForwardedCardConnectionUpdated_At | ForwardedCardConnectionPostCard | ForwardedCardConnectionP1 | ForwardedCardConnectionP2 | ForwardedCardConnectionP3 | ForwardedCardConnectionP1Sentence | ForwardedCardConnectionP2Sentence | ForwardedCardConnectionP3Sentence | ForwardedCardConnectionSignature | ForwardedCardConnectionFrom | ForwardedCardConnectionTo | ForwardedCardConnectionGeneralText | ForwardedCardConnectionDear | ForwardedCardConnectionPromotionLink | ForwardedCardConnectionCreated_By | ForwardedCardConnectionUpdated_By | CreateForwardedCardPayload | UpdateForwardedCardPayload | DeleteForwardedCardPayload | Invite | InviteConnection | InviteAggregator | InviteGroupBy | InviteConnectionId | InviteConnectionCreated_At | InviteConnectionUpdated_At | InviteConnectionEmail | InviteConnectionCompany | InviteConnectionCreated_By | InviteConnectionUpdated_By | CreateInvitePayload | UpdateInvitePayload | DeleteInvitePayload | Language | LanguageConnection | LanguageAggregator | LanguageGroupBy | LanguageConnectionId | LanguageConnectionCreated_At | LanguageConnectionUpdated_At | LanguageConnectionImage | LanguageConnectionName | LanguageConnectionCreated_By | LanguageConnectionUpdated_By | CreateLanguagePayload | UpdateLanguagePayload | DeleteLanguagePayload | Logo | LogoConnection | LogoAggregator | LogoGroupBy | LogoConnectionId | LogoConnectionCreated_At | LogoConnectionUpdated_At | LogoConnectionLogo | LogoConnectionName | LogoConnectionCreated_By | LogoConnectionUpdated_By | CreateLogoPayload | UpdateLogoPayload | DeleteLogoPayload | Modal | ModalConnection | ModalAggregator | ModalGroupBy | ModalConnectionId | ModalConnectionCreated_At | ModalConnectionUpdated_At | ModalConnectionTitle | ModalConnectionSubtitle | ModalConnectionMessage | ModalConnectionImage | ModalConnectionCreated_By | ModalConnectionUpdated_By | CreateModalPayload | UpdateModalPayload | DeleteModalPayload | Module | ModuleConnection | ModuleAggregator | ModuleAggregatorSum | ModuleAggregatorAvg | ModuleAggregatorMin | ModuleAggregatorMax | ModuleGroupBy | ModuleConnectionId | ModuleConnectionCreated_At | ModuleConnectionUpdated_At | ModuleConnectionNameEnglish | ModuleConnectionNameFrench | ModuleConnectionNameGerman | ModuleConnectionNameSpanish | ModuleConnectionNameMandarin | ModuleConnectionCover | ModuleConnectionDescriptionEnglish | ModuleConnectionDescriptionFrench | ModuleConnectionDescriptionGerman | ModuleConnectionDescriptionMandarin | ModuleConnectionDescriptionSpanish | ModuleConnectionPosition | ModuleConnectionCreated_By | ModuleConnectionUpdated_By | CreateModulePayload | UpdateModulePayload | DeleteModulePayload | Notes | NotesConnection | NotesAggregator | NotesGroupBy | NotesConnectionId | NotesConnectionCreated_At | NotesConnectionUpdated_At | NotesConnectionName | NotesConnectionNote | NotesConnectionSub_Module_Submission | NotesConnectionSectionOrSubmissionId | NotesConnectionProgramme_Submission | NotesConnectionProgramme | NotesConnectionUser | NotesConnectionCreated_By | NotesConnectionUpdated_By | CreateNotePayload | UpdateNotePayload | DeleteNotePayload | Notification | NotificationConnection | NotificationAggregator | NotificationGroupBy | NotificationConnectionId | NotificationConnectionCreated_At | NotificationConnectionUpdated_At | NotificationConnectionTitle | NotificationConnectionTimeStamp | NotificationConnectionPath | NotificationConnectionRead | NotificationConnectionReport | NotificationConnectionProgramme_Report | NotificationConnectionSubmodule_Report | NotificationConnectionCreated_By | NotificationConnectionUpdated_By | CreateNotificationPayload | UpdateNotificationPayload | DeleteNotificationPayload | Participants | ParticipantsConnection | ParticipantsAggregator | ParticipantsGroupBy | ParticipantsConnectionId | ParticipantsConnectionCreated_At | ParticipantsConnectionUpdated_At | ParticipantsConnectionName | ParticipantsConnectionEmail | ParticipantsConnectionType | ParticipantsConnectionProgramme_Submission | ParticipantsConnectionSub_Module_Submission | ParticipantsConnectionCoach_Email | ParticipantsConnectionSurvey_Sent_Date | ParticipantsConnectionCreated_By | ParticipantsConnectionUpdated_By | CreateParticipantPayload | UpdateParticipantPayload | DeleteParticipantPayload | PostCardImage | PostCardImageConnection | PostCardImageAggregator | PostCardImageGroupBy | PostCardImageConnectionId | PostCardImageConnectionCreated_At | PostCardImageConnectionUpdated_At | PostCardImageConnectionImage | PostCardImageConnectionCreated_By | PostCardImageConnectionUpdated_By | CreatePostCardImagePayload | UpdatePostCardImagePayload | DeletePostCardImagePayload | PostCardSentence | PostCardSentenceConnection | PostCardSentenceAggregator | PostCardSentenceGroupBy | PostCardSentenceConnectionId | PostCardSentenceConnectionCreated_At | PostCardSentenceConnectionUpdated_At | PostCardSentenceConnectionPostCardSentence | PostCardSentenceConnectionCreated_By | PostCardSentenceConnectionUpdated_By | CreatePostCardSentencePayload | UpdatePostCardSentencePayload | DeletePostCardSentencePayload | PostCard | PostCardConnection | PostCardAggregator | PostCardGroupBy | PostCardConnectionId | PostCardConnectionCreated_At | PostCardConnectionUpdated_At | PostCardConnectionFrontImage | PostCardConnectionToken | PostCardConnectionPostCardImage | PostCardConnectionFrontText | PostCardConnectionCompanyLogo | PostCardConnectionExpirationTime | PostCardConnectionUser | PostCardConnectionCreated_By | PostCardConnectionUpdated_By | CreatePostCardPayload | UpdatePostCardPayload | DeletePostCardPayload | ProgrammeReport | ProgrammeReportConnection | ProgrammeReportAggregator | ProgrammeReportGroupBy | ProgrammeReportConnectionId | ProgrammeReportConnectionCreated_At | ProgrammeReportConnectionUpdated_At | ProgrammeReportConnectionName | ProgrammeReportConnectionProgramme_Submission | ProgrammeReportConnectionNotification | ProgrammeReportConnectionCreated_By | ProgrammeReportConnectionUpdated_By | CreateProgrammeReportPayload | UpdateProgrammeReportPayload | DeleteProgrammeReportPayload | ProgrammeSubmission | ProgrammeSubmissionConnection | ProgrammeSubmissionAggregator | ProgrammeSubmissionAggregatorSum | ProgrammeSubmissionAggregatorAvg | ProgrammeSubmissionAggregatorMin | ProgrammeSubmissionAggregatorMax | ProgrammeSubmissionGroupBy | ProgrammeSubmissionConnectionId | ProgrammeSubmissionConnectionCreated_At | ProgrammeSubmissionConnectionUpdated_At | ProgrammeSubmissionConnectionStatus | ProgrammeSubmissionConnectionProgress | ProgrammeSubmissionConnectionUser | ProgrammeSubmissionConnectionLanguage | ProgrammeSubmissionConnectionProgramme_Type | ProgrammeSubmissionConnectionProgramme_Report | ProgrammeSubmissionConnectionProgramme | ProgrammeSubmissionConnectionCompetency_Url | ProgrammeSubmissionConnectionFeedfoward_Url | ProgrammeSubmissionConnectionSelected | ProgrammeSubmissionConnectionEmailSent | ProgrammeSubmissionConnectionIsUpdatedByStakeholder | ProgrammeSubmissionConnectionCreated_By | ProgrammeSubmissionConnectionUpdated_By | CreateProgrammeSubmissionPayload | UpdateProgrammeSubmissionPayload | DeleteProgrammeSubmissionPayload | ProgrammeType | ProgrammeTypeConnection | ProgrammeTypeAggregator | ProgrammeTypeAggregatorSum | ProgrammeTypeAggregatorAvg | ProgrammeTypeAggregatorMin | ProgrammeTypeAggregatorMax | ProgrammeTypeGroupBy | ProgrammeTypeConnectionId | ProgrammeTypeConnectionCreated_At | ProgrammeTypeConnectionUpdated_At | ProgrammeTypeConnectionTitle | ProgrammeTypeConnectionDescription | ProgrammeTypeConnectionCover | ProgrammeTypeConnectionIsCoaching | ProgrammeTypeConnectionShowParticipants | ProgrammeTypeConnectionCompetencySurvey | ProgrammeTypeConnectionFeedForwardSurvey | ProgrammeTypeConnectionShowSession | ProgrammeTypeConnectionNotes | ProgrammeTypeConnectionShowArticle | ProgrammeTypeConnectionDeadline | ProgrammeTypeConnectionPosition | ProgrammeTypeConnectionModal | ProgrammeTypeConnectionModule | ProgrammeTypeConnectionIsSubModule | ProgrammeTypeConnectionIsTemplate | ProgrammeTypeConnectionCompetencyEmailTitle | ProgrammeTypeConnectionEmail_Template | ProgrammeTypeConnectionShowStatistics | ProgrammeTypeConnectionProgrammeTypeInstructions | ProgrammeTypeConnectionEmailSend | ProgrammeTypeConnectionType_Form_Collection | ProgrammeTypeConnectionArchive | ProgrammeTypeConnectionCreated_By | ProgrammeTypeConnectionUpdated_By | CreateProgrammeTypePayload | UpdateProgrammeTypePayload | DeleteProgrammeTypePayload | Programmes | ProgrammesConnection | ProgrammesAggregator | ProgrammesAggregatorSum | ProgrammesAggregatorAvg | ProgrammesAggregatorMin | ProgrammesAggregatorMax | ProgrammesGroupBy | ProgrammesConnectionId | ProgrammesConnectionCreated_At | ProgrammesConnectionUpdated_At | ProgrammesConnectionName | ProgrammesConnectionDescription | ProgrammesConnectionStart | ProgrammesConnectionIsCustomJourney | ProgrammesConnectionShowTimeline | ProgrammesConnectionProgrammeTitle | ProgrammesConnectionPosition | ProgrammesConnectionLogo | ProgrammesConnectionSendTypeform | ProgrammesConnectionType_Form_Collection | ProgrammesConnectionWhatToExpect | ProgrammesConnectionCompletion | ProgrammesConnectionIsTemplate | ProgrammesConnectionThree_60_Form_Id | ProgrammesConnectionCreated_By | ProgrammesConnectionUpdated_By | CreateProgrammePayload | UpdateProgrammePayload | DeleteProgrammePayload | Region | RegionConnection | RegionAggregator | RegionGroupBy | RegionConnectionId | RegionConnectionCreated_At | RegionConnectionUpdated_At | RegionConnectionNameEnglish | RegionConnectionNameSpanish | RegionConnectionNameFrench | RegionConnectionNameGerman | RegionConnectionNameMandarin | RegionConnectionCreated_By | RegionConnectionUpdated_By | CreateRegionPayload | UpdateRegionPayload | DeleteRegionPayload | Report | ReportConnection | ReportAggregator | ReportGroupBy | ReportConnectionId | ReportConnectionCreated_At | ReportConnectionUpdated_At | ReportConnectionName | ReportConnectionType | ReportConnectionSubmission | ReportConnectionReport | ReportConnectionSectionOrModuleId | ReportConnectionNotification | ReportConnectionSub_Module_Submission | ReportConnectionCreated_By | ReportConnectionUpdated_By | CreateReportPayload | UpdateReportPayload | DeleteReportPayload | RespondentsAnswers | RespondentsAnswersConnection | RespondentsAnswersAggregator | RespondentsAnswersGroupBy | RespondentsAnswersConnectionId | RespondentsAnswersConnectionCreated_At | RespondentsAnswersConnectionUpdated_At | RespondentsAnswersConnectionProgramme_Submission | RespondentsAnswersConnectionEmail | RespondentsAnswersConnectionSubmission | RespondentsAnswersConnectionSub_Module_Submission | RespondentsAnswersConnectionUser | RespondentsAnswersConnectionForm_Id | RespondentsAnswersConnectionSection_Id | RespondentsAnswersConnectionCreated_By | RespondentsAnswersConnectionUpdated_By | CreateRespondentsAnswerPayload | UpdateRespondentsAnswerPayload | DeleteRespondentsAnswerPayload | Section | SectionConnection | SectionAggregator | SectionAggregatorSum | SectionAggregatorAvg | SectionAggregatorMin | SectionAggregatorMax | SectionGroupBy | SectionConnectionId | SectionConnectionCreated_At | SectionConnectionUpdated_At | SectionConnectionTitleEnglish | SectionConnectionSubTitleEnglish | SectionConnectionVideoEnglish | SectionConnectionTitleFrench | SectionConnectionSubTitleFrench | SectionConnectionVideoFrench | SectionConnectionTitleGerman | SectionConnectionSubTitleGerman | SectionConnectionVideoGerman | SectionConnectionTitleSpanish | SectionConnectionSubTitleSpanish | SectionConnectionVideoSpanish | SectionConnectionTitleMandarin | SectionConnectionSubTitleMandarin | SectionConnectionVideoMandarin | SectionConnectionModule | SectionConnectionCover | SectionConnectionPosition | SectionConnectionSub_Module | SectionConnectionShowSession | SectionConnectionIsCoaching | SectionConnectionShowParticipants | SectionConnectionCompetencySurvey | SectionConnectionFeedForwardSurvey | SectionConnectionIsTemplate | SectionConnectionGetStartedText | SectionConnectionNotes | SectionConnectionSendTypeForm | SectionConnectionType_Form_Collection | SectionConnectionEmail_Template | SectionConnectionArchive | SectionConnectionInstructionsText | SectionConnectionCreated_By | SectionConnectionUpdated_By | CreateSectionPayload | UpdateSectionPayload | DeleteSectionPayload | SubModuleSubmission | SubModuleSubmissionConnection | SubModuleSubmissionAggregator | SubModuleSubmissionAggregatorSum | SubModuleSubmissionAggregatorAvg | SubModuleSubmissionAggregatorMin | SubModuleSubmissionAggregatorMax | SubModuleSubmissionGroupBy | SubModuleSubmissionConnectionId | SubModuleSubmissionConnectionCreated_At | SubModuleSubmissionConnectionUpdated_At | SubModuleSubmissionConnectionLanguage | SubModuleSubmissionConnectionUser | SubModuleSubmissionConnectionView | SubModuleSubmissionConnectionSub_Module | SubModuleSubmissionConnectionProgress | SubModuleSubmissionConnectionStatus | SubModuleSubmissionConnectionTimeSpent | SubModuleSubmissionConnectionFeedfoward_Url | SubModuleSubmissionConnectionCompetency_Url | SubModuleSubmissionConnectionSectionTypeform | SubModuleSubmissionConnectionProgrammeTypeForm | SubModuleSubmissionConnectionThree_60_Survey_Form_Id | SubModuleSubmissionConnectionProgramme | SubModuleSubmissionConnectionCreated_By | SubModuleSubmissionConnectionUpdated_By | CreateSubModuleSubmissionPayload | UpdateSubModuleSubmissionPayload | DeleteSubModuleSubmissionPayload | SubModule | SubModuleConnection | SubModuleAggregator | SubModuleAggregatorSum | SubModuleAggregatorAvg | SubModuleAggregatorMin | SubModuleAggregatorMax | SubModuleGroupBy | SubModuleConnectionId | SubModuleConnectionCreated_At | SubModuleConnectionUpdated_At | SubModuleConnectionNameEnglish | SubModuleConnectionNameFrench | SubModuleConnectionNameGerman | SubModuleConnectionNameSpanish | SubModuleConnectionNameMandarin | SubModuleConnectionCover | SubModuleConnectionDescriptionEnglish | SubModuleConnectionDescriptionFrench | SubModuleConnectionDescriptionGerman | SubModuleConnectionDescriptionMandarin | SubModuleConnectionDescriptionSpanish | SubModuleConnectionPosition | SubModuleConnectionProgramme_Type | SubModuleConnectionCreated_By | SubModuleConnectionUpdated_By | CreateSubModulePayload | UpdateSubModulePayload | DeleteSubModulePayload | Submission | SubmissionConnection | SubmissionAggregator | SubmissionAggregatorSum | SubmissionAggregatorAvg | SubmissionAggregatorMin | SubmissionAggregatorMax | SubmissionGroupBy | SubmissionConnectionId | SubmissionConnectionCreated_At | SubmissionConnectionUpdated_At | SubmissionConnectionLanguage | SubmissionConnectionProgress | SubmissionConnectionStatus | SubmissionConnectionTimeSpent | SubmissionConnectionUser | SubmissionConnectionViews | SubmissionConnectionModule | SubmissionConnectionCompetency_Url | SubmissionConnectionCreated_By | SubmissionConnectionUpdated_By | CreateSubmissionPayload | UpdateSubmissionPayload | DeleteSubmissionPayload | SubmoduleReport | SubmoduleReportConnection | SubmoduleReportAggregator | SubmoduleReportGroupBy | SubmoduleReportConnectionId | SubmoduleReportConnectionCreated_At | SubmoduleReportConnectionUpdated_At | SubmoduleReportConnectionName | SubmoduleReportConnectionSub_Module_Submission | SubmoduleReportConnectionNotification | SubmoduleReportConnectionSectionTitle | SubmoduleReportConnectionUser | SubmoduleReportConnectionCreated_By | SubmoduleReportConnectionUpdated_By | CreateSubmoduleReportPayload | UpdateSubmoduleReportPayload | DeleteSubmoduleReportPayload | SurveyReports | SurveyReportsConnection | SurveyReportsAggregator | SurveyReportsGroupBy | SurveyReportsConnectionId | SurveyReportsConnectionCreated_At | SurveyReportsConnectionUpdated_At | SurveyReportsConnectionName | SurveyReportsConnectionReport | SurveyReportsConnectionCreated_By | SurveyReportsConnectionUpdated_By | CreateSurveyReportPayload | UpdateSurveyReportPayload | DeleteSurveyReportPayload | Translations | UpdateTranslationPayload | DeleteTranslationPayload | TypeFormCollection | TypeFormCollectionConnection | TypeFormCollectionAggregator | TypeFormCollectionGroupBy | TypeFormCollectionConnectionId | TypeFormCollectionConnectionCreated_At | TypeFormCollectionConnectionUpdated_At | TypeFormCollectionConnectionName | TypeFormCollectionConnectionTypeFormUrl | TypeFormCollectionConnectionSubmissions | TypeFormCollectionConnectionCreated_By | TypeFormCollectionConnectionUpdated_By | CreateTypeFormCollectionPayload | UpdateTypeFormCollectionPayload | DeleteTypeFormCollectionPayload | UploadedReports | UploadedReportsConnection | UploadedReportsAggregator | UploadedReportsGroupBy | UploadedReportsConnectionId | UploadedReportsConnectionCreated_At | UploadedReportsConnectionUpdated_At | UploadedReportsConnectionName | UploadedReportsConnectionType | UploadedReportsConnectionSub_Module_Submission | UploadedReportsConnectionSectionOrModuleId | UploadedReportsConnectionSubmission | UploadedReportsConnectionProgramme_Submission | UploadedReportsConnectionCreated_By | UploadedReportsConnectionUpdated_By | CreateUploadedReportPayload | UpdateUploadedReportPayload | DeleteUploadedReportPayload | UserUploadedDocument | UserUploadedDocumentConnection | UserUploadedDocumentAggregator | UserUploadedDocumentGroupBy | UserUploadedDocumentConnectionId | UserUploadedDocumentConnectionCreated_At | UserUploadedDocumentConnectionUpdated_At | UserUploadedDocumentConnectionName | UserUploadedDocumentConnectionUser | UserUploadedDocumentConnectionCreated_By | UserUploadedDocumentConnectionUpdated_By | CreateUserUploadedDocumentPayload | UpdateUserUploadedDocumentPayload | DeleteUserUploadedDocumentPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionCreated_By | UploadFileConnectionUpdated_By | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | UsersPermissionsRoleConnectionCreated_By | UsersPermissionsRoleConnectionUpdated_By | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserAggregatorSum | UsersPermissionsUserAggregatorAvg | UsersPermissionsUserAggregatorMin | UsersPermissionsUserAggregatorMax | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionPhoneNumber | UsersPermissionsUserConnectionProfilePicture | UsersPermissionsUserConnectionLanguage | UsersPermissionsUserConnectionFirstName | UsersPermissionsUserConnectionLastName | UsersPermissionsUserConnectionJobTitle | UsersPermissionsUserConnectionModulesRead | UsersPermissionsUserConnectionHomePromptsRead | UsersPermissionsUserConnectionProgrammePromptsRead | UsersPermissionsUserConnectionModulePromptsRead | UsersPermissionsUserConnectionBookmarks | UsersPermissionsUserConnectionReport | UsersPermissionsUserConnectionCompany | UsersPermissionsUserConnectionArticlesViewed | UsersPermissionsUserConnectionPostCard | UsersPermissionsUserConnectionTimezone | UsersPermissionsUserConnectionCertificate | UsersPermissionsUserConnectionLoginAttempts | UsersPermissionsUserConnectionFeedForwardUrl | UsersPermissionsUserConnectionDivision | UsersPermissionsUserConnectionRegion | UsersPermissionsUserConnectionLoginWithSso | UsersPermissionsUserConnectionProgrammeEvalutionEmailSent | UsersPermissionsUserConnectionUpdatedDetails | UsersPermissionsUserConnectionOnboarding | UsersPermissionsUserConnectionTriggerReport | UsersPermissionsUserConnectionClientId | UsersPermissionsUserConnectionCurrent_Survey | UsersPermissionsUserConnectionCoach | UsersPermissionsUserConnectionThree_60_Form_Id | UsersPermissionsUserConnectionCreated_By | UsersPermissionsUserConnectionUpdated_By | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentGravitasScaleItemsGravitasScaleItems | ComponentOptionColorAndRating | ComponentOptionOption | ComponentOptionSliderHeadings | ComponentOptionSliderQuestions | ComponentOptionTimezone | ComponentQuestionTypesCompetency | ComponentQuestionTypesCompetency2 | ComponentQuestionTypesDocuments | ComponentQuestionTypesFeedForward1 | ComponentQuestionTypesFeedForward2 | ComponentQuestionTypesGravitasGap | ComponentQuestionTypesGravitasScale | ComponentQuestionTypesGravitasSliders | ComponentQuestionTypesMultipleChoice | ComponentQuestionTypesNestedQuestions | ComponentQuestionTypesParticipant | ComponentQuestionTypesQuestionscompetency2 | ComponentQuestionTypesSaboteurQuestions | ComponentQuestionTypesSaboteurVideos | ComponentQuestionTypesSaboteur | ComponentQuestionTypesSimpleQuestion | ComponentQuestionTypesSimpleReadOnly | ComponentQuestionTypesSliderQuestions | ComponentQuestionTypesStakeholderMap | ComponentQuestionTypesUploadDocuments | ComponentQuestionTypesUploadQuestion | ComponentQuestionTypesValuesBubble | ComponentQuestionTypesValuesCharacters | ComponentQuestionTypesValuesGaps | ComponentQuestionTypesValuesNested | ComponentQuestionTypesValuesSliders | ComponentQuestionTypesXyGraph | ComponentRatingInputRatingInput | ComponentSaboteurVideoSaboteurVideo | ComponentStakeholderMapItemStackholderMapItem | ComponentSubmissionsAnswer | ComponentSubmissionsCharacteristics | ComponentSubmissionsCompetencyAnswer | ComponentSubmissionsCompetencyParticipants | ComponentSubmissionsGravitasGap | ComponentSubmissionsGravitasSlidersAnswers | ComponentSubmissionsNotes | ComponentSubmissionsParticipants | ComponentSubmissionsProgrammeSubmissions | ComponentSubmissionsRepeatAnswer | ComponentSubmissionsSaboteurComponent | ComponentSubmissionsSabtourVideosComponent | ComponentSubmissionsSectionSubmission | ComponentSubmissionsSkipProofComponent | ComponentSubmissionsSubModuleSubmission | ComponentSubmissionsUploadDocuments | ComponentSubmissionsValuesGaps | ComponentTranslationsAboutUs | ComponentTranslationsButtons | ComponentTranslationsDashboardScreen | ComponentTranslationsFaqsFrench | ComponentTranslationsFaqsGerman | ComponentTranslationsFaqsMandarin | ComponentTranslationsFaqsQuestionAnswer | ComponentTranslationsFaqsSpanish | ComponentTranslationsFaqs | ComponentTranslationsHelpAndSupport | ComponentTranslationsHomeScreen | ComponentTranslationsLanguageSelection | ComponentTranslationsLetsGetStartedScreen | ComponentTranslationsMenu | ComponentTranslationsMyLibraryScreen | ComponentTranslationsMyProfileScreen | ComponentTranslationsMyWorkScreen | ComponentTranslationsPersonalScreen | ComponentTranslationsPrivacyPolicy | ComponentTranslationsProgrammeScreen | ComponentTranslationsSettingsScreen | ComponentTranslationsTermsOfService | ComponentTranslationsWelcomeScreen | ComponentTranslationsWhatToExpect | ComponentXyGraphItemXyGraphItem;

export type ConfirmAppointmentResponse = {
   __typename?: 'ConfirmAppointmentResponse';
  success?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type EBooking = {
   __typename?: 'EBooking';
  id?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
  eventTypeId?: Maybe<Scalars['ID']>;
  uid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
};

export type EventLocation = {
   __typename?: 'EventLocation';
  type?: Maybe<Scalars['String']>;
};

export type EventType = {
   __typename?: 'EventType';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  locations?: Maybe<Array<Maybe<EventLocation>>>;
  length?: Maybe<Scalars['Int']>;
  hidden?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
  teamId?: Maybe<Scalars['ID']>;
  eventName?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  periodType?: Maybe<Scalars['String']>;
  periodStartDate?: Maybe<Scalars['String']>;
  periodEndDate?: Maybe<Scalars['String']>;
  periodDays?: Maybe<Scalars['Int']>;
  periodCountCalendarDays?: Maybe<Scalars['Boolean']>;
  requiresConfirmation?: Maybe<Scalars['Boolean']>;
  recurringEvent?: Maybe<Scalars['Boolean']>;
  disableGuests?: Maybe<Scalars['Boolean']>;
  hideCalendarNotes?: Maybe<Scalars['Boolean']>;
  minimumBookingNotice?: Maybe<Scalars['Int']>;
  beforeEventBuffer?: Maybe<Scalars['Int']>;
  afterEventBuffer?: Maybe<Scalars['Int']>;
  seatsPerTimeSlot?: Maybe<Scalars['Int']>;
  schedulingType?: Maybe<Scalars['String']>;
  scheduleId?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  slotInterval?: Maybe<Scalars['Int']>;
  successRedirectUrl?: Maybe<Scalars['String']>;
};

export type ProgrammeSubmissionResponse = {
   __typename?: 'ProgrammeSubmissionResponse';
  success?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type EmailsSent = {
   __typename?: 'EmailsSent';
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EmailSentProgramme = {
   __typename?: 'EmailSentProgramme';
  successed?: Maybe<Scalars['String']>;
};

export type ReportDetail = {
   __typename?: 'ReportDetail';
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
};

export type SectionReport = {
   __typename?: 'SectionReport';
  programmeName?: Maybe<Scalars['String']>;
  report?: Maybe<ReportDetail>;
  programmeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ProgrammeTypeReport = {
   __typename?: 'ProgrammeTypeReport';
  programmeType?: Maybe<Scalars['String']>;
  programmeName?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<SectionReport>>>;
};

export type ReportsGrouped = {
   __typename?: 'ReportsGrouped';
  companyName: Scalars['String'];
  programmeType?: Maybe<Array<Maybe<ProgrammeTypeReport>>>;
};

export type ReportsSubmissionGrouped = {
   __typename?: 'ReportsSubmissionGrouped';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
  programmeType?: Maybe<Scalars['String']>;
  sub_module_submission?: Maybe<Scalars['Int']>;
  notification?: Maybe<Scalars['String']>;
  report?: Maybe<ReportDetail>;
};

export type SubModuleSubmissionReport = {
   __typename?: 'SubModuleSubmissionReport';
  id: Scalars['ID'];
  sub_module: SubModule;
  reports: Array<Report>;
};

export type SubModule = {
   __typename?: 'SubModule';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nameEnglish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  cover?: Maybe<UploadFile>;
  descriptionEnglish?: Maybe<Scalars['String']>;
  descriptionFrench?: Maybe<Scalars['String']>;
  descriptionGerman?: Maybe<Scalars['String']>;
  descriptionMandarin?: Maybe<Scalars['String']>;
  descriptionSpanish?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  programme_type?: Maybe<ProgrammeType>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  sections?: Maybe<Array<Maybe<Section>>>;
  sub_module_submissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
};


export type SubModuleSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubModuleSub_Module_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProgrammeType = {
   __typename?: 'ProgrammeType';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  cover?: Maybe<UploadFile>;
  isCoaching?: Maybe<Scalars['Boolean']>;
  showParticipants?: Maybe<Scalars['Boolean']>;
  competencySurvey?: Maybe<Scalars['Boolean']>;
  feedForwardSurvey?: Maybe<Scalars['Boolean']>;
  showSession?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['Boolean']>;
  showArticle?: Maybe<Scalars['Boolean']>;
  deadline?: Maybe<Scalars['DateTime']>;
  programmeQuestions?: Maybe<Array<Maybe<ProgrammeTypeProgrammeQuestionsDynamicZone>>>;
  position?: Maybe<Scalars['Int']>;
  modal?: Maybe<Modal>;
  module?: Maybe<Module>;
  isSubModule?: Maybe<Scalars['Boolean']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  competencyEmailTitle?: Maybe<Scalars['String']>;
  email_template?: Maybe<EmailTemplate>;
  showStatistics?: Maybe<Scalars['Boolean']>;
  programmeTypeInstructions?: Maybe<Scalars['String']>;
  emailSend?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<TypeFormCollection>;
  archive?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  programme_submissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  programmes?: Maybe<Array<Maybe<Programmes>>>;
  events?: Maybe<Array<Maybe<Event>>>;
  sub_modules?: Maybe<Array<Maybe<SubModule>>>;
  articles?: Maybe<Array<Maybe<Article>>>;
};


export type ProgrammeTypeProgramme_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeTypeProgrammesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeTypeEventsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeTypeSub_ModulesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeTypeArticlesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProgrammeTypeProgrammeQuestionsDynamicZone = ComponentQuestionTypesValuesNested | ComponentQuestionTypesValuesBubble | ComponentQuestionTypesValuesCharacters | ComponentQuestionTypesValuesSliders | ComponentQuestionTypesValuesGaps | ComponentQuestionTypesSaboteurVideos | ComponentQuestionTypesMultipleChoice | ComponentQuestionTypesSaboteur | ComponentQuestionTypesSimpleQuestion | ComponentQuestionTypesXyGraph | ComponentQuestionTypesNestedQuestions | ComponentQuestionTypesUploadQuestion | ComponentQuestionTypesGravitasScale | ComponentQuestionTypesParticipant | ComponentQuestionTypesStakeholderMap | ComponentQuestionTypesFeedForward1 | ComponentQuestionTypesFeedForward2 | ComponentQuestionTypesSimpleReadOnly | ComponentQuestionTypesCompetency2 | ComponentQuestionTypesCompetency | ComponentQuestionTypesGravitasGap | ComponentQuestionTypesSliderQuestions | ComponentQuestionTypesGravitasSliders;

export type ComponentQuestionTypesValuesNested = {
   __typename?: 'ComponentQuestionTypesValuesNested';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ComponentQuestionTypesSimpleQuestion>>>;
};

export type ComponentQuestionTypesSimpleQuestion = {
   __typename?: 'ComponentQuestionTypesSimpleQuestion';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  isNumeric?: Maybe<Scalars['Boolean']>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesBubble = {
   __typename?: 'ComponentQuestionTypesValuesBubble';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesCharacters = {
   __typename?: 'ComponentQuestionTypesValuesCharacters';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesSliders = {
   __typename?: 'ComponentQuestionTypesValuesSliders';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sliderQuestions?: Maybe<Array<Maybe<ComponentQuestionTypesSliderQuestions>>>;
};

export type ComponentQuestionTypesSliderQuestions = {
   __typename?: 'ComponentQuestionTypesSliderQuestions';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesGaps = {
   __typename?: 'ComponentQuestionTypesValuesGaps';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSaboteurVideos = {
   __typename?: 'ComponentQuestionTypesSaboteurVideos';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  SaboteurVideo?: Maybe<Array<Maybe<ComponentSaboteurVideoSaboteurVideo>>>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentSaboteurVideoSaboteurVideo = {
   __typename?: 'ComponentSaboteurVideoSaboteurVideo';
  id: Scalars['ID'];
  videoTitleEnglish?: Maybe<Scalars['String']>;
  videoTitleFrench?: Maybe<Scalars['String']>;
  videoTitleGerman?: Maybe<Scalars['String']>;
  videoTitleSpanish?: Maybe<Scalars['String']>;
  videoTitleMandarin?: Maybe<Scalars['String']>;
  video?: Maybe<UploadFile>;
  videoDescriptionEnglish?: Maybe<Scalars['String']>;
  videoDescriptionFrench?: Maybe<Scalars['String']>;
  videoDescriptionGerman?: Maybe<Scalars['String']>;
  videoDescriptionSpanish?: Maybe<Scalars['String']>;
  videoDescriptionMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesMultipleChoice = {
   __typename?: 'ComponentQuestionTypesMultipleChoice';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  option?: Maybe<Array<Maybe<ComponentOptionOption>>>;
  numberOfAnswers?: Maybe<Scalars['Int']>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentOptionOption = {
   __typename?: 'ComponentOptionOption';
  id: Scalars['ID'];
  optionEnglish?: Maybe<Scalars['String']>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  optionFrench?: Maybe<Scalars['String']>;
  optionGerman?: Maybe<Scalars['String']>;
  optionSpanish?: Maybe<Scalars['String']>;
  optionMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSaboteur = {
   __typename?: 'ComponentQuestionTypesSaboteur';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  labelEnglish?: Maybe<Scalars['String']>;
  labelFrench?: Maybe<Scalars['String']>;
  labelGerman?: Maybe<Scalars['String']>;
  labelSpanish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  saboteurQuestions?: Maybe<Array<Maybe<ComponentQuestionTypesSaboteurQuestions>>>;
};

export type ComponentQuestionTypesSaboteurQuestions = {
   __typename?: 'ComponentQuestionTypesSaboteurQuestions';
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  labelEnglish?: Maybe<Scalars['String']>;
  skipProof?: Maybe<Scalars['Boolean']>;
  labelFrench?: Maybe<Scalars['String']>;
  labelGerman?: Maybe<Scalars['String']>;
  labelSpanish?: Maybe<Scalars['String']>;
  labelMandarin?: Maybe<Scalars['String']>;
  proof?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentQuestionTypesSaboteurQuestionsProofArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentQuestionTypesXyGraph = {
   __typename?: 'ComponentQuestionTypesXYGraph';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  labelXEnglish?: Maybe<Scalars['String']>;
  labelYEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  labelXFrench?: Maybe<Scalars['String']>;
  labelYFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  labelXGerman?: Maybe<Scalars['String']>;
  labelYGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  labelXSpanish?: Maybe<Scalars['String']>;
  labelYSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  labelXMandarin?: Maybe<Scalars['String']>;
  labelYMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesNestedQuestions = {
   __typename?: 'ComponentQuestionTypesNestedQuestions';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ComponentQuestionTypesSimpleQuestion>>>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesUploadQuestion = {
   __typename?: 'ComponentQuestionTypesUploadQuestion';
  id: Scalars['ID'];
  file?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentQuestionTypesUploadQuestionFileArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentQuestionTypesGravitasScale = {
   __typename?: 'ComponentQuestionTypesGravitasScale';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  questionOneFrench?: Maybe<Scalars['String']>;
  questionTwoFrench?: Maybe<Scalars['String']>;
  questionThreeFrench?: Maybe<Scalars['String']>;
  titleOneFrench?: Maybe<Scalars['String']>;
  titleTwoFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  questionOneGerman?: Maybe<Scalars['String']>;
  questionTwoGerman?: Maybe<Scalars['String']>;
  questionThreeGerman?: Maybe<Scalars['String']>;
  titleOneGerman?: Maybe<Scalars['String']>;
  titleTwoGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  questionOneSpanish?: Maybe<Scalars['String']>;
  questionTwoSpanish?: Maybe<Scalars['String']>;
  questionThreeSpanish?: Maybe<Scalars['String']>;
  titleOneSpanish?: Maybe<Scalars['String']>;
  titleTwoSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  questionOneMandarin?: Maybe<Scalars['String']>;
  questionTwoMandarin?: Maybe<Scalars['String']>;
  questionThreeMandarin?: Maybe<Scalars['String']>;
  titleOneMandarin?: Maybe<Scalars['String']>;
  titleTwoMandarin?: Maybe<Scalars['String']>;
  ratingInput?: Maybe<Array<Maybe<ComponentRatingInputRatingInput>>>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  questionOneEnglish?: Maybe<Scalars['String']>;
  questionTwoEnglish?: Maybe<Scalars['String']>;
  questionThreeEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
  titleOneEnglish?: Maybe<Scalars['String']>;
  titleTwoEnglish?: Maybe<Scalars['String']>;
};

export type ComponentRatingInputRatingInput = {
   __typename?: 'ComponentRatingInputRatingInput';
  id: Scalars['ID'];
  labelOneEnglish?: Maybe<Scalars['String']>;
  labelTwoEnglish?: Maybe<Scalars['String']>;
  labelOneFrench?: Maybe<Scalars['String']>;
  labelTwoFrench?: Maybe<Scalars['String']>;
  labelOneGerman?: Maybe<Scalars['String']>;
  labelTwoGerman?: Maybe<Scalars['String']>;
  labelOneSpanish?: Maybe<Scalars['String']>;
  labelTwoSpanish?: Maybe<Scalars['String']>;
  labelOneMandarin?: Maybe<Scalars['String']>;
  labelTwoMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesParticipant = {
   __typename?: 'ComponentQuestionTypesParticipant';
  id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesStakeholderMap = {
   __typename?: 'ComponentQuestionTypesStakeholderMap';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  questionX?: Maybe<Scalars['String']>;
  questionY?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesFeedForward1 = {
   __typename?: 'ComponentQuestionTypesFeedForward1';
  id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesFeedForward2 = {
   __typename?: 'ComponentQuestionTypesFeedForward2';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSimpleReadOnly = {
   __typename?: 'ComponentQuestionTypesSimpleReadOnly';
  id: Scalars['ID'];
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  contentFrench?: Maybe<Scalars['String']>;
  contentGerman?: Maybe<Scalars['String']>;
  contentSpanish?: Maybe<Scalars['String']>;
  contentMandarin?: Maybe<Scalars['String']>;
  photo?: Maybe<UploadFile>;
  contentEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesCompetency2 = {
   __typename?: 'ComponentQuestionTypesCompetency2';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  questionscompetency2?: Maybe<Array<Maybe<ComponentQuestionTypesQuestionscompetency2>>>;
  titleFrench?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesQuestionscompetency2 = {
   __typename?: 'ComponentQuestionTypesQuestionscompetency2';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  maxiNumber?: Maybe<Scalars['Long']>;
  maxiLabel?: Maybe<Scalars['String']>;
  simpleQuestion?: Maybe<Scalars['Boolean']>;
  miniNumber?: Maybe<Scalars['Long']>;
  miniLabel?: Maybe<Scalars['String']>;
  midiLabel?: Maybe<Scalars['String']>;
  textboxQuestion?: Maybe<Scalars['String']>;
};


export type ComponentQuestionTypesCompetency = {
   __typename?: 'ComponentQuestionTypesCompetency';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  minNumber?: Maybe<Scalars['Long']>;
  maxNumber?: Maybe<Scalars['Long']>;
  miniLabel?: Maybe<Scalars['String']>;
  maxiLabel?: Maybe<Scalars['String']>;
  simpleQuestion?: Maybe<Scalars['Boolean']>;
};

export type ComponentQuestionTypesGravitasGap = {
   __typename?: 'ComponentQuestionTypesGravitasGap';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color1?: Maybe<Scalars['String']>;
  color2?: Maybe<Scalars['String']>;
  color3?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesGravitasSliders = {
   __typename?: 'ComponentQuestionTypesGravitasSliders';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  positiveHeadingEnglish?: Maybe<Scalars['String']>;
  positiveHeadingGerman?: Maybe<Scalars['String']>;
  positiveHeadingMandarin?: Maybe<Scalars['String']>;
  positiveHeadingSpanish?: Maybe<Scalars['String']>;
  positiveHeadingFrench?: Maybe<Scalars['String']>;
  negativeHeadingEnglish?: Maybe<Scalars['String']>;
  negativeHeadingMandarin?: Maybe<Scalars['String']>;
  negativeHeadingSpanish?: Maybe<Scalars['String']>;
  negativeHeadingGerman?: Maybe<Scalars['String']>;
  negativeHeadingFrench?: Maybe<Scalars['String']>;
  sliderQuestions?: Maybe<Array<Maybe<ComponentOptionSliderQuestions>>>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  sliderHeadings?: Maybe<Array<Maybe<ComponentOptionSliderHeadings>>>;
};

export type ComponentOptionSliderQuestions = {
   __typename?: 'ComponentOptionSliderQuestions';
  id: Scalars['ID'];
  questionPositiveEnglish?: Maybe<Scalars['String']>;
  questionPositiveGerman?: Maybe<Scalars['String']>;
  questionPositiveFrench?: Maybe<Scalars['String']>;
  questionPositiveMandarin?: Maybe<Scalars['String']>;
  questionPositiveSpanish?: Maybe<Scalars['String']>;
  questionNegativeFrench?: Maybe<Scalars['String']>;
  questionNegativeSpanish?: Maybe<Scalars['String']>;
  questionNegativeEnglish?: Maybe<Scalars['String']>;
  questionNegativeMandarin?: Maybe<Scalars['String']>;
  questionNegativeGerman?: Maybe<Scalars['String']>;
};

export type ComponentOptionSliderHeadings = {
   __typename?: 'ComponentOptionSliderHeadings';
  id: Scalars['ID'];
  headingEnglish?: Maybe<Scalars['String']>;
  headingMandarin?: Maybe<Scalars['String']>;
  headingSpanish?: Maybe<Scalars['String']>;
  headingFrench?: Maybe<Scalars['String']>;
  headingGerman?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};

export type Modal = {
   __typename?: 'Modal';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  programme_types?: Maybe<Array<Maybe<ProgrammeType>>>;
};


export type ModalProgramme_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Module = {
   __typename?: 'Module';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nameEnglish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  cover?: Maybe<UploadFile>;
  descriptionEnglish?: Maybe<Scalars['String']>;
  descriptionFrench?: Maybe<Scalars['String']>;
  descriptionGerman?: Maybe<Scalars['String']>;
  descriptionMandarin?: Maybe<Scalars['String']>;
  descriptionSpanish?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  sections?: Maybe<Array<Maybe<Section>>>;
  submissions?: Maybe<Array<Maybe<Submission>>>;
  companies?: Maybe<Array<Maybe<Company>>>;
};


export type ModuleSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ModuleSubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ModuleCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Section = {
   __typename?: 'Section';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  videoEnglish?: Maybe<UploadFile>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  videoFrench?: Maybe<UploadFile>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  videoGerman?: Maybe<UploadFile>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  videoSpanish?: Maybe<UploadFile>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  videoMandarin?: Maybe<UploadFile>;
  module?: Maybe<Module>;
  cover?: Maybe<UploadFile>;
  position?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<Maybe<SectionQuestionsDynamicZone>>>;
  sub_module?: Maybe<SubModule>;
  showSession?: Maybe<Scalars['Boolean']>;
  isCoaching?: Maybe<Scalars['Boolean']>;
  showParticipants?: Maybe<Scalars['Boolean']>;
  competencySurvey?: Maybe<Scalars['Boolean']>;
  feedForwardSurvey?: Maybe<Scalars['Boolean']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  getStartedText?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['Boolean']>;
  sendTypeForm?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<TypeFormCollection>;
  email_template?: Maybe<EmailTemplate>;
  archive?: Maybe<Scalars['Boolean']>;
  instructionsText?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  events?: Maybe<Array<Maybe<Event>>>;
};


export type SectionEventsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SectionQuestionsDynamicZone = ComponentQuestionTypesMultipleChoice | ComponentQuestionTypesSaboteur | ComponentQuestionTypesSimpleQuestion | ComponentQuestionTypesXyGraph | ComponentQuestionTypesNestedQuestions | ComponentQuestionTypesGravitasScale | ComponentQuestionTypesStakeholderMap | ComponentQuestionTypesSaboteurVideos | ComponentQuestionTypesValuesSliders | ComponentQuestionTypesSimpleReadOnly | ComponentQuestionTypesValuesNested | ComponentQuestionTypesValuesGaps | ComponentQuestionTypesUploadQuestion | ComponentQuestionTypesParticipant | ComponentQuestionTypesValuesCharacters | ComponentQuestionTypesCompetency | ComponentQuestionTypesValuesBubble | ComponentQuestionTypesSliderQuestions | ComponentQuestionTypesFeedForward1 | ComponentQuestionTypesFeedForward2 | ComponentQuestionTypesCompetency2 | ComponentQuestionTypesGravitasSliders | ComponentQuestionTypesUploadDocuments | ComponentQuestionTypesGravitasGap;

export type ComponentQuestionTypesUploadDocuments = {
   __typename?: 'ComponentQuestionTypesUploadDocuments';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
};

export type TypeFormCollection = {
   __typename?: 'TypeFormCollection';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  typeFormUrl?: Maybe<Scalars['String']>;
  submissions?: Maybe<Scalars['Long']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  sections?: Maybe<Array<Maybe<Section>>>;
  programmes?: Maybe<Array<Maybe<Programmes>>>;
  programme_types?: Maybe<Array<Maybe<ProgrammeType>>>;
};


export type TypeFormCollectionSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TypeFormCollectionProgrammesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TypeFormCollectionProgramme_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Programmes = {
   __typename?: 'Programmes';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  isCustomJourney?: Maybe<Scalars['Boolean']>;
  showTimeline?: Maybe<Scalars['Boolean']>;
  programmeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  logo?: Maybe<UploadFile>;
  sendTypeform?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<TypeFormCollection>;
  whatToExpect?: Maybe<Scalars['String']>;
  completion?: Maybe<Scalars['DateTime']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  three_60_form_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  companies?: Maybe<Array<Maybe<Company>>>;
  programme_types?: Maybe<Array<Maybe<ProgrammeType>>>;
  programme_submissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  articles?: Maybe<Array<Maybe<Article>>>;
  email_logs?: Maybe<Array<Maybe<EmailLog>>>;
  email_templates?: Maybe<Array<Maybe<EmailTemplate>>>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  sub_module_submissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
};


export type ProgrammesCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesProgramme_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesProgramme_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesArticlesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesEmail_LogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesEmail_TemplatesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammesSub_Module_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProgrammeSubmission = {
   __typename?: 'ProgrammeSubmission';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  status?: Maybe<Enum_Programmesubmission_Status>;
  progress?: Maybe<Scalars['Int']>;
  user?: Maybe<UsersPermissionsUser>;
  language?: Maybe<Language>;
  programme_type?: Maybe<ProgrammeType>;
  programmeResponses?: Maybe<Array<Maybe<ComponentSubmissionsProgrammeSubmissions>>>;
  myNotes?: Maybe<Array<Maybe<ComponentSubmissionsNotes>>>;
  submissionparticipants?: Maybe<Array<Maybe<ComponentSubmissionsParticipants>>>;
  programme_report?: Maybe<ProgrammeReport>;
  programme?: Maybe<Programmes>;
  competency_url?: Maybe<CompetencyUrl>;
  feedfoward_url?: Maybe<FeedfowardUrl>;
  selected?: Maybe<Scalars['Boolean']>;
  emailSent?: Maybe<Scalars['Boolean']>;
  isUpdatedByStakeholder?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  coach_sessions?: Maybe<Array<Maybe<CoachSession>>>;
  respondents_answers?: Maybe<Array<Maybe<RespondentsAnswers>>>;
  participants?: Maybe<Array<Maybe<Participants>>>;
  uploaded_reports?: Maybe<Array<Maybe<UploadedReports>>>;
  notes?: Maybe<Array<Maybe<Notes>>>;
};


export type ProgrammeSubmissionCoach_SessionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeSubmissionRespondents_AnswersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeSubmissionParticipantsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeSubmissionUploaded_ReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProgrammeSubmissionNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Programmesubmission_Status {
  NotStartedYet = 'not_started_yet',
  InProgress = 'in_progress',
  Completed = 'completed',
  UnderReview = 'under_review',
  Resubmission = 'resubmission'
}

export type Language = {
   __typename?: 'Language';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  image?: Maybe<UploadFile>;
  name?: Maybe<Enum_Language_Name>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  programme_submissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  companies?: Maybe<Array<Maybe<Company>>>;
};


export type LanguageUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type LanguageProgramme_SubmissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type LanguageCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Language_Name {
  English = 'English',
  French = 'French',
  German = 'German',
  Spanish = 'Spanish',
  Mandarin = 'Mandarin'
}

export type ComponentSubmissionsProgrammeSubmissions = {
   __typename?: 'ComponentSubmissionsProgrammeSubmissions';
  id: Scalars['ID'];
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswer>>>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItems>>>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItem>>>;
  stakeholderChart?: Maybe<UploadFile>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItem>>>;
  xYGraphChart?: Maybe<UploadFile>;
  saboteurImage?: Maybe<UploadFile>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristics>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<UploadFile>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGaps>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponent>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswer>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<ComponentSubmissionsSabtourVideosComponent>>>;
  saboteur?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<ComponentSubmissionsGravitasSlidersAnswers>>>;
  gravitasGap?: Maybe<Array<Maybe<ComponentSubmissionsGravitasGap>>>;
};

export type ComponentSubmissionsAnswer = {
   __typename?: 'ComponentSubmissionsAnswer';
  id: Scalars['ID'];
  questionId?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  nestedAnswers?: Maybe<Array<Maybe<ComponentSubmissionsRepeatAnswer>>>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  feedback?: Maybe<Scalars['String']>;
  outcome?: Maybe<Enum_Componentsubmissionsanswer_Outcome>;
  questionTitle?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsRepeatAnswer = {
   __typename?: 'ComponentSubmissionsRepeatAnswer';
  id: Scalars['ID'];
  answer?: Maybe<Scalars['String']>;
  questionTitle?: Maybe<Scalars['String']>;
};

export enum Enum_Componentsubmissionsanswer_Outcome {
  ResubmissionNeeded = 'Resubmission_Needed'
}

export type ComponentGravitasScaleItemsGravitasScaleItems = {
   __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems';
  id: Scalars['ID'];
  labelOne?: Maybe<Scalars['String']>;
  labelTwo?: Maybe<Scalars['String']>;
  answerOne?: Maybe<Scalars['Int']>;
  answerTwo?: Maybe<Scalars['Int']>;
  answerThree?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  labelThree?: Maybe<Scalars['String']>;
};

export type ComponentStakeholderMapItemStackholderMapItem = {
   __typename?: 'ComponentStakeholderMapItemStackholderMapItem';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  valueX?: Maybe<Scalars['Int']>;
  valueY?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
};

export type ComponentXyGraphItemXyGraphItem = {
   __typename?: 'ComponentXYGraphItemXYGraphItem';
  id: Scalars['ID'];
  valueX?: Maybe<Scalars['Int']>;
  valueY?: Maybe<Scalars['Int']>;
  image?: Maybe<UploadFile>;
  color?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsCharacteristics = {
   __typename?: 'ComponentSubmissionsCharacteristics';
  id: Scalars['ID'];
  answer?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsValuesGaps = {
   __typename?: 'ComponentSubmissionsValuesGaps';
  id: Scalars['ID'];
  gap?: Maybe<Scalars['String']>;
  commitment?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSkipProofComponent = {
   __typename?: 'ComponentSubmissionsSkipProofComponent';
  id: Scalars['ID'];
  skipProofValue?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsCompetencyAnswer = {
   __typename?: 'ComponentSubmissionsCompetencyAnswer';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  response?: Maybe<Scalars['String']>;
  isSimpleQuestion?: Maybe<Scalars['Boolean']>;
  steps?: Maybe<Scalars['Int']>;
  textboxQuestion?: Maybe<Scalars['String']>;
  headingQuestion?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSabtourVideosComponent = {
   __typename?: 'ComponentSubmissionsSabtourVideosComponent';
  id: Scalars['ID'];
  sabtourValue?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSaboteurComponent = {
   __typename?: 'ComponentSubmissionsSaboteurComponent';
  id: Scalars['ID'];
  saboteurProofValue?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsGravitasSlidersAnswers = {
   __typename?: 'ComponentSubmissionsGravitasSlidersAnswers';
  id: Scalars['ID'];
  negativeQuestion?: Maybe<Scalars['String']>;
  positiveQuestion?: Maybe<Scalars['String']>;
  colorAndRating?: Maybe<Array<Maybe<ComponentOptionColorAndRating>>>;
};

export type ComponentOptionColorAndRating = {
   __typename?: 'ComponentOptionColorAndRating';
  id: Scalars['ID'];
  color?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
};

export type ComponentSubmissionsGravitasGap = {
   __typename?: 'ComponentSubmissionsGravitasGap';
  id: Scalars['ID'];
  gap?: Maybe<Scalars['String']>;
  commitment?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsNotes = {
   __typename?: 'ComponentSubmissionsNotes';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<UploadFile>;
};

export type ComponentSubmissionsParticipants = {
   __typename?: 'ComponentSubmissionsParticipants';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ProgrammeReport = {
   __typename?: 'ProgrammeReport';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  notification?: Maybe<Notification>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  report?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ProgrammeReportReportArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Notification = {
   __typename?: 'Notification';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  path?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  report?: Maybe<Report>;
  programme_report?: Maybe<ProgrammeReport>;
  submodule_report?: Maybe<SubmoduleReport>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type NotificationUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Report = {
   __typename?: 'Report';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Report_Type>;
  submission?: Maybe<Submission>;
  report?: Maybe<UploadFile>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  notification?: Maybe<Notification>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export enum Enum_Report_Type {
  Section = 'Section',
  Module = 'Module',
  AllModules = 'All_Modules',
  MiniSection = 'Mini_Section'
}

export type Submission = {
   __typename?: 'Submission';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  language?: Maybe<Language>;
  section?: Maybe<Array<Maybe<ComponentSubmissionsSectionSubmission>>>;
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Submission_Status>;
  timeSpent?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  views?: Maybe<Scalars['Int']>;
  module?: Maybe<Module>;
  competency_url?: Maybe<CompetencyUrl>;
  participants?: Maybe<Array<Maybe<ComponentSubmissionsParticipants>>>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  reports?: Maybe<Array<Maybe<Report>>>;
  respondents_answers?: Maybe<Array<Maybe<RespondentsAnswers>>>;
  uploaded_reports?: Maybe<Array<Maybe<UploadedReports>>>;
};


export type SubmissionReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubmissionRespondents_AnswersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubmissionUploaded_ReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentSubmissionsSectionSubmission = {
   __typename?: 'ComponentSubmissionsSectionSubmission';
  id: Scalars['ID'];
  section?: Maybe<Section>;
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswer>>>;
  progress?: Maybe<Scalars['Int']>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItems>>>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItem>>>;
  stakeholderChart?: Maybe<UploadFile>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItem>>>;
  xYGraphChart?: Maybe<UploadFile>;
  saboteurImage?: Maybe<UploadFile>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristics>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<UploadFile>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGaps>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponent>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<ComponentSubmissionsSabtourVideosComponent>>>;
  saboteur?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswer>>>;
  uploadDocuments?: Maybe<Array<Maybe<ComponentSubmissionsUploadDocuments>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<ComponentSubmissionsGravitasSlidersAnswers>>>;
  gravitasGap?: Maybe<Array<Maybe<ComponentSubmissionsGravitasGap>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
};

export type ComponentSubmissionsUploadDocuments = {
   __typename?: 'ComponentSubmissionsUploadDocuments';
  id: Scalars['ID'];
  saboteurProofValue?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']>;
};

export enum Enum_Submission_Status {
  NotStarted = 'Not_Started',
  InProgress = 'In_Progress',
  UnderReview = 'Under_Review',
  Passed = 'Passed',
  Resubmission = 'Resubmission'
}

export type CompetencyUrl = {
   __typename?: 'CompetencyUrl';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  submission?: Maybe<Submission>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  coach_email?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type SubModuleSubmission = {
   __typename?: 'SubModuleSubmission';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  language?: Maybe<Language>;
  user?: Maybe<UsersPermissionsUser>;
  view?: Maybe<Scalars['Int']>;
  sub_module?: Maybe<SubModule>;
  section?: Maybe<Array<Maybe<ComponentSubmissionsSectionSubmission>>>;
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Submodulesubmission_Status>;
  timeSpent?: Maybe<Scalars['String']>;
  submissionparticipants?: Maybe<Array<Maybe<ComponentSubmissionsParticipants>>>;
  competency_participants?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyParticipants>>>;
  feedfoward_url?: Maybe<FeedfowardUrl>;
  competency_url?: Maybe<CompetencyUrl>;
  sectionTypeform?: Maybe<Scalars['Boolean']>;
  programmeTypeForm?: Maybe<Scalars['Boolean']>;
  three_60_survey_form_id?: Maybe<Scalars['String']>;
  programme?: Maybe<Programmes>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  reports?: Maybe<Array<Maybe<Report>>>;
  coach_sessions?: Maybe<Array<Maybe<CoachSession>>>;
  respondents_answers?: Maybe<Array<Maybe<RespondentsAnswers>>>;
  uploaded_reports?: Maybe<Array<Maybe<UploadedReports>>>;
  participants?: Maybe<Array<Maybe<Participants>>>;
  notes?: Maybe<Array<Maybe<Notes>>>;
};


export type SubModuleSubmissionReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubModuleSubmissionCoach_SessionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubModuleSubmissionRespondents_AnswersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubModuleSubmissionUploaded_ReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubModuleSubmissionParticipantsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubModuleSubmissionNotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Submodulesubmission_Status {
  NotStarted = 'Not_Started',
  InProgress = 'In_Progress',
  UnderReview = 'Under_Review',
  Passed = 'Passed',
  Resubmission = 'Resubmission'
}

export type ComponentSubmissionsCompetencyParticipants = {
   __typename?: 'ComponentSubmissionsCompetencyParticipants';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type FeedfowardUrl = {
   __typename?: 'FeedfowardUrl';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  coach_email?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type CoachSession = {
   __typename?: 'CoachSession';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UsersPermissionsUser>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  appointment?: Maybe<Appointments>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type Appointments = {
   __typename?: 'Appointments';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  calendarId?: Maybe<Scalars['Long']>;
  businessId?: Maybe<Scalars['Long']>;
  appointmentTitle?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  appointmentScheduleId?: Maybe<Scalars['Long']>;
  appointmentUrl?: Maybe<Scalars['String']>;
  appointmentStartDate?: Maybe<Scalars['DateTime']>;
  appointmentEndDate?: Maybe<Scalars['DateTime']>;
  coach_session?: Maybe<CoachSession>;
  status?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type RespondentsAnswers = {
   __typename?: 'RespondentsAnswers';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  programme_submission?: Maybe<ProgrammeSubmission>;
  email?: Maybe<Scalars['String']>;
  submission?: Maybe<Submission>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  user?: Maybe<UsersPermissionsUser>;
  form_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type UploadedReports = {
   __typename?: 'UploadedReports';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Uploadedreports_Type>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  submission?: Maybe<Submission>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  report?: Maybe<Array<Maybe<UploadFile>>>;
};


export type UploadedReportsReportArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Uploadedreports_Type {
  Section = 'Section',
  UserUpload = 'UserUpload'
}

export type Participants = {
   __typename?: 'Participants';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Participants_Type>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  coach_email?: Maybe<Scalars['String']>;
  survey_sent_date?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export enum Enum_Participants_Type {
  Feedforward = 'Feedforward',
  Competency = 'Competency'
}

export type Notes = {
   __typename?: 'Notes';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  sectionOrSubmissionId?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  notesId?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  programme?: Maybe<Programmes>;
  user?: Maybe<UsersPermissionsUser>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  document?: Maybe<Array<Maybe<UploadFile>>>;
};


export type NotesDocumentArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SubmoduleReport = {
   __typename?: 'SubmoduleReport';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  notification?: Maybe<Notification>;
  sectionTitle?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  report?: Maybe<Array<Maybe<UploadFile>>>;
};


export type SubmoduleReportReportArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Article = {
   __typename?: 'Article';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titleEnglish?: Maybe<Scalars['String']>;
  contentEnglish?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  datePublished?: Maybe<Scalars['Date']>;
  readTime?: Maybe<Scalars['Int']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  contentFrench?: Maybe<Scalars['String']>;
  contentGerman?: Maybe<Scalars['String']>;
  contentSpanish?: Maybe<Scalars['String']>;
  contentMandarin?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Long']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  companies?: Maybe<Array<Maybe<Company>>>;
  programme_types?: Maybe<Array<Maybe<ProgrammeType>>>;
  programmes?: Maybe<Array<Maybe<Programmes>>>;
};


export type ArticleCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ArticleProgramme_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ArticleProgrammesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type EmailLog = {
   __typename?: 'EmailLog';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  programme?: Maybe<Programmes>;
  company?: Maybe<Company>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type EmailTemplate = {
   __typename?: 'EmailTemplate';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  programme?: Maybe<Programmes>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  programme_types?: Maybe<Array<Maybe<ProgrammeType>>>;
  sections?: Maybe<Array<Maybe<Section>>>;
};


export type EmailTemplateProgramme_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type EmailTemplateSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Event = {
   __typename?: 'Event';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['Long']>;
  description?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['Long']>;
  classId?: Maybe<Scalars['Long']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  programme_types?: Maybe<Array<Maybe<ProgrammeType>>>;
  sections?: Maybe<Array<Maybe<Section>>>;
};


export type EventProgramme_TypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type EventSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SubModuleSubmissionResponse = {
   __typename?: 'SubModuleSubmissionResponse';
  success?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type Emails = {
   __typename?: 'Emails';
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EmailSent = {
   __typename?: 'EmailSent';
  success?: Maybe<Scalars['String']>;
};

export type CheckConfirmed = {
   __typename?: 'CheckConfirmed';
  success?: Maybe<Scalars['String']>;
};

export type OrderedSubmissions = {
   __typename?: 'OrderedSubmissions';
  programmeSubmission: ProgrammeSubmission;
  subModuleSubmissions: Array<SubModuleSubmission>;
};

export type UsersPermissionsMe = {
   __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
   __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
   __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UserPermissionsPasswordPayload = {
   __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type AccountChangeConnection = {
   __typename?: 'AccountChangeConnection';
  values?: Maybe<Array<Maybe<AccountChange>>>;
  groupBy?: Maybe<AccountChangeGroupBy>;
  aggregate?: Maybe<AccountChangeAggregator>;
};

export type AccountChangeGroupBy = {
   __typename?: 'AccountChangeGroupBy';
  id?: Maybe<Array<Maybe<AccountChangeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AccountChangeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AccountChangeConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<AccountChangeConnectionUser>>>;
  oldDivision?: Maybe<Array<Maybe<AccountChangeConnectionOldDivision>>>;
  oldRegion?: Maybe<Array<Maybe<AccountChangeConnectionOldRegion>>>;
  newDivision?: Maybe<Array<Maybe<AccountChangeConnectionNewDivision>>>;
  newRegion?: Maybe<Array<Maybe<AccountChangeConnectionNewRegion>>>;
  accept?: Maybe<Array<Maybe<AccountChangeConnectionAccept>>>;
  userUpdated?: Maybe<Array<Maybe<AccountChangeConnectionUserUpdated>>>;
  created_by?: Maybe<Array<Maybe<AccountChangeConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<AccountChangeConnectionUpdated_By>>>;
};

export type AccountChangeConnectionId = {
   __typename?: 'AccountChangeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionCreated_At = {
   __typename?: 'AccountChangeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionUpdated_At = {
   __typename?: 'AccountChangeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionUser = {
   __typename?: 'AccountChangeConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionOldDivision = {
   __typename?: 'AccountChangeConnectionOldDivision';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionOldRegion = {
   __typename?: 'AccountChangeConnectionOldRegion';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionNewDivision = {
   __typename?: 'AccountChangeConnectionNewDivision';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionNewRegion = {
   __typename?: 'AccountChangeConnectionNewRegion';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionAccept = {
   __typename?: 'AccountChangeConnectionAccept';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionUserUpdated = {
   __typename?: 'AccountChangeConnectionUserUpdated';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionCreated_By = {
   __typename?: 'AccountChangeConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeConnectionUpdated_By = {
   __typename?: 'AccountChangeConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AccountChangeConnection>;
};

export type AccountChangeAggregator = {
   __typename?: 'AccountChangeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateAccountChangePayload = {
   __typename?: 'createAccountChangePayload';
  accountChange?: Maybe<AccountChange>;
};

export type UpdateAccountChangePayload = {
   __typename?: 'updateAccountChangePayload';
  accountChange?: Maybe<AccountChange>;
};

export type DeleteAccountChangePayload = {
   __typename?: 'deleteAccountChangePayload';
  accountChange?: Maybe<AccountChange>;
};

export type AppointmentsConnection = {
   __typename?: 'AppointmentsConnection';
  values?: Maybe<Array<Maybe<Appointments>>>;
  groupBy?: Maybe<AppointmentsGroupBy>;
  aggregate?: Maybe<AppointmentsAggregator>;
};

export type AppointmentsGroupBy = {
   __typename?: 'AppointmentsGroupBy';
  id?: Maybe<Array<Maybe<AppointmentsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AppointmentsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AppointmentsConnectionUpdated_At>>>;
  calendarId?: Maybe<Array<Maybe<AppointmentsConnectionCalendarId>>>;
  businessId?: Maybe<Array<Maybe<AppointmentsConnectionBusinessId>>>;
  appointmentTitle?: Maybe<Array<Maybe<AppointmentsConnectionAppointmentTitle>>>;
  clientName?: Maybe<Array<Maybe<AppointmentsConnectionClientName>>>;
  clientEmail?: Maybe<Array<Maybe<AppointmentsConnectionClientEmail>>>;
  appointmentScheduleId?: Maybe<Array<Maybe<AppointmentsConnectionAppointmentScheduleId>>>;
  appointmentUrl?: Maybe<Array<Maybe<AppointmentsConnectionAppointmentUrl>>>;
  appointmentStartDate?: Maybe<Array<Maybe<AppointmentsConnectionAppointmentStartDate>>>;
  appointmentEndDate?: Maybe<Array<Maybe<AppointmentsConnectionAppointmentEndDate>>>;
  coach_session?: Maybe<Array<Maybe<AppointmentsConnectionCoach_Session>>>;
  status?: Maybe<Array<Maybe<AppointmentsConnectionStatus>>>;
  created_by?: Maybe<Array<Maybe<AppointmentsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<AppointmentsConnectionUpdated_By>>>;
};

export type AppointmentsConnectionId = {
   __typename?: 'AppointmentsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionCreated_At = {
   __typename?: 'AppointmentsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionUpdated_At = {
   __typename?: 'AppointmentsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionCalendarId = {
   __typename?: 'AppointmentsConnectionCalendarId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionBusinessId = {
   __typename?: 'AppointmentsConnectionBusinessId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionAppointmentTitle = {
   __typename?: 'AppointmentsConnectionAppointmentTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionClientName = {
   __typename?: 'AppointmentsConnectionClientName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionClientEmail = {
   __typename?: 'AppointmentsConnectionClientEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionAppointmentScheduleId = {
   __typename?: 'AppointmentsConnectionAppointmentScheduleId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionAppointmentUrl = {
   __typename?: 'AppointmentsConnectionAppointmentUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionAppointmentStartDate = {
   __typename?: 'AppointmentsConnectionAppointmentStartDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionAppointmentEndDate = {
   __typename?: 'AppointmentsConnectionAppointmentEndDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionCoach_Session = {
   __typename?: 'AppointmentsConnectionCoach_session';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionStatus = {
   __typename?: 'AppointmentsConnectionStatus';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionCreated_By = {
   __typename?: 'AppointmentsConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsConnectionUpdated_By = {
   __typename?: 'AppointmentsConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AppointmentsConnection>;
};

export type AppointmentsAggregator = {
   __typename?: 'AppointmentsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateAppointmentPayload = {
   __typename?: 'createAppointmentPayload';
  appointment?: Maybe<Appointments>;
};

export type UpdateAppointmentPayload = {
   __typename?: 'updateAppointmentPayload';
  appointment?: Maybe<Appointments>;
};

export type DeleteAppointmentPayload = {
   __typename?: 'deleteAppointmentPayload';
  appointment?: Maybe<Appointments>;
};

export type ArticleConnection = {
   __typename?: 'ArticleConnection';
  values?: Maybe<Array<Maybe<Article>>>;
  groupBy?: Maybe<ArticleGroupBy>;
  aggregate?: Maybe<ArticleAggregator>;
};

export type ArticleGroupBy = {
   __typename?: 'ArticleGroupBy';
  id?: Maybe<Array<Maybe<ArticleConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ArticleConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ArticleConnectionUpdated_At>>>;
  titleEnglish?: Maybe<Array<Maybe<ArticleConnectionTitleEnglish>>>;
  contentEnglish?: Maybe<Array<Maybe<ArticleConnectionContentEnglish>>>;
  image?: Maybe<Array<Maybe<ArticleConnectionImage>>>;
  datePublished?: Maybe<Array<Maybe<ArticleConnectionDatePublished>>>;
  readTime?: Maybe<Array<Maybe<ArticleConnectionReadTime>>>;
  titleFrench?: Maybe<Array<Maybe<ArticleConnectionTitleFrench>>>;
  titleGerman?: Maybe<Array<Maybe<ArticleConnectionTitleGerman>>>;
  titleSpanish?: Maybe<Array<Maybe<ArticleConnectionTitleSpanish>>>;
  titleMandarin?: Maybe<Array<Maybe<ArticleConnectionTitleMandarin>>>;
  contentFrench?: Maybe<Array<Maybe<ArticleConnectionContentFrench>>>;
  contentGerman?: Maybe<Array<Maybe<ArticleConnectionContentGerman>>>;
  contentSpanish?: Maybe<Array<Maybe<ArticleConnectionContentSpanish>>>;
  contentMandarin?: Maybe<Array<Maybe<ArticleConnectionContentMandarin>>>;
  link?: Maybe<Array<Maybe<ArticleConnectionLink>>>;
  position?: Maybe<Array<Maybe<ArticleConnectionPosition>>>;
  created_by?: Maybe<Array<Maybe<ArticleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ArticleConnectionUpdated_By>>>;
};

export type ArticleConnectionId = {
   __typename?: 'ArticleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionCreated_At = {
   __typename?: 'ArticleConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionUpdated_At = {
   __typename?: 'ArticleConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionTitleEnglish = {
   __typename?: 'ArticleConnectionTitleEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionContentEnglish = {
   __typename?: 'ArticleConnectionContentEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionImage = {
   __typename?: 'ArticleConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionDatePublished = {
   __typename?: 'ArticleConnectionDatePublished';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionReadTime = {
   __typename?: 'ArticleConnectionReadTime';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionTitleFrench = {
   __typename?: 'ArticleConnectionTitleFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionTitleGerman = {
   __typename?: 'ArticleConnectionTitleGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionTitleSpanish = {
   __typename?: 'ArticleConnectionTitleSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionTitleMandarin = {
   __typename?: 'ArticleConnectionTitleMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionContentFrench = {
   __typename?: 'ArticleConnectionContentFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionContentGerman = {
   __typename?: 'ArticleConnectionContentGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionContentSpanish = {
   __typename?: 'ArticleConnectionContentSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionContentMandarin = {
   __typename?: 'ArticleConnectionContentMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionLink = {
   __typename?: 'ArticleConnectionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionPosition = {
   __typename?: 'ArticleConnectionPosition';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionCreated_By = {
   __typename?: 'ArticleConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleConnectionUpdated_By = {
   __typename?: 'ArticleConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ArticleConnection>;
};

export type ArticleAggregator = {
   __typename?: 'ArticleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ArticleAggregatorSum>;
  avg?: Maybe<ArticleAggregatorAvg>;
  min?: Maybe<ArticleAggregatorMin>;
  max?: Maybe<ArticleAggregatorMax>;
};

export type ArticleAggregatorSum = {
   __typename?: 'ArticleAggregatorSum';
  readTime?: Maybe<Scalars['Float']>;
};

export type ArticleAggregatorAvg = {
   __typename?: 'ArticleAggregatorAvg';
  readTime?: Maybe<Scalars['Float']>;
};

export type ArticleAggregatorMin = {
   __typename?: 'ArticleAggregatorMin';
  readTime?: Maybe<Scalars['Float']>;
};

export type ArticleAggregatorMax = {
   __typename?: 'ArticleAggregatorMax';
  readTime?: Maybe<Scalars['Float']>;
};

export type CreateArticlePayload = {
   __typename?: 'createArticlePayload';
  article?: Maybe<Article>;
};

export type UpdateArticlePayload = {
   __typename?: 'updateArticlePayload';
  article?: Maybe<Article>;
};

export type DeleteArticlePayload = {
   __typename?: 'deleteArticlePayload';
  article?: Maybe<Article>;
};

export type AuditTrail = {
   __typename?: 'AuditTrail';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  details?: Maybe<Scalars['JSON']>;
  action?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  by?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type AuditTrailConnection = {
   __typename?: 'AuditTrailConnection';
  values?: Maybe<Array<Maybe<AuditTrail>>>;
  groupBy?: Maybe<AuditTrailGroupBy>;
  aggregate?: Maybe<AuditTrailAggregator>;
};

export type AuditTrailGroupBy = {
   __typename?: 'AuditTrailGroupBy';
  id?: Maybe<Array<Maybe<AuditTrailConnectionId>>>;
  created_at?: Maybe<Array<Maybe<AuditTrailConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<AuditTrailConnectionUpdated_At>>>;
  details?: Maybe<Array<Maybe<AuditTrailConnectionDetails>>>;
  action?: Maybe<Array<Maybe<AuditTrailConnectionAction>>>;
  section?: Maybe<Array<Maybe<AuditTrailConnectionSection>>>;
  by?: Maybe<Array<Maybe<AuditTrailConnectionBy>>>;
  created_by?: Maybe<Array<Maybe<AuditTrailConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<AuditTrailConnectionUpdated_By>>>;
};

export type AuditTrailConnectionId = {
   __typename?: 'AuditTrailConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionCreated_At = {
   __typename?: 'AuditTrailConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionUpdated_At = {
   __typename?: 'AuditTrailConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionDetails = {
   __typename?: 'AuditTrailConnectionDetails';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionAction = {
   __typename?: 'AuditTrailConnectionAction';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionSection = {
   __typename?: 'AuditTrailConnectionSection';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionBy = {
   __typename?: 'AuditTrailConnectionBy';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionCreated_By = {
   __typename?: 'AuditTrailConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailConnectionUpdated_By = {
   __typename?: 'AuditTrailConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AuditTrailConnection>;
};

export type AuditTrailAggregator = {
   __typename?: 'AuditTrailAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateAuditTrailPayload = {
   __typename?: 'createAuditTrailPayload';
  auditTrail?: Maybe<AuditTrail>;
};

export type UpdateAuditTrailPayload = {
   __typename?: 'updateAuditTrailPayload';
  auditTrail?: Maybe<AuditTrail>;
};

export type DeleteAuditTrailPayload = {
   __typename?: 'deleteAuditTrailPayload';
  auditTrail?: Maybe<AuditTrail>;
};

export type Booking = {
   __typename?: 'Booking';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUser>;
  confirmed?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['Int']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  isUpdated?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  organiser?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type BookingConnection = {
   __typename?: 'BookingConnection';
  values?: Maybe<Array<Maybe<Booking>>>;
  groupBy?: Maybe<BookingGroupBy>;
  aggregate?: Maybe<BookingAggregator>;
};

export type BookingGroupBy = {
   __typename?: 'BookingGroupBy';
  id?: Maybe<Array<Maybe<BookingConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BookingConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BookingConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<BookingConnectionTitle>>>;
  description?: Maybe<Array<Maybe<BookingConnectionDescription>>>;
  duration?: Maybe<Array<Maybe<BookingConnectionDuration>>>;
  date?: Maybe<Array<Maybe<BookingConnectionDate>>>;
  user?: Maybe<Array<Maybe<BookingConnectionUser>>>;
  confirmed?: Maybe<Array<Maybe<BookingConnectionConfirmed>>>;
  eventId?: Maybe<Array<Maybe<BookingConnectionEventId>>>;
  cancelled?: Maybe<Array<Maybe<BookingConnectionCancelled>>>;
  isUpdated?: Maybe<Array<Maybe<BookingConnectionIsUpdated>>>;
  end?: Maybe<Array<Maybe<BookingConnectionEnd>>>;
  location?: Maybe<Array<Maybe<BookingConnectionLocation>>>;
  organiser?: Maybe<Array<Maybe<BookingConnectionOrganiser>>>;
  created_by?: Maybe<Array<Maybe<BookingConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<BookingConnectionUpdated_By>>>;
};

export type BookingConnectionId = {
   __typename?: 'BookingConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionCreated_At = {
   __typename?: 'BookingConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionUpdated_At = {
   __typename?: 'BookingConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionTitle = {
   __typename?: 'BookingConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionDescription = {
   __typename?: 'BookingConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionDuration = {
   __typename?: 'BookingConnectionDuration';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionDate = {
   __typename?: 'BookingConnectionDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionUser = {
   __typename?: 'BookingConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionConfirmed = {
   __typename?: 'BookingConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionEventId = {
   __typename?: 'BookingConnectionEventId';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionCancelled = {
   __typename?: 'BookingConnectionCancelled';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionIsUpdated = {
   __typename?: 'BookingConnectionIsUpdated';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionEnd = {
   __typename?: 'BookingConnectionEnd';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionLocation = {
   __typename?: 'BookingConnectionLocation';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionOrganiser = {
   __typename?: 'BookingConnectionOrganiser';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionCreated_By = {
   __typename?: 'BookingConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionUpdated_By = {
   __typename?: 'BookingConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingAggregator = {
   __typename?: 'BookingAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<BookingAggregatorSum>;
  avg?: Maybe<BookingAggregatorAvg>;
  min?: Maybe<BookingAggregatorMin>;
  max?: Maybe<BookingAggregatorMax>;
};

export type BookingAggregatorSum = {
   __typename?: 'BookingAggregatorSum';
  duration?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
};

export type BookingAggregatorAvg = {
   __typename?: 'BookingAggregatorAvg';
  duration?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
};

export type BookingAggregatorMin = {
   __typename?: 'BookingAggregatorMin';
  duration?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
};

export type BookingAggregatorMax = {
   __typename?: 'BookingAggregatorMax';
  duration?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
};

export type CreateBookingPayload = {
   __typename?: 'createBookingPayload';
  booking?: Maybe<Booking>;
};

export type UpdateBookingPayload = {
   __typename?: 'updateBookingPayload';
  booking?: Maybe<Booking>;
};

export type DeleteBookingPayload = {
   __typename?: 'deleteBookingPayload';
  booking?: Maybe<Booking>;
};

export type CoachSessionConnection = {
   __typename?: 'CoachSessionConnection';
  values?: Maybe<Array<Maybe<CoachSession>>>;
  groupBy?: Maybe<CoachSessionGroupBy>;
  aggregate?: Maybe<CoachSessionAggregator>;
};

export type CoachSessionGroupBy = {
   __typename?: 'CoachSessionGroupBy';
  id?: Maybe<Array<Maybe<CoachSessionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CoachSessionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CoachSessionConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<CoachSessionConnectionTitle>>>;
  status?: Maybe<Array<Maybe<CoachSessionConnectionStatus>>>;
  user?: Maybe<Array<Maybe<CoachSessionConnectionUser>>>;
  programme_submission?: Maybe<Array<Maybe<CoachSessionConnectionProgramme_Submission>>>;
  sub_module_submission?: Maybe<Array<Maybe<CoachSessionConnectionSub_Module_Submission>>>;
  appointment?: Maybe<Array<Maybe<CoachSessionConnectionAppointment>>>;
  created_by?: Maybe<Array<Maybe<CoachSessionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CoachSessionConnectionUpdated_By>>>;
};

export type CoachSessionConnectionId = {
   __typename?: 'CoachSessionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionCreated_At = {
   __typename?: 'CoachSessionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionUpdated_At = {
   __typename?: 'CoachSessionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionTitle = {
   __typename?: 'CoachSessionConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionStatus = {
   __typename?: 'CoachSessionConnectionStatus';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionUser = {
   __typename?: 'CoachSessionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionProgramme_Submission = {
   __typename?: 'CoachSessionConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionSub_Module_Submission = {
   __typename?: 'CoachSessionConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionAppointment = {
   __typename?: 'CoachSessionConnectionAppointment';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionCreated_By = {
   __typename?: 'CoachSessionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionConnectionUpdated_By = {
   __typename?: 'CoachSessionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSessionConnection>;
};

export type CoachSessionAggregator = {
   __typename?: 'CoachSessionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateCoachSessionPayload = {
   __typename?: 'createCoachSessionPayload';
  coachSession?: Maybe<CoachSession>;
};

export type UpdateCoachSessionPayload = {
   __typename?: 'updateCoachSessionPayload';
  coachSession?: Maybe<CoachSession>;
};

export type DeleteCoachSessionPayload = {
   __typename?: 'deleteCoachSessionPayload';
  coachSession?: Maybe<CoachSession>;
};

export type CoachSubmittedReports = {
   __typename?: 'CoachSubmittedReports';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  notesId?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type CoachSubmittedReportsConnection = {
   __typename?: 'CoachSubmittedReportsConnection';
  values?: Maybe<Array<Maybe<CoachSubmittedReports>>>;
  groupBy?: Maybe<CoachSubmittedReportsGroupBy>;
  aggregate?: Maybe<CoachSubmittedReportsAggregator>;
};

export type CoachSubmittedReportsGroupBy = {
   __typename?: 'CoachSubmittedReportsGroupBy';
  id?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionName>>>;
  user?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionUser>>>;
  created_by?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CoachSubmittedReportsConnectionUpdated_By>>>;
};

export type CoachSubmittedReportsConnectionId = {
   __typename?: 'CoachSubmittedReportsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsConnectionCreated_At = {
   __typename?: 'CoachSubmittedReportsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsConnectionUpdated_At = {
   __typename?: 'CoachSubmittedReportsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsConnectionName = {
   __typename?: 'CoachSubmittedReportsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsConnectionUser = {
   __typename?: 'CoachSubmittedReportsConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsConnectionCreated_By = {
   __typename?: 'CoachSubmittedReportsConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsConnectionUpdated_By = {
   __typename?: 'CoachSubmittedReportsConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachSubmittedReportsConnection>;
};

export type CoachSubmittedReportsAggregator = {
   __typename?: 'CoachSubmittedReportsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateCoachSubmittedReportPayload = {
   __typename?: 'createCoachSubmittedReportPayload';
  coachSubmittedReport?: Maybe<CoachSubmittedReports>;
};

export type UpdateCoachSubmittedReportPayload = {
   __typename?: 'updateCoachSubmittedReportPayload';
  coachSubmittedReport?: Maybe<CoachSubmittedReports>;
};

export type DeleteCoachSubmittedReportPayload = {
   __typename?: 'deleteCoachSubmittedReportPayload';
  coachSubmittedReport?: Maybe<CoachSubmittedReports>;
};

export type Coach = {
   __typename?: 'Coach';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  isCoachAddedByUser?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type CoachConnection = {
   __typename?: 'CoachConnection';
  values?: Maybe<Array<Maybe<Coach>>>;
  groupBy?: Maybe<CoachGroupBy>;
  aggregate?: Maybe<CoachAggregator>;
};

export type CoachGroupBy = {
   __typename?: 'CoachGroupBy';
  id?: Maybe<Array<Maybe<CoachConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CoachConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CoachConnectionUpdated_At>>>;
  email?: Maybe<Array<Maybe<CoachConnectionEmail>>>;
  firstname?: Maybe<Array<Maybe<CoachConnectionFirstname>>>;
  lastname?: Maybe<Array<Maybe<CoachConnectionLastname>>>;
  isCoachAddedByUser?: Maybe<Array<Maybe<CoachConnectionIsCoachAddedByUser>>>;
  createdBy?: Maybe<Array<Maybe<CoachConnectionCreatedBy>>>;
  created_by?: Maybe<Array<Maybe<CoachConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CoachConnectionUpdated_By>>>;
};

export type CoachConnectionId = {
   __typename?: 'CoachConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionCreated_At = {
   __typename?: 'CoachConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionUpdated_At = {
   __typename?: 'CoachConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionEmail = {
   __typename?: 'CoachConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionFirstname = {
   __typename?: 'CoachConnectionFirstname';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionLastname = {
   __typename?: 'CoachConnectionLastname';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionIsCoachAddedByUser = {
   __typename?: 'CoachConnectionIsCoachAddedByUser';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionCreatedBy = {
   __typename?: 'CoachConnectionCreatedBy';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionCreated_By = {
   __typename?: 'CoachConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachConnectionUpdated_By = {
   __typename?: 'CoachConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CoachConnection>;
};

export type CoachAggregator = {
   __typename?: 'CoachAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateCoachPayload = {
   __typename?: 'createCoachPayload';
  coach?: Maybe<Coach>;
};

export type UpdateCoachPayload = {
   __typename?: 'updateCoachPayload';
  coach?: Maybe<Coach>;
};

export type DeleteCoachPayload = {
   __typename?: 'deleteCoachPayload';
  coach?: Maybe<Coach>;
};

export type CompanyConnection = {
   __typename?: 'CompanyConnection';
  values?: Maybe<Array<Maybe<Company>>>;
  groupBy?: Maybe<CompanyGroupBy>;
  aggregate?: Maybe<CompanyAggregator>;
};

export type CompanyGroupBy = {
   __typename?: 'CompanyGroupBy';
  id?: Maybe<Array<Maybe<CompanyConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CompanyConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CompanyConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<CompanyConnectionName>>>;
  logo?: Maybe<Array<Maybe<CompanyConnectionLogo>>>;
  certificateTemplate?: Maybe<Array<Maybe<CompanyConnectionCertificateTemplate>>>;
  welcomeScreen?: Maybe<Array<Maybe<CompanyConnectionWelcomeScreen>>>;
  languageSelection?: Maybe<Array<Maybe<CompanyConnectionLanguageSelection>>>;
  letsGetStartedScreen?: Maybe<Array<Maybe<CompanyConnectionLetsGetStartedScreen>>>;
  whatToExpect?: Maybe<Array<Maybe<CompanyConnectionWhatToExpect>>>;
  isTemplate?: Maybe<Array<Maybe<CompanyConnectionIsTemplate>>>;
  programmesTitle?: Maybe<Array<Maybe<CompanyConnectionProgrammesTitle>>>;
  programmesSubTitle?: Maybe<Array<Maybe<CompanyConnectionProgrammesSubTitle>>>;
  aboutUs?: Maybe<Array<Maybe<CompanyConnectionAboutUs>>>;
  usersConfirmDetails?: Maybe<Array<Maybe<CompanyConnectionUsersConfirmDetails>>>;
  created_by?: Maybe<Array<Maybe<CompanyConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CompanyConnectionUpdated_By>>>;
};

export type CompanyConnectionId = {
   __typename?: 'CompanyConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionCreated_At = {
   __typename?: 'CompanyConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionUpdated_At = {
   __typename?: 'CompanyConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionName = {
   __typename?: 'CompanyConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionLogo = {
   __typename?: 'CompanyConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionCertificateTemplate = {
   __typename?: 'CompanyConnectionCertificateTemplate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionWelcomeScreen = {
   __typename?: 'CompanyConnectionWelcomeScreen';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionLanguageSelection = {
   __typename?: 'CompanyConnectionLanguageSelection';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionLetsGetStartedScreen = {
   __typename?: 'CompanyConnectionLetsGetStartedScreen';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionWhatToExpect = {
   __typename?: 'CompanyConnectionWhatToExpect';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionIsTemplate = {
   __typename?: 'CompanyConnectionIsTemplate';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionProgrammesTitle = {
   __typename?: 'CompanyConnectionProgrammesTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionProgrammesSubTitle = {
   __typename?: 'CompanyConnectionProgrammesSubTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionAboutUs = {
   __typename?: 'CompanyConnectionAboutUs';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionUsersConfirmDetails = {
   __typename?: 'CompanyConnectionUsersConfirmDetails';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionCreated_By = {
   __typename?: 'CompanyConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyConnectionUpdated_By = {
   __typename?: 'CompanyConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompanyConnection>;
};

export type CompanyAggregator = {
   __typename?: 'CompanyAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateCompanyPayload = {
   __typename?: 'createCompanyPayload';
  company?: Maybe<Company>;
};

export type UpdateCompanyPayload = {
   __typename?: 'updateCompanyPayload';
  company?: Maybe<Company>;
};

export type DeleteCompanyPayload = {
   __typename?: 'deleteCompanyPayload';
  company?: Maybe<Company>;
};

export type CompetencyUrlConnection = {
   __typename?: 'CompetencyUrlConnection';
  values?: Maybe<Array<Maybe<CompetencyUrl>>>;
  groupBy?: Maybe<CompetencyUrlGroupBy>;
  aggregate?: Maybe<CompetencyUrlAggregator>;
};

export type CompetencyUrlGroupBy = {
   __typename?: 'CompetencyUrlGroupBy';
  id?: Maybe<Array<Maybe<CompetencyUrlConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CompetencyUrlConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CompetencyUrlConnectionUpdated_At>>>;
  url?: Maybe<Array<Maybe<CompetencyUrlConnectionUrl>>>;
  programme_submission?: Maybe<Array<Maybe<CompetencyUrlConnectionProgramme_Submission>>>;
  submission?: Maybe<Array<Maybe<CompetencyUrlConnectionSubmission>>>;
  sub_module_submission?: Maybe<Array<Maybe<CompetencyUrlConnectionSub_Module_Submission>>>;
  coach_email?: Maybe<Array<Maybe<CompetencyUrlConnectionCoach_Email>>>;
  created_by?: Maybe<Array<Maybe<CompetencyUrlConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CompetencyUrlConnectionUpdated_By>>>;
};

export type CompetencyUrlConnectionId = {
   __typename?: 'CompetencyUrlConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionCreated_At = {
   __typename?: 'CompetencyUrlConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionUpdated_At = {
   __typename?: 'CompetencyUrlConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionUrl = {
   __typename?: 'CompetencyUrlConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionProgramme_Submission = {
   __typename?: 'CompetencyUrlConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionSubmission = {
   __typename?: 'CompetencyUrlConnectionSubmission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionSub_Module_Submission = {
   __typename?: 'CompetencyUrlConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionCoach_Email = {
   __typename?: 'CompetencyUrlConnectionCoach_email';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionCreated_By = {
   __typename?: 'CompetencyUrlConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlConnectionUpdated_By = {
   __typename?: 'CompetencyUrlConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CompetencyUrlConnection>;
};

export type CompetencyUrlAggregator = {
   __typename?: 'CompetencyUrlAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateCompetencyUrlPayload = {
   __typename?: 'createCompetencyUrlPayload';
  competencyUrl?: Maybe<CompetencyUrl>;
};

export type UpdateCompetencyUrlPayload = {
   __typename?: 'updateCompetencyUrlPayload';
  competencyUrl?: Maybe<CompetencyUrl>;
};

export type DeleteCompetencyUrlPayload = {
   __typename?: 'deleteCompetencyUrlPayload';
  competencyUrl?: Maybe<CompetencyUrl>;
};

export type Division = {
   __typename?: 'Division';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  titleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  companies?: Maybe<Array<Maybe<Company>>>;
};


export type DivisionUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type DivisionCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type DivisionConnection = {
   __typename?: 'DivisionConnection';
  values?: Maybe<Array<Maybe<Division>>>;
  groupBy?: Maybe<DivisionGroupBy>;
  aggregate?: Maybe<DivisionAggregator>;
};

export type DivisionGroupBy = {
   __typename?: 'DivisionGroupBy';
  id?: Maybe<Array<Maybe<DivisionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DivisionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DivisionConnectionUpdated_At>>>;
  titleEnglish?: Maybe<Array<Maybe<DivisionConnectionTitleEnglish>>>;
  titleFrench?: Maybe<Array<Maybe<DivisionConnectionTitleFrench>>>;
  titleGerman?: Maybe<Array<Maybe<DivisionConnectionTitleGerman>>>;
  titleSpanish?: Maybe<Array<Maybe<DivisionConnectionTitleSpanish>>>;
  titleMandarin?: Maybe<Array<Maybe<DivisionConnectionTitleMandarin>>>;
  created_by?: Maybe<Array<Maybe<DivisionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<DivisionConnectionUpdated_By>>>;
};

export type DivisionConnectionId = {
   __typename?: 'DivisionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionCreated_At = {
   __typename?: 'DivisionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionUpdated_At = {
   __typename?: 'DivisionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionTitleEnglish = {
   __typename?: 'DivisionConnectionTitleEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionTitleFrench = {
   __typename?: 'DivisionConnectionTitleFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionTitleGerman = {
   __typename?: 'DivisionConnectionTitleGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionTitleSpanish = {
   __typename?: 'DivisionConnectionTitleSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionTitleMandarin = {
   __typename?: 'DivisionConnectionTitleMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionCreated_By = {
   __typename?: 'DivisionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionConnectionUpdated_By = {
   __typename?: 'DivisionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DivisionConnection>;
};

export type DivisionAggregator = {
   __typename?: 'DivisionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateDivisionPayload = {
   __typename?: 'createDivisionPayload';
  division?: Maybe<Division>;
};

export type UpdateDivisionPayload = {
   __typename?: 'updateDivisionPayload';
  division?: Maybe<Division>;
};

export type DeleteDivisionPayload = {
   __typename?: 'deleteDivisionPayload';
  division?: Maybe<Division>;
};

export type EmailLogConnection = {
   __typename?: 'EmailLogConnection';
  values?: Maybe<Array<Maybe<EmailLog>>>;
  groupBy?: Maybe<EmailLogGroupBy>;
  aggregate?: Maybe<EmailLogAggregator>;
};

export type EmailLogGroupBy = {
   __typename?: 'EmailLogGroupBy';
  id?: Maybe<Array<Maybe<EmailLogConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EmailLogConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EmailLogConnectionUpdated_At>>>;
  to?: Maybe<Array<Maybe<EmailLogConnectionTo>>>;
  subject?: Maybe<Array<Maybe<EmailLogConnectionSubject>>>;
  body?: Maybe<Array<Maybe<EmailLogConnectionBody>>>;
  timestamp?: Maybe<Array<Maybe<EmailLogConnectionTimestamp>>>;
  programme?: Maybe<Array<Maybe<EmailLogConnectionProgramme>>>;
  company?: Maybe<Array<Maybe<EmailLogConnectionCompany>>>;
  created_by?: Maybe<Array<Maybe<EmailLogConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<EmailLogConnectionUpdated_By>>>;
};

export type EmailLogConnectionId = {
   __typename?: 'EmailLogConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionCreated_At = {
   __typename?: 'EmailLogConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionUpdated_At = {
   __typename?: 'EmailLogConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionTo = {
   __typename?: 'EmailLogConnectionTo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionSubject = {
   __typename?: 'EmailLogConnectionSubject';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionBody = {
   __typename?: 'EmailLogConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionTimestamp = {
   __typename?: 'EmailLogConnectionTimestamp';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionProgramme = {
   __typename?: 'EmailLogConnectionProgramme';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionCompany = {
   __typename?: 'EmailLogConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionCreated_By = {
   __typename?: 'EmailLogConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogConnectionUpdated_By = {
   __typename?: 'EmailLogConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailLogConnection>;
};

export type EmailLogAggregator = {
   __typename?: 'EmailLogAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateEmailLogPayload = {
   __typename?: 'createEmailLogPayload';
  emailLog?: Maybe<EmailLog>;
};

export type UpdateEmailLogPayload = {
   __typename?: 'updateEmailLogPayload';
  emailLog?: Maybe<EmailLog>;
};

export type DeleteEmailLogPayload = {
   __typename?: 'deleteEmailLogPayload';
  emailLog?: Maybe<EmailLog>;
};

export type EmailTemplateConnection = {
   __typename?: 'EmailTemplateConnection';
  values?: Maybe<Array<Maybe<EmailTemplate>>>;
  groupBy?: Maybe<EmailTemplateGroupBy>;
  aggregate?: Maybe<EmailTemplateAggregator>;
};

export type EmailTemplateGroupBy = {
   __typename?: 'EmailTemplateGroupBy';
  id?: Maybe<Array<Maybe<EmailTemplateConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EmailTemplateConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EmailTemplateConnectionUpdated_At>>>;
  subject?: Maybe<Array<Maybe<EmailTemplateConnectionSubject>>>;
  body?: Maybe<Array<Maybe<EmailTemplateConnectionBody>>>;
  programme?: Maybe<Array<Maybe<EmailTemplateConnectionProgramme>>>;
  created_by?: Maybe<Array<Maybe<EmailTemplateConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<EmailTemplateConnectionUpdated_By>>>;
};

export type EmailTemplateConnectionId = {
   __typename?: 'EmailTemplateConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionCreated_At = {
   __typename?: 'EmailTemplateConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionUpdated_At = {
   __typename?: 'EmailTemplateConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionSubject = {
   __typename?: 'EmailTemplateConnectionSubject';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionBody = {
   __typename?: 'EmailTemplateConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionProgramme = {
   __typename?: 'EmailTemplateConnectionProgramme';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionCreated_By = {
   __typename?: 'EmailTemplateConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateConnectionUpdated_By = {
   __typename?: 'EmailTemplateConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EmailTemplateConnection>;
};

export type EmailTemplateAggregator = {
   __typename?: 'EmailTemplateAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateEmailTemplatePayload = {
   __typename?: 'createEmailTemplatePayload';
  emailTemplate?: Maybe<EmailTemplate>;
};

export type UpdateEmailTemplatePayload = {
   __typename?: 'updateEmailTemplatePayload';
  emailTemplate?: Maybe<EmailTemplate>;
};

export type DeleteEmailTemplatePayload = {
   __typename?: 'deleteEmailTemplatePayload';
  emailTemplate?: Maybe<EmailTemplate>;
};

export type EventConnection = {
   __typename?: 'EventConnection';
  values?: Maybe<Array<Maybe<Event>>>;
  groupBy?: Maybe<EventGroupBy>;
  aggregate?: Maybe<EventAggregator>;
};

export type EventGroupBy = {
   __typename?: 'EventGroupBy';
  id?: Maybe<Array<Maybe<EventConnectionId>>>;
  created_at?: Maybe<Array<Maybe<EventConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<EventConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<EventConnectionName>>>;
  link?: Maybe<Array<Maybe<EventConnectionLink>>>;
  sessionId?: Maybe<Array<Maybe<EventConnectionSessionId>>>;
  description?: Maybe<Array<Maybe<EventConnectionDescription>>>;
  serviceId?: Maybe<Array<Maybe<EventConnectionServiceId>>>;
  classId?: Maybe<Array<Maybe<EventConnectionClassId>>>;
  created_by?: Maybe<Array<Maybe<EventConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<EventConnectionUpdated_By>>>;
};

export type EventConnectionId = {
   __typename?: 'EventConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionCreated_At = {
   __typename?: 'EventConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionUpdated_At = {
   __typename?: 'EventConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionName = {
   __typename?: 'EventConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionLink = {
   __typename?: 'EventConnectionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionSessionId = {
   __typename?: 'EventConnectionSessionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionDescription = {
   __typename?: 'EventConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionServiceId = {
   __typename?: 'EventConnectionServiceId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionClassId = {
   __typename?: 'EventConnectionClassId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionCreated_By = {
   __typename?: 'EventConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EventConnection>;
};

export type EventConnectionUpdated_By = {
   __typename?: 'EventConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<EventConnection>;
};

export type EventAggregator = {
   __typename?: 'EventAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateEventPayload = {
   __typename?: 'createEventPayload';
  event?: Maybe<Event>;
};

export type UpdateEventPayload = {
   __typename?: 'updateEventPayload';
  event?: Maybe<Event>;
};

export type DeleteEventPayload = {
   __typename?: 'deleteEventPayload';
  event?: Maybe<Event>;
};

export type FeedfowardUrlConnection = {
   __typename?: 'FeedfowardUrlConnection';
  values?: Maybe<Array<Maybe<FeedfowardUrl>>>;
  groupBy?: Maybe<FeedfowardUrlGroupBy>;
  aggregate?: Maybe<FeedfowardUrlAggregator>;
};

export type FeedfowardUrlGroupBy = {
   __typename?: 'FeedfowardUrlGroupBy';
  id?: Maybe<Array<Maybe<FeedfowardUrlConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FeedfowardUrlConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FeedfowardUrlConnectionUpdated_At>>>;
  url?: Maybe<Array<Maybe<FeedfowardUrlConnectionUrl>>>;
  programme_submission?: Maybe<Array<Maybe<FeedfowardUrlConnectionProgramme_Submission>>>;
  sub_module_submission?: Maybe<Array<Maybe<FeedfowardUrlConnectionSub_Module_Submission>>>;
  coach_email?: Maybe<Array<Maybe<FeedfowardUrlConnectionCoach_Email>>>;
  created_by?: Maybe<Array<Maybe<FeedfowardUrlConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<FeedfowardUrlConnectionUpdated_By>>>;
};

export type FeedfowardUrlConnectionId = {
   __typename?: 'FeedfowardUrlConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionCreated_At = {
   __typename?: 'FeedfowardUrlConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionUpdated_At = {
   __typename?: 'FeedfowardUrlConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionUrl = {
   __typename?: 'FeedfowardUrlConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionProgramme_Submission = {
   __typename?: 'FeedfowardUrlConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionSub_Module_Submission = {
   __typename?: 'FeedfowardUrlConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionCoach_Email = {
   __typename?: 'FeedfowardUrlConnectionCoach_email';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionCreated_By = {
   __typename?: 'FeedfowardUrlConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlConnectionUpdated_By = {
   __typename?: 'FeedfowardUrlConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeedfowardUrlConnection>;
};

export type FeedfowardUrlAggregator = {
   __typename?: 'FeedfowardUrlAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateFeedfowardUrlPayload = {
   __typename?: 'createFeedfowardUrlPayload';
  feedfowardUrl?: Maybe<FeedfowardUrl>;
};

export type UpdateFeedfowardUrlPayload = {
   __typename?: 'updateFeedfowardUrlPayload';
  feedfowardUrl?: Maybe<FeedfowardUrl>;
};

export type DeleteFeedfowardUrlPayload = {
   __typename?: 'deleteFeedfowardUrlPayload';
  feedfowardUrl?: Maybe<FeedfowardUrl>;
};

export type ForwardedCard = {
   __typename?: 'ForwardedCard';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  postCard?: Maybe<PostCard>;
  p1: Scalars['String'];
  p2: Scalars['String'];
  p3: Scalars['String'];
  p1Sentence: Scalars['String'];
  p2Sentence: Scalars['String'];
  p3Sentence: Scalars['String'];
  signature: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
  generalText?: Maybe<Scalars['String']>;
  dear: Scalars['String'];
  promotionLink?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type PostCard = {
   __typename?: 'PostCard';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  frontImage?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  postCardImage?: Maybe<PostCardImage>;
  frontText?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Logo>;
  expirationTime?: Maybe<Scalars['Long']>;
  user?: Maybe<UsersPermissionsUser>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  forwardedCards?: Maybe<Array<Maybe<ForwardedCard>>>;
};


export type PostCardForwardedCardsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PostCardImage = {
   __typename?: 'PostCardImage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  image?: Maybe<UploadFile>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  postCards?: Maybe<Array<Maybe<PostCard>>>;
};


export type PostCardImagePostCardsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Logo = {
   __typename?: 'Logo';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  logo?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  postCards?: Maybe<Array<Maybe<PostCard>>>;
};


export type LogoPostCardsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ForwardedCardConnection = {
   __typename?: 'ForwardedCardConnection';
  values?: Maybe<Array<Maybe<ForwardedCard>>>;
  groupBy?: Maybe<ForwardedCardGroupBy>;
  aggregate?: Maybe<ForwardedCardAggregator>;
};

export type ForwardedCardGroupBy = {
   __typename?: 'ForwardedCardGroupBy';
  id?: Maybe<Array<Maybe<ForwardedCardConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ForwardedCardConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ForwardedCardConnectionUpdated_At>>>;
  postCard?: Maybe<Array<Maybe<ForwardedCardConnectionPostCard>>>;
  p1?: Maybe<Array<Maybe<ForwardedCardConnectionP1>>>;
  p2?: Maybe<Array<Maybe<ForwardedCardConnectionP2>>>;
  p3?: Maybe<Array<Maybe<ForwardedCardConnectionP3>>>;
  p1Sentence?: Maybe<Array<Maybe<ForwardedCardConnectionP1Sentence>>>;
  p2Sentence?: Maybe<Array<Maybe<ForwardedCardConnectionP2Sentence>>>;
  p3Sentence?: Maybe<Array<Maybe<ForwardedCardConnectionP3Sentence>>>;
  signature?: Maybe<Array<Maybe<ForwardedCardConnectionSignature>>>;
  from?: Maybe<Array<Maybe<ForwardedCardConnectionFrom>>>;
  to?: Maybe<Array<Maybe<ForwardedCardConnectionTo>>>;
  generalText?: Maybe<Array<Maybe<ForwardedCardConnectionGeneralText>>>;
  dear?: Maybe<Array<Maybe<ForwardedCardConnectionDear>>>;
  promotionLink?: Maybe<Array<Maybe<ForwardedCardConnectionPromotionLink>>>;
  created_by?: Maybe<Array<Maybe<ForwardedCardConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ForwardedCardConnectionUpdated_By>>>;
};

export type ForwardedCardConnectionId = {
   __typename?: 'ForwardedCardConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionCreated_At = {
   __typename?: 'ForwardedCardConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionUpdated_At = {
   __typename?: 'ForwardedCardConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionPostCard = {
   __typename?: 'ForwardedCardConnectionPostCard';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionP1 = {
   __typename?: 'ForwardedCardConnectionP1';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionP2 = {
   __typename?: 'ForwardedCardConnectionP2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionP3 = {
   __typename?: 'ForwardedCardConnectionP3';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionP1Sentence = {
   __typename?: 'ForwardedCardConnectionP1Sentence';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionP2Sentence = {
   __typename?: 'ForwardedCardConnectionP2Sentence';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionP3Sentence = {
   __typename?: 'ForwardedCardConnectionP3Sentence';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionSignature = {
   __typename?: 'ForwardedCardConnectionSignature';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionFrom = {
   __typename?: 'ForwardedCardConnectionFrom';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionTo = {
   __typename?: 'ForwardedCardConnectionTo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionGeneralText = {
   __typename?: 'ForwardedCardConnectionGeneralText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionDear = {
   __typename?: 'ForwardedCardConnectionDear';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionPromotionLink = {
   __typename?: 'ForwardedCardConnectionPromotionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionCreated_By = {
   __typename?: 'ForwardedCardConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardConnectionUpdated_By = {
   __typename?: 'ForwardedCardConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ForwardedCardConnection>;
};

export type ForwardedCardAggregator = {
   __typename?: 'ForwardedCardAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateForwardedCardPayload = {
   __typename?: 'createForwardedCardPayload';
  forwardedCard?: Maybe<ForwardedCard>;
};

export type UpdateForwardedCardPayload = {
   __typename?: 'updateForwardedCardPayload';
  forwardedCard?: Maybe<ForwardedCard>;
};

export type DeleteForwardedCardPayload = {
   __typename?: 'deleteForwardedCardPayload';
  forwardedCard?: Maybe<ForwardedCard>;
};

export type Invite = {
   __typename?: 'Invite';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type InviteConnection = {
   __typename?: 'InviteConnection';
  values?: Maybe<Array<Maybe<Invite>>>;
  groupBy?: Maybe<InviteGroupBy>;
  aggregate?: Maybe<InviteAggregator>;
};

export type InviteGroupBy = {
   __typename?: 'InviteGroupBy';
  id?: Maybe<Array<Maybe<InviteConnectionId>>>;
  created_at?: Maybe<Array<Maybe<InviteConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<InviteConnectionUpdated_At>>>;
  email?: Maybe<Array<Maybe<InviteConnectionEmail>>>;
  company?: Maybe<Array<Maybe<InviteConnectionCompany>>>;
  created_by?: Maybe<Array<Maybe<InviteConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<InviteConnectionUpdated_By>>>;
};

export type InviteConnectionId = {
   __typename?: 'InviteConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteConnectionCreated_At = {
   __typename?: 'InviteConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteConnectionUpdated_At = {
   __typename?: 'InviteConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteConnectionEmail = {
   __typename?: 'InviteConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteConnectionCompany = {
   __typename?: 'InviteConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteConnectionCreated_By = {
   __typename?: 'InviteConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteConnectionUpdated_By = {
   __typename?: 'InviteConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<InviteConnection>;
};

export type InviteAggregator = {
   __typename?: 'InviteAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateInvitePayload = {
   __typename?: 'createInvitePayload';
  invite?: Maybe<Invite>;
};

export type UpdateInvitePayload = {
   __typename?: 'updateInvitePayload';
  invite?: Maybe<Invite>;
};

export type DeleteInvitePayload = {
   __typename?: 'deleteInvitePayload';
  invite?: Maybe<Invite>;
};

export type LanguageConnection = {
   __typename?: 'LanguageConnection';
  values?: Maybe<Array<Maybe<Language>>>;
  groupBy?: Maybe<LanguageGroupBy>;
  aggregate?: Maybe<LanguageAggregator>;
};

export type LanguageGroupBy = {
   __typename?: 'LanguageGroupBy';
  id?: Maybe<Array<Maybe<LanguageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<LanguageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<LanguageConnectionUpdated_At>>>;
  image?: Maybe<Array<Maybe<LanguageConnectionImage>>>;
  name?: Maybe<Array<Maybe<LanguageConnectionName>>>;
  created_by?: Maybe<Array<Maybe<LanguageConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<LanguageConnectionUpdated_By>>>;
};

export type LanguageConnectionId = {
   __typename?: 'LanguageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageConnectionCreated_At = {
   __typename?: 'LanguageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageConnectionUpdated_At = {
   __typename?: 'LanguageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageConnectionImage = {
   __typename?: 'LanguageConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageConnectionName = {
   __typename?: 'LanguageConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageConnectionCreated_By = {
   __typename?: 'LanguageConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageConnectionUpdated_By = {
   __typename?: 'LanguageConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LanguageConnection>;
};

export type LanguageAggregator = {
   __typename?: 'LanguageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateLanguagePayload = {
   __typename?: 'createLanguagePayload';
  language?: Maybe<Language>;
};

export type UpdateLanguagePayload = {
   __typename?: 'updateLanguagePayload';
  language?: Maybe<Language>;
};

export type DeleteLanguagePayload = {
   __typename?: 'deleteLanguagePayload';
  language?: Maybe<Language>;
};

export type LogoConnection = {
   __typename?: 'LogoConnection';
  values?: Maybe<Array<Maybe<Logo>>>;
  groupBy?: Maybe<LogoGroupBy>;
  aggregate?: Maybe<LogoAggregator>;
};

export type LogoGroupBy = {
   __typename?: 'LogoGroupBy';
  id?: Maybe<Array<Maybe<LogoConnectionId>>>;
  created_at?: Maybe<Array<Maybe<LogoConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<LogoConnectionUpdated_At>>>;
  logo?: Maybe<Array<Maybe<LogoConnectionLogo>>>;
  name?: Maybe<Array<Maybe<LogoConnectionName>>>;
  created_by?: Maybe<Array<Maybe<LogoConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<LogoConnectionUpdated_By>>>;
};

export type LogoConnectionId = {
   __typename?: 'LogoConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoConnectionCreated_At = {
   __typename?: 'LogoConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoConnectionUpdated_At = {
   __typename?: 'LogoConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoConnectionLogo = {
   __typename?: 'LogoConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoConnectionName = {
   __typename?: 'LogoConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoConnectionCreated_By = {
   __typename?: 'LogoConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoConnectionUpdated_By = {
   __typename?: 'LogoConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LogoConnection>;
};

export type LogoAggregator = {
   __typename?: 'LogoAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateLogoPayload = {
   __typename?: 'createLogoPayload';
  logo?: Maybe<Logo>;
};

export type UpdateLogoPayload = {
   __typename?: 'updateLogoPayload';
  logo?: Maybe<Logo>;
};

export type DeleteLogoPayload = {
   __typename?: 'deleteLogoPayload';
  logo?: Maybe<Logo>;
};

export type ModalConnection = {
   __typename?: 'ModalConnection';
  values?: Maybe<Array<Maybe<Modal>>>;
  groupBy?: Maybe<ModalGroupBy>;
  aggregate?: Maybe<ModalAggregator>;
};

export type ModalGroupBy = {
   __typename?: 'ModalGroupBy';
  id?: Maybe<Array<Maybe<ModalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ModalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ModalConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<ModalConnectionTitle>>>;
  subtitle?: Maybe<Array<Maybe<ModalConnectionSubtitle>>>;
  message?: Maybe<Array<Maybe<ModalConnectionMessage>>>;
  image?: Maybe<Array<Maybe<ModalConnectionImage>>>;
  created_by?: Maybe<Array<Maybe<ModalConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ModalConnectionUpdated_By>>>;
};

export type ModalConnectionId = {
   __typename?: 'ModalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionCreated_At = {
   __typename?: 'ModalConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionUpdated_At = {
   __typename?: 'ModalConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionTitle = {
   __typename?: 'ModalConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionSubtitle = {
   __typename?: 'ModalConnectionSubtitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionMessage = {
   __typename?: 'ModalConnectionMessage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionImage = {
   __typename?: 'ModalConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionCreated_By = {
   __typename?: 'ModalConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalConnectionUpdated_By = {
   __typename?: 'ModalConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModalConnection>;
};

export type ModalAggregator = {
   __typename?: 'ModalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateModalPayload = {
   __typename?: 'createModalPayload';
  modal?: Maybe<Modal>;
};

export type UpdateModalPayload = {
   __typename?: 'updateModalPayload';
  modal?: Maybe<Modal>;
};

export type DeleteModalPayload = {
   __typename?: 'deleteModalPayload';
  modal?: Maybe<Modal>;
};

export type ModuleConnection = {
   __typename?: 'ModuleConnection';
  values?: Maybe<Array<Maybe<Module>>>;
  groupBy?: Maybe<ModuleGroupBy>;
  aggregate?: Maybe<ModuleAggregator>;
};

export type ModuleGroupBy = {
   __typename?: 'ModuleGroupBy';
  id?: Maybe<Array<Maybe<ModuleConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ModuleConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ModuleConnectionUpdated_At>>>;
  nameEnglish?: Maybe<Array<Maybe<ModuleConnectionNameEnglish>>>;
  nameFrench?: Maybe<Array<Maybe<ModuleConnectionNameFrench>>>;
  nameGerman?: Maybe<Array<Maybe<ModuleConnectionNameGerman>>>;
  nameSpanish?: Maybe<Array<Maybe<ModuleConnectionNameSpanish>>>;
  nameMandarin?: Maybe<Array<Maybe<ModuleConnectionNameMandarin>>>;
  cover?: Maybe<Array<Maybe<ModuleConnectionCover>>>;
  descriptionEnglish?: Maybe<Array<Maybe<ModuleConnectionDescriptionEnglish>>>;
  descriptionFrench?: Maybe<Array<Maybe<ModuleConnectionDescriptionFrench>>>;
  descriptionGerman?: Maybe<Array<Maybe<ModuleConnectionDescriptionGerman>>>;
  descriptionMandarin?: Maybe<Array<Maybe<ModuleConnectionDescriptionMandarin>>>;
  descriptionSpanish?: Maybe<Array<Maybe<ModuleConnectionDescriptionSpanish>>>;
  position?: Maybe<Array<Maybe<ModuleConnectionPosition>>>;
  created_by?: Maybe<Array<Maybe<ModuleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ModuleConnectionUpdated_By>>>;
};

export type ModuleConnectionId = {
   __typename?: 'ModuleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionCreated_At = {
   __typename?: 'ModuleConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionUpdated_At = {
   __typename?: 'ModuleConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionNameEnglish = {
   __typename?: 'ModuleConnectionNameEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionNameFrench = {
   __typename?: 'ModuleConnectionNameFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionNameGerman = {
   __typename?: 'ModuleConnectionNameGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionNameSpanish = {
   __typename?: 'ModuleConnectionNameSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionNameMandarin = {
   __typename?: 'ModuleConnectionNameMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionCover = {
   __typename?: 'ModuleConnectionCover';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionDescriptionEnglish = {
   __typename?: 'ModuleConnectionDescriptionEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionDescriptionFrench = {
   __typename?: 'ModuleConnectionDescriptionFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionDescriptionGerman = {
   __typename?: 'ModuleConnectionDescriptionGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionDescriptionMandarin = {
   __typename?: 'ModuleConnectionDescriptionMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionDescriptionSpanish = {
   __typename?: 'ModuleConnectionDescriptionSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionPosition = {
   __typename?: 'ModuleConnectionPosition';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionCreated_By = {
   __typename?: 'ModuleConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleConnectionUpdated_By = {
   __typename?: 'ModuleConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ModuleConnection>;
};

export type ModuleAggregator = {
   __typename?: 'ModuleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ModuleAggregatorSum>;
  avg?: Maybe<ModuleAggregatorAvg>;
  min?: Maybe<ModuleAggregatorMin>;
  max?: Maybe<ModuleAggregatorMax>;
};

export type ModuleAggregatorSum = {
   __typename?: 'ModuleAggregatorSum';
  position?: Maybe<Scalars['Float']>;
};

export type ModuleAggregatorAvg = {
   __typename?: 'ModuleAggregatorAvg';
  position?: Maybe<Scalars['Float']>;
};

export type ModuleAggregatorMin = {
   __typename?: 'ModuleAggregatorMin';
  position?: Maybe<Scalars['Float']>;
};

export type ModuleAggregatorMax = {
   __typename?: 'ModuleAggregatorMax';
  position?: Maybe<Scalars['Float']>;
};

export type CreateModulePayload = {
   __typename?: 'createModulePayload';
  module?: Maybe<Module>;
};

export type UpdateModulePayload = {
   __typename?: 'updateModulePayload';
  module?: Maybe<Module>;
};

export type DeleteModulePayload = {
   __typename?: 'deleteModulePayload';
  module?: Maybe<Module>;
};

export type NotesConnection = {
   __typename?: 'NotesConnection';
  values?: Maybe<Array<Maybe<Notes>>>;
  groupBy?: Maybe<NotesGroupBy>;
  aggregate?: Maybe<NotesAggregator>;
};

export type NotesGroupBy = {
   __typename?: 'NotesGroupBy';
  id?: Maybe<Array<Maybe<NotesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NotesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NotesConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<NotesConnectionName>>>;
  note?: Maybe<Array<Maybe<NotesConnectionNote>>>;
  sub_module_submission?: Maybe<Array<Maybe<NotesConnectionSub_Module_Submission>>>;
  sectionOrSubmissionId?: Maybe<Array<Maybe<NotesConnectionSectionOrSubmissionId>>>;
  programme_submission?: Maybe<Array<Maybe<NotesConnectionProgramme_Submission>>>;
  programme?: Maybe<Array<Maybe<NotesConnectionProgramme>>>;
  user?: Maybe<Array<Maybe<NotesConnectionUser>>>;
  created_by?: Maybe<Array<Maybe<NotesConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<NotesConnectionUpdated_By>>>;
};

export type NotesConnectionId = {
   __typename?: 'NotesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionCreated_At = {
   __typename?: 'NotesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionUpdated_At = {
   __typename?: 'NotesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionName = {
   __typename?: 'NotesConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionNote = {
   __typename?: 'NotesConnectionNote';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionSub_Module_Submission = {
   __typename?: 'NotesConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionSectionOrSubmissionId = {
   __typename?: 'NotesConnectionSectionOrSubmissionId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionProgramme_Submission = {
   __typename?: 'NotesConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionProgramme = {
   __typename?: 'NotesConnectionProgramme';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionUser = {
   __typename?: 'NotesConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionCreated_By = {
   __typename?: 'NotesConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesConnectionUpdated_By = {
   __typename?: 'NotesConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotesConnection>;
};

export type NotesAggregator = {
   __typename?: 'NotesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateNotePayload = {
   __typename?: 'createNotePayload';
  note?: Maybe<Notes>;
};

export type UpdateNotePayload = {
   __typename?: 'updateNotePayload';
  note?: Maybe<Notes>;
};

export type DeleteNotePayload = {
   __typename?: 'deleteNotePayload';
  note?: Maybe<Notes>;
};

export type NotificationConnection = {
   __typename?: 'NotificationConnection';
  values?: Maybe<Array<Maybe<Notification>>>;
  groupBy?: Maybe<NotificationGroupBy>;
  aggregate?: Maybe<NotificationAggregator>;
};

export type NotificationGroupBy = {
   __typename?: 'NotificationGroupBy';
  id?: Maybe<Array<Maybe<NotificationConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NotificationConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NotificationConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<NotificationConnectionTitle>>>;
  timeStamp?: Maybe<Array<Maybe<NotificationConnectionTimeStamp>>>;
  path?: Maybe<Array<Maybe<NotificationConnectionPath>>>;
  read?: Maybe<Array<Maybe<NotificationConnectionRead>>>;
  report?: Maybe<Array<Maybe<NotificationConnectionReport>>>;
  programme_report?: Maybe<Array<Maybe<NotificationConnectionProgramme_Report>>>;
  submodule_report?: Maybe<Array<Maybe<NotificationConnectionSubmodule_Report>>>;
  created_by?: Maybe<Array<Maybe<NotificationConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<NotificationConnectionUpdated_By>>>;
};

export type NotificationConnectionId = {
   __typename?: 'NotificationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionCreated_At = {
   __typename?: 'NotificationConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionUpdated_At = {
   __typename?: 'NotificationConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionTitle = {
   __typename?: 'NotificationConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionTimeStamp = {
   __typename?: 'NotificationConnectionTimeStamp';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionPath = {
   __typename?: 'NotificationConnectionPath';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionRead = {
   __typename?: 'NotificationConnectionRead';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionReport = {
   __typename?: 'NotificationConnectionReport';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionProgramme_Report = {
   __typename?: 'NotificationConnectionProgramme_report';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionSubmodule_Report = {
   __typename?: 'NotificationConnectionSubmodule_report';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionCreated_By = {
   __typename?: 'NotificationConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationConnectionUpdated_By = {
   __typename?: 'NotificationConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotificationConnection>;
};

export type NotificationAggregator = {
   __typename?: 'NotificationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateNotificationPayload = {
   __typename?: 'createNotificationPayload';
  notification?: Maybe<Notification>;
};

export type UpdateNotificationPayload = {
   __typename?: 'updateNotificationPayload';
  notification?: Maybe<Notification>;
};

export type DeleteNotificationPayload = {
   __typename?: 'deleteNotificationPayload';
  notification?: Maybe<Notification>;
};

export type ParticipantsConnection = {
   __typename?: 'ParticipantsConnection';
  values?: Maybe<Array<Maybe<Participants>>>;
  groupBy?: Maybe<ParticipantsGroupBy>;
  aggregate?: Maybe<ParticipantsAggregator>;
};

export type ParticipantsGroupBy = {
   __typename?: 'ParticipantsGroupBy';
  id?: Maybe<Array<Maybe<ParticipantsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ParticipantsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ParticipantsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ParticipantsConnectionName>>>;
  email?: Maybe<Array<Maybe<ParticipantsConnectionEmail>>>;
  type?: Maybe<Array<Maybe<ParticipantsConnectionType>>>;
  programme_submission?: Maybe<Array<Maybe<ParticipantsConnectionProgramme_Submission>>>;
  sub_module_submission?: Maybe<Array<Maybe<ParticipantsConnectionSub_Module_Submission>>>;
  coach_email?: Maybe<Array<Maybe<ParticipantsConnectionCoach_Email>>>;
  survey_sent_date?: Maybe<Array<Maybe<ParticipantsConnectionSurvey_Sent_Date>>>;
  created_by?: Maybe<Array<Maybe<ParticipantsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ParticipantsConnectionUpdated_By>>>;
};

export type ParticipantsConnectionId = {
   __typename?: 'ParticipantsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionCreated_At = {
   __typename?: 'ParticipantsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionUpdated_At = {
   __typename?: 'ParticipantsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionName = {
   __typename?: 'ParticipantsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionEmail = {
   __typename?: 'ParticipantsConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionType = {
   __typename?: 'ParticipantsConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionProgramme_Submission = {
   __typename?: 'ParticipantsConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionSub_Module_Submission = {
   __typename?: 'ParticipantsConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionCoach_Email = {
   __typename?: 'ParticipantsConnectionCoach_email';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionSurvey_Sent_Date = {
   __typename?: 'ParticipantsConnectionSurvey_sent_date';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionCreated_By = {
   __typename?: 'ParticipantsConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsConnectionUpdated_By = {
   __typename?: 'ParticipantsConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParticipantsConnection>;
};

export type ParticipantsAggregator = {
   __typename?: 'ParticipantsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateParticipantPayload = {
   __typename?: 'createParticipantPayload';
  participant?: Maybe<Participants>;
};

export type UpdateParticipantPayload = {
   __typename?: 'updateParticipantPayload';
  participant?: Maybe<Participants>;
};

export type DeleteParticipantPayload = {
   __typename?: 'deleteParticipantPayload';
  participant?: Maybe<Participants>;
};

export type PostCardImageConnection = {
   __typename?: 'PostCardImageConnection';
  values?: Maybe<Array<Maybe<PostCardImage>>>;
  groupBy?: Maybe<PostCardImageGroupBy>;
  aggregate?: Maybe<PostCardImageAggregator>;
};

export type PostCardImageGroupBy = {
   __typename?: 'PostCardImageGroupBy';
  id?: Maybe<Array<Maybe<PostCardImageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PostCardImageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PostCardImageConnectionUpdated_At>>>;
  image?: Maybe<Array<Maybe<PostCardImageConnectionImage>>>;
  created_by?: Maybe<Array<Maybe<PostCardImageConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<PostCardImageConnectionUpdated_By>>>;
};

export type PostCardImageConnectionId = {
   __typename?: 'PostCardImageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardImageConnection>;
};

export type PostCardImageConnectionCreated_At = {
   __typename?: 'PostCardImageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostCardImageConnection>;
};

export type PostCardImageConnectionUpdated_At = {
   __typename?: 'PostCardImageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostCardImageConnection>;
};

export type PostCardImageConnectionImage = {
   __typename?: 'PostCardImageConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardImageConnection>;
};

export type PostCardImageConnectionCreated_By = {
   __typename?: 'PostCardImageConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardImageConnection>;
};

export type PostCardImageConnectionUpdated_By = {
   __typename?: 'PostCardImageConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardImageConnection>;
};

export type PostCardImageAggregator = {
   __typename?: 'PostCardImageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreatePostCardImagePayload = {
   __typename?: 'createPostCardImagePayload';
  postCardImage?: Maybe<PostCardImage>;
};

export type UpdatePostCardImagePayload = {
   __typename?: 'updatePostCardImagePayload';
  postCardImage?: Maybe<PostCardImage>;
};

export type DeletePostCardImagePayload = {
   __typename?: 'deletePostCardImagePayload';
  postCardImage?: Maybe<PostCardImage>;
};

export type PostCardSentence = {
   __typename?: 'PostCardSentence';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  postCardSentence?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type PostCardSentenceConnection = {
   __typename?: 'PostCardSentenceConnection';
  values?: Maybe<Array<Maybe<PostCardSentence>>>;
  groupBy?: Maybe<PostCardSentenceGroupBy>;
  aggregate?: Maybe<PostCardSentenceAggregator>;
};

export type PostCardSentenceGroupBy = {
   __typename?: 'PostCardSentenceGroupBy';
  id?: Maybe<Array<Maybe<PostCardSentenceConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PostCardSentenceConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PostCardSentenceConnectionUpdated_At>>>;
  postCardSentence?: Maybe<Array<Maybe<PostCardSentenceConnectionPostCardSentence>>>;
  created_by?: Maybe<Array<Maybe<PostCardSentenceConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<PostCardSentenceConnectionUpdated_By>>>;
};

export type PostCardSentenceConnectionId = {
   __typename?: 'PostCardSentenceConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardSentenceConnection>;
};

export type PostCardSentenceConnectionCreated_At = {
   __typename?: 'PostCardSentenceConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostCardSentenceConnection>;
};

export type PostCardSentenceConnectionUpdated_At = {
   __typename?: 'PostCardSentenceConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostCardSentenceConnection>;
};

export type PostCardSentenceConnectionPostCardSentence = {
   __typename?: 'PostCardSentenceConnectionPostCardSentence';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostCardSentenceConnection>;
};

export type PostCardSentenceConnectionCreated_By = {
   __typename?: 'PostCardSentenceConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardSentenceConnection>;
};

export type PostCardSentenceConnectionUpdated_By = {
   __typename?: 'PostCardSentenceConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardSentenceConnection>;
};

export type PostCardSentenceAggregator = {
   __typename?: 'PostCardSentenceAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreatePostCardSentencePayload = {
   __typename?: 'createPostCardSentencePayload';
  postCardSentence?: Maybe<PostCardSentence>;
};

export type UpdatePostCardSentencePayload = {
   __typename?: 'updatePostCardSentencePayload';
  postCardSentence?: Maybe<PostCardSentence>;
};

export type DeletePostCardSentencePayload = {
   __typename?: 'deletePostCardSentencePayload';
  postCardSentence?: Maybe<PostCardSentence>;
};

export type PostCardConnection = {
   __typename?: 'PostCardConnection';
  values?: Maybe<Array<Maybe<PostCard>>>;
  groupBy?: Maybe<PostCardGroupBy>;
  aggregate?: Maybe<PostCardAggregator>;
};

export type PostCardGroupBy = {
   __typename?: 'PostCardGroupBy';
  id?: Maybe<Array<Maybe<PostCardConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PostCardConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PostCardConnectionUpdated_At>>>;
  frontImage?: Maybe<Array<Maybe<PostCardConnectionFrontImage>>>;
  token?: Maybe<Array<Maybe<PostCardConnectionToken>>>;
  postCardImage?: Maybe<Array<Maybe<PostCardConnectionPostCardImage>>>;
  frontText?: Maybe<Array<Maybe<PostCardConnectionFrontText>>>;
  companyLogo?: Maybe<Array<Maybe<PostCardConnectionCompanyLogo>>>;
  expirationTime?: Maybe<Array<Maybe<PostCardConnectionExpirationTime>>>;
  user?: Maybe<Array<Maybe<PostCardConnectionUser>>>;
  created_by?: Maybe<Array<Maybe<PostCardConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<PostCardConnectionUpdated_By>>>;
};

export type PostCardConnectionId = {
   __typename?: 'PostCardConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionCreated_At = {
   __typename?: 'PostCardConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionUpdated_At = {
   __typename?: 'PostCardConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionFrontImage = {
   __typename?: 'PostCardConnectionFrontImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionToken = {
   __typename?: 'PostCardConnectionToken';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionPostCardImage = {
   __typename?: 'PostCardConnectionPostCardImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionFrontText = {
   __typename?: 'PostCardConnectionFrontText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionCompanyLogo = {
   __typename?: 'PostCardConnectionCompanyLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionExpirationTime = {
   __typename?: 'PostCardConnectionExpirationTime';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionUser = {
   __typename?: 'PostCardConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionCreated_By = {
   __typename?: 'PostCardConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardConnectionUpdated_By = {
   __typename?: 'PostCardConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostCardConnection>;
};

export type PostCardAggregator = {
   __typename?: 'PostCardAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreatePostCardPayload = {
   __typename?: 'createPostCardPayload';
  postCard?: Maybe<PostCard>;
};

export type UpdatePostCardPayload = {
   __typename?: 'updatePostCardPayload';
  postCard?: Maybe<PostCard>;
};

export type DeletePostCardPayload = {
   __typename?: 'deletePostCardPayload';
  postCard?: Maybe<PostCard>;
};

export type ProgrammeReportConnection = {
   __typename?: 'ProgrammeReportConnection';
  values?: Maybe<Array<Maybe<ProgrammeReport>>>;
  groupBy?: Maybe<ProgrammeReportGroupBy>;
  aggregate?: Maybe<ProgrammeReportAggregator>;
};

export type ProgrammeReportGroupBy = {
   __typename?: 'ProgrammeReportGroupBy';
  id?: Maybe<Array<Maybe<ProgrammeReportConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProgrammeReportConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProgrammeReportConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ProgrammeReportConnectionName>>>;
  programme_submission?: Maybe<Array<Maybe<ProgrammeReportConnectionProgramme_Submission>>>;
  notification?: Maybe<Array<Maybe<ProgrammeReportConnectionNotification>>>;
  created_by?: Maybe<Array<Maybe<ProgrammeReportConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ProgrammeReportConnectionUpdated_By>>>;
};

export type ProgrammeReportConnectionId = {
   __typename?: 'ProgrammeReportConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionCreated_At = {
   __typename?: 'ProgrammeReportConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionUpdated_At = {
   __typename?: 'ProgrammeReportConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionName = {
   __typename?: 'ProgrammeReportConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionProgramme_Submission = {
   __typename?: 'ProgrammeReportConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionNotification = {
   __typename?: 'ProgrammeReportConnectionNotification';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionCreated_By = {
   __typename?: 'ProgrammeReportConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportConnectionUpdated_By = {
   __typename?: 'ProgrammeReportConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeReportConnection>;
};

export type ProgrammeReportAggregator = {
   __typename?: 'ProgrammeReportAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateProgrammeReportPayload = {
   __typename?: 'createProgrammeReportPayload';
  programmeReport?: Maybe<ProgrammeReport>;
};

export type UpdateProgrammeReportPayload = {
   __typename?: 'updateProgrammeReportPayload';
  programmeReport?: Maybe<ProgrammeReport>;
};

export type DeleteProgrammeReportPayload = {
   __typename?: 'deleteProgrammeReportPayload';
  programmeReport?: Maybe<ProgrammeReport>;
};

export type ProgrammeSubmissionConnection = {
   __typename?: 'ProgrammeSubmissionConnection';
  values?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  groupBy?: Maybe<ProgrammeSubmissionGroupBy>;
  aggregate?: Maybe<ProgrammeSubmissionAggregator>;
};

export type ProgrammeSubmissionGroupBy = {
   __typename?: 'ProgrammeSubmissionGroupBy';
  id?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionUpdated_At>>>;
  status?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionStatus>>>;
  progress?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionProgress>>>;
  user?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionUser>>>;
  language?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionLanguage>>>;
  programme_type?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionProgramme_Type>>>;
  programme_report?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionProgramme_Report>>>;
  programme?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionProgramme>>>;
  competency_url?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionCompetency_Url>>>;
  feedfoward_url?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionFeedfoward_Url>>>;
  selected?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionSelected>>>;
  emailSent?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionEmailSent>>>;
  isUpdatedByStakeholder?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionIsUpdatedByStakeholder>>>;
  created_by?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ProgrammeSubmissionConnectionUpdated_By>>>;
};

export type ProgrammeSubmissionConnectionId = {
   __typename?: 'ProgrammeSubmissionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionCreated_At = {
   __typename?: 'ProgrammeSubmissionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionUpdated_At = {
   __typename?: 'ProgrammeSubmissionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionStatus = {
   __typename?: 'ProgrammeSubmissionConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionProgress = {
   __typename?: 'ProgrammeSubmissionConnectionProgress';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionUser = {
   __typename?: 'ProgrammeSubmissionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionLanguage = {
   __typename?: 'ProgrammeSubmissionConnectionLanguage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionProgramme_Type = {
   __typename?: 'ProgrammeSubmissionConnectionProgramme_type';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionProgramme_Report = {
   __typename?: 'ProgrammeSubmissionConnectionProgramme_report';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionProgramme = {
   __typename?: 'ProgrammeSubmissionConnectionProgramme';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionCompetency_Url = {
   __typename?: 'ProgrammeSubmissionConnectionCompetency_url';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionFeedfoward_Url = {
   __typename?: 'ProgrammeSubmissionConnectionFeedfoward_url';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionSelected = {
   __typename?: 'ProgrammeSubmissionConnectionSelected';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionEmailSent = {
   __typename?: 'ProgrammeSubmissionConnectionEmailSent';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionIsUpdatedByStakeholder = {
   __typename?: 'ProgrammeSubmissionConnectionIsUpdatedByStakeholder';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionCreated_By = {
   __typename?: 'ProgrammeSubmissionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionConnectionUpdated_By = {
   __typename?: 'ProgrammeSubmissionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeSubmissionConnection>;
};

export type ProgrammeSubmissionAggregator = {
   __typename?: 'ProgrammeSubmissionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ProgrammeSubmissionAggregatorSum>;
  avg?: Maybe<ProgrammeSubmissionAggregatorAvg>;
  min?: Maybe<ProgrammeSubmissionAggregatorMin>;
  max?: Maybe<ProgrammeSubmissionAggregatorMax>;
};

export type ProgrammeSubmissionAggregatorSum = {
   __typename?: 'ProgrammeSubmissionAggregatorSum';
  progress?: Maybe<Scalars['Float']>;
};

export type ProgrammeSubmissionAggregatorAvg = {
   __typename?: 'ProgrammeSubmissionAggregatorAvg';
  progress?: Maybe<Scalars['Float']>;
};

export type ProgrammeSubmissionAggregatorMin = {
   __typename?: 'ProgrammeSubmissionAggregatorMin';
  progress?: Maybe<Scalars['Float']>;
};

export type ProgrammeSubmissionAggregatorMax = {
   __typename?: 'ProgrammeSubmissionAggregatorMax';
  progress?: Maybe<Scalars['Float']>;
};

export type CreateProgrammeSubmissionPayload = {
   __typename?: 'createProgrammeSubmissionPayload';
  programmeSubmission?: Maybe<ProgrammeSubmission>;
};

export type UpdateProgrammeSubmissionPayload = {
   __typename?: 'updateProgrammeSubmissionPayload';
  programmeSubmission?: Maybe<ProgrammeSubmission>;
};

export type DeleteProgrammeSubmissionPayload = {
   __typename?: 'deleteProgrammeSubmissionPayload';
  programmeSubmission?: Maybe<ProgrammeSubmission>;
};

export type ProgrammeTypeConnection = {
   __typename?: 'ProgrammeTypeConnection';
  values?: Maybe<Array<Maybe<ProgrammeType>>>;
  groupBy?: Maybe<ProgrammeTypeGroupBy>;
  aggregate?: Maybe<ProgrammeTypeAggregator>;
};

export type ProgrammeTypeGroupBy = {
   __typename?: 'ProgrammeTypeGroupBy';
  id?: Maybe<Array<Maybe<ProgrammeTypeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProgrammeTypeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProgrammeTypeConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<ProgrammeTypeConnectionTitle>>>;
  description?: Maybe<Array<Maybe<ProgrammeTypeConnectionDescription>>>;
  cover?: Maybe<Array<Maybe<ProgrammeTypeConnectionCover>>>;
  isCoaching?: Maybe<Array<Maybe<ProgrammeTypeConnectionIsCoaching>>>;
  showParticipants?: Maybe<Array<Maybe<ProgrammeTypeConnectionShowParticipants>>>;
  competencySurvey?: Maybe<Array<Maybe<ProgrammeTypeConnectionCompetencySurvey>>>;
  feedForwardSurvey?: Maybe<Array<Maybe<ProgrammeTypeConnectionFeedForwardSurvey>>>;
  showSession?: Maybe<Array<Maybe<ProgrammeTypeConnectionShowSession>>>;
  notes?: Maybe<Array<Maybe<ProgrammeTypeConnectionNotes>>>;
  showArticle?: Maybe<Array<Maybe<ProgrammeTypeConnectionShowArticle>>>;
  deadline?: Maybe<Array<Maybe<ProgrammeTypeConnectionDeadline>>>;
  position?: Maybe<Array<Maybe<ProgrammeTypeConnectionPosition>>>;
  modal?: Maybe<Array<Maybe<ProgrammeTypeConnectionModal>>>;
  module?: Maybe<Array<Maybe<ProgrammeTypeConnectionModule>>>;
  isSubModule?: Maybe<Array<Maybe<ProgrammeTypeConnectionIsSubModule>>>;
  isTemplate?: Maybe<Array<Maybe<ProgrammeTypeConnectionIsTemplate>>>;
  competencyEmailTitle?: Maybe<Array<Maybe<ProgrammeTypeConnectionCompetencyEmailTitle>>>;
  email_template?: Maybe<Array<Maybe<ProgrammeTypeConnectionEmail_Template>>>;
  showStatistics?: Maybe<Array<Maybe<ProgrammeTypeConnectionShowStatistics>>>;
  programmeTypeInstructions?: Maybe<Array<Maybe<ProgrammeTypeConnectionProgrammeTypeInstructions>>>;
  emailSend?: Maybe<Array<Maybe<ProgrammeTypeConnectionEmailSend>>>;
  type_form_collection?: Maybe<Array<Maybe<ProgrammeTypeConnectionType_Form_Collection>>>;
  archive?: Maybe<Array<Maybe<ProgrammeTypeConnectionArchive>>>;
  created_by?: Maybe<Array<Maybe<ProgrammeTypeConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ProgrammeTypeConnectionUpdated_By>>>;
};

export type ProgrammeTypeConnectionId = {
   __typename?: 'ProgrammeTypeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionCreated_At = {
   __typename?: 'ProgrammeTypeConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionUpdated_At = {
   __typename?: 'ProgrammeTypeConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionTitle = {
   __typename?: 'ProgrammeTypeConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionDescription = {
   __typename?: 'ProgrammeTypeConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionCover = {
   __typename?: 'ProgrammeTypeConnectionCover';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionIsCoaching = {
   __typename?: 'ProgrammeTypeConnectionIsCoaching';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionShowParticipants = {
   __typename?: 'ProgrammeTypeConnectionShowParticipants';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionCompetencySurvey = {
   __typename?: 'ProgrammeTypeConnectionCompetencySurvey';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionFeedForwardSurvey = {
   __typename?: 'ProgrammeTypeConnectionFeedForwardSurvey';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionShowSession = {
   __typename?: 'ProgrammeTypeConnectionShowSession';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionNotes = {
   __typename?: 'ProgrammeTypeConnectionNotes';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionShowArticle = {
   __typename?: 'ProgrammeTypeConnectionShowArticle';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionDeadline = {
   __typename?: 'ProgrammeTypeConnectionDeadline';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionPosition = {
   __typename?: 'ProgrammeTypeConnectionPosition';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionModal = {
   __typename?: 'ProgrammeTypeConnectionModal';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionModule = {
   __typename?: 'ProgrammeTypeConnectionModule';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionIsSubModule = {
   __typename?: 'ProgrammeTypeConnectionIsSubModule';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionIsTemplate = {
   __typename?: 'ProgrammeTypeConnectionIsTemplate';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionCompetencyEmailTitle = {
   __typename?: 'ProgrammeTypeConnectionCompetencyEmailTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionEmail_Template = {
   __typename?: 'ProgrammeTypeConnectionEmail_template';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionShowStatistics = {
   __typename?: 'ProgrammeTypeConnectionShowStatistics';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionProgrammeTypeInstructions = {
   __typename?: 'ProgrammeTypeConnectionProgrammeTypeInstructions';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionEmailSend = {
   __typename?: 'ProgrammeTypeConnectionEmailSend';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionType_Form_Collection = {
   __typename?: 'ProgrammeTypeConnectionType_form_collection';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionArchive = {
   __typename?: 'ProgrammeTypeConnectionArchive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionCreated_By = {
   __typename?: 'ProgrammeTypeConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeConnectionUpdated_By = {
   __typename?: 'ProgrammeTypeConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammeTypeConnection>;
};

export type ProgrammeTypeAggregator = {
   __typename?: 'ProgrammeTypeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ProgrammeTypeAggregatorSum>;
  avg?: Maybe<ProgrammeTypeAggregatorAvg>;
  min?: Maybe<ProgrammeTypeAggregatorMin>;
  max?: Maybe<ProgrammeTypeAggregatorMax>;
};

export type ProgrammeTypeAggregatorSum = {
   __typename?: 'ProgrammeTypeAggregatorSum';
  position?: Maybe<Scalars['Float']>;
};

export type ProgrammeTypeAggregatorAvg = {
   __typename?: 'ProgrammeTypeAggregatorAvg';
  position?: Maybe<Scalars['Float']>;
};

export type ProgrammeTypeAggregatorMin = {
   __typename?: 'ProgrammeTypeAggregatorMin';
  position?: Maybe<Scalars['Float']>;
};

export type ProgrammeTypeAggregatorMax = {
   __typename?: 'ProgrammeTypeAggregatorMax';
  position?: Maybe<Scalars['Float']>;
};

export type CreateProgrammeTypePayload = {
   __typename?: 'createProgrammeTypePayload';
  programmeType?: Maybe<ProgrammeType>;
};

export type UpdateProgrammeTypePayload = {
   __typename?: 'updateProgrammeTypePayload';
  programmeType?: Maybe<ProgrammeType>;
};

export type DeleteProgrammeTypePayload = {
   __typename?: 'deleteProgrammeTypePayload';
  programmeType?: Maybe<ProgrammeType>;
};

export type ProgrammesConnection = {
   __typename?: 'ProgrammesConnection';
  values?: Maybe<Array<Maybe<Programmes>>>;
  groupBy?: Maybe<ProgrammesGroupBy>;
  aggregate?: Maybe<ProgrammesAggregator>;
};

export type ProgrammesGroupBy = {
   __typename?: 'ProgrammesGroupBy';
  id?: Maybe<Array<Maybe<ProgrammesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProgrammesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProgrammesConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ProgrammesConnectionName>>>;
  description?: Maybe<Array<Maybe<ProgrammesConnectionDescription>>>;
  start?: Maybe<Array<Maybe<ProgrammesConnectionStart>>>;
  isCustomJourney?: Maybe<Array<Maybe<ProgrammesConnectionIsCustomJourney>>>;
  showTimeline?: Maybe<Array<Maybe<ProgrammesConnectionShowTimeline>>>;
  programmeTitle?: Maybe<Array<Maybe<ProgrammesConnectionProgrammeTitle>>>;
  position?: Maybe<Array<Maybe<ProgrammesConnectionPosition>>>;
  logo?: Maybe<Array<Maybe<ProgrammesConnectionLogo>>>;
  sendTypeform?: Maybe<Array<Maybe<ProgrammesConnectionSendTypeform>>>;
  type_form_collection?: Maybe<Array<Maybe<ProgrammesConnectionType_Form_Collection>>>;
  whatToExpect?: Maybe<Array<Maybe<ProgrammesConnectionWhatToExpect>>>;
  completion?: Maybe<Array<Maybe<ProgrammesConnectionCompletion>>>;
  isTemplate?: Maybe<Array<Maybe<ProgrammesConnectionIsTemplate>>>;
  three_60_form_id?: Maybe<Array<Maybe<ProgrammesConnectionThree_60_Form_Id>>>;
  created_by?: Maybe<Array<Maybe<ProgrammesConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ProgrammesConnectionUpdated_By>>>;
};

export type ProgrammesConnectionId = {
   __typename?: 'ProgrammesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionCreated_At = {
   __typename?: 'ProgrammesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionUpdated_At = {
   __typename?: 'ProgrammesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionName = {
   __typename?: 'ProgrammesConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionDescription = {
   __typename?: 'ProgrammesConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionStart = {
   __typename?: 'ProgrammesConnectionStart';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionIsCustomJourney = {
   __typename?: 'ProgrammesConnectionIsCustomJourney';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionShowTimeline = {
   __typename?: 'ProgrammesConnectionShowTimeline';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionProgrammeTitle = {
   __typename?: 'ProgrammesConnectionProgrammeTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionPosition = {
   __typename?: 'ProgrammesConnectionPosition';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionLogo = {
   __typename?: 'ProgrammesConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionSendTypeform = {
   __typename?: 'ProgrammesConnectionSendTypeform';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionType_Form_Collection = {
   __typename?: 'ProgrammesConnectionType_form_collection';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionWhatToExpect = {
   __typename?: 'ProgrammesConnectionWhatToExpect';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionCompletion = {
   __typename?: 'ProgrammesConnectionCompletion';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionIsTemplate = {
   __typename?: 'ProgrammesConnectionIsTemplate';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionThree_60_Form_Id = {
   __typename?: 'ProgrammesConnectionThree_60_form_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionCreated_By = {
   __typename?: 'ProgrammesConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesConnectionUpdated_By = {
   __typename?: 'ProgrammesConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProgrammesConnection>;
};

export type ProgrammesAggregator = {
   __typename?: 'ProgrammesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ProgrammesAggregatorSum>;
  avg?: Maybe<ProgrammesAggregatorAvg>;
  min?: Maybe<ProgrammesAggregatorMin>;
  max?: Maybe<ProgrammesAggregatorMax>;
};

export type ProgrammesAggregatorSum = {
   __typename?: 'ProgrammesAggregatorSum';
  position?: Maybe<Scalars['Float']>;
};

export type ProgrammesAggregatorAvg = {
   __typename?: 'ProgrammesAggregatorAvg';
  position?: Maybe<Scalars['Float']>;
};

export type ProgrammesAggregatorMin = {
   __typename?: 'ProgrammesAggregatorMin';
  position?: Maybe<Scalars['Float']>;
};

export type ProgrammesAggregatorMax = {
   __typename?: 'ProgrammesAggregatorMax';
  position?: Maybe<Scalars['Float']>;
};

export type CreateProgrammePayload = {
   __typename?: 'createProgrammePayload';
  programme?: Maybe<Programmes>;
};

export type UpdateProgrammePayload = {
   __typename?: 'updateProgrammePayload';
  programme?: Maybe<Programmes>;
};

export type DeleteProgrammePayload = {
   __typename?: 'deleteProgrammePayload';
  programme?: Maybe<Programmes>;
};

export type Region = {
   __typename?: 'Region';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  nameEnglish?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  companies?: Maybe<Array<Maybe<Company>>>;
};


export type RegionUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type RegionCompaniesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RegionConnection = {
   __typename?: 'RegionConnection';
  values?: Maybe<Array<Maybe<Region>>>;
  groupBy?: Maybe<RegionGroupBy>;
  aggregate?: Maybe<RegionAggregator>;
};

export type RegionGroupBy = {
   __typename?: 'RegionGroupBy';
  id?: Maybe<Array<Maybe<RegionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RegionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RegionConnectionUpdated_At>>>;
  nameEnglish?: Maybe<Array<Maybe<RegionConnectionNameEnglish>>>;
  nameSpanish?: Maybe<Array<Maybe<RegionConnectionNameSpanish>>>;
  nameFrench?: Maybe<Array<Maybe<RegionConnectionNameFrench>>>;
  nameGerman?: Maybe<Array<Maybe<RegionConnectionNameGerman>>>;
  nameMandarin?: Maybe<Array<Maybe<RegionConnectionNameMandarin>>>;
  created_by?: Maybe<Array<Maybe<RegionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<RegionConnectionUpdated_By>>>;
};

export type RegionConnectionId = {
   __typename?: 'RegionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionCreated_At = {
   __typename?: 'RegionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionUpdated_At = {
   __typename?: 'RegionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionNameEnglish = {
   __typename?: 'RegionConnectionNameEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionNameSpanish = {
   __typename?: 'RegionConnectionNameSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionNameFrench = {
   __typename?: 'RegionConnectionNameFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionNameGerman = {
   __typename?: 'RegionConnectionNameGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionNameMandarin = {
   __typename?: 'RegionConnectionNameMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionCreated_By = {
   __typename?: 'RegionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionConnectionUpdated_By = {
   __typename?: 'RegionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RegionConnection>;
};

export type RegionAggregator = {
   __typename?: 'RegionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRegionPayload = {
   __typename?: 'createRegionPayload';
  region?: Maybe<Region>;
};

export type UpdateRegionPayload = {
   __typename?: 'updateRegionPayload';
  region?: Maybe<Region>;
};

export type DeleteRegionPayload = {
   __typename?: 'deleteRegionPayload';
  region?: Maybe<Region>;
};

export type ReportConnection = {
   __typename?: 'ReportConnection';
  values?: Maybe<Array<Maybe<Report>>>;
  groupBy?: Maybe<ReportGroupBy>;
  aggregate?: Maybe<ReportAggregator>;
};

export type ReportGroupBy = {
   __typename?: 'ReportGroupBy';
  id?: Maybe<Array<Maybe<ReportConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ReportConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ReportConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ReportConnectionName>>>;
  type?: Maybe<Array<Maybe<ReportConnectionType>>>;
  submission?: Maybe<Array<Maybe<ReportConnectionSubmission>>>;
  report?: Maybe<Array<Maybe<ReportConnectionReport>>>;
  sectionOrModuleId?: Maybe<Array<Maybe<ReportConnectionSectionOrModuleId>>>;
  notification?: Maybe<Array<Maybe<ReportConnectionNotification>>>;
  sub_module_submission?: Maybe<Array<Maybe<ReportConnectionSub_Module_Submission>>>;
  created_by?: Maybe<Array<Maybe<ReportConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ReportConnectionUpdated_By>>>;
};

export type ReportConnectionId = {
   __typename?: 'ReportConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreated_At = {
   __typename?: 'ReportConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdated_At = {
   __typename?: 'ReportConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionName = {
   __typename?: 'ReportConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionType = {
   __typename?: 'ReportConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionSubmission = {
   __typename?: 'ReportConnectionSubmission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionReport = {
   __typename?: 'ReportConnectionReport';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionSectionOrModuleId = {
   __typename?: 'ReportConnectionSectionOrModuleId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionNotification = {
   __typename?: 'ReportConnectionNotification';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionSub_Module_Submission = {
   __typename?: 'ReportConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreated_By = {
   __typename?: 'ReportConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdated_By = {
   __typename?: 'ReportConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportAggregator = {
   __typename?: 'ReportAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateReportPayload = {
   __typename?: 'createReportPayload';
  report?: Maybe<Report>;
};

export type UpdateReportPayload = {
   __typename?: 'updateReportPayload';
  report?: Maybe<Report>;
};

export type DeleteReportPayload = {
   __typename?: 'deleteReportPayload';
  report?: Maybe<Report>;
};

export type RespondentsAnswersConnection = {
   __typename?: 'RespondentsAnswersConnection';
  values?: Maybe<Array<Maybe<RespondentsAnswers>>>;
  groupBy?: Maybe<RespondentsAnswersGroupBy>;
  aggregate?: Maybe<RespondentsAnswersAggregator>;
};

export type RespondentsAnswersGroupBy = {
   __typename?: 'RespondentsAnswersGroupBy';
  id?: Maybe<Array<Maybe<RespondentsAnswersConnectionId>>>;
  created_at?: Maybe<Array<Maybe<RespondentsAnswersConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<RespondentsAnswersConnectionUpdated_At>>>;
  programme_submission?: Maybe<Array<Maybe<RespondentsAnswersConnectionProgramme_Submission>>>;
  email?: Maybe<Array<Maybe<RespondentsAnswersConnectionEmail>>>;
  submission?: Maybe<Array<Maybe<RespondentsAnswersConnectionSubmission>>>;
  sub_module_submission?: Maybe<Array<Maybe<RespondentsAnswersConnectionSub_Module_Submission>>>;
  user?: Maybe<Array<Maybe<RespondentsAnswersConnectionUser>>>;
  form_id?: Maybe<Array<Maybe<RespondentsAnswersConnectionForm_Id>>>;
  section_id?: Maybe<Array<Maybe<RespondentsAnswersConnectionSection_Id>>>;
  created_by?: Maybe<Array<Maybe<RespondentsAnswersConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<RespondentsAnswersConnectionUpdated_By>>>;
};

export type RespondentsAnswersConnectionId = {
   __typename?: 'RespondentsAnswersConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionCreated_At = {
   __typename?: 'RespondentsAnswersConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionUpdated_At = {
   __typename?: 'RespondentsAnswersConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionProgramme_Submission = {
   __typename?: 'RespondentsAnswersConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionEmail = {
   __typename?: 'RespondentsAnswersConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionSubmission = {
   __typename?: 'RespondentsAnswersConnectionSubmission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionSub_Module_Submission = {
   __typename?: 'RespondentsAnswersConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionUser = {
   __typename?: 'RespondentsAnswersConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionForm_Id = {
   __typename?: 'RespondentsAnswersConnectionForm_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionSection_Id = {
   __typename?: 'RespondentsAnswersConnectionSection_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionCreated_By = {
   __typename?: 'RespondentsAnswersConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersConnectionUpdated_By = {
   __typename?: 'RespondentsAnswersConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<RespondentsAnswersConnection>;
};

export type RespondentsAnswersAggregator = {
   __typename?: 'RespondentsAnswersAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRespondentsAnswerPayload = {
   __typename?: 'createRespondentsAnswerPayload';
  respondentsAnswer?: Maybe<RespondentsAnswers>;
};

export type UpdateRespondentsAnswerPayload = {
   __typename?: 'updateRespondentsAnswerPayload';
  respondentsAnswer?: Maybe<RespondentsAnswers>;
};

export type DeleteRespondentsAnswerPayload = {
   __typename?: 'deleteRespondentsAnswerPayload';
  respondentsAnswer?: Maybe<RespondentsAnswers>;
};

export type SectionConnection = {
   __typename?: 'SectionConnection';
  values?: Maybe<Array<Maybe<Section>>>;
  groupBy?: Maybe<SectionGroupBy>;
  aggregate?: Maybe<SectionAggregator>;
};

export type SectionGroupBy = {
   __typename?: 'SectionGroupBy';
  id?: Maybe<Array<Maybe<SectionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SectionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SectionConnectionUpdated_At>>>;
  titleEnglish?: Maybe<Array<Maybe<SectionConnectionTitleEnglish>>>;
  subTitleEnglish?: Maybe<Array<Maybe<SectionConnectionSubTitleEnglish>>>;
  videoEnglish?: Maybe<Array<Maybe<SectionConnectionVideoEnglish>>>;
  titleFrench?: Maybe<Array<Maybe<SectionConnectionTitleFrench>>>;
  subTitleFrench?: Maybe<Array<Maybe<SectionConnectionSubTitleFrench>>>;
  videoFrench?: Maybe<Array<Maybe<SectionConnectionVideoFrench>>>;
  titleGerman?: Maybe<Array<Maybe<SectionConnectionTitleGerman>>>;
  subTitleGerman?: Maybe<Array<Maybe<SectionConnectionSubTitleGerman>>>;
  videoGerman?: Maybe<Array<Maybe<SectionConnectionVideoGerman>>>;
  titleSpanish?: Maybe<Array<Maybe<SectionConnectionTitleSpanish>>>;
  subTitleSpanish?: Maybe<Array<Maybe<SectionConnectionSubTitleSpanish>>>;
  videoSpanish?: Maybe<Array<Maybe<SectionConnectionVideoSpanish>>>;
  titleMandarin?: Maybe<Array<Maybe<SectionConnectionTitleMandarin>>>;
  subTitleMandarin?: Maybe<Array<Maybe<SectionConnectionSubTitleMandarin>>>;
  videoMandarin?: Maybe<Array<Maybe<SectionConnectionVideoMandarin>>>;
  module?: Maybe<Array<Maybe<SectionConnectionModule>>>;
  cover?: Maybe<Array<Maybe<SectionConnectionCover>>>;
  position?: Maybe<Array<Maybe<SectionConnectionPosition>>>;
  sub_module?: Maybe<Array<Maybe<SectionConnectionSub_Module>>>;
  showSession?: Maybe<Array<Maybe<SectionConnectionShowSession>>>;
  isCoaching?: Maybe<Array<Maybe<SectionConnectionIsCoaching>>>;
  showParticipants?: Maybe<Array<Maybe<SectionConnectionShowParticipants>>>;
  competencySurvey?: Maybe<Array<Maybe<SectionConnectionCompetencySurvey>>>;
  feedForwardSurvey?: Maybe<Array<Maybe<SectionConnectionFeedForwardSurvey>>>;
  isTemplate?: Maybe<Array<Maybe<SectionConnectionIsTemplate>>>;
  getStartedText?: Maybe<Array<Maybe<SectionConnectionGetStartedText>>>;
  Notes?: Maybe<Array<Maybe<SectionConnectionNotes>>>;
  sendTypeForm?: Maybe<Array<Maybe<SectionConnectionSendTypeForm>>>;
  type_form_collection?: Maybe<Array<Maybe<SectionConnectionType_Form_Collection>>>;
  email_template?: Maybe<Array<Maybe<SectionConnectionEmail_Template>>>;
  archive?: Maybe<Array<Maybe<SectionConnectionArchive>>>;
  instructionsText?: Maybe<Array<Maybe<SectionConnectionInstructionsText>>>;
  created_by?: Maybe<Array<Maybe<SectionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SectionConnectionUpdated_By>>>;
};

export type SectionConnectionId = {
   __typename?: 'SectionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionCreated_At = {
   __typename?: 'SectionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionUpdated_At = {
   __typename?: 'SectionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionTitleEnglish = {
   __typename?: 'SectionConnectionTitleEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSubTitleEnglish = {
   __typename?: 'SectionConnectionSubTitleEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionVideoEnglish = {
   __typename?: 'SectionConnectionVideoEnglish';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionTitleFrench = {
   __typename?: 'SectionConnectionTitleFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSubTitleFrench = {
   __typename?: 'SectionConnectionSubTitleFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionVideoFrench = {
   __typename?: 'SectionConnectionVideoFrench';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionTitleGerman = {
   __typename?: 'SectionConnectionTitleGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSubTitleGerman = {
   __typename?: 'SectionConnectionSubTitleGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionVideoGerman = {
   __typename?: 'SectionConnectionVideoGerman';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionTitleSpanish = {
   __typename?: 'SectionConnectionTitleSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSubTitleSpanish = {
   __typename?: 'SectionConnectionSubTitleSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionVideoSpanish = {
   __typename?: 'SectionConnectionVideoSpanish';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionTitleMandarin = {
   __typename?: 'SectionConnectionTitleMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSubTitleMandarin = {
   __typename?: 'SectionConnectionSubTitleMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionVideoMandarin = {
   __typename?: 'SectionConnectionVideoMandarin';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionModule = {
   __typename?: 'SectionConnectionModule';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionCover = {
   __typename?: 'SectionConnectionCover';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionPosition = {
   __typename?: 'SectionConnectionPosition';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSub_Module = {
   __typename?: 'SectionConnectionSub_module';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionShowSession = {
   __typename?: 'SectionConnectionShowSession';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionIsCoaching = {
   __typename?: 'SectionConnectionIsCoaching';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionShowParticipants = {
   __typename?: 'SectionConnectionShowParticipants';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionCompetencySurvey = {
   __typename?: 'SectionConnectionCompetencySurvey';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionFeedForwardSurvey = {
   __typename?: 'SectionConnectionFeedForwardSurvey';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionIsTemplate = {
   __typename?: 'SectionConnectionIsTemplate';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionGetStartedText = {
   __typename?: 'SectionConnectionGetStartedText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionNotes = {
   __typename?: 'SectionConnectionNotes';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionSendTypeForm = {
   __typename?: 'SectionConnectionSendTypeForm';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionType_Form_Collection = {
   __typename?: 'SectionConnectionType_form_collection';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionEmail_Template = {
   __typename?: 'SectionConnectionEmail_template';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionArchive = {
   __typename?: 'SectionConnectionArchive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionInstructionsText = {
   __typename?: 'SectionConnectionInstructionsText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionCreated_By = {
   __typename?: 'SectionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionUpdated_By = {
   __typename?: 'SectionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionAggregator = {
   __typename?: 'SectionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<SectionAggregatorSum>;
  avg?: Maybe<SectionAggregatorAvg>;
  min?: Maybe<SectionAggregatorMin>;
  max?: Maybe<SectionAggregatorMax>;
};

export type SectionAggregatorSum = {
   __typename?: 'SectionAggregatorSum';
  position?: Maybe<Scalars['Float']>;
};

export type SectionAggregatorAvg = {
   __typename?: 'SectionAggregatorAvg';
  position?: Maybe<Scalars['Float']>;
};

export type SectionAggregatorMin = {
   __typename?: 'SectionAggregatorMin';
  position?: Maybe<Scalars['Float']>;
};

export type SectionAggregatorMax = {
   __typename?: 'SectionAggregatorMax';
  position?: Maybe<Scalars['Float']>;
};

export type CreateSectionPayload = {
   __typename?: 'createSectionPayload';
  section?: Maybe<Section>;
};

export type UpdateSectionPayload = {
   __typename?: 'updateSectionPayload';
  section?: Maybe<Section>;
};

export type DeleteSectionPayload = {
   __typename?: 'deleteSectionPayload';
  section?: Maybe<Section>;
};

export type SubModuleSubmissionConnection = {
   __typename?: 'SubModuleSubmissionConnection';
  values?: Maybe<Array<Maybe<SubModuleSubmission>>>;
  groupBy?: Maybe<SubModuleSubmissionGroupBy>;
  aggregate?: Maybe<SubModuleSubmissionAggregator>;
};

export type SubModuleSubmissionGroupBy = {
   __typename?: 'SubModuleSubmissionGroupBy';
  id?: Maybe<Array<Maybe<SubModuleSubmissionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubModuleSubmissionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubModuleSubmissionConnectionUpdated_At>>>;
  language?: Maybe<Array<Maybe<SubModuleSubmissionConnectionLanguage>>>;
  user?: Maybe<Array<Maybe<SubModuleSubmissionConnectionUser>>>;
  view?: Maybe<Array<Maybe<SubModuleSubmissionConnectionView>>>;
  sub_module?: Maybe<Array<Maybe<SubModuleSubmissionConnectionSub_Module>>>;
  progress?: Maybe<Array<Maybe<SubModuleSubmissionConnectionProgress>>>;
  status?: Maybe<Array<Maybe<SubModuleSubmissionConnectionStatus>>>;
  timeSpent?: Maybe<Array<Maybe<SubModuleSubmissionConnectionTimeSpent>>>;
  feedfoward_url?: Maybe<Array<Maybe<SubModuleSubmissionConnectionFeedfoward_Url>>>;
  competency_url?: Maybe<Array<Maybe<SubModuleSubmissionConnectionCompetency_Url>>>;
  sectionTypeform?: Maybe<Array<Maybe<SubModuleSubmissionConnectionSectionTypeform>>>;
  programmeTypeForm?: Maybe<Array<Maybe<SubModuleSubmissionConnectionProgrammeTypeForm>>>;
  three_60_survey_form_id?: Maybe<Array<Maybe<SubModuleSubmissionConnectionThree_60_Survey_Form_Id>>>;
  programme?: Maybe<Array<Maybe<SubModuleSubmissionConnectionProgramme>>>;
  created_by?: Maybe<Array<Maybe<SubModuleSubmissionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SubModuleSubmissionConnectionUpdated_By>>>;
};

export type SubModuleSubmissionConnectionId = {
   __typename?: 'SubModuleSubmissionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionCreated_At = {
   __typename?: 'SubModuleSubmissionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionUpdated_At = {
   __typename?: 'SubModuleSubmissionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionLanguage = {
   __typename?: 'SubModuleSubmissionConnectionLanguage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionUser = {
   __typename?: 'SubModuleSubmissionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionView = {
   __typename?: 'SubModuleSubmissionConnectionView';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionSub_Module = {
   __typename?: 'SubModuleSubmissionConnectionSub_module';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionProgress = {
   __typename?: 'SubModuleSubmissionConnectionProgress';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionStatus = {
   __typename?: 'SubModuleSubmissionConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionTimeSpent = {
   __typename?: 'SubModuleSubmissionConnectionTimeSpent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionFeedfoward_Url = {
   __typename?: 'SubModuleSubmissionConnectionFeedfoward_url';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionCompetency_Url = {
   __typename?: 'SubModuleSubmissionConnectionCompetency_url';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionSectionTypeform = {
   __typename?: 'SubModuleSubmissionConnectionSectionTypeform';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionProgrammeTypeForm = {
   __typename?: 'SubModuleSubmissionConnectionProgrammeTypeForm';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionThree_60_Survey_Form_Id = {
   __typename?: 'SubModuleSubmissionConnectionThree_60_survey_form_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionProgramme = {
   __typename?: 'SubModuleSubmissionConnectionProgramme';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionCreated_By = {
   __typename?: 'SubModuleSubmissionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionConnectionUpdated_By = {
   __typename?: 'SubModuleSubmissionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleSubmissionConnection>;
};

export type SubModuleSubmissionAggregator = {
   __typename?: 'SubModuleSubmissionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<SubModuleSubmissionAggregatorSum>;
  avg?: Maybe<SubModuleSubmissionAggregatorAvg>;
  min?: Maybe<SubModuleSubmissionAggregatorMin>;
  max?: Maybe<SubModuleSubmissionAggregatorMax>;
};

export type SubModuleSubmissionAggregatorSum = {
   __typename?: 'SubModuleSubmissionAggregatorSum';
  view?: Maybe<Scalars['Float']>;
  progress?: Maybe<Scalars['Float']>;
};

export type SubModuleSubmissionAggregatorAvg = {
   __typename?: 'SubModuleSubmissionAggregatorAvg';
  view?: Maybe<Scalars['Float']>;
  progress?: Maybe<Scalars['Float']>;
};

export type SubModuleSubmissionAggregatorMin = {
   __typename?: 'SubModuleSubmissionAggregatorMin';
  view?: Maybe<Scalars['Float']>;
  progress?: Maybe<Scalars['Float']>;
};

export type SubModuleSubmissionAggregatorMax = {
   __typename?: 'SubModuleSubmissionAggregatorMax';
  view?: Maybe<Scalars['Float']>;
  progress?: Maybe<Scalars['Float']>;
};

export type CreateSubModuleSubmissionPayload = {
   __typename?: 'createSubModuleSubmissionPayload';
  subModuleSubmission?: Maybe<SubModuleSubmission>;
};

export type UpdateSubModuleSubmissionPayload = {
   __typename?: 'updateSubModuleSubmissionPayload';
  subModuleSubmission?: Maybe<SubModuleSubmission>;
};

export type DeleteSubModuleSubmissionPayload = {
   __typename?: 'deleteSubModuleSubmissionPayload';
  subModuleSubmission?: Maybe<SubModuleSubmission>;
};

export type SubModuleConnection = {
   __typename?: 'SubModuleConnection';
  values?: Maybe<Array<Maybe<SubModule>>>;
  groupBy?: Maybe<SubModuleGroupBy>;
  aggregate?: Maybe<SubModuleAggregator>;
};

export type SubModuleGroupBy = {
   __typename?: 'SubModuleGroupBy';
  id?: Maybe<Array<Maybe<SubModuleConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubModuleConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubModuleConnectionUpdated_At>>>;
  nameEnglish?: Maybe<Array<Maybe<SubModuleConnectionNameEnglish>>>;
  nameFrench?: Maybe<Array<Maybe<SubModuleConnectionNameFrench>>>;
  nameGerman?: Maybe<Array<Maybe<SubModuleConnectionNameGerman>>>;
  nameSpanish?: Maybe<Array<Maybe<SubModuleConnectionNameSpanish>>>;
  nameMandarin?: Maybe<Array<Maybe<SubModuleConnectionNameMandarin>>>;
  cover?: Maybe<Array<Maybe<SubModuleConnectionCover>>>;
  descriptionEnglish?: Maybe<Array<Maybe<SubModuleConnectionDescriptionEnglish>>>;
  descriptionFrench?: Maybe<Array<Maybe<SubModuleConnectionDescriptionFrench>>>;
  descriptionGerman?: Maybe<Array<Maybe<SubModuleConnectionDescriptionGerman>>>;
  descriptionMandarin?: Maybe<Array<Maybe<SubModuleConnectionDescriptionMandarin>>>;
  descriptionSpanish?: Maybe<Array<Maybe<SubModuleConnectionDescriptionSpanish>>>;
  position?: Maybe<Array<Maybe<SubModuleConnectionPosition>>>;
  programme_type?: Maybe<Array<Maybe<SubModuleConnectionProgramme_Type>>>;
  created_by?: Maybe<Array<Maybe<SubModuleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SubModuleConnectionUpdated_By>>>;
};

export type SubModuleConnectionId = {
   __typename?: 'SubModuleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionCreated_At = {
   __typename?: 'SubModuleConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionUpdated_At = {
   __typename?: 'SubModuleConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionNameEnglish = {
   __typename?: 'SubModuleConnectionNameEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionNameFrench = {
   __typename?: 'SubModuleConnectionNameFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionNameGerman = {
   __typename?: 'SubModuleConnectionNameGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionNameSpanish = {
   __typename?: 'SubModuleConnectionNameSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionNameMandarin = {
   __typename?: 'SubModuleConnectionNameMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionCover = {
   __typename?: 'SubModuleConnectionCover';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionDescriptionEnglish = {
   __typename?: 'SubModuleConnectionDescriptionEnglish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionDescriptionFrench = {
   __typename?: 'SubModuleConnectionDescriptionFrench';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionDescriptionGerman = {
   __typename?: 'SubModuleConnectionDescriptionGerman';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionDescriptionMandarin = {
   __typename?: 'SubModuleConnectionDescriptionMandarin';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionDescriptionSpanish = {
   __typename?: 'SubModuleConnectionDescriptionSpanish';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionPosition = {
   __typename?: 'SubModuleConnectionPosition';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionProgramme_Type = {
   __typename?: 'SubModuleConnectionProgramme_type';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionCreated_By = {
   __typename?: 'SubModuleConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleConnectionUpdated_By = {
   __typename?: 'SubModuleConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubModuleConnection>;
};

export type SubModuleAggregator = {
   __typename?: 'SubModuleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<SubModuleAggregatorSum>;
  avg?: Maybe<SubModuleAggregatorAvg>;
  min?: Maybe<SubModuleAggregatorMin>;
  max?: Maybe<SubModuleAggregatorMax>;
};

export type SubModuleAggregatorSum = {
   __typename?: 'SubModuleAggregatorSum';
  position?: Maybe<Scalars['Float']>;
};

export type SubModuleAggregatorAvg = {
   __typename?: 'SubModuleAggregatorAvg';
  position?: Maybe<Scalars['Float']>;
};

export type SubModuleAggregatorMin = {
   __typename?: 'SubModuleAggregatorMin';
  position?: Maybe<Scalars['Float']>;
};

export type SubModuleAggregatorMax = {
   __typename?: 'SubModuleAggregatorMax';
  position?: Maybe<Scalars['Float']>;
};

export type CreateSubModulePayload = {
   __typename?: 'createSubModulePayload';
  subModule?: Maybe<SubModule>;
};

export type UpdateSubModulePayload = {
   __typename?: 'updateSubModulePayload';
  subModule?: Maybe<SubModule>;
};

export type DeleteSubModulePayload = {
   __typename?: 'deleteSubModulePayload';
  subModule?: Maybe<SubModule>;
};

export type SubmissionConnection = {
   __typename?: 'SubmissionConnection';
  values?: Maybe<Array<Maybe<Submission>>>;
  groupBy?: Maybe<SubmissionGroupBy>;
  aggregate?: Maybe<SubmissionAggregator>;
};

export type SubmissionGroupBy = {
   __typename?: 'SubmissionGroupBy';
  id?: Maybe<Array<Maybe<SubmissionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubmissionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubmissionConnectionUpdated_At>>>;
  language?: Maybe<Array<Maybe<SubmissionConnectionLanguage>>>;
  progress?: Maybe<Array<Maybe<SubmissionConnectionProgress>>>;
  status?: Maybe<Array<Maybe<SubmissionConnectionStatus>>>;
  timeSpent?: Maybe<Array<Maybe<SubmissionConnectionTimeSpent>>>;
  user?: Maybe<Array<Maybe<SubmissionConnectionUser>>>;
  views?: Maybe<Array<Maybe<SubmissionConnectionViews>>>;
  module?: Maybe<Array<Maybe<SubmissionConnectionModule>>>;
  competency_url?: Maybe<Array<Maybe<SubmissionConnectionCompetency_Url>>>;
  created_by?: Maybe<Array<Maybe<SubmissionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SubmissionConnectionUpdated_By>>>;
};

export type SubmissionConnectionId = {
   __typename?: 'SubmissionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionCreated_At = {
   __typename?: 'SubmissionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionUpdated_At = {
   __typename?: 'SubmissionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionLanguage = {
   __typename?: 'SubmissionConnectionLanguage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionProgress = {
   __typename?: 'SubmissionConnectionProgress';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionStatus = {
   __typename?: 'SubmissionConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionTimeSpent = {
   __typename?: 'SubmissionConnectionTimeSpent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionUser = {
   __typename?: 'SubmissionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionViews = {
   __typename?: 'SubmissionConnectionViews';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionModule = {
   __typename?: 'SubmissionConnectionModule';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionCompetency_Url = {
   __typename?: 'SubmissionConnectionCompetency_url';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionCreated_By = {
   __typename?: 'SubmissionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionConnectionUpdated_By = {
   __typename?: 'SubmissionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmissionConnection>;
};

export type SubmissionAggregator = {
   __typename?: 'SubmissionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<SubmissionAggregatorSum>;
  avg?: Maybe<SubmissionAggregatorAvg>;
  min?: Maybe<SubmissionAggregatorMin>;
  max?: Maybe<SubmissionAggregatorMax>;
};

export type SubmissionAggregatorSum = {
   __typename?: 'SubmissionAggregatorSum';
  progress?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

export type SubmissionAggregatorAvg = {
   __typename?: 'SubmissionAggregatorAvg';
  progress?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

export type SubmissionAggregatorMin = {
   __typename?: 'SubmissionAggregatorMin';
  progress?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

export type SubmissionAggregatorMax = {
   __typename?: 'SubmissionAggregatorMax';
  progress?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

export type CreateSubmissionPayload = {
   __typename?: 'createSubmissionPayload';
  submission?: Maybe<Submission>;
};

export type UpdateSubmissionPayload = {
   __typename?: 'updateSubmissionPayload';
  submission?: Maybe<Submission>;
};

export type DeleteSubmissionPayload = {
   __typename?: 'deleteSubmissionPayload';
  submission?: Maybe<Submission>;
};

export type SubmoduleReportConnection = {
   __typename?: 'SubmoduleReportConnection';
  values?: Maybe<Array<Maybe<SubmoduleReport>>>;
  groupBy?: Maybe<SubmoduleReportGroupBy>;
  aggregate?: Maybe<SubmoduleReportAggregator>;
};

export type SubmoduleReportGroupBy = {
   __typename?: 'SubmoduleReportGroupBy';
  id?: Maybe<Array<Maybe<SubmoduleReportConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubmoduleReportConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubmoduleReportConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<SubmoduleReportConnectionName>>>;
  sub_module_submission?: Maybe<Array<Maybe<SubmoduleReportConnectionSub_Module_Submission>>>;
  notification?: Maybe<Array<Maybe<SubmoduleReportConnectionNotification>>>;
  sectionTitle?: Maybe<Array<Maybe<SubmoduleReportConnectionSectionTitle>>>;
  user?: Maybe<Array<Maybe<SubmoduleReportConnectionUser>>>;
  created_by?: Maybe<Array<Maybe<SubmoduleReportConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SubmoduleReportConnectionUpdated_By>>>;
};

export type SubmoduleReportConnectionId = {
   __typename?: 'SubmoduleReportConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionCreated_At = {
   __typename?: 'SubmoduleReportConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionUpdated_At = {
   __typename?: 'SubmoduleReportConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionName = {
   __typename?: 'SubmoduleReportConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionSub_Module_Submission = {
   __typename?: 'SubmoduleReportConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionNotification = {
   __typename?: 'SubmoduleReportConnectionNotification';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionSectionTitle = {
   __typename?: 'SubmoduleReportConnectionSectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionUser = {
   __typename?: 'SubmoduleReportConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionCreated_By = {
   __typename?: 'SubmoduleReportConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportConnectionUpdated_By = {
   __typename?: 'SubmoduleReportConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubmoduleReportConnection>;
};

export type SubmoduleReportAggregator = {
   __typename?: 'SubmoduleReportAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateSubmoduleReportPayload = {
   __typename?: 'createSubmoduleReportPayload';
  submoduleReport?: Maybe<SubmoduleReport>;
};

export type UpdateSubmoduleReportPayload = {
   __typename?: 'updateSubmoduleReportPayload';
  submoduleReport?: Maybe<SubmoduleReport>;
};

export type DeleteSubmoduleReportPayload = {
   __typename?: 'deleteSubmoduleReportPayload';
  submoduleReport?: Maybe<SubmoduleReport>;
};

export type SurveyReports = {
   __typename?: 'SurveyReports';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  report?: Maybe<UploadFile>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type SurveyReportsConnection = {
   __typename?: 'SurveyReportsConnection';
  values?: Maybe<Array<Maybe<SurveyReports>>>;
  groupBy?: Maybe<SurveyReportsGroupBy>;
  aggregate?: Maybe<SurveyReportsAggregator>;
};

export type SurveyReportsGroupBy = {
   __typename?: 'SurveyReportsGroupBy';
  id?: Maybe<Array<Maybe<SurveyReportsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SurveyReportsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SurveyReportsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<SurveyReportsConnectionName>>>;
  report?: Maybe<Array<Maybe<SurveyReportsConnectionReport>>>;
  created_by?: Maybe<Array<Maybe<SurveyReportsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SurveyReportsConnectionUpdated_By>>>;
};

export type SurveyReportsConnectionId = {
   __typename?: 'SurveyReportsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsConnectionCreated_At = {
   __typename?: 'SurveyReportsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsConnectionUpdated_At = {
   __typename?: 'SurveyReportsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsConnectionName = {
   __typename?: 'SurveyReportsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsConnectionReport = {
   __typename?: 'SurveyReportsConnectionReport';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsConnectionCreated_By = {
   __typename?: 'SurveyReportsConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsConnectionUpdated_By = {
   __typename?: 'SurveyReportsConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SurveyReportsConnection>;
};

export type SurveyReportsAggregator = {
   __typename?: 'SurveyReportsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateSurveyReportPayload = {
   __typename?: 'createSurveyReportPayload';
  surveyReport?: Maybe<SurveyReports>;
};

export type UpdateSurveyReportPayload = {
   __typename?: 'updateSurveyReportPayload';
  surveyReport?: Maybe<SurveyReports>;
};

export type DeleteSurveyReportPayload = {
   __typename?: 'deleteSurveyReportPayload';
  surveyReport?: Maybe<SurveyReports>;
};

export type Translations = {
   __typename?: 'Translations';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  languageSelection?: Maybe<ComponentTranslationsLanguageSelection>;
  welcomeScreen?: Maybe<ComponentTranslationsWelcomeScreen>;
  letsGetStartedScreen?: Maybe<ComponentTranslationsLetsGetStartedScreen>;
  whatToExpect?: Maybe<ComponentTranslationsWhatToExpect>;
  homeScreen?: Maybe<ComponentTranslationsHomeScreen>;
  myWorkScreen?: Maybe<ComponentTranslationsMyWorkScreen>;
  myLibraryScreen?: Maybe<ComponentTranslationsMyLibraryScreen>;
  myProfileScreen?: Maybe<ComponentTranslationsMyProfileScreen>;
  personalScreen?: Maybe<ComponentTranslationsPersonalScreen>;
  menu?: Maybe<ComponentTranslationsMenu>;
  settingsScreen?: Maybe<ComponentTranslationsSettingsScreen>;
  helpAndSupport?: Maybe<ComponentTranslationsHelpAndSupport>;
  aboutUs?: Maybe<ComponentTranslationsAboutUs>;
  buttons?: Maybe<ComponentTranslationsButtons>;
  programmesScreen?: Maybe<ComponentTranslationsProgrammeScreen>;
  faqs?: Maybe<ComponentTranslationsFaqs>;
  termsofService?: Maybe<ComponentTranslationsTermsOfService>;
  privacyPolicy?: Maybe<ComponentTranslationsPrivacyPolicy>;
  dashboardScreen?: Maybe<ComponentTranslationsDashboardScreen>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ComponentTranslationsLanguageSelection = {
   __typename?: 'ComponentTranslationsLanguageSelection';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsWelcomeScreen = {
   __typename?: 'ComponentTranslationsWelcomeScreen';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  videoEnglish?: Maybe<UploadFile>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  videoFrench?: Maybe<UploadFile>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  videoGerman?: Maybe<UploadFile>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  videoSpanish?: Maybe<UploadFile>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
  videoMandarin?: Maybe<UploadFile>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsLetsGetStartedScreen = {
   __typename?: 'ComponentTranslationsLetsGetStartedScreen';
  id: Scalars['ID'];
  image?: Maybe<UploadFile>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']>;
  firstNameErrorEnglish?: Maybe<Scalars['String']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']>;
  lastNameErrorEnglish?: Maybe<Scalars['String']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']>;
  jobTitleErrorEnglish?: Maybe<Scalars['String']>;
  divisionLabelEnglish?: Maybe<Scalars['String']>;
  divisionErrorEnglish?: Maybe<Scalars['String']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  firstNameLabelFrench?: Maybe<Scalars['String']>;
  firstNameErrorFrench?: Maybe<Scalars['String']>;
  lastNameLabelFrench?: Maybe<Scalars['String']>;
  lastNameErrorFrench?: Maybe<Scalars['String']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']>;
  jobTitleErrorFrench?: Maybe<Scalars['String']>;
  divisionLabelFrench?: Maybe<Scalars['String']>;
  divisionErrorFrench?: Maybe<Scalars['String']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  firstNameLabelGerman?: Maybe<Scalars['String']>;
  firstNameErrorGerman?: Maybe<Scalars['String']>;
  lastNameLabelGerman?: Maybe<Scalars['String']>;
  lastNameErrorGerman?: Maybe<Scalars['String']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']>;
  jobTitleErrorGerman?: Maybe<Scalars['String']>;
  divisionLabelGerman?: Maybe<Scalars['String']>;
  divisionErrorGerman?: Maybe<Scalars['String']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']>;
  firstNameErrorSpanish?: Maybe<Scalars['String']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']>;
  lastNameErrorSpanish?: Maybe<Scalars['String']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']>;
  jobTitleErrorSpanish?: Maybe<Scalars['String']>;
  divisionLabelSpanish?: Maybe<Scalars['String']>;
  divisionErrorSpanish?: Maybe<Scalars['String']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']>;
  firstNameErrorMandarin?: Maybe<Scalars['String']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']>;
  lastNameErrorMandarin?: Maybe<Scalars['String']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']>;
  jobTitleErrorMandarin?: Maybe<Scalars['String']>;
  divisionLabelMandarin?: Maybe<Scalars['String']>;
  divisionErrorMandarin?: Maybe<Scalars['String']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
  timezoneErrorEnglish?: Maybe<Scalars['String']>;
  timezoneLabelSpanish?: Maybe<Scalars['String']>;
  timezoneLabelFrench?: Maybe<Scalars['String']>;
  timezoneLabelGerman?: Maybe<Scalars['String']>;
  timezoneLabelMandarin?: Maybe<Scalars['String']>;
  timezoneLabelEnglish?: Maybe<Scalars['String']>;
  timezoneErrorFrench?: Maybe<Scalars['String']>;
  timezoneErrorSpanish?: Maybe<Scalars['String']>;
  timezoneErrorGerman?: Maybe<Scalars['String']>;
  timezoneErrorMandarin?: Maybe<Scalars['String']>;
  regionLabelEnglish?: Maybe<Scalars['String']>;
  regionErrorEnglish?: Maybe<Scalars['String']>;
  regionLabelFrench?: Maybe<Scalars['String']>;
  regionErrorFrench?: Maybe<Scalars['String']>;
  regionLabelSpanish?: Maybe<Scalars['String']>;
  regionErrorSpanish?: Maybe<Scalars['String']>;
  regionLabelGerman?: Maybe<Scalars['String']>;
  regionErrorGerman?: Maybe<Scalars['String']>;
  regionLabelMandarin?: Maybe<Scalars['String']>;
  regionErrorMandarin?: Maybe<Scalars['String']>;
  leftTitleEnglish?: Maybe<Scalars['String']>;
  leftSubtitleEnglish?: Maybe<Scalars['String']>;
  leftTitleSpanish?: Maybe<Scalars['String']>;
  leftSubtitleSpanish?: Maybe<Scalars['String']>;
  leftTitleMandarin?: Maybe<Scalars['String']>;
  leftSubTitleMandarin?: Maybe<Scalars['String']>;
  leftTitleFrench?: Maybe<Scalars['String']>;
  leftSubtitleFrench?: Maybe<Scalars['String']>;
  leftSubtitleGerman?: Maybe<Scalars['String']>;
  leftTitleGerman?: Maybe<Scalars['String']>;
  leftTitleCzech?: Maybe<Scalars['String']>;
  havingTroubleEnglish?: Maybe<Scalars['String']>;
  havingTroubleSpanish?: Maybe<Scalars['String']>;
  havingTroubleFrench?: Maybe<Scalars['String']>;
  havingTroubleMandarin?: Maybe<Scalars['String']>;
  havingTroubleGerman?: Maybe<Scalars['String']>;
  getHelpButtonEnglish?: Maybe<Scalars['String']>;
  getHelpButtonSpanish?: Maybe<Scalars['String']>;
  getHelpButtonFrench?: Maybe<Scalars['String']>;
  getHelpButtonGerman?: Maybe<Scalars['String']>;
  getHelpButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsWhatToExpect = {
   __typename?: 'ComponentTranslationsWhatToExpect';
  id: Scalars['ID'];
  image?: Maybe<UploadFile>;
  titleEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  getStartedButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  getStartedButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  getStartedButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  getStartedButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
  getStartedButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsHomeScreen = {
   __typename?: 'ComponentTranslationsHomeScreen';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  myProgrammeEnglish?: Maybe<Scalars['String']>;
  completedModulesEnglish?: Maybe<Scalars['String']>;
  noChangesEnglish?: Maybe<Scalars['String']>;
  changesUpEnglish?: Maybe<Scalars['String']>;
  changesDownEnglish?: Maybe<Scalars['String']>;
  viewModulesEnglish?: Maybe<Scalars['String']>;
  myLibraryEnglish?: Maybe<Scalars['String']>;
  viewedArticlesEnglish?: Maybe<Scalars['String']>;
  viewLibraryEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  myProgrammeFrench?: Maybe<Scalars['String']>;
  completedModulesFrench?: Maybe<Scalars['String']>;
  noChangesFrench?: Maybe<Scalars['String']>;
  changesUpFrench?: Maybe<Scalars['String']>;
  changesDownFrench?: Maybe<Scalars['String']>;
  viewModulesFrench?: Maybe<Scalars['String']>;
  myLibraryFrench?: Maybe<Scalars['String']>;
  viewedArticlesFrench?: Maybe<Scalars['String']>;
  viewLibraryFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  myProgrammeGerman?: Maybe<Scalars['String']>;
  completedModulesGerman?: Maybe<Scalars['String']>;
  noChangesGerman?: Maybe<Scalars['String']>;
  changesUpGerman?: Maybe<Scalars['String']>;
  changesDownGerman?: Maybe<Scalars['String']>;
  viewModulesGerman?: Maybe<Scalars['String']>;
  myLibraryGerman?: Maybe<Scalars['String']>;
  viewedArticlesGerman?: Maybe<Scalars['String']>;
  viewLibraryGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  myProgrammeSpanish?: Maybe<Scalars['String']>;
  completedModulesSpanish?: Maybe<Scalars['String']>;
  noChangesSpanish?: Maybe<Scalars['String']>;
  changesUpSpanish?: Maybe<Scalars['String']>;
  changesDownSpanish?: Maybe<Scalars['String']>;
  viewModulesSpanish?: Maybe<Scalars['String']>;
  myLibrarySpanish?: Maybe<Scalars['String']>;
  viewedArticlesSpanish?: Maybe<Scalars['String']>;
  viewLibrarySpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  myProgrammeMandarin?: Maybe<Scalars['String']>;
  completedModulesMandarin?: Maybe<Scalars['String']>;
  noChangesMandarin?: Maybe<Scalars['String']>;
  changesUpMandarin?: Maybe<Scalars['String']>;
  changesDownMandarin?: Maybe<Scalars['String']>;
  viewModulesMandarin?: Maybe<Scalars['String']>;
  myLibraryMandarin?: Maybe<Scalars['String']>;
  viewedArticlesMandarin?: Maybe<Scalars['String']>;
  viewLibraryMandarin?: Maybe<Scalars['String']>;
  welcomeEnglish?: Maybe<Scalars['String']>;
  welcomeFrench?: Maybe<Scalars['String']>;
  welcomeGerman?: Maybe<Scalars['String']>;
  welcomeSpanish?: Maybe<Scalars['String']>;
  welcomeMandarin?: Maybe<Scalars['String']>;
  programmeProgressEnglish?: Maybe<Scalars['String']>;
  programmeProgressFrench?: Maybe<Scalars['String']>;
  programmeProgressGerman?: Maybe<Scalars['String']>;
  programmeProgressSpanish?: Maybe<Scalars['String']>;
  programmeProgressMandarin?: Maybe<Scalars['String']>;
  whatsNextEnglish?: Maybe<Scalars['String']>;
  whatsNextFrench?: Maybe<Scalars['String']>;
  whatsNextGerman?: Maybe<Scalars['String']>;
  whatsNextSpanish?: Maybe<Scalars['String']>;
  whatsNextMandarin?: Maybe<Scalars['String']>;
  whatToExpectEnglish?: Maybe<Scalars['String']>;
  whatToExpectFrench?: Maybe<Scalars['String']>;
  whatToExpectGerman?: Maybe<Scalars['String']>;
  whatToExpectSpanish?: Maybe<Scalars['String']>;
  whatToExpectMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMyWorkScreen = {
   __typename?: 'ComponentTranslationsMyWorkScreen';
  id: Scalars['ID'];
  emptyStateTitleEnglish?: Maybe<Scalars['String']>;
  emptyStateDescEnglish?: Maybe<Scalars['String']>;
  subtitleEnglish?: Maybe<Scalars['String']>;
  feedbackEnglish?: Maybe<Scalars['String']>;
  feedbackNotEligibleEnglish?: Maybe<Scalars['String']>;
  feedbackNotReceivedEnglish?: Maybe<Scalars['String']>;
  notStartedEnglish?: Maybe<Scalars['String']>;
  emptyStateTitleFrench?: Maybe<Scalars['String']>;
  emptyStateDescFrench?: Maybe<Scalars['String']>;
  subtitleFrench?: Maybe<Scalars['String']>;
  feedbackFrench?: Maybe<Scalars['String']>;
  feedbackNotEligibleFrench?: Maybe<Scalars['String']>;
  feedbackNotReceivedFrench?: Maybe<Scalars['String']>;
  notStartedFrench?: Maybe<Scalars['String']>;
  emptyStateTitleGerman?: Maybe<Scalars['String']>;
  emptyStateDescGerman?: Maybe<Scalars['String']>;
  subtitleGerman?: Maybe<Scalars['String']>;
  feedbackGerman?: Maybe<Scalars['String']>;
  feedbackNotEligibleGerman?: Maybe<Scalars['String']>;
  feedbackNotReceivedGerman?: Maybe<Scalars['String']>;
  notStartedGerman?: Maybe<Scalars['String']>;
  emptyStateTitleSpanish?: Maybe<Scalars['String']>;
  emptyStateDescSpanish?: Maybe<Scalars['String']>;
  subtitleSpanish?: Maybe<Scalars['String']>;
  feedbackSpanish?: Maybe<Scalars['String']>;
  feedbackNotEligibleSpanish?: Maybe<Scalars['String']>;
  feedbackNotReceivedSpanish?: Maybe<Scalars['String']>;
  notStartedSpanish?: Maybe<Scalars['String']>;
  emptyStateTitleMandarin?: Maybe<Scalars['String']>;
  emptyStateDescMandarin?: Maybe<Scalars['String']>;
  subtitleMandarin?: Maybe<Scalars['String']>;
  feedbackMandarin?: Maybe<Scalars['String']>;
  feedbackNotEligibleMandarin?: Maybe<Scalars['String']>;
  feedbackNotReceivedMandarin?: Maybe<Scalars['String']>;
  notStartedMandarin?: Maybe<Scalars['String']>;
  downloadContentTextEnglish?: Maybe<Scalars['String']>;
  downloadContentTextFrench?: Maybe<Scalars['String']>;
  downloadContentTextGerman?: Maybe<Scalars['String']>;
  downloadContentTextSpanish?: Maybe<Scalars['String']>;
  downloadContentTextMandarin?: Maybe<Scalars['String']>;
  myNotesEnglish?: Maybe<Scalars['String']>;
  myNotesSpanish?: Maybe<Scalars['String']>;
  myNotesMandarin?: Maybe<Scalars['String']>;
  myNotesFrench?: Maybe<Scalars['String']>;
  myNotesGerman?: Maybe<Scalars['String']>;
  moduleReportsEnglish?: Maybe<Scalars['String']>;
  moduleReportsMandarin?: Maybe<Scalars['String']>;
  moduleReportsSpanish?: Maybe<Scalars['String']>;
  moduleReportsFrench?: Maybe<Scalars['String']>;
  moduleReportsGerman?: Maybe<Scalars['String']>;
  documentsEnglish?: Maybe<Scalars['String']>;
  documentsSpanish?: Maybe<Scalars['String']>;
  documentsFrench?: Maybe<Scalars['String']>;
  documentsMandarin?: Maybe<Scalars['String']>;
  documentsGerman?: Maybe<Scalars['String']>;
  deleteHeadingEnglish?: Maybe<Scalars['String']>;
  deleteHeadingSpanish?: Maybe<Scalars['String']>;
  deleteHeadingGerman?: Maybe<Scalars['String']>;
  deleteHeadingMandarin?: Maybe<Scalars['String']>;
  deleteHeadingFrench?: Maybe<Scalars['String']>;
  deleteMessageEnglish?: Maybe<Scalars['String']>;
  deleteMessageSpanish?: Maybe<Scalars['String']>;
  deleteMessageGerman?: Maybe<Scalars['String']>;
  deleteMessageFrench?: Maybe<Scalars['String']>;
  deleteMessageMandarin?: Maybe<Scalars['String']>;
  recentNotesEnglish?: Maybe<Scalars['String']>;
  recentNotesSpanish?: Maybe<Scalars['String']>;
  recentNotesGerman?: Maybe<Scalars['String']>;
  recentNotesFrench?: Maybe<Scalars['String']>;
  recentNotesMandarin?: Maybe<Scalars['String']>;
  programmeHeadingEnglish?: Maybe<Scalars['String']>;
  programmeHeadingSpanish?: Maybe<Scalars['String']>;
  programmeHeadingFrench?: Maybe<Scalars['String']>;
  programmeHeadingMandarin?: Maybe<Scalars['String']>;
  programmeHeadingGerman?: Maybe<Scalars['String']>;
  noNotesHeadingEnglish?: Maybe<Scalars['String']>;
  noNotesHeadingSpanish?: Maybe<Scalars['String']>;
  noNotesHeadingFrench?: Maybe<Scalars['String']>;
  noNotesHeadingMandarin?: Maybe<Scalars['String']>;
  noNotesHeadingGerman?: Maybe<Scalars['String']>;
  noNotesSubHeadingEnglish?: Maybe<Scalars['String']>;
  noNotesSubHeadingFrench?: Maybe<Scalars['String']>;
  noNotesSubHeadingSpanish?: Maybe<Scalars['String']>;
  noNotesSubHeadingGerman?: Maybe<Scalars['String']>;
  noNotesSubHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsHeadingEnglish?: Maybe<Scalars['String']>;
  noModuleReportsHeadingSpanish?: Maybe<Scalars['String']>;
  noModuleReportsHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsHeadingFrench?: Maybe<Scalars['String']>;
  noModuleReportsHeadingGerman?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingEnglish?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingFrench?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingGerman?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingSpanish?: Maybe<Scalars['String']>;
  noDocumentsHeadingEnglish?: Maybe<Scalars['String']>;
  noDocumentsHeadingSpanish?: Maybe<Scalars['String']>;
  noDocumentsHeadingGerman?: Maybe<Scalars['String']>;
  noDocumentsHeadingMandarin?: Maybe<Scalars['String']>;
  noDocumentsHeadingFrench?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingEnglish?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingFrench?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingMandarin?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingGerman?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingSpanish?: Maybe<Scalars['String']>;
  sectionCompletedEnglish?: Maybe<Scalars['String']>;
  sectionCompletedSpanish?: Maybe<Scalars['String']>;
  sectionCompletedGerman?: Maybe<Scalars['String']>;
  sectionCompletedFrench?: Maybe<Scalars['String']>;
  sectionCompletedMandarin?: Maybe<Scalars['String']>;
  documentsUploadedEnglish?: Maybe<Scalars['String']>;
  documentsUploadedSpanish?: Maybe<Scalars['String']>;
  documentsUploadedFrench?: Maybe<Scalars['String']>;
  documentsUploadedMandarin?: Maybe<Scalars['String']>;
  documentsUploadedGerman?: Maybe<Scalars['String']>;
  uploadButtonEnglish?: Maybe<Scalars['String']>;
  uploadButtonFrench?: Maybe<Scalars['String']>;
  uploadButtonMandarin?: Maybe<Scalars['String']>;
  uploadButtonSpanish?: Maybe<Scalars['String']>;
  uploadButtonGerman?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMyLibraryScreen = {
   __typename?: 'ComponentTranslationsMyLibraryScreen';
  id: Scalars['ID'];
  allArticlesEnglish?: Maybe<Scalars['String']>;
  myBookmarksEnglish?: Maybe<Scalars['String']>;
  allArticlesFrench?: Maybe<Scalars['String']>;
  myBookmarksFrench?: Maybe<Scalars['String']>;
  allArticlesGerman?: Maybe<Scalars['String']>;
  myBookmarksGerman?: Maybe<Scalars['String']>;
  allArticlesSpanish?: Maybe<Scalars['String']>;
  myBookmarksSpanish?: Maybe<Scalars['String']>;
  allArticlesMandarin?: Maybe<Scalars['String']>;
  myBookmarksMandarin?: Maybe<Scalars['String']>;
  viewArticleEnglish?: Maybe<Scalars['String']>;
  viewArticleFrench?: Maybe<Scalars['String']>;
  viewArticleSpanish?: Maybe<Scalars['String']>;
  viewArticleGerman?: Maybe<Scalars['String']>;
  viewArticleMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMyProfileScreen = {
   __typename?: 'ComponentTranslationsMyProfileScreen';
  id: Scalars['ID'];
  detailsEnglish?: Maybe<Scalars['String']>;
  settingsEnglish?: Maybe<Scalars['String']>;
  logoutEnglish?: Maybe<Scalars['String']>;
  joinEnglish?: Maybe<Scalars['String']>;
  detailsFrench?: Maybe<Scalars['String']>;
  settingsFrench?: Maybe<Scalars['String']>;
  logoutFrench?: Maybe<Scalars['String']>;
  joinFrench?: Maybe<Scalars['String']>;
  detailsGerman?: Maybe<Scalars['String']>;
  settingsGerman?: Maybe<Scalars['String']>;
  logoutGerman?: Maybe<Scalars['String']>;
  joinGerman?: Maybe<Scalars['String']>;
  detailsSpanish?: Maybe<Scalars['String']>;
  settingsSpanish?: Maybe<Scalars['String']>;
  logoutSpanish?: Maybe<Scalars['String']>;
  joinSpanish?: Maybe<Scalars['String']>;
  detailsMandarin?: Maybe<Scalars['String']>;
  settingsMandarin?: Maybe<Scalars['String']>;
  logoutMandarin?: Maybe<Scalars['String']>;
  joinMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsPersonalScreen = {
   __typename?: 'ComponentTranslationsPersonalScreen';
  id: Scalars['ID'];
  changePhotoEnglish?: Maybe<Scalars['String']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']>;
  emailLabelEnglish?: Maybe<Scalars['String']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']>;
  divisionLabelEnglish?: Maybe<Scalars['String']>;
  editInfoButtonEnglish?: Maybe<Scalars['String']>;
  changePhotoFrench?: Maybe<Scalars['String']>;
  firstNameLabelFrench?: Maybe<Scalars['String']>;
  lastNameLabelFrench?: Maybe<Scalars['String']>;
  emailLabelFrench?: Maybe<Scalars['String']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']>;
  divisionLabelFrench?: Maybe<Scalars['String']>;
  editInfoButtonFrench?: Maybe<Scalars['String']>;
  changePhotoGerman?: Maybe<Scalars['String']>;
  firstNameLabelGerman?: Maybe<Scalars['String']>;
  lastNameLabelGerman?: Maybe<Scalars['String']>;
  emailLabelGerman?: Maybe<Scalars['String']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']>;
  divisionLabelGerman?: Maybe<Scalars['String']>;
  editInfoButtonGerman?: Maybe<Scalars['String']>;
  changePhotoSpanish?: Maybe<Scalars['String']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']>;
  emailLabelSpanish?: Maybe<Scalars['String']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']>;
  divisionLabelSpanish?: Maybe<Scalars['String']>;
  editInfoButtonSpanish?: Maybe<Scalars['String']>;
  changePhotoMandarin?: Maybe<Scalars['String']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']>;
  emailLabelMandarin?: Maybe<Scalars['String']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']>;
  divisionLabelMandarin?: Maybe<Scalars['String']>;
  editInfoButtonMandarin?: Maybe<Scalars['String']>;
  resetPasswordEnglish?: Maybe<Scalars['String']>;
  resetPasswordFrench?: Maybe<Scalars['String']>;
  resetPasswordSpanish?: Maybe<Scalars['String']>;
  resetPasswordGerman?: Maybe<Scalars['String']>;
  resetPasswordMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMenu = {
   __typename?: 'ComponentTranslationsMenu';
  id: Scalars['ID'];
  homeEnglish?: Maybe<Scalars['String']>;
  myProgrammeEnglish?: Maybe<Scalars['String']>;
  myWorkEnglish?: Maybe<Scalars['String']>;
  myLibraryEnglish?: Maybe<Scalars['String']>;
  myProfileEnglish?: Maybe<Scalars['String']>;
  helpAndSupportEnglish?: Maybe<Scalars['String']>;
  signOutEnglish?: Maybe<Scalars['String']>;
  homeFrench?: Maybe<Scalars['String']>;
  myProgrammeFrench?: Maybe<Scalars['String']>;
  myWorkFrench?: Maybe<Scalars['String']>;
  myLibraryFrench?: Maybe<Scalars['String']>;
  myProfileFrench?: Maybe<Scalars['String']>;
  helpAndSupportFrench?: Maybe<Scalars['String']>;
  signOutFrench?: Maybe<Scalars['String']>;
  homeGerman?: Maybe<Scalars['String']>;
  myProgrammeGerman?: Maybe<Scalars['String']>;
  myWorkGerman?: Maybe<Scalars['String']>;
  myLibraryGerman?: Maybe<Scalars['String']>;
  myProfileGerman?: Maybe<Scalars['String']>;
  helpAndSupportGerman?: Maybe<Scalars['String']>;
  signOutGerman?: Maybe<Scalars['String']>;
  homeSpanish?: Maybe<Scalars['String']>;
  myProgrammeSpanish?: Maybe<Scalars['String']>;
  myWorkSpanish?: Maybe<Scalars['String']>;
  myLibrarySpanish?: Maybe<Scalars['String']>;
  myProfileSpanish?: Maybe<Scalars['String']>;
  helpAndSupportSpanish?: Maybe<Scalars['String']>;
  signOutSpanish?: Maybe<Scalars['String']>;
  homeMandarin?: Maybe<Scalars['String']>;
  myProgrammeMandarin?: Maybe<Scalars['String']>;
  myWorkMandarin?: Maybe<Scalars['String']>;
  myLibraryMandarin?: Maybe<Scalars['String']>;
  myProfileMandarin?: Maybe<Scalars['String']>;
  helpAndSupportMandarin?: Maybe<Scalars['String']>;
  signOutMandarin?: Maybe<Scalars['String']>;
  aboutUsEnglish?: Maybe<Scalars['String']>;
  aboutUsFrench?: Maybe<Scalars['String']>;
  aboutUsGerman?: Maybe<Scalars['String']>;
  myNotesMandarin?: Maybe<Scalars['String']>;
  myNotesGerman?: Maybe<Scalars['String']>;
  myNotesSpanish?: Maybe<Scalars['String']>;
  myNotesEnglish?: Maybe<Scalars['String']>;
  myNotesFrench?: Maybe<Scalars['String']>;
  notificationsEnglish?: Maybe<Scalars['String']>;
  notificationsFrench?: Maybe<Scalars['String']>;
  notificationsGerman?: Maybe<Scalars['String']>;
  notificationsSpanish?: Maybe<Scalars['String']>;
  notificationsMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsSettingsScreen = {
   __typename?: 'ComponentTranslationsSettingsScreen';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  saveButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  saveButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  saveButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  saveButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  saveButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsHelpAndSupport = {
   __typename?: 'ComponentTranslationsHelpAndSupport';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  knowledgeBaseEnglish?: Maybe<Scalars['String']>;
  liveChatEnglish?: Maybe<Scalars['String']>;
  myTicketsEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  knowledgeBaseFrench?: Maybe<Scalars['String']>;
  liveChatFrench?: Maybe<Scalars['String']>;
  myTicketsFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  knowledgeBaseGerman?: Maybe<Scalars['String']>;
  liveChatGerman?: Maybe<Scalars['String']>;
  myTicketsGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  knowledgeBaseSpanish?: Maybe<Scalars['String']>;
  liveChatSpanish?: Maybe<Scalars['String']>;
  myTicketsSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  knowledgeBaseMandarin?: Maybe<Scalars['String']>;
  liveChatMandarin?: Maybe<Scalars['String']>;
  myTicketsMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsAboutUs = {
   __typename?: 'ComponentTranslationsAboutUs';
  id: Scalars['ID'];
  textEnglish?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  userGuidelinesTextEnglish?: Maybe<Scalars['String']>;
  userGuidelinesTextFrench?: Maybe<Scalars['String']>;
  userGuidelinesTextGerman?: Maybe<Scalars['String']>;
  userGuidelinesEnglish?: Maybe<Array<Maybe<UploadFile>>>;
  userGuidelinesFrench?: Maybe<Array<Maybe<UploadFile>>>;
  userGuidelinesGerman?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentTranslationsAboutUsUserGuidelinesEnglishArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ComponentTranslationsAboutUsUserGuidelinesFrenchArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ComponentTranslationsAboutUsUserGuidelinesGermanArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentTranslationsButtons = {
   __typename?: 'ComponentTranslationsButtons';
  id: Scalars['ID'];
  backBtnsEnglish?: Maybe<Scalars['String']>;
  backBtnsFrench?: Maybe<Scalars['String']>;
  backBtnsGerman?: Maybe<Scalars['String']>;
  nextBtnsEnglish?: Maybe<Scalars['String']>;
  nextBtnsFrench?: Maybe<Scalars['String']>;
  nextBtnsGerman?: Maybe<Scalars['String']>;
  addMoreBtnsEnglish?: Maybe<Scalars['String']>;
  addMoreBtnsFrench?: Maybe<Scalars['String']>;
  addMoreBtnsGerman?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsProgrammeScreen = {
   __typename?: 'ComponentTranslationsProgrammeScreen';
  id: Scalars['ID'];
  changeButtonEnglish?: Maybe<Scalars['String']>;
  changeButtonFrench?: Maybe<Scalars['String']>;
  changeButtonGerman?: Maybe<Scalars['String']>;
  changeButtonSpanish?: Maybe<Scalars['String']>;
  changeButtonMandarin?: Maybe<Scalars['String']>;
  programmeOverviewEnglish?: Maybe<Scalars['String']>;
  programmeOverviewFrench?: Maybe<Scalars['String']>;
  programmeOverviewSpanish?: Maybe<Scalars['String']>;
  programmeOverviewGerman?: Maybe<Scalars['String']>;
  programmeOverviewMandarin?: Maybe<Scalars['String']>;
  programmeTextEnglish?: Maybe<Scalars['String']>;
  programmeTextFrench?: Maybe<Scalars['String']>;
  programmeTextSpanish?: Maybe<Scalars['String']>;
  programmeTextGerman?: Maybe<Scalars['String']>;
  programmeTextMandarin?: Maybe<Scalars['String']>;
  informationEnglish?: Maybe<Scalars['String']>;
  informationFrench?: Maybe<Scalars['String']>;
  informationGerman?: Maybe<Scalars['String']>;
  informationSpanish?: Maybe<Scalars['String']>;
  informationMandarin?: Maybe<Scalars['String']>;
  selectProgrammesTitleEnglish?: Maybe<Scalars['String']>;
  selectProgrammesTitleFrench?: Maybe<Scalars['String']>;
  selectProgrammesTitleGerman?: Maybe<Scalars['String']>;
  selectProgrammesTitleSpanish?: Maybe<Scalars['String']>;
  selectProgrammesTitleMandarin?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleEnglish?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleFrench?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleGerman?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleSpanish?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleMandarin?: Maybe<Scalars['String']>;
  selectButtonEnglish?: Maybe<Scalars['String']>;
  selectButtonFrench?: Maybe<Scalars['String']>;
  selectButtonGerman?: Maybe<Scalars['String']>;
  selectButtonSpanish?: Maybe<Scalars['String']>;
  selectButtonMandarin?: Maybe<Scalars['String']>;
  changeProgrammeTypeEnglish?: Maybe<Scalars['String']>;
  changeProgrammeTypeFrench?: Maybe<Scalars['String']>;
  changeProgrammeTypeGerman?: Maybe<Scalars['String']>;
  changeProgrammeTypeSpanish?: Maybe<Scalars['String']>;
  changeProgrammeTypeMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqs = {
   __typename?: 'ComponentTranslationsFaqs';
  id: Scalars['ID'];
  faqsEnglish?: Maybe<Array<Maybe<ComponentTranslationsFaqsQuestionAnswer>>>;
  faqsFrench?: Maybe<Array<Maybe<ComponentTranslationsFaqsFrench>>>;
  faqsGerman?: Maybe<Array<Maybe<ComponentTranslationsFaqsGerman>>>;
  faqsMandarin?: Maybe<Array<Maybe<ComponentTranslationsFaqsMandarin>>>;
  faqsSpanish?: Maybe<Array<Maybe<ComponentTranslationsFaqsSpanish>>>;
};

export type ComponentTranslationsFaqsQuestionAnswer = {
   __typename?: 'ComponentTranslationsFaqsQuestionAnswer';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsFrench = {
   __typename?: 'ComponentTranslationsFaqsFrench';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsGerman = {
   __typename?: 'ComponentTranslationsFaqsGerman';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsMandarin = {
   __typename?: 'ComponentTranslationsFaqsMandarin';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsSpanish = {
   __typename?: 'ComponentTranslationsFaqsSpanish';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsTermsOfService = {
   __typename?: 'ComponentTranslationsTermsOfService';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  textEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  textSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  textMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsPrivacyPolicy = {
   __typename?: 'ComponentTranslationsPrivacyPolicy';
  id: Scalars['ID'];
  titleEnglish?: Maybe<Scalars['String']>;
  textEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  textSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  textMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsDashboardScreen = {
   __typename?: 'ComponentTranslationsDashboardScreen';
  id: Scalars['ID'];
  myProgrammesEnglish?: Maybe<Scalars['String']>;
  myProgrammesFrench?: Maybe<Scalars['String']>;
  myProgrammesGerman?: Maybe<Scalars['String']>;
  myProgrammesSpanish?: Maybe<Scalars['String']>;
  myProgrammesMandarin?: Maybe<Scalars['String']>;
  suggestedTitleEnglish?: Maybe<Scalars['String']>;
  suggestedTitleFrench?: Maybe<Scalars['String']>;
  suggestedTitleSpanish?: Maybe<Scalars['String']>;
  suggestedTitleGerman?: Maybe<Scalars['String']>;
  suggestedTitleMandarin?: Maybe<Scalars['String']>;
  uploadTitleEnglish?: Maybe<Scalars['String']>;
  uploadTitleFrench?: Maybe<Scalars['String']>;
  uploadTitleSpanish?: Maybe<Scalars['String']>;
  uploadTitleGerman?: Maybe<Scalars['String']>;
  uploadTitleMandarin?: Maybe<Scalars['String']>;
  viewAllEnglish?: Maybe<Scalars['String']>;
  viewAllFrench?: Maybe<Scalars['String']>;
  viewAllMandarin?: Maybe<Scalars['String']>;
  viewAllSpanish?: Maybe<Scalars['String']>;
  viewAllGerman?: Maybe<Scalars['String']>;
  logOutDashboardEnglish?: Maybe<Scalars['String']>;
  logOutDashboardFrench?: Maybe<Scalars['String']>;
  logOutDashboardMandarin?: Maybe<Scalars['String']>;
  logOutDashboardSpanish?: Maybe<Scalars['String']>;
  logOutDashboardGerman?: Maybe<Scalars['String']>;
  notepadTextEnglish?: Maybe<Scalars['String']>;
  notepadTextFrench?: Maybe<Scalars['String']>;
  notepadTextMandarin?: Maybe<Scalars['String']>;
  notepadTextSpanish?: Maybe<Scalars['String']>;
  notepadTextGerman?: Maybe<Scalars['String']>;
};

export type UpdateTranslationPayload = {
   __typename?: 'updateTranslationPayload';
  translation?: Maybe<Translations>;
};

export type DeleteTranslationPayload = {
   __typename?: 'deleteTranslationPayload';
  translation?: Maybe<Translations>;
};

export type TypeFormCollectionConnection = {
   __typename?: 'TypeFormCollectionConnection';
  values?: Maybe<Array<Maybe<TypeFormCollection>>>;
  groupBy?: Maybe<TypeFormCollectionGroupBy>;
  aggregate?: Maybe<TypeFormCollectionAggregator>;
};

export type TypeFormCollectionGroupBy = {
   __typename?: 'TypeFormCollectionGroupBy';
  id?: Maybe<Array<Maybe<TypeFormCollectionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TypeFormCollectionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TypeFormCollectionConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TypeFormCollectionConnectionName>>>;
  typeFormUrl?: Maybe<Array<Maybe<TypeFormCollectionConnectionTypeFormUrl>>>;
  submissions?: Maybe<Array<Maybe<TypeFormCollectionConnectionSubmissions>>>;
  created_by?: Maybe<Array<Maybe<TypeFormCollectionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<TypeFormCollectionConnectionUpdated_By>>>;
};

export type TypeFormCollectionConnectionId = {
   __typename?: 'TypeFormCollectionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionCreated_At = {
   __typename?: 'TypeFormCollectionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionUpdated_At = {
   __typename?: 'TypeFormCollectionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionName = {
   __typename?: 'TypeFormCollectionConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionTypeFormUrl = {
   __typename?: 'TypeFormCollectionConnectionTypeFormUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionSubmissions = {
   __typename?: 'TypeFormCollectionConnectionSubmissions';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionCreated_By = {
   __typename?: 'TypeFormCollectionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionConnectionUpdated_By = {
   __typename?: 'TypeFormCollectionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TypeFormCollectionConnection>;
};

export type TypeFormCollectionAggregator = {
   __typename?: 'TypeFormCollectionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateTypeFormCollectionPayload = {
   __typename?: 'createTypeFormCollectionPayload';
  typeFormCollection?: Maybe<TypeFormCollection>;
};

export type UpdateTypeFormCollectionPayload = {
   __typename?: 'updateTypeFormCollectionPayload';
  typeFormCollection?: Maybe<TypeFormCollection>;
};

export type DeleteTypeFormCollectionPayload = {
   __typename?: 'deleteTypeFormCollectionPayload';
  typeFormCollection?: Maybe<TypeFormCollection>;
};

export type UploadedReportsConnection = {
   __typename?: 'UploadedReportsConnection';
  values?: Maybe<Array<Maybe<UploadedReports>>>;
  groupBy?: Maybe<UploadedReportsGroupBy>;
  aggregate?: Maybe<UploadedReportsAggregator>;
};

export type UploadedReportsGroupBy = {
   __typename?: 'UploadedReportsGroupBy';
  id?: Maybe<Array<Maybe<UploadedReportsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadedReportsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadedReportsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadedReportsConnectionName>>>;
  type?: Maybe<Array<Maybe<UploadedReportsConnectionType>>>;
  sub_module_submission?: Maybe<Array<Maybe<UploadedReportsConnectionSub_Module_Submission>>>;
  sectionOrModuleId?: Maybe<Array<Maybe<UploadedReportsConnectionSectionOrModuleId>>>;
  submission?: Maybe<Array<Maybe<UploadedReportsConnectionSubmission>>>;
  programme_submission?: Maybe<Array<Maybe<UploadedReportsConnectionProgramme_Submission>>>;
  created_by?: Maybe<Array<Maybe<UploadedReportsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UploadedReportsConnectionUpdated_By>>>;
};

export type UploadedReportsConnectionId = {
   __typename?: 'UploadedReportsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionCreated_At = {
   __typename?: 'UploadedReportsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionUpdated_At = {
   __typename?: 'UploadedReportsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionName = {
   __typename?: 'UploadedReportsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionType = {
   __typename?: 'UploadedReportsConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionSub_Module_Submission = {
   __typename?: 'UploadedReportsConnectionSub_module_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionSectionOrModuleId = {
   __typename?: 'UploadedReportsConnectionSectionOrModuleId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionSubmission = {
   __typename?: 'UploadedReportsConnectionSubmission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionProgramme_Submission = {
   __typename?: 'UploadedReportsConnectionProgramme_submission';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionCreated_By = {
   __typename?: 'UploadedReportsConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsConnectionUpdated_By = {
   __typename?: 'UploadedReportsConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadedReportsConnection>;
};

export type UploadedReportsAggregator = {
   __typename?: 'UploadedReportsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateUploadedReportPayload = {
   __typename?: 'createUploadedReportPayload';
  uploadedReport?: Maybe<UploadedReports>;
};

export type UpdateUploadedReportPayload = {
   __typename?: 'updateUploadedReportPayload';
  uploadedReport?: Maybe<UploadedReports>;
};

export type DeleteUploadedReportPayload = {
   __typename?: 'deleteUploadedReportPayload';
  uploadedReport?: Maybe<UploadedReports>;
};

export type UserUploadedDocument = {
   __typename?: 'UserUploadedDocument';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  documents?: Maybe<Array<Maybe<ComponentQuestionTypesDocuments>>>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ComponentQuestionTypesDocuments = {
   __typename?: 'ComponentQuestionTypesDocuments';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  document?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentQuestionTypesDocumentsDocumentArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UserUploadedDocumentConnection = {
   __typename?: 'UserUploadedDocumentConnection';
  values?: Maybe<Array<Maybe<UserUploadedDocument>>>;
  groupBy?: Maybe<UserUploadedDocumentGroupBy>;
  aggregate?: Maybe<UserUploadedDocumentAggregator>;
};

export type UserUploadedDocumentGroupBy = {
   __typename?: 'UserUploadedDocumentGroupBy';
  id?: Maybe<Array<Maybe<UserUploadedDocumentConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UserUploadedDocumentConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UserUploadedDocumentConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UserUploadedDocumentConnectionName>>>;
  user?: Maybe<Array<Maybe<UserUploadedDocumentConnectionUser>>>;
  created_by?: Maybe<Array<Maybe<UserUploadedDocumentConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UserUploadedDocumentConnectionUpdated_By>>>;
};

export type UserUploadedDocumentConnectionId = {
   __typename?: 'UserUploadedDocumentConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentConnectionCreated_At = {
   __typename?: 'UserUploadedDocumentConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentConnectionUpdated_At = {
   __typename?: 'UserUploadedDocumentConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentConnectionName = {
   __typename?: 'UserUploadedDocumentConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentConnectionUser = {
   __typename?: 'UserUploadedDocumentConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentConnectionCreated_By = {
   __typename?: 'UserUploadedDocumentConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentConnectionUpdated_By = {
   __typename?: 'UserUploadedDocumentConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UserUploadedDocumentConnection>;
};

export type UserUploadedDocumentAggregator = {
   __typename?: 'UserUploadedDocumentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateUserUploadedDocumentPayload = {
   __typename?: 'createUserUploadedDocumentPayload';
  userUploadedDocument?: Maybe<UserUploadedDocument>;
};

export type UpdateUserUploadedDocumentPayload = {
   __typename?: 'updateUserUploadedDocumentPayload';
  userUploadedDocument?: Maybe<UserUploadedDocument>;
};

export type DeleteUserUploadedDocumentPayload = {
   __typename?: 'deleteUserUploadedDocumentPayload';
  userUploadedDocument?: Maybe<UserUploadedDocument>;
};

export type UploadFileConnection = {
   __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileGroupBy = {
   __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  created_by?: Maybe<Array<Maybe<UploadFileConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UploadFileConnectionUpdated_By>>>;
};

export type UploadFileConnectionId = {
   __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
   __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
   __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
   __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
   __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
   __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
   __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
   __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
   __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
   __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
   __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
   __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
   __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
   __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
   __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
   __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
   __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_By = {
   __typename?: 'UploadFileConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_By = {
   __typename?: 'UploadFileConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileAggregator = {
   __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorSum = {
   __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorAvg = {
   __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
   __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
   __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsRoleConnection = {
   __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleGroupBy = {
   __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionUpdated_By>>>;
};

export type UsersPermissionsRoleConnectionId = {
   __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
   __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
   __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
   __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionCreated_By = {
   __typename?: 'UsersPermissionsRoleConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionUpdated_By = {
   __typename?: 'UsersPermissionsRoleConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleAggregator = {
   __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRolePayload = {
   __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRolePayload = {
   __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRolePayload = {
   __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserConnection = {
   __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserGroupBy = {
   __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  phoneNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoneNumber>>>;
  profilePicture?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProfilePicture>>>;
  language?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLanguage>>>;
  firstName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLastName>>>;
  jobTitle?: Maybe<Array<Maybe<UsersPermissionsUserConnectionJobTitle>>>;
  modulesRead?: Maybe<Array<Maybe<UsersPermissionsUserConnectionModulesRead>>>;
  homePromptsRead?: Maybe<Array<Maybe<UsersPermissionsUserConnectionHomePromptsRead>>>;
  programmePromptsRead?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProgrammePromptsRead>>>;
  modulePromptsRead?: Maybe<Array<Maybe<UsersPermissionsUserConnectionModulePromptsRead>>>;
  bookmarks?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBookmarks>>>;
  report?: Maybe<Array<Maybe<UsersPermissionsUserConnectionReport>>>;
  company?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCompany>>>;
  articlesViewed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionArticlesViewed>>>;
  postCard?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPostCard>>>;
  timezone?: Maybe<Array<Maybe<UsersPermissionsUserConnectionTimezone>>>;
  certificate?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCertificate>>>;
  loginAttempts?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLoginAttempts>>>;
  feedForwardUrl?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFeedForwardUrl>>>;
  division?: Maybe<Array<Maybe<UsersPermissionsUserConnectionDivision>>>;
  region?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRegion>>>;
  loginWithSSO?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLoginWithSso>>>;
  programmeEvalutionEmailSent?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProgrammeEvalutionEmailSent>>>;
  updatedDetails?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdatedDetails>>>;
  onboarding?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOnboarding>>>;
  triggerReport?: Maybe<Array<Maybe<UsersPermissionsUserConnectionTriggerReport>>>;
  clientId?: Maybe<Array<Maybe<UsersPermissionsUserConnectionClientId>>>;
  current_survey?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCurrent_Survey>>>;
  coach?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCoach>>>;
  three_60_form_id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionThree_60_Form_Id>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_By>>>;
};

export type UsersPermissionsUserConnectionId = {
   __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
   __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
   __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
   __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
   __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
   __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
   __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
   __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
   __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPhoneNumber = {
   __typename?: 'UsersPermissionsUserConnectionPhoneNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProfilePicture = {
   __typename?: 'UsersPermissionsUserConnectionProfilePicture';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLanguage = {
   __typename?: 'UsersPermissionsUserConnectionLanguage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionFirstName = {
   __typename?: 'UsersPermissionsUserConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLastName = {
   __typename?: 'UsersPermissionsUserConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionJobTitle = {
   __typename?: 'UsersPermissionsUserConnectionJobTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionModulesRead = {
   __typename?: 'UsersPermissionsUserConnectionModulesRead';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionHomePromptsRead = {
   __typename?: 'UsersPermissionsUserConnectionHomePromptsRead';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProgrammePromptsRead = {
   __typename?: 'UsersPermissionsUserConnectionProgrammePromptsRead';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionModulePromptsRead = {
   __typename?: 'UsersPermissionsUserConnectionModulePromptsRead';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBookmarks = {
   __typename?: 'UsersPermissionsUserConnectionBookmarks';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionReport = {
   __typename?: 'UsersPermissionsUserConnectionReport';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCompany = {
   __typename?: 'UsersPermissionsUserConnectionCompany';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionArticlesViewed = {
   __typename?: 'UsersPermissionsUserConnectionArticlesViewed';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPostCard = {
   __typename?: 'UsersPermissionsUserConnectionPostCard';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionTimezone = {
   __typename?: 'UsersPermissionsUserConnectionTimezone';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCertificate = {
   __typename?: 'UsersPermissionsUserConnectionCertificate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLoginAttempts = {
   __typename?: 'UsersPermissionsUserConnectionLoginAttempts';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionFeedForwardUrl = {
   __typename?: 'UsersPermissionsUserConnectionFeedForwardUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionDivision = {
   __typename?: 'UsersPermissionsUserConnectionDivision';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRegion = {
   __typename?: 'UsersPermissionsUserConnectionRegion';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLoginWithSso = {
   __typename?: 'UsersPermissionsUserConnectionLoginWithSSO';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProgrammeEvalutionEmailSent = {
   __typename?: 'UsersPermissionsUserConnectionProgrammeEvalutionEmailSent';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdatedDetails = {
   __typename?: 'UsersPermissionsUserConnectionUpdatedDetails';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionOnboarding = {
   __typename?: 'UsersPermissionsUserConnectionOnboarding';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionTriggerReport = {
   __typename?: 'UsersPermissionsUserConnectionTriggerReport';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionClientId = {
   __typename?: 'UsersPermissionsUserConnectionClientId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCurrent_Survey = {
   __typename?: 'UsersPermissionsUserConnectionCurrent_survey';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCoach = {
   __typename?: 'UsersPermissionsUserConnectionCoach';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionThree_60_Form_Id = {
   __typename?: 'UsersPermissionsUserConnectionThree_60_form_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_By = {
   __typename?: 'UsersPermissionsUserConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_By = {
   __typename?: 'UsersPermissionsUserConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserAggregator = {
   __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UsersPermissionsUserAggregatorSum>;
  avg?: Maybe<UsersPermissionsUserAggregatorAvg>;
  min?: Maybe<UsersPermissionsUserAggregatorMin>;
  max?: Maybe<UsersPermissionsUserAggregatorMax>;
};

export type UsersPermissionsUserAggregatorSum = {
   __typename?: 'UsersPermissionsUserAggregatorSum';
  loginAttempts?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsUserAggregatorAvg = {
   __typename?: 'UsersPermissionsUserAggregatorAvg';
  loginAttempts?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsUserAggregatorMin = {
   __typename?: 'UsersPermissionsUserAggregatorMin';
  loginAttempts?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsUserAggregatorMax = {
   __typename?: 'UsersPermissionsUserAggregatorMax';
  loginAttempts?: Maybe<Scalars['Float']>;
};

export type CreateUserPayload = {
   __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserPayload = {
   __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserPayload = {
   __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type ComponentOptionTimezone = {
   __typename?: 'ComponentOptionTimezone';
  id: Scalars['ID'];
  abbrev?: Maybe<Scalars['String']>;
  altName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSubModuleSubmission = {
   __typename?: 'ComponentSubmissionsSubModuleSubmission';
  id: Scalars['ID'];
  section?: Maybe<Section>;
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswer>>>;
  progress?: Maybe<Scalars['Int']>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItems>>>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItem>>>;
  stakeholderChart?: Maybe<UploadFile>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItem>>>;
  xYGraphChart?: Maybe<UploadFile>;
  saboteurImage?: Maybe<UploadFile>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristics>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<UploadFile>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGaps>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponent>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswer>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
   __typename?: 'Mutation';
  createAccountChange?: Maybe<CreateAccountChangePayload>;
  updateAccountChange?: Maybe<UpdateAccountChangePayload>;
  deleteAccountChange?: Maybe<DeleteAccountChangePayload>;
  createAppointment?: Maybe<CreateAppointmentPayload>;
  updateAppointment?: Maybe<UpdateAppointmentPayload>;
  deleteAppointment?: Maybe<DeleteAppointmentPayload>;
  createArticle?: Maybe<CreateArticlePayload>;
  updateArticle?: Maybe<UpdateArticlePayload>;
  deleteArticle?: Maybe<DeleteArticlePayload>;
  createAuditTrail?: Maybe<CreateAuditTrailPayload>;
  updateAuditTrail?: Maybe<UpdateAuditTrailPayload>;
  deleteAuditTrail?: Maybe<DeleteAuditTrailPayload>;
  createBooking?: Maybe<CreateBookingPayload>;
  updateBooking?: Maybe<UpdateBookingPayload>;
  deleteBooking?: Maybe<DeleteBookingPayload>;
  createCoachSession?: Maybe<CreateCoachSessionPayload>;
  updateCoachSession?: Maybe<UpdateCoachSessionPayload>;
  deleteCoachSession?: Maybe<DeleteCoachSessionPayload>;
  createCoachSubmittedReport?: Maybe<CreateCoachSubmittedReportPayload>;
  updateCoachSubmittedReport?: Maybe<UpdateCoachSubmittedReportPayload>;
  deleteCoachSubmittedReport?: Maybe<DeleteCoachSubmittedReportPayload>;
  createCoach?: Maybe<CreateCoachPayload>;
  updateCoach?: Maybe<UpdateCoachPayload>;
  deleteCoach?: Maybe<DeleteCoachPayload>;
  createCompany?: Maybe<CreateCompanyPayload>;
  updateCompany?: Maybe<UpdateCompanyPayload>;
  deleteCompany?: Maybe<DeleteCompanyPayload>;
  createCompetencyUrl?: Maybe<CreateCompetencyUrlPayload>;
  updateCompetencyUrl?: Maybe<UpdateCompetencyUrlPayload>;
  deleteCompetencyUrl?: Maybe<DeleteCompetencyUrlPayload>;
  createDivision?: Maybe<CreateDivisionPayload>;
  updateDivision?: Maybe<UpdateDivisionPayload>;
  deleteDivision?: Maybe<DeleteDivisionPayload>;
  createEmailLog?: Maybe<CreateEmailLogPayload>;
  updateEmailLog?: Maybe<UpdateEmailLogPayload>;
  deleteEmailLog?: Maybe<DeleteEmailLogPayload>;
  createEmailTemplate?: Maybe<CreateEmailTemplatePayload>;
  updateEmailTemplate?: Maybe<UpdateEmailTemplatePayload>;
  deleteEmailTemplate?: Maybe<DeleteEmailTemplatePayload>;
  createEvent?: Maybe<CreateEventPayload>;
  updateEvent?: Maybe<UpdateEventPayload>;
  deleteEvent?: Maybe<DeleteEventPayload>;
  createFeedfowardUrl?: Maybe<CreateFeedfowardUrlPayload>;
  updateFeedfowardUrl?: Maybe<UpdateFeedfowardUrlPayload>;
  deleteFeedfowardUrl?: Maybe<DeleteFeedfowardUrlPayload>;
  createForwardedCard?: Maybe<CreateForwardedCardPayload>;
  updateForwardedCard?: Maybe<UpdateForwardedCardPayload>;
  deleteForwardedCard?: Maybe<DeleteForwardedCardPayload>;
  createInvite?: Maybe<CreateInvitePayload>;
  updateInvite?: Maybe<UpdateInvitePayload>;
  deleteInvite?: Maybe<DeleteInvitePayload>;
  createLanguage?: Maybe<CreateLanguagePayload>;
  updateLanguage?: Maybe<UpdateLanguagePayload>;
  deleteLanguage?: Maybe<DeleteLanguagePayload>;
  createLogo?: Maybe<CreateLogoPayload>;
  updateLogo?: Maybe<UpdateLogoPayload>;
  deleteLogo?: Maybe<DeleteLogoPayload>;
  createModal?: Maybe<CreateModalPayload>;
  updateModal?: Maybe<UpdateModalPayload>;
  deleteModal?: Maybe<DeleteModalPayload>;
  createModule?: Maybe<CreateModulePayload>;
  updateModule?: Maybe<UpdateModulePayload>;
  deleteModule?: Maybe<DeleteModulePayload>;
  createNote?: Maybe<CreateNotePayload>;
  updateNote?: Maybe<UpdateNotePayload>;
  deleteNote?: Maybe<DeleteNotePayload>;
  createNotification?: Maybe<CreateNotificationPayload>;
  updateNotification?: Maybe<UpdateNotificationPayload>;
  deleteNotification?: Maybe<DeleteNotificationPayload>;
  createParticipant?: Maybe<CreateParticipantPayload>;
  updateParticipant?: Maybe<UpdateParticipantPayload>;
  deleteParticipant?: Maybe<DeleteParticipantPayload>;
  createPostCardImage?: Maybe<CreatePostCardImagePayload>;
  updatePostCardImage?: Maybe<UpdatePostCardImagePayload>;
  deletePostCardImage?: Maybe<DeletePostCardImagePayload>;
  createPostCardSentence?: Maybe<CreatePostCardSentencePayload>;
  updatePostCardSentence?: Maybe<UpdatePostCardSentencePayload>;
  deletePostCardSentence?: Maybe<DeletePostCardSentencePayload>;
  createPostCard?: Maybe<CreatePostCardPayload>;
  updatePostCard?: Maybe<UpdatePostCardPayload>;
  deletePostCard?: Maybe<DeletePostCardPayload>;
  createProgrammeReport?: Maybe<CreateProgrammeReportPayload>;
  updateProgrammeReport?: Maybe<UpdateProgrammeReportPayload>;
  deleteProgrammeReport?: Maybe<DeleteProgrammeReportPayload>;
  createProgrammeSubmission?: Maybe<CreateProgrammeSubmissionPayload>;
  updateProgrammeSubmission?: Maybe<UpdateProgrammeSubmissionPayload>;
  deleteProgrammeSubmission?: Maybe<DeleteProgrammeSubmissionPayload>;
  createProgrammeType?: Maybe<CreateProgrammeTypePayload>;
  updateProgrammeType?: Maybe<UpdateProgrammeTypePayload>;
  deleteProgrammeType?: Maybe<DeleteProgrammeTypePayload>;
  createProgramme?: Maybe<CreateProgrammePayload>;
  updateProgramme?: Maybe<UpdateProgrammePayload>;
  deleteProgramme?: Maybe<DeleteProgrammePayload>;
  createRegion?: Maybe<CreateRegionPayload>;
  updateRegion?: Maybe<UpdateRegionPayload>;
  deleteRegion?: Maybe<DeleteRegionPayload>;
  createReport?: Maybe<CreateReportPayload>;
  updateReport?: Maybe<UpdateReportPayload>;
  deleteReport?: Maybe<DeleteReportPayload>;
  createRespondentsAnswer?: Maybe<CreateRespondentsAnswerPayload>;
  updateRespondentsAnswer?: Maybe<UpdateRespondentsAnswerPayload>;
  deleteRespondentsAnswer?: Maybe<DeleteRespondentsAnswerPayload>;
  createSection?: Maybe<CreateSectionPayload>;
  updateSection?: Maybe<UpdateSectionPayload>;
  deleteSection?: Maybe<DeleteSectionPayload>;
  createSubModuleSubmission?: Maybe<CreateSubModuleSubmissionPayload>;
  updateSubModuleSubmission?: Maybe<UpdateSubModuleSubmissionPayload>;
  deleteSubModuleSubmission?: Maybe<DeleteSubModuleSubmissionPayload>;
  createSubModule?: Maybe<CreateSubModulePayload>;
  updateSubModule?: Maybe<UpdateSubModulePayload>;
  deleteSubModule?: Maybe<DeleteSubModulePayload>;
  createSubmission?: Maybe<CreateSubmissionPayload>;
  updateSubmission?: Maybe<UpdateSubmissionPayload>;
  deleteSubmission?: Maybe<DeleteSubmissionPayload>;
  createSubmoduleReport?: Maybe<CreateSubmoduleReportPayload>;
  updateSubmoduleReport?: Maybe<UpdateSubmoduleReportPayload>;
  deleteSubmoduleReport?: Maybe<DeleteSubmoduleReportPayload>;
  createSurveyReport?: Maybe<CreateSurveyReportPayload>;
  updateSurveyReport?: Maybe<UpdateSurveyReportPayload>;
  deleteSurveyReport?: Maybe<DeleteSurveyReportPayload>;
  updateTranslation?: Maybe<UpdateTranslationPayload>;
  deleteTranslation?: Maybe<DeleteTranslationPayload>;
  createTypeFormCollection?: Maybe<CreateTypeFormCollectionPayload>;
  updateTypeFormCollection?: Maybe<UpdateTypeFormCollectionPayload>;
  deleteTypeFormCollection?: Maybe<DeleteTypeFormCollectionPayload>;
  createUploadedReport?: Maybe<CreateUploadedReportPayload>;
  updateUploadedReport?: Maybe<UpdateUploadedReportPayload>;
  deleteUploadedReport?: Maybe<DeleteUploadedReportPayload>;
  createUserUploadedDocument?: Maybe<CreateUserUploadedDocumentPayload>;
  updateUserUploadedDocument?: Maybe<UpdateUserUploadedDocumentPayload>;
  deleteUserUploadedDocument?: Maybe<DeleteUserUploadedDocumentPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  confirmMyAppointments: ConfirmAppointmentResponse;
  addNote: Notes;
  deletedNote?: Maybe<Notes>;
  updateMyProgrammeSubmissions: ProgrammeSubmission;
  generateMyProgrammeSubmissionResponses?: Maybe<ProgrammeSubmissionResponse>;
  generateCompetencyResponses?: Maybe<ProgrammeSubmissionResponse>;
  resendProgrammeMail?: Maybe<EmailSentProgramme>;
  updateMySubModuleSubmission: SubModuleSubmission;
  generateMySubModuleSubmissionResponses?: Maybe<SubModuleSubmissionResponse>;
  resendMail?: Maybe<EmailSent>;
  generateMySubModuleSubmissionComptencyResponses?: Maybe<SubModuleSubmissionResponse>;
  generateMyMiniSectionSubmissionResponse?: Maybe<SubModuleSubmissionResponse>;
  updateMySubmission: Submission;
  addDocument: UserUploadedDocument;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  updateSelf: UsersPermissionsUser;
};


export type MutationCreateAccountChangeArgs = {
  input?: Maybe<CreateAccountChangeInput>;
};


export type MutationUpdateAccountChangeArgs = {
  input?: Maybe<UpdateAccountChangeInput>;
};


export type MutationDeleteAccountChangeArgs = {
  input?: Maybe<DeleteAccountChangeInput>;
};


export type MutationCreateAppointmentArgs = {
  input?: Maybe<CreateAppointmentInput>;
};


export type MutationUpdateAppointmentArgs = {
  input?: Maybe<UpdateAppointmentInput>;
};


export type MutationDeleteAppointmentArgs = {
  input?: Maybe<DeleteAppointmentInput>;
};


export type MutationCreateArticleArgs = {
  input?: Maybe<CreateArticleInput>;
};


export type MutationUpdateArticleArgs = {
  input?: Maybe<UpdateArticleInput>;
};


export type MutationDeleteArticleArgs = {
  input?: Maybe<DeleteArticleInput>;
};


export type MutationCreateAuditTrailArgs = {
  input?: Maybe<CreateAuditTrailInput>;
};


export type MutationUpdateAuditTrailArgs = {
  input?: Maybe<UpdateAuditTrailInput>;
};


export type MutationDeleteAuditTrailArgs = {
  input?: Maybe<DeleteAuditTrailInput>;
};


export type MutationCreateBookingArgs = {
  input?: Maybe<CreateBookingInput>;
};


export type MutationUpdateBookingArgs = {
  input?: Maybe<UpdateBookingInput>;
};


export type MutationDeleteBookingArgs = {
  input?: Maybe<DeleteBookingInput>;
};


export type MutationCreateCoachSessionArgs = {
  input?: Maybe<CreateCoachSessionInput>;
};


export type MutationUpdateCoachSessionArgs = {
  input?: Maybe<UpdateCoachSessionInput>;
};


export type MutationDeleteCoachSessionArgs = {
  input?: Maybe<DeleteCoachSessionInput>;
};


export type MutationCreateCoachSubmittedReportArgs = {
  input?: Maybe<CreateCoachSubmittedReportInput>;
};


export type MutationUpdateCoachSubmittedReportArgs = {
  input?: Maybe<UpdateCoachSubmittedReportInput>;
};


export type MutationDeleteCoachSubmittedReportArgs = {
  input?: Maybe<DeleteCoachSubmittedReportInput>;
};


export type MutationCreateCoachArgs = {
  input?: Maybe<CreateCoachInput>;
};


export type MutationUpdateCoachArgs = {
  input?: Maybe<UpdateCoachInput>;
};


export type MutationDeleteCoachArgs = {
  input?: Maybe<DeleteCoachInput>;
};


export type MutationCreateCompanyArgs = {
  input?: Maybe<CreateCompanyInput>;
};


export type MutationUpdateCompanyArgs = {
  input?: Maybe<UpdateCompanyInput>;
};


export type MutationDeleteCompanyArgs = {
  input?: Maybe<DeleteCompanyInput>;
};


export type MutationCreateCompetencyUrlArgs = {
  input?: Maybe<CreateCompetencyUrlInput>;
};


export type MutationUpdateCompetencyUrlArgs = {
  input?: Maybe<UpdateCompetencyUrlInput>;
};


export type MutationDeleteCompetencyUrlArgs = {
  input?: Maybe<DeleteCompetencyUrlInput>;
};


export type MutationCreateDivisionArgs = {
  input?: Maybe<CreateDivisionInput>;
};


export type MutationUpdateDivisionArgs = {
  input?: Maybe<UpdateDivisionInput>;
};


export type MutationDeleteDivisionArgs = {
  input?: Maybe<DeleteDivisionInput>;
};


export type MutationCreateEmailLogArgs = {
  input?: Maybe<CreateEmailLogInput>;
};


export type MutationUpdateEmailLogArgs = {
  input?: Maybe<UpdateEmailLogInput>;
};


export type MutationDeleteEmailLogArgs = {
  input?: Maybe<DeleteEmailLogInput>;
};


export type MutationCreateEmailTemplateArgs = {
  input?: Maybe<CreateEmailTemplateInput>;
};


export type MutationUpdateEmailTemplateArgs = {
  input?: Maybe<UpdateEmailTemplateInput>;
};


export type MutationDeleteEmailTemplateArgs = {
  input?: Maybe<DeleteEmailTemplateInput>;
};


export type MutationCreateEventArgs = {
  input?: Maybe<CreateEventInput>;
};


export type MutationUpdateEventArgs = {
  input?: Maybe<UpdateEventInput>;
};


export type MutationDeleteEventArgs = {
  input?: Maybe<DeleteEventInput>;
};


export type MutationCreateFeedfowardUrlArgs = {
  input?: Maybe<CreateFeedfowardUrlInput>;
};


export type MutationUpdateFeedfowardUrlArgs = {
  input?: Maybe<UpdateFeedfowardUrlInput>;
};


export type MutationDeleteFeedfowardUrlArgs = {
  input?: Maybe<DeleteFeedfowardUrlInput>;
};


export type MutationCreateForwardedCardArgs = {
  input?: Maybe<CreateForwardedCardInput>;
};


export type MutationUpdateForwardedCardArgs = {
  input?: Maybe<UpdateForwardedCardInput>;
};


export type MutationDeleteForwardedCardArgs = {
  input?: Maybe<DeleteForwardedCardInput>;
};


export type MutationCreateInviteArgs = {
  input?: Maybe<CreateInviteInput>;
};


export type MutationUpdateInviteArgs = {
  input?: Maybe<UpdateInviteInput>;
};


export type MutationDeleteInviteArgs = {
  input?: Maybe<DeleteInviteInput>;
};


export type MutationCreateLanguageArgs = {
  input?: Maybe<CreateLanguageInput>;
};


export type MutationUpdateLanguageArgs = {
  input?: Maybe<UpdateLanguageInput>;
};


export type MutationDeleteLanguageArgs = {
  input?: Maybe<DeleteLanguageInput>;
};


export type MutationCreateLogoArgs = {
  input?: Maybe<CreateLogoInput>;
};


export type MutationUpdateLogoArgs = {
  input?: Maybe<UpdateLogoInput>;
};


export type MutationDeleteLogoArgs = {
  input?: Maybe<DeleteLogoInput>;
};


export type MutationCreateModalArgs = {
  input?: Maybe<CreateModalInput>;
};


export type MutationUpdateModalArgs = {
  input?: Maybe<UpdateModalInput>;
};


export type MutationDeleteModalArgs = {
  input?: Maybe<DeleteModalInput>;
};


export type MutationCreateModuleArgs = {
  input?: Maybe<CreateModuleInput>;
};


export type MutationUpdateModuleArgs = {
  input?: Maybe<UpdateModuleInput>;
};


export type MutationDeleteModuleArgs = {
  input?: Maybe<DeleteModuleInput>;
};


export type MutationCreateNoteArgs = {
  input?: Maybe<CreateNoteInput>;
};


export type MutationUpdateNoteArgs = {
  input?: Maybe<UpdateNoteInput>;
};


export type MutationDeleteNoteArgs = {
  input?: Maybe<DeleteNoteInput>;
};


export type MutationCreateNotificationArgs = {
  input?: Maybe<CreateNotificationInput>;
};


export type MutationUpdateNotificationArgs = {
  input?: Maybe<UpdateNotificationInput>;
};


export type MutationDeleteNotificationArgs = {
  input?: Maybe<DeleteNotificationInput>;
};


export type MutationCreateParticipantArgs = {
  input?: Maybe<CreateParticipantInput>;
};


export type MutationUpdateParticipantArgs = {
  input?: Maybe<UpdateParticipantInput>;
};


export type MutationDeleteParticipantArgs = {
  input?: Maybe<DeleteParticipantInput>;
};


export type MutationCreatePostCardImageArgs = {
  input?: Maybe<CreatePostCardImageInput>;
};


export type MutationUpdatePostCardImageArgs = {
  input?: Maybe<UpdatePostCardImageInput>;
};


export type MutationDeletePostCardImageArgs = {
  input?: Maybe<DeletePostCardImageInput>;
};


export type MutationCreatePostCardSentenceArgs = {
  input?: Maybe<CreatePostCardSentenceInput>;
};


export type MutationUpdatePostCardSentenceArgs = {
  input?: Maybe<UpdatePostCardSentenceInput>;
};


export type MutationDeletePostCardSentenceArgs = {
  input?: Maybe<DeletePostCardSentenceInput>;
};


export type MutationCreatePostCardArgs = {
  input?: Maybe<CreatePostCardInput>;
};


export type MutationUpdatePostCardArgs = {
  input?: Maybe<UpdatePostCardInput>;
};


export type MutationDeletePostCardArgs = {
  input?: Maybe<DeletePostCardInput>;
};


export type MutationCreateProgrammeReportArgs = {
  input?: Maybe<CreateProgrammeReportInput>;
};


export type MutationUpdateProgrammeReportArgs = {
  input?: Maybe<UpdateProgrammeReportInput>;
};


export type MutationDeleteProgrammeReportArgs = {
  input?: Maybe<DeleteProgrammeReportInput>;
};


export type MutationCreateProgrammeSubmissionArgs = {
  input?: Maybe<CreateProgrammeSubmissionInput>;
};


export type MutationUpdateProgrammeSubmissionArgs = {
  input?: Maybe<UpdateProgrammeSubmissionInput>;
};


export type MutationDeleteProgrammeSubmissionArgs = {
  input?: Maybe<DeleteProgrammeSubmissionInput>;
};


export type MutationCreateProgrammeTypeArgs = {
  input?: Maybe<CreateProgrammeTypeInput>;
};


export type MutationUpdateProgrammeTypeArgs = {
  input?: Maybe<UpdateProgrammeTypeInput>;
};


export type MutationDeleteProgrammeTypeArgs = {
  input?: Maybe<DeleteProgrammeTypeInput>;
};


export type MutationCreateProgrammeArgs = {
  input?: Maybe<CreateProgrammeInput>;
};


export type MutationUpdateProgrammeArgs = {
  input?: Maybe<UpdateProgrammeInput>;
};


export type MutationDeleteProgrammeArgs = {
  input?: Maybe<DeleteProgrammeInput>;
};


export type MutationCreateRegionArgs = {
  input?: Maybe<CreateRegionInput>;
};


export type MutationUpdateRegionArgs = {
  input?: Maybe<UpdateRegionInput>;
};


export type MutationDeleteRegionArgs = {
  input?: Maybe<DeleteRegionInput>;
};


export type MutationCreateReportArgs = {
  input?: Maybe<CreateReportInput>;
};


export type MutationUpdateReportArgs = {
  input?: Maybe<UpdateReportInput>;
};


export type MutationDeleteReportArgs = {
  input?: Maybe<DeleteReportInput>;
};


export type MutationCreateRespondentsAnswerArgs = {
  input?: Maybe<CreateRespondentsAnswerInput>;
};


export type MutationUpdateRespondentsAnswerArgs = {
  input?: Maybe<UpdateRespondentsAnswerInput>;
};


export type MutationDeleteRespondentsAnswerArgs = {
  input?: Maybe<DeleteRespondentsAnswerInput>;
};


export type MutationCreateSectionArgs = {
  input?: Maybe<CreateSectionInput>;
};


export type MutationUpdateSectionArgs = {
  input?: Maybe<UpdateSectionInput>;
};


export type MutationDeleteSectionArgs = {
  input?: Maybe<DeleteSectionInput>;
};


export type MutationCreateSubModuleSubmissionArgs = {
  input?: Maybe<CreateSubModuleSubmissionInput>;
};


export type MutationUpdateSubModuleSubmissionArgs = {
  input?: Maybe<UpdateSubModuleSubmissionInput>;
};


export type MutationDeleteSubModuleSubmissionArgs = {
  input?: Maybe<DeleteSubModuleSubmissionInput>;
};


export type MutationCreateSubModuleArgs = {
  input?: Maybe<CreateSubModuleInput>;
};


export type MutationUpdateSubModuleArgs = {
  input?: Maybe<UpdateSubModuleInput>;
};


export type MutationDeleteSubModuleArgs = {
  input?: Maybe<DeleteSubModuleInput>;
};


export type MutationCreateSubmissionArgs = {
  input?: Maybe<CreateSubmissionInput>;
};


export type MutationUpdateSubmissionArgs = {
  input?: Maybe<UpdateSubmissionInput>;
};


export type MutationDeleteSubmissionArgs = {
  input?: Maybe<DeleteSubmissionInput>;
};


export type MutationCreateSubmoduleReportArgs = {
  input?: Maybe<CreateSubmoduleReportInput>;
};


export type MutationUpdateSubmoduleReportArgs = {
  input?: Maybe<UpdateSubmoduleReportInput>;
};


export type MutationDeleteSubmoduleReportArgs = {
  input?: Maybe<DeleteSubmoduleReportInput>;
};


export type MutationCreateSurveyReportArgs = {
  input?: Maybe<CreateSurveyReportInput>;
};


export type MutationUpdateSurveyReportArgs = {
  input?: Maybe<UpdateSurveyReportInput>;
};


export type MutationDeleteSurveyReportArgs = {
  input?: Maybe<DeleteSurveyReportInput>;
};


export type MutationUpdateTranslationArgs = {
  input?: Maybe<UpdateTranslationInput>;
};


export type MutationCreateTypeFormCollectionArgs = {
  input?: Maybe<CreateTypeFormCollectionInput>;
};


export type MutationUpdateTypeFormCollectionArgs = {
  input?: Maybe<UpdateTypeFormCollectionInput>;
};


export type MutationDeleteTypeFormCollectionArgs = {
  input?: Maybe<DeleteTypeFormCollectionInput>;
};


export type MutationCreateUploadedReportArgs = {
  input?: Maybe<CreateUploadedReportInput>;
};


export type MutationUpdateUploadedReportArgs = {
  input?: Maybe<UpdateUploadedReportInput>;
};


export type MutationDeleteUploadedReportArgs = {
  input?: Maybe<DeleteUploadedReportInput>;
};


export type MutationCreateUserUploadedDocumentArgs = {
  input?: Maybe<CreateUserUploadedDocumentInput>;
};


export type MutationUpdateUserUploadedDocumentArgs = {
  input?: Maybe<UpdateUserUploadedDocumentInput>;
};


export type MutationDeleteUserUploadedDocumentArgs = {
  input?: Maybe<DeleteUserUploadedDocumentInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationConfirmMyAppointmentsArgs = {
  appointmentScheduleId: Scalars['ID'];
  programmeSubmissionId: Scalars['ID'];
  subModule: Scalars['Boolean'];
};


export type MutationAddNoteArgs = {
  input: EditNoteInput;
};


export type MutationDeletedNoteArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateMyProgrammeSubmissionsArgs = {
  id: Scalars['ID'];
  isPdf?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  input: EditProgrammeSubmissionInput;
};


export type MutationGenerateMyProgrammeSubmissionResponsesArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateCompetencyResponsesArgs = {
  id: Scalars['ID'];
};


export type MutationResendProgrammeMailArgs = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};


export type MutationUpdateMySubModuleSubmissionArgs = {
  id: Scalars['ID'];
  currentSection?: Maybe<Scalars['Int']>;
  isPdf?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  programmeSubmissionId?: Maybe<Scalars['ID']>;
  input: EditSubModuleSubmissionInput;
};


export type MutationGenerateMySubModuleSubmissionResponsesArgs = {
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['Int']>;
};


export type MutationResendMailArgs = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};


export type MutationGenerateMySubModuleSubmissionComptencyResponsesArgs = {
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['Int']>;
};


export type MutationGenerateMyMiniSectionSubmissionResponseArgs = {
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['Int']>;
  secId?: Maybe<Scalars['Int']>;
};


export type MutationUpdateMySubmissionArgs = {
  id: Scalars['ID'];
  currentSection?: Maybe<Scalars['Int']>;
  programmeSubmissionId?: Maybe<Scalars['ID']>;
  input: EditSubmissionInput;
};


export type MutationAddDocumentArgs = {
  input: EditUserUploadedDocumentInput;
  editFlag?: Maybe<Scalars['Boolean']>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationUpdateSelfArgs = {
  user: EditUserInput;
};

export type CreateAccountChangeInput = {
  data?: Maybe<AccountChangeInput>;
};

export type AccountChangeInput = {
  user?: Maybe<Scalars['ID']>;
  oldDivision?: Maybe<Scalars['ID']>;
  oldRegion?: Maybe<Scalars['ID']>;
  newDivision?: Maybe<Scalars['ID']>;
  newRegion?: Maybe<Scalars['ID']>;
  accept?: Maybe<Scalars['Boolean']>;
  userUpdated?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateAccountChangeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAccountChangeInput>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type EditAccountChangeInput = {
  user?: Maybe<Scalars['ID']>;
  oldDivision?: Maybe<Scalars['ID']>;
  oldRegion?: Maybe<Scalars['ID']>;
  newDivision?: Maybe<Scalars['ID']>;
  newRegion?: Maybe<Scalars['ID']>;
  accept?: Maybe<Scalars['Boolean']>;
  userUpdated?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteAccountChangeInput = {
  where?: Maybe<InputId>;
};

export type CreateAppointmentInput = {
  data?: Maybe<AppointmentInput>;
};

export type AppointmentInput = {
  calendarId?: Maybe<Scalars['Long']>;
  businessId?: Maybe<Scalars['Long']>;
  appointmentTitle?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  appointmentScheduleId?: Maybe<Scalars['Long']>;
  appointmentUrl?: Maybe<Scalars['String']>;
  appointmentStartDate?: Maybe<Scalars['DateTime']>;
  appointmentEndDate?: Maybe<Scalars['DateTime']>;
  coach_session?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateAppointmentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAppointmentInput>;
};

export type EditAppointmentInput = {
  calendarId?: Maybe<Scalars['Long']>;
  businessId?: Maybe<Scalars['Long']>;
  appointmentTitle?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  appointmentScheduleId?: Maybe<Scalars['Long']>;
  appointmentUrl?: Maybe<Scalars['String']>;
  appointmentStartDate?: Maybe<Scalars['DateTime']>;
  appointmentEndDate?: Maybe<Scalars['DateTime']>;
  coach_session?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteAppointmentInput = {
  where?: Maybe<InputId>;
};

export type CreateArticleInput = {
  data?: Maybe<ArticleInput>;
};

export type ArticleInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  contentEnglish?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  datePublished?: Maybe<Scalars['Date']>;
  readTime?: Maybe<Scalars['Int']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  contentFrench?: Maybe<Scalars['String']>;
  contentGerman?: Maybe<Scalars['String']>;
  contentSpanish?: Maybe<Scalars['String']>;
  contentMandarin?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  position?: Maybe<Scalars['Long']>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateArticleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditArticleInput>;
};

export type EditArticleInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  contentEnglish?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  datePublished?: Maybe<Scalars['Date']>;
  readTime?: Maybe<Scalars['Int']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  contentFrench?: Maybe<Scalars['String']>;
  contentGerman?: Maybe<Scalars['String']>;
  contentSpanish?: Maybe<Scalars['String']>;
  contentMandarin?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  position?: Maybe<Scalars['Long']>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteArticleInput = {
  where?: Maybe<InputId>;
};

export type CreateAuditTrailInput = {
  data?: Maybe<AuditTrailInput>;
};

export type AuditTrailInput = {
  details?: Maybe<Scalars['JSON']>;
  action?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  by?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateAuditTrailInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAuditTrailInput>;
};

export type EditAuditTrailInput = {
  details?: Maybe<Scalars['JSON']>;
  action?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  by?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteAuditTrailInput = {
  where?: Maybe<InputId>;
};

export type CreateBookingInput = {
  data?: Maybe<BookingInput>;
};

export type BookingInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  user?: Maybe<Scalars['ID']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['Int']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  isUpdated?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  organiser?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateBookingInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBookingInput>;
};

export type EditBookingInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  user?: Maybe<Scalars['ID']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['Int']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  isUpdated?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  organiser?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteBookingInput = {
  where?: Maybe<InputId>;
};

export type CreateCoachSessionInput = {
  data?: Maybe<CoachSessionInput>;
};

export type CoachSessionInput = {
  title?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  user?: Maybe<Scalars['ID']>;
  programme_submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  appointment?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCoachSessionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCoachSessionInput>;
};

export type EditCoachSessionInput = {
  title?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  user?: Maybe<Scalars['ID']>;
  programme_submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  appointment?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCoachSessionInput = {
  where?: Maybe<InputId>;
};

export type CreateCoachSubmittedReportInput = {
  data?: Maybe<CoachSubmittedReportInput>;
};

export type CoachSubmittedReportInput = {
  name?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  notesId?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponentInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentSubmissionsSaboteurComponentInput = {
  saboteurProofValue?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateCoachSubmittedReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCoachSubmittedReportInput>;
};

export type EditCoachSubmittedReportInput = {
  name?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  notesId?: Maybe<Array<Maybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentSubmissionsSaboteurComponentInput = {
  id?: Maybe<Scalars['ID']>;
  saboteurProofValue?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type DeleteCoachSubmittedReportInput = {
  where?: Maybe<InputId>;
};

export type CreateCoachInput = {
  data?: Maybe<CoachInput>;
};

export type CoachInput = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  isCoachAddedByUser?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCoachInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCoachInput>;
};

export type EditCoachInput = {
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  isCoachAddedByUser?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCoachInput = {
  where?: Maybe<InputId>;
};

export type CreateCompanyInput = {
  data?: Maybe<CompanyInput>;
};

export type CompanyInput = {
  name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  modules?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  certificateTemplate?: Maybe<Scalars['ID']>;
  articles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  welcomeScreen?: Maybe<ComponentTranslationsWelcomeScreenInput>;
  languageSelection?: Maybe<ComponentTranslationsLanguageSelectionInput>;
  letsGetStartedScreen?: Maybe<ComponentTranslationsLetsGetStartedScreenInput>;
  whatToExpect?: Maybe<ComponentTranslationsWhatToExpectInput>;
  divisions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  regions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  programmesTitle?: Maybe<Scalars['String']>;
  programmesSubTitle?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  aboutUs?: Maybe<ComponentTranslationsAboutUsInput>;
  email_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  usersConfirmDetails?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentTranslationsWelcomeScreenInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  videoEnglish?: Maybe<Scalars['ID']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  videoFrench?: Maybe<Scalars['ID']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  videoGerman?: Maybe<Scalars['ID']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  videoSpanish?: Maybe<Scalars['ID']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
  videoMandarin?: Maybe<Scalars['ID']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsLanguageSelectionInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsLetsGetStartedScreenInput = {
  image?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']>;
  firstNameErrorEnglish?: Maybe<Scalars['String']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']>;
  lastNameErrorEnglish?: Maybe<Scalars['String']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']>;
  jobTitleErrorEnglish?: Maybe<Scalars['String']>;
  divisionLabelEnglish?: Maybe<Scalars['String']>;
  divisionErrorEnglish?: Maybe<Scalars['String']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  firstNameLabelFrench?: Maybe<Scalars['String']>;
  firstNameErrorFrench?: Maybe<Scalars['String']>;
  lastNameLabelFrench?: Maybe<Scalars['String']>;
  lastNameErrorFrench?: Maybe<Scalars['String']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']>;
  jobTitleErrorFrench?: Maybe<Scalars['String']>;
  divisionLabelFrench?: Maybe<Scalars['String']>;
  divisionErrorFrench?: Maybe<Scalars['String']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  firstNameLabelGerman?: Maybe<Scalars['String']>;
  firstNameErrorGerman?: Maybe<Scalars['String']>;
  lastNameLabelGerman?: Maybe<Scalars['String']>;
  lastNameErrorGerman?: Maybe<Scalars['String']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']>;
  jobTitleErrorGerman?: Maybe<Scalars['String']>;
  divisionLabelGerman?: Maybe<Scalars['String']>;
  divisionErrorGerman?: Maybe<Scalars['String']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']>;
  firstNameErrorSpanish?: Maybe<Scalars['String']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']>;
  lastNameErrorSpanish?: Maybe<Scalars['String']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']>;
  jobTitleErrorSpanish?: Maybe<Scalars['String']>;
  divisionLabelSpanish?: Maybe<Scalars['String']>;
  divisionErrorSpanish?: Maybe<Scalars['String']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']>;
  firstNameErrorMandarin?: Maybe<Scalars['String']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']>;
  lastNameErrorMandarin?: Maybe<Scalars['String']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']>;
  jobTitleErrorMandarin?: Maybe<Scalars['String']>;
  divisionLabelMandarin?: Maybe<Scalars['String']>;
  divisionErrorMandarin?: Maybe<Scalars['String']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
  timezoneErrorEnglish?: Maybe<Scalars['String']>;
  timezoneLabelSpanish?: Maybe<Scalars['String']>;
  timezoneLabelFrench?: Maybe<Scalars['String']>;
  timezoneLabelGerman?: Maybe<Scalars['String']>;
  timezoneLabelMandarin?: Maybe<Scalars['String']>;
  timezoneLabelEnglish?: Maybe<Scalars['String']>;
  timezoneErrorFrench?: Maybe<Scalars['String']>;
  timezoneErrorSpanish?: Maybe<Scalars['String']>;
  timezoneErrorGerman?: Maybe<Scalars['String']>;
  timezoneErrorMandarin?: Maybe<Scalars['String']>;
  regionLabelEnglish?: Maybe<Scalars['String']>;
  regionErrorEnglish?: Maybe<Scalars['String']>;
  regionLabelFrench?: Maybe<Scalars['String']>;
  regionErrorFrench?: Maybe<Scalars['String']>;
  regionLabelSpanish?: Maybe<Scalars['String']>;
  regionErrorSpanish?: Maybe<Scalars['String']>;
  regionLabelGerman?: Maybe<Scalars['String']>;
  regionErrorGerman?: Maybe<Scalars['String']>;
  regionLabelMandarin?: Maybe<Scalars['String']>;
  regionErrorMandarin?: Maybe<Scalars['String']>;
  leftTitleEnglish?: Maybe<Scalars['String']>;
  leftSubtitleEnglish?: Maybe<Scalars['String']>;
  leftTitleSpanish?: Maybe<Scalars['String']>;
  leftSubtitleSpanish?: Maybe<Scalars['String']>;
  leftTitleMandarin?: Maybe<Scalars['String']>;
  leftSubTitleMandarin?: Maybe<Scalars['String']>;
  leftTitleFrench?: Maybe<Scalars['String']>;
  leftSubtitleFrench?: Maybe<Scalars['String']>;
  leftSubtitleGerman?: Maybe<Scalars['String']>;
  leftTitleGerman?: Maybe<Scalars['String']>;
  leftTitleCzech?: Maybe<Scalars['String']>;
  havingTroubleEnglish?: Maybe<Scalars['String']>;
  havingTroubleSpanish?: Maybe<Scalars['String']>;
  havingTroubleFrench?: Maybe<Scalars['String']>;
  havingTroubleMandarin?: Maybe<Scalars['String']>;
  havingTroubleGerman?: Maybe<Scalars['String']>;
  getHelpButtonEnglish?: Maybe<Scalars['String']>;
  getHelpButtonSpanish?: Maybe<Scalars['String']>;
  getHelpButtonFrench?: Maybe<Scalars['String']>;
  getHelpButtonGerman?: Maybe<Scalars['String']>;
  getHelpButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsWhatToExpectInput = {
  image?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  getStartedButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  getStartedButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  getStartedButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  getStartedButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
  getStartedButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsAboutUsInput = {
  textEnglish?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  userGuidelinesTextEnglish?: Maybe<Scalars['String']>;
  userGuidelinesTextFrench?: Maybe<Scalars['String']>;
  userGuidelinesTextGerman?: Maybe<Scalars['String']>;
  userGuidelinesEnglish?: Maybe<Array<Maybe<Scalars['ID']>>>;
  userGuidelinesFrench?: Maybe<Array<Maybe<Scalars['ID']>>>;
  userGuidelinesGerman?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateCompanyInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCompanyInput>;
};

export type EditCompanyInput = {
  name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  modules?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  certificateTemplate?: Maybe<Scalars['ID']>;
  articles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  welcomeScreen?: Maybe<EditComponentTranslationsWelcomeScreenInput>;
  languageSelection?: Maybe<EditComponentTranslationsLanguageSelectionInput>;
  letsGetStartedScreen?: Maybe<EditComponentTranslationsLetsGetStartedScreenInput>;
  whatToExpect?: Maybe<EditComponentTranslationsWhatToExpectInput>;
  divisions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  regions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  programmesTitle?: Maybe<Scalars['String']>;
  programmesSubTitle?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  aboutUs?: Maybe<EditComponentTranslationsAboutUsInput>;
  email_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  usersConfirmDetails?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentTranslationsWelcomeScreenInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  videoEnglish?: Maybe<Scalars['ID']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  videoFrench?: Maybe<Scalars['ID']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  videoGerman?: Maybe<Scalars['ID']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  videoSpanish?: Maybe<Scalars['ID']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
  videoMandarin?: Maybe<Scalars['ID']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsLanguageSelectionInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsLetsGetStartedScreenInput = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']>;
  firstNameErrorEnglish?: Maybe<Scalars['String']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']>;
  lastNameErrorEnglish?: Maybe<Scalars['String']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']>;
  jobTitleErrorEnglish?: Maybe<Scalars['String']>;
  divisionLabelEnglish?: Maybe<Scalars['String']>;
  divisionErrorEnglish?: Maybe<Scalars['String']>;
  nextButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  firstNameLabelFrench?: Maybe<Scalars['String']>;
  firstNameErrorFrench?: Maybe<Scalars['String']>;
  lastNameLabelFrench?: Maybe<Scalars['String']>;
  lastNameErrorFrench?: Maybe<Scalars['String']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']>;
  jobTitleErrorFrench?: Maybe<Scalars['String']>;
  divisionLabelFrench?: Maybe<Scalars['String']>;
  divisionErrorFrench?: Maybe<Scalars['String']>;
  nextButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  firstNameLabelGerman?: Maybe<Scalars['String']>;
  firstNameErrorGerman?: Maybe<Scalars['String']>;
  lastNameLabelGerman?: Maybe<Scalars['String']>;
  lastNameErrorGerman?: Maybe<Scalars['String']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']>;
  jobTitleErrorGerman?: Maybe<Scalars['String']>;
  divisionLabelGerman?: Maybe<Scalars['String']>;
  divisionErrorGerman?: Maybe<Scalars['String']>;
  nextButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']>;
  firstNameErrorSpanish?: Maybe<Scalars['String']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']>;
  lastNameErrorSpanish?: Maybe<Scalars['String']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']>;
  jobTitleErrorSpanish?: Maybe<Scalars['String']>;
  divisionLabelSpanish?: Maybe<Scalars['String']>;
  divisionErrorSpanish?: Maybe<Scalars['String']>;
  nextButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']>;
  firstNameErrorMandarin?: Maybe<Scalars['String']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']>;
  lastNameErrorMandarin?: Maybe<Scalars['String']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']>;
  jobTitleErrorMandarin?: Maybe<Scalars['String']>;
  divisionLabelMandarin?: Maybe<Scalars['String']>;
  divisionErrorMandarin?: Maybe<Scalars['String']>;
  nextButtonMandarin?: Maybe<Scalars['String']>;
  timezoneErrorEnglish?: Maybe<Scalars['String']>;
  timezoneLabelSpanish?: Maybe<Scalars['String']>;
  timezoneLabelFrench?: Maybe<Scalars['String']>;
  timezoneLabelGerman?: Maybe<Scalars['String']>;
  timezoneLabelMandarin?: Maybe<Scalars['String']>;
  timezoneLabelEnglish?: Maybe<Scalars['String']>;
  timezoneErrorFrench?: Maybe<Scalars['String']>;
  timezoneErrorSpanish?: Maybe<Scalars['String']>;
  timezoneErrorGerman?: Maybe<Scalars['String']>;
  timezoneErrorMandarin?: Maybe<Scalars['String']>;
  regionLabelEnglish?: Maybe<Scalars['String']>;
  regionErrorEnglish?: Maybe<Scalars['String']>;
  regionLabelFrench?: Maybe<Scalars['String']>;
  regionErrorFrench?: Maybe<Scalars['String']>;
  regionLabelSpanish?: Maybe<Scalars['String']>;
  regionErrorSpanish?: Maybe<Scalars['String']>;
  regionLabelGerman?: Maybe<Scalars['String']>;
  regionErrorGerman?: Maybe<Scalars['String']>;
  regionLabelMandarin?: Maybe<Scalars['String']>;
  regionErrorMandarin?: Maybe<Scalars['String']>;
  leftTitleEnglish?: Maybe<Scalars['String']>;
  leftSubtitleEnglish?: Maybe<Scalars['String']>;
  leftTitleSpanish?: Maybe<Scalars['String']>;
  leftSubtitleSpanish?: Maybe<Scalars['String']>;
  leftTitleMandarin?: Maybe<Scalars['String']>;
  leftSubTitleMandarin?: Maybe<Scalars['String']>;
  leftTitleFrench?: Maybe<Scalars['String']>;
  leftSubtitleFrench?: Maybe<Scalars['String']>;
  leftSubtitleGerman?: Maybe<Scalars['String']>;
  leftTitleGerman?: Maybe<Scalars['String']>;
  leftTitleCzech?: Maybe<Scalars['String']>;
  havingTroubleEnglish?: Maybe<Scalars['String']>;
  havingTroubleSpanish?: Maybe<Scalars['String']>;
  havingTroubleFrench?: Maybe<Scalars['String']>;
  havingTroubleMandarin?: Maybe<Scalars['String']>;
  havingTroubleGerman?: Maybe<Scalars['String']>;
  getHelpButtonEnglish?: Maybe<Scalars['String']>;
  getHelpButtonSpanish?: Maybe<Scalars['String']>;
  getHelpButtonFrench?: Maybe<Scalars['String']>;
  getHelpButtonGerman?: Maybe<Scalars['String']>;
  getHelpButtonMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsWhatToExpectInput = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  bodyEnglish?: Maybe<Scalars['String']>;
  getStartedButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  bodyFrench?: Maybe<Scalars['String']>;
  getStartedButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  bodyGerman?: Maybe<Scalars['String']>;
  getStartedButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  bodySpanish?: Maybe<Scalars['String']>;
  getStartedButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  bodyMandarin?: Maybe<Scalars['String']>;
  getStartedButtonMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsAboutUsInput = {
  id?: Maybe<Scalars['ID']>;
  textEnglish?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  userGuidelinesTextEnglish?: Maybe<Scalars['String']>;
  userGuidelinesTextFrench?: Maybe<Scalars['String']>;
  userGuidelinesTextGerman?: Maybe<Scalars['String']>;
  userGuidelinesEnglish?: Maybe<Array<Maybe<Scalars['ID']>>>;
  userGuidelinesFrench?: Maybe<Array<Maybe<Scalars['ID']>>>;
  userGuidelinesGerman?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteCompanyInput = {
  where?: Maybe<InputId>;
};

export type CreateCompetencyUrlInput = {
  data?: Maybe<CompetencyUrlInput>;
};

export type CompetencyUrlInput = {
  url?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<Scalars['ID']>;
  submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  coach_email?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCompetencyUrlInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCompetencyUrlInput>;
};

export type EditCompetencyUrlInput = {
  url?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<Scalars['ID']>;
  submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  coach_email?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCompetencyUrlInput = {
  where?: Maybe<InputId>;
};

export type CreateDivisionInput = {
  data?: Maybe<DivisionInput>;
};

export type DivisionInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateDivisionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDivisionInput>;
};

export type EditDivisionInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteDivisionInput = {
  where?: Maybe<InputId>;
};

export type CreateEmailLogInput = {
  data?: Maybe<EmailLogInput>;
};

export type EmailLogInput = {
  to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  programme?: Maybe<Scalars['ID']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateEmailLogInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEmailLogInput>;
};

export type EditEmailLogInput = {
  to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  programme?: Maybe<Scalars['ID']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteEmailLogInput = {
  where?: Maybe<InputId>;
};

export type CreateEmailTemplateInput = {
  data?: Maybe<EmailTemplateInput>;
};

export type EmailTemplateInput = {
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateEmailTemplateInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEmailTemplateInput>;
};

export type EditEmailTemplateInput = {
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteEmailTemplateInput = {
  where?: Maybe<InputId>;
};

export type CreateEventInput = {
  data?: Maybe<EventInput>;
};

export type EventInput = {
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sessionId?: Maybe<Scalars['Long']>;
  description?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['Long']>;
  classId?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateEventInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditEventInput>;
};

export type EditEventInput = {
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sessionId?: Maybe<Scalars['Long']>;
  description?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['Long']>;
  classId?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteEventInput = {
  where?: Maybe<InputId>;
};

export type CreateFeedfowardUrlInput = {
  data?: Maybe<FeedfowardUrlInput>;
};

export type FeedfowardUrlInput = {
  url?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  coach_email?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateFeedfowardUrlInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFeedfowardUrlInput>;
};

export type EditFeedfowardUrlInput = {
  url?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  coach_email?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteFeedfowardUrlInput = {
  where?: Maybe<InputId>;
};

export type CreateForwardedCardInput = {
  data?: Maybe<ForwardedCardInput>;
};

export type ForwardedCardInput = {
  postCard?: Maybe<Scalars['ID']>;
  p1: Scalars['String'];
  p2: Scalars['String'];
  p3: Scalars['String'];
  p1Sentence: Scalars['String'];
  p2Sentence: Scalars['String'];
  p3Sentence: Scalars['String'];
  signature: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
  generalText?: Maybe<Scalars['String']>;
  dear: Scalars['String'];
  promotionLink?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateForwardedCardInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditForwardedCardInput>;
};

export type EditForwardedCardInput = {
  postCard?: Maybe<Scalars['ID']>;
  p1?: Maybe<Scalars['String']>;
  p2?: Maybe<Scalars['String']>;
  p3?: Maybe<Scalars['String']>;
  p1Sentence?: Maybe<Scalars['String']>;
  p2Sentence?: Maybe<Scalars['String']>;
  p3Sentence?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  generalText?: Maybe<Scalars['String']>;
  dear?: Maybe<Scalars['String']>;
  promotionLink?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteForwardedCardInput = {
  where?: Maybe<InputId>;
};

export type CreateInviteInput = {
  data?: Maybe<InviteInput>;
};

export type InviteInput = {
  email?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateInviteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditInviteInput>;
};

export type EditInviteInput = {
  email?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteInviteInput = {
  where?: Maybe<InputId>;
};

export type CreateLanguageInput = {
  data?: Maybe<LanguageInput>;
};

export type LanguageInput = {
  image?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Enum_Language_Name>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateLanguageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditLanguageInput>;
};

export type EditLanguageInput = {
  image?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Enum_Language_Name>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteLanguageInput = {
  where?: Maybe<InputId>;
};

export type CreateLogoInput = {
  data?: Maybe<LogoInput>;
};

export type LogoInput = {
  logo?: Maybe<Scalars['ID']>;
  postCards?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateLogoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditLogoInput>;
};

export type EditLogoInput = {
  logo?: Maybe<Scalars['ID']>;
  postCards?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteLogoInput = {
  where?: Maybe<InputId>;
};

export type CreateModalInput = {
  data?: Maybe<ModalInput>;
};

export type ModalInput = {
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateModalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditModalInput>;
};

export type EditModalInput = {
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteModalInput = {
  where?: Maybe<InputId>;
};

export type CreateModuleInput = {
  data?: Maybe<ModuleInput>;
};

export type ModuleInput = {
  nameEnglish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  cover?: Maybe<Scalars['ID']>;
  submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  descriptionEnglish?: Maybe<Scalars['String']>;
  descriptionFrench?: Maybe<Scalars['String']>;
  descriptionGerman?: Maybe<Scalars['String']>;
  descriptionMandarin?: Maybe<Scalars['String']>;
  descriptionSpanish?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  position?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateModuleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditModuleInput>;
};

export type EditModuleInput = {
  nameEnglish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  cover?: Maybe<Scalars['ID']>;
  submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  descriptionEnglish?: Maybe<Scalars['String']>;
  descriptionFrench?: Maybe<Scalars['String']>;
  descriptionGerman?: Maybe<Scalars['String']>;
  descriptionMandarin?: Maybe<Scalars['String']>;
  descriptionSpanish?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  position?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteModuleInput = {
  where?: Maybe<InputId>;
};

export type CreateNoteInput = {
  data?: Maybe<NoteInput>;
};

export type NoteInput = {
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  sectionOrSubmissionId?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<Scalars['ID']>;
  document?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notesId?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponentInput>>>;
  programme?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateNoteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNoteInput>;
};

export type EditNoteInput = {
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  sectionOrSubmissionId?: Maybe<Scalars['String']>;
  programme_submission?: Maybe<Scalars['ID']>;
  document?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notesId?: Maybe<Array<Maybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  programme?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteNoteInput = {
  where?: Maybe<InputId>;
};

export type CreateNotificationInput = {
  data?: Maybe<NotificationInput>;
};

export type NotificationInput = {
  title?: Maybe<Scalars['String']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  path?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  report?: Maybe<Scalars['ID']>;
  programme_report?: Maybe<Scalars['ID']>;
  submodule_report?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateNotificationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNotificationInput>;
};

export type EditNotificationInput = {
  title?: Maybe<Scalars['String']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  path?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  report?: Maybe<Scalars['ID']>;
  programme_report?: Maybe<Scalars['ID']>;
  submodule_report?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteNotificationInput = {
  where?: Maybe<InputId>;
};

export type CreateParticipantInput = {
  data?: Maybe<ParticipantInput>;
};

export type ParticipantInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Participants_Type>;
  programme_submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  coach_email?: Maybe<Scalars['String']>;
  survey_sent_date?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateParticipantInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditParticipantInput>;
};

export type EditParticipantInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Participants_Type>;
  programme_submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  coach_email?: Maybe<Scalars['String']>;
  survey_sent_date?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteParticipantInput = {
  where?: Maybe<InputId>;
};

export type CreatePostCardImageInput = {
  data?: Maybe<PostCardImageInput>;
};

export type PostCardImageInput = {
  image?: Maybe<Scalars['ID']>;
  postCards?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdatePostCardImageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPostCardImageInput>;
};

export type EditPostCardImageInput = {
  image?: Maybe<Scalars['ID']>;
  postCards?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeletePostCardImageInput = {
  where?: Maybe<InputId>;
};

export type CreatePostCardSentenceInput = {
  data?: Maybe<PostCardSentenceInput>;
};

export type PostCardSentenceInput = {
  postCardSentence?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdatePostCardSentenceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPostCardSentenceInput>;
};

export type EditPostCardSentenceInput = {
  postCardSentence?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeletePostCardSentenceInput = {
  where?: Maybe<InputId>;
};

export type CreatePostCardInput = {
  data?: Maybe<PostCardInput>;
};

export type PostCardInput = {
  frontImage?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  postCardImage?: Maybe<Scalars['ID']>;
  forwardedCards?: Maybe<Array<Maybe<Scalars['ID']>>>;
  frontText?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['ID']>;
  expirationTime?: Maybe<Scalars['Long']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdatePostCardInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPostCardInput>;
};

export type EditPostCardInput = {
  frontImage?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  postCardImage?: Maybe<Scalars['ID']>;
  forwardedCards?: Maybe<Array<Maybe<Scalars['ID']>>>;
  frontText?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['ID']>;
  expirationTime?: Maybe<Scalars['Long']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeletePostCardInput = {
  where?: Maybe<InputId>;
};

export type CreateProgrammeReportInput = {
  data?: Maybe<ProgrammeReportInput>;
};

export type ProgrammeReportInput = {
  name?: Maybe<Scalars['String']>;
  report?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_submission?: Maybe<Scalars['ID']>;
  notification?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateProgrammeReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProgrammeReportInput>;
};

export type EditProgrammeReportInput = {
  name?: Maybe<Scalars['String']>;
  report?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_submission?: Maybe<Scalars['ID']>;
  notification?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProgrammeReportInput = {
  where?: Maybe<InputId>;
};

export type CreateProgrammeSubmissionInput = {
  data?: Maybe<ProgrammeSubmissionInput>;
};

export type ProgrammeSubmissionInput = {
  status?: Maybe<Enum_Programmesubmission_Status>;
  progress?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['ID']>;
  programme_type?: Maybe<Scalars['ID']>;
  coach_sessions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmeResponses?: Maybe<Array<Maybe<ComponentSubmissionsProgrammeSubmissionInput>>>;
  myNotes?: Maybe<Array<Maybe<ComponentSubmissionsNoteInput>>>;
  submissionparticipants?: Maybe<Array<Maybe<ComponentSubmissionsParticipantInput>>>;
  programme_report?: Maybe<Scalars['ID']>;
  programme?: Maybe<Scalars['ID']>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  competency_url?: Maybe<Scalars['ID']>;
  feedfoward_url?: Maybe<Scalars['ID']>;
  selected?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Array<Maybe<Scalars['ID']>>>;
  uploaded_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
  isUpdatedByStakeholder?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentSubmissionsProgrammeSubmissionInput = {
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswerInput>>>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItemInput>>>;
  stakeholderChart?: Maybe<Scalars['ID']>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItemInput>>>;
  xYGraphChart?: Maybe<Scalars['ID']>;
  saboteurImage?: Maybe<Scalars['ID']>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristicInput>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<Scalars['ID']>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGapInput>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponentInput>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswerInput>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<ComponentSubmissionsSabtourVideosComponentInput>>>;
  saboteur?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponentInput>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<ComponentSubmissionsGravitasSlidersAnswerInput>>>;
  gravitasGap?: Maybe<Array<Maybe<ComponentSubmissionsGravitasGapInput>>>;
};

export type ComponentSubmissionsAnswerInput = {
  questionId?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  nestedAnswers?: Maybe<Array<Maybe<ComponentSubmissionsRepeatAnswerInput>>>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  feedback?: Maybe<Scalars['String']>;
  outcome?: Maybe<Enum_Componentsubmissionsanswer_Outcome>;
  questionTitle?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsRepeatAnswerInput = {
  answer?: Maybe<Scalars['String']>;
  questionTitle?: Maybe<Scalars['String']>;
};

export type ComponentGravitasScaleItemsGravitasScaleItemInput = {
  labelOne?: Maybe<Scalars['String']>;
  labelTwo?: Maybe<Scalars['String']>;
  answerOne?: Maybe<Scalars['Int']>;
  answerTwo?: Maybe<Scalars['Int']>;
  answerThree?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  labelThree?: Maybe<Scalars['String']>;
};

export type ComponentStakeholderMapItemStackholderMapItemInput = {
  name?: Maybe<Scalars['String']>;
  valueX?: Maybe<Scalars['Int']>;
  valueY?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
};

export type ComponentXyGraphItemXyGraphItemInput = {
  valueX?: Maybe<Scalars['Int']>;
  valueY?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsCharacteristicInput = {
  answer?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsValuesGapInput = {
  gap?: Maybe<Scalars['String']>;
  commitment?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSkipProofComponentInput = {
  skipProofValue?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsCompetencyAnswerInput = {
  question?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  response?: Maybe<Scalars['String']>;
  isSimpleQuestion?: Maybe<Scalars['Boolean']>;
  steps?: Maybe<Scalars['Int']>;
  textboxQuestion?: Maybe<Scalars['String']>;
  headingQuestion?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSabtourVideosComponentInput = {
  sabtourValue?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsGravitasSlidersAnswerInput = {
  negativeQuestion?: Maybe<Scalars['String']>;
  positiveQuestion?: Maybe<Scalars['String']>;
  colorAndRating?: Maybe<Array<Maybe<ComponentOptionColorAndRatingInput>>>;
};

export type ComponentOptionColorAndRatingInput = {
  color?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
};

export type ComponentSubmissionsGravitasGapInput = {
  gap?: Maybe<Scalars['String']>;
  commitment?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsNoteInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['ID']>;
};

export type ComponentSubmissionsParticipantInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type UpdateProgrammeSubmissionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProgrammeSubmissionInput>;
};

export type EditProgrammeSubmissionInput = {
  status?: Maybe<Enum_Programmesubmission_Status>;
  progress?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['ID']>;
  programme_type?: Maybe<Scalars['ID']>;
  coach_sessions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmeResponses?: Maybe<Array<Maybe<EditComponentSubmissionsProgrammeSubmissionInput>>>;
  myNotes?: Maybe<Array<Maybe<EditComponentSubmissionsNoteInput>>>;
  submissionparticipants?: Maybe<Array<Maybe<EditComponentSubmissionsParticipantInput>>>;
  programme_report?: Maybe<Scalars['ID']>;
  programme?: Maybe<Scalars['ID']>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  competency_url?: Maybe<Scalars['ID']>;
  feedfoward_url?: Maybe<Scalars['ID']>;
  selected?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Array<Maybe<Scalars['ID']>>>;
  uploaded_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
  isUpdatedByStakeholder?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentSubmissionsProgrammeSubmissionInput = {
  id?: Maybe<Scalars['ID']>;
  answers?: Maybe<Array<Maybe<EditComponentSubmissionsAnswerInput>>>;
  gravitasScales?: Maybe<Array<Maybe<EditComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  stakeholderItems?: Maybe<Array<Maybe<EditComponentStakeholderMapItemStackholderMapItemInput>>>;
  stakeholderChart?: Maybe<Scalars['ID']>;
  xYGraphItems?: Maybe<Array<Maybe<EditComponentXyGraphItemXyGraphItemInput>>>;
  xYGraphChart?: Maybe<Scalars['ID']>;
  saboteurImage?: Maybe<Scalars['ID']>;
  characteristics?: Maybe<Array<Maybe<EditComponentSubmissionsCharacteristicInput>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<Scalars['ID']>;
  gapsAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsValuesGapInput>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<EditComponentSubmissionsSkipProofComponentInput>>>;
  competencyAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsCompetencyAnswerInput>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<EditComponentSubmissionsSabtourVideosComponentInput>>>;
  saboteur?: Maybe<Array<Maybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsGravitasSlidersAnswerInput>>>;
  gravitasGap?: Maybe<Array<Maybe<EditComponentSubmissionsGravitasGapInput>>>;
};

export type EditComponentSubmissionsAnswerInput = {
  id?: Maybe<Scalars['ID']>;
  questionId?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  nestedAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsRepeatAnswerInput>>>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  feedback?: Maybe<Scalars['String']>;
  outcome?: Maybe<Enum_Componentsubmissionsanswer_Outcome>;
  questionTitle?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsRepeatAnswerInput = {
  id?: Maybe<Scalars['ID']>;
  answer?: Maybe<Scalars['String']>;
  questionTitle?: Maybe<Scalars['String']>;
};

export type EditComponentGravitasScaleItemsGravitasScaleItemInput = {
  id?: Maybe<Scalars['ID']>;
  labelOne?: Maybe<Scalars['String']>;
  labelTwo?: Maybe<Scalars['String']>;
  answerOne?: Maybe<Scalars['Int']>;
  answerTwo?: Maybe<Scalars['Int']>;
  answerThree?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  labelThree?: Maybe<Scalars['String']>;
};

export type EditComponentStakeholderMapItemStackholderMapItemInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  valueX?: Maybe<Scalars['Int']>;
  valueY?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
};

export type EditComponentXyGraphItemXyGraphItemInput = {
  id?: Maybe<Scalars['ID']>;
  valueX?: Maybe<Scalars['Int']>;
  valueY?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsCharacteristicInput = {
  id?: Maybe<Scalars['ID']>;
  answer?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsValuesGapInput = {
  id?: Maybe<Scalars['ID']>;
  gap?: Maybe<Scalars['String']>;
  commitment?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsSkipProofComponentInput = {
  id?: Maybe<Scalars['ID']>;
  skipProofValue?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsCompetencyAnswerInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  response?: Maybe<Scalars['String']>;
  isSimpleQuestion?: Maybe<Scalars['Boolean']>;
  steps?: Maybe<Scalars['Int']>;
  textboxQuestion?: Maybe<Scalars['String']>;
  headingQuestion?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsSabtourVideosComponentInput = {
  id?: Maybe<Scalars['ID']>;
  sabtourValue?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsGravitasSlidersAnswerInput = {
  id?: Maybe<Scalars['ID']>;
  negativeQuestion?: Maybe<Scalars['String']>;
  positiveQuestion?: Maybe<Scalars['String']>;
  colorAndRating?: Maybe<Array<Maybe<EditComponentOptionColorAndRatingInput>>>;
};

export type EditComponentOptionColorAndRatingInput = {
  id?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
};

export type EditComponentSubmissionsGravitasGapInput = {
  id?: Maybe<Scalars['ID']>;
  gap?: Maybe<Scalars['String']>;
  commitment?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsNoteInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['ID']>;
};

export type EditComponentSubmissionsParticipantInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type DeleteProgrammeSubmissionInput = {
  where?: Maybe<InputId>;
};

export type CreateProgrammeTypeInput = {
  data?: Maybe<ProgrammeTypeInput>;
};

export type ProgrammeTypeInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['ID']>;
  isCoaching?: Maybe<Scalars['Boolean']>;
  showParticipants?: Maybe<Scalars['Boolean']>;
  competencySurvey?: Maybe<Scalars['Boolean']>;
  feedForwardSurvey?: Maybe<Scalars['Boolean']>;
  showSession?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['Boolean']>;
  showArticle?: Maybe<Scalars['Boolean']>;
  deadline?: Maybe<Scalars['DateTime']>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmeQuestions?: Maybe<Array<Scalars['ProgrammeTypeProgrammeQuestionsDynamicZoneInput']>>;
  position?: Maybe<Scalars['Int']>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  modal?: Maybe<Scalars['ID']>;
  module?: Maybe<Scalars['ID']>;
  isSubModule?: Maybe<Scalars['Boolean']>;
  events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sub_modules?: Maybe<Array<Maybe<Scalars['ID']>>>;
  articles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  competencyEmailTitle?: Maybe<Scalars['String']>;
  email_template?: Maybe<Scalars['ID']>;
  showStatistics?: Maybe<Scalars['Boolean']>;
  programmeTypeInstructions?: Maybe<Scalars['String']>;
  emailSend?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<Scalars['ID']>;
  archive?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type UpdateProgrammeTypeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProgrammeTypeInput>;
};

export type EditProgrammeTypeInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['ID']>;
  isCoaching?: Maybe<Scalars['Boolean']>;
  showParticipants?: Maybe<Scalars['Boolean']>;
  competencySurvey?: Maybe<Scalars['Boolean']>;
  feedForwardSurvey?: Maybe<Scalars['Boolean']>;
  showSession?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['Boolean']>;
  showArticle?: Maybe<Scalars['Boolean']>;
  deadline?: Maybe<Scalars['DateTime']>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmeQuestions?: Maybe<Array<Scalars['ProgrammeTypeProgrammeQuestionsDynamicZoneInput']>>;
  position?: Maybe<Scalars['Int']>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  modal?: Maybe<Scalars['ID']>;
  module?: Maybe<Scalars['ID']>;
  isSubModule?: Maybe<Scalars['Boolean']>;
  events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sub_modules?: Maybe<Array<Maybe<Scalars['ID']>>>;
  articles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  competencyEmailTitle?: Maybe<Scalars['String']>;
  email_template?: Maybe<Scalars['ID']>;
  showStatistics?: Maybe<Scalars['Boolean']>;
  programmeTypeInstructions?: Maybe<Scalars['String']>;
  emailSend?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<Scalars['ID']>;
  archive?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProgrammeTypeInput = {
  where?: Maybe<InputId>;
};

export type CreateProgrammeInput = {
  data?: Maybe<ProgrammeInput>;
};

export type ProgrammeInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  start?: Maybe<Scalars['DateTime']>;
  isCustomJourney?: Maybe<Scalars['Boolean']>;
  showTimeline?: Maybe<Scalars['Boolean']>;
  programmeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  logo?: Maybe<Scalars['ID']>;
  articles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sendTypeform?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<Scalars['ID']>;
  email_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  email_templates?: Maybe<Array<Maybe<Scalars['ID']>>>;
  whatToExpect?: Maybe<Scalars['String']>;
  completion?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  three_60_form_id?: Maybe<Scalars['String']>;
  sub_module_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateProgrammeInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProgrammeInput>;
};

export type EditProgrammeInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  start?: Maybe<Scalars['DateTime']>;
  isCustomJourney?: Maybe<Scalars['Boolean']>;
  showTimeline?: Maybe<Scalars['Boolean']>;
  programmeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  logo?: Maybe<Scalars['ID']>;
  articles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sendTypeform?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<Scalars['ID']>;
  email_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  email_templates?: Maybe<Array<Maybe<Scalars['ID']>>>;
  whatToExpect?: Maybe<Scalars['String']>;
  completion?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  three_60_form_id?: Maybe<Scalars['String']>;
  sub_module_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProgrammeInput = {
  where?: Maybe<InputId>;
};

export type CreateRegionInput = {
  data?: Maybe<RegionInput>;
};

export type RegionInput = {
  nameEnglish?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateRegionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRegionInput>;
};

export type EditRegionInput = {
  nameEnglish?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteRegionInput = {
  where?: Maybe<InputId>;
};

export type CreateReportInput = {
  data?: Maybe<ReportInput>;
};

export type ReportInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Report_Type>;
  submission?: Maybe<Scalars['ID']>;
  report?: Maybe<Scalars['ID']>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  notification?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReportInput>;
};

export type EditReportInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Report_Type>;
  submission?: Maybe<Scalars['ID']>;
  report?: Maybe<Scalars['ID']>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  notification?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteReportInput = {
  where?: Maybe<InputId>;
};

export type CreateRespondentsAnswerInput = {
  data?: Maybe<RespondentsAnswerInput>;
};

export type RespondentsAnswerInput = {
  programme_submission?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  form_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateRespondentsAnswerInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRespondentsAnswerInput>;
};

export type EditRespondentsAnswerInput = {
  programme_submission?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  submission?: Maybe<Scalars['ID']>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  form_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteRespondentsAnswerInput = {
  where?: Maybe<InputId>;
};

export type CreateSectionInput = {
  data?: Maybe<SectionInput>;
};

export type SectionInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  videoEnglish?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  videoFrench?: Maybe<Scalars['ID']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  videoGerman?: Maybe<Scalars['ID']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  videoSpanish?: Maybe<Scalars['ID']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  videoMandarin?: Maybe<Scalars['ID']>;
  module?: Maybe<Scalars['ID']>;
  cover?: Maybe<Scalars['ID']>;
  position?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<Scalars['SectionQuestionsDynamicZoneInput']>>;
  sub_module?: Maybe<Scalars['ID']>;
  showSession?: Maybe<Scalars['Boolean']>;
  isCoaching?: Maybe<Scalars['Boolean']>;
  showParticipants?: Maybe<Scalars['Boolean']>;
  competencySurvey?: Maybe<Scalars['Boolean']>;
  feedForwardSurvey?: Maybe<Scalars['Boolean']>;
  events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  getStartedText?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['Boolean']>;
  sendTypeForm?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<Scalars['ID']>;
  email_template?: Maybe<Scalars['ID']>;
  archive?: Maybe<Scalars['Boolean']>;
  instructionsText?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type UpdateSectionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSectionInput>;
};

export type EditSectionInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  videoEnglish?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  videoFrench?: Maybe<Scalars['ID']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  videoGerman?: Maybe<Scalars['ID']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  videoSpanish?: Maybe<Scalars['ID']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  videoMandarin?: Maybe<Scalars['ID']>;
  module?: Maybe<Scalars['ID']>;
  cover?: Maybe<Scalars['ID']>;
  position?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<Scalars['SectionQuestionsDynamicZoneInput']>>;
  sub_module?: Maybe<Scalars['ID']>;
  showSession?: Maybe<Scalars['Boolean']>;
  isCoaching?: Maybe<Scalars['Boolean']>;
  showParticipants?: Maybe<Scalars['Boolean']>;
  competencySurvey?: Maybe<Scalars['Boolean']>;
  feedForwardSurvey?: Maybe<Scalars['Boolean']>;
  events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  getStartedText?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['Boolean']>;
  sendTypeForm?: Maybe<Scalars['Boolean']>;
  type_form_collection?: Maybe<Scalars['ID']>;
  email_template?: Maybe<Scalars['ID']>;
  archive?: Maybe<Scalars['Boolean']>;
  instructionsText?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteSectionInput = {
  where?: Maybe<InputId>;
};

export type CreateSubModuleSubmissionInput = {
  data?: Maybe<SubModuleSubmissionInput>;
};

export type SubModuleSubmissionInput = {
  language?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  view?: Maybe<Scalars['Int']>;
  sub_module?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  section?: Maybe<Array<Maybe<ComponentSubmissionsSectionSubmissionInput>>>;
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Submodulesubmission_Status>;
  timeSpent?: Maybe<Scalars['String']>;
  coach_sessions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  submissionparticipants?: Maybe<Array<Maybe<ComponentSubmissionsParticipantInput>>>;
  competency_participants?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyParticipantInput>>>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  feedfoward_url?: Maybe<Scalars['ID']>;
  competency_url?: Maybe<Scalars['ID']>;
  uploaded_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  participants?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sectionTypeform?: Maybe<Scalars['Boolean']>;
  programmeTypeForm?: Maybe<Scalars['Boolean']>;
  three_60_survey_form_id?: Maybe<Scalars['String']>;
  programme?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentSubmissionsSectionSubmissionInput = {
  section?: Maybe<Scalars['ID']>;
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswerInput>>>;
  progress?: Maybe<Scalars['Int']>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItemInput>>>;
  stakeholderChart?: Maybe<Scalars['ID']>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItemInput>>>;
  xYGraphChart?: Maybe<Scalars['ID']>;
  saboteurImage?: Maybe<Scalars['ID']>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristicInput>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<Scalars['ID']>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGapInput>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponentInput>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<ComponentSubmissionsSabtourVideosComponentInput>>>;
  saboteur?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponentInput>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswerInput>>>;
  uploadDocuments?: Maybe<Array<Maybe<ComponentSubmissionsUploadDocumentInput>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<ComponentSubmissionsGravitasSlidersAnswerInput>>>;
  gravitasGap?: Maybe<Array<Maybe<ComponentSubmissionsGravitasGapInput>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
};

export type ComponentSubmissionsUploadDocumentInput = {
  saboteurProofValue?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsCompetencyParticipantInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type UpdateSubModuleSubmissionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubModuleSubmissionInput>;
};

export type EditSubModuleSubmissionInput = {
  language?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  view?: Maybe<Scalars['Int']>;
  sub_module?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  section?: Maybe<Array<Maybe<EditComponentSubmissionsSectionSubmissionInput>>>;
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Submodulesubmission_Status>;
  timeSpent?: Maybe<Scalars['String']>;
  coach_sessions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  submissionparticipants?: Maybe<Array<Maybe<EditComponentSubmissionsParticipantInput>>>;
  competency_participants?: Maybe<Array<Maybe<EditComponentSubmissionsCompetencyParticipantInput>>>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  feedfoward_url?: Maybe<Scalars['ID']>;
  competency_url?: Maybe<Scalars['ID']>;
  uploaded_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  participants?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sectionTypeform?: Maybe<Scalars['Boolean']>;
  programmeTypeForm?: Maybe<Scalars['Boolean']>;
  three_60_survey_form_id?: Maybe<Scalars['String']>;
  programme?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentSubmissionsSectionSubmissionInput = {
  id?: Maybe<Scalars['ID']>;
  section?: Maybe<Scalars['ID']>;
  answers?: Maybe<Array<Maybe<EditComponentSubmissionsAnswerInput>>>;
  progress?: Maybe<Scalars['Int']>;
  gravitasScales?: Maybe<Array<Maybe<EditComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  stakeholderItems?: Maybe<Array<Maybe<EditComponentStakeholderMapItemStackholderMapItemInput>>>;
  stakeholderChart?: Maybe<Scalars['ID']>;
  xYGraphItems?: Maybe<Array<Maybe<EditComponentXyGraphItemXyGraphItemInput>>>;
  xYGraphChart?: Maybe<Scalars['ID']>;
  saboteurImage?: Maybe<Scalars['ID']>;
  characteristics?: Maybe<Array<Maybe<EditComponentSubmissionsCharacteristicInput>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<Scalars['ID']>;
  gapsAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsValuesGapInput>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<EditComponentSubmissionsSkipProofComponentInput>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<EditComponentSubmissionsSabtourVideosComponentInput>>>;
  saboteur?: Maybe<Array<Maybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  competencyAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsCompetencyAnswerInput>>>;
  uploadDocuments?: Maybe<Array<Maybe<EditComponentSubmissionsUploadDocumentInput>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsGravitasSlidersAnswerInput>>>;
  gravitasGap?: Maybe<Array<Maybe<EditComponentSubmissionsGravitasGapInput>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
};

export type EditComponentSubmissionsUploadDocumentInput = {
  id?: Maybe<Scalars['ID']>;
  saboteurProofValue?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type EditComponentSubmissionsCompetencyParticipantInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type DeleteSubModuleSubmissionInput = {
  where?: Maybe<InputId>;
};

export type CreateSubModuleInput = {
  data?: Maybe<SubModuleInput>;
};

export type SubModuleInput = {
  nameEnglish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  cover?: Maybe<Scalars['ID']>;
  descriptionEnglish?: Maybe<Scalars['String']>;
  descriptionFrench?: Maybe<Scalars['String']>;
  descriptionGerman?: Maybe<Scalars['String']>;
  descriptionMandarin?: Maybe<Scalars['String']>;
  descriptionSpanish?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  sub_module_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_type?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateSubModuleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubModuleInput>;
};

export type EditSubModuleInput = {
  nameEnglish?: Maybe<Scalars['String']>;
  nameFrench?: Maybe<Scalars['String']>;
  nameGerman?: Maybe<Scalars['String']>;
  nameSpanish?: Maybe<Scalars['String']>;
  nameMandarin?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  cover?: Maybe<Scalars['ID']>;
  descriptionEnglish?: Maybe<Scalars['String']>;
  descriptionFrench?: Maybe<Scalars['String']>;
  descriptionGerman?: Maybe<Scalars['String']>;
  descriptionMandarin?: Maybe<Scalars['String']>;
  descriptionSpanish?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  sub_module_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_type?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteSubModuleInput = {
  where?: Maybe<InputId>;
};

export type CreateSubmissionInput = {
  data?: Maybe<SubmissionInput>;
};

export type SubmissionInput = {
  language?: Maybe<Scalars['ID']>;
  section?: Maybe<Array<Maybe<ComponentSubmissionsSectionSubmissionInput>>>;
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Submission_Status>;
  timeSpent?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  views?: Maybe<Scalars['Int']>;
  module?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  competency_url?: Maybe<Scalars['ID']>;
  participants?: Maybe<Array<Maybe<ComponentSubmissionsParticipantInput>>>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  uploaded_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateSubmissionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubmissionInput>;
};

export type EditSubmissionInput = {
  language?: Maybe<Scalars['ID']>;
  section?: Maybe<Array<Maybe<EditComponentSubmissionsSectionSubmissionInput>>>;
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Submission_Status>;
  timeSpent?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  views?: Maybe<Scalars['Int']>;
  module?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  competency_url?: Maybe<Scalars['ID']>;
  participants?: Maybe<Array<Maybe<EditComponentSubmissionsParticipantInput>>>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  uploaded_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteSubmissionInput = {
  where?: Maybe<InputId>;
};

export type CreateSubmoduleReportInput = {
  data?: Maybe<SubmoduleReportInput>;
};

export type SubmoduleReportInput = {
  name?: Maybe<Scalars['String']>;
  report?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  notification?: Maybe<Scalars['ID']>;
  sectionTitle?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateSubmoduleReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubmoduleReportInput>;
};

export type EditSubmoduleReportInput = {
  name?: Maybe<Scalars['String']>;
  report?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  notification?: Maybe<Scalars['ID']>;
  sectionTitle?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteSubmoduleReportInput = {
  where?: Maybe<InputId>;
};

export type CreateSurveyReportInput = {
  data?: Maybe<SurveyReportInput>;
};

export type SurveyReportInput = {
  name?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateSurveyReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSurveyReportInput>;
};

export type EditSurveyReportInput = {
  name?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteSurveyReportInput = {
  where?: Maybe<InputId>;
};

export type UpdateTranslationInput = {
  data?: Maybe<EditTranslationInput>;
};

export type EditTranslationInput = {
  languageSelection?: Maybe<EditComponentTranslationsLanguageSelectionInput>;
  welcomeScreen?: Maybe<EditComponentTranslationsWelcomeScreenInput>;
  letsGetStartedScreen?: Maybe<EditComponentTranslationsLetsGetStartedScreenInput>;
  whatToExpect?: Maybe<EditComponentTranslationsWhatToExpectInput>;
  homeScreen?: Maybe<EditComponentTranslationsHomeScreenInput>;
  myWorkScreen?: Maybe<EditComponentTranslationsMyWorkScreenInput>;
  myLibraryScreen?: Maybe<EditComponentTranslationsMyLibraryScreenInput>;
  myProfileScreen?: Maybe<EditComponentTranslationsMyProfileScreenInput>;
  personalScreen?: Maybe<EditComponentTranslationsPersonalScreenInput>;
  menu?: Maybe<EditComponentTranslationsMenuInput>;
  settingsScreen?: Maybe<EditComponentTranslationsSettingsScreenInput>;
  helpAndSupport?: Maybe<EditComponentTranslationsHelpAndSupportInput>;
  aboutUs?: Maybe<EditComponentTranslationsAboutUsInput>;
  buttons?: Maybe<EditComponentTranslationsButtonInput>;
  programmesScreen?: Maybe<EditComponentTranslationsProgrammeScreenInput>;
  faqs?: Maybe<EditComponentTranslationsFaqInput>;
  termsofService?: Maybe<EditComponentTranslationsTermsOfServiceInput>;
  privacyPolicy?: Maybe<EditComponentTranslationsPrivacyPolicyInput>;
  dashboardScreen?: Maybe<EditComponentTranslationsDashboardScreenInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentTranslationsHomeScreenInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  myProgrammeEnglish?: Maybe<Scalars['String']>;
  completedModulesEnglish?: Maybe<Scalars['String']>;
  noChangesEnglish?: Maybe<Scalars['String']>;
  changesUpEnglish?: Maybe<Scalars['String']>;
  changesDownEnglish?: Maybe<Scalars['String']>;
  viewModulesEnglish?: Maybe<Scalars['String']>;
  myLibraryEnglish?: Maybe<Scalars['String']>;
  viewedArticlesEnglish?: Maybe<Scalars['String']>;
  viewLibraryEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  myProgrammeFrench?: Maybe<Scalars['String']>;
  completedModulesFrench?: Maybe<Scalars['String']>;
  noChangesFrench?: Maybe<Scalars['String']>;
  changesUpFrench?: Maybe<Scalars['String']>;
  changesDownFrench?: Maybe<Scalars['String']>;
  viewModulesFrench?: Maybe<Scalars['String']>;
  myLibraryFrench?: Maybe<Scalars['String']>;
  viewedArticlesFrench?: Maybe<Scalars['String']>;
  viewLibraryFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  myProgrammeGerman?: Maybe<Scalars['String']>;
  completedModulesGerman?: Maybe<Scalars['String']>;
  noChangesGerman?: Maybe<Scalars['String']>;
  changesUpGerman?: Maybe<Scalars['String']>;
  changesDownGerman?: Maybe<Scalars['String']>;
  viewModulesGerman?: Maybe<Scalars['String']>;
  myLibraryGerman?: Maybe<Scalars['String']>;
  viewedArticlesGerman?: Maybe<Scalars['String']>;
  viewLibraryGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  myProgrammeSpanish?: Maybe<Scalars['String']>;
  completedModulesSpanish?: Maybe<Scalars['String']>;
  noChangesSpanish?: Maybe<Scalars['String']>;
  changesUpSpanish?: Maybe<Scalars['String']>;
  changesDownSpanish?: Maybe<Scalars['String']>;
  viewModulesSpanish?: Maybe<Scalars['String']>;
  myLibrarySpanish?: Maybe<Scalars['String']>;
  viewedArticlesSpanish?: Maybe<Scalars['String']>;
  viewLibrarySpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  myProgrammeMandarin?: Maybe<Scalars['String']>;
  completedModulesMandarin?: Maybe<Scalars['String']>;
  noChangesMandarin?: Maybe<Scalars['String']>;
  changesUpMandarin?: Maybe<Scalars['String']>;
  changesDownMandarin?: Maybe<Scalars['String']>;
  viewModulesMandarin?: Maybe<Scalars['String']>;
  myLibraryMandarin?: Maybe<Scalars['String']>;
  viewedArticlesMandarin?: Maybe<Scalars['String']>;
  viewLibraryMandarin?: Maybe<Scalars['String']>;
  welcomeEnglish?: Maybe<Scalars['String']>;
  welcomeFrench?: Maybe<Scalars['String']>;
  welcomeGerman?: Maybe<Scalars['String']>;
  welcomeSpanish?: Maybe<Scalars['String']>;
  welcomeMandarin?: Maybe<Scalars['String']>;
  programmeProgressEnglish?: Maybe<Scalars['String']>;
  programmeProgressFrench?: Maybe<Scalars['String']>;
  programmeProgressGerman?: Maybe<Scalars['String']>;
  programmeProgressSpanish?: Maybe<Scalars['String']>;
  programmeProgressMandarin?: Maybe<Scalars['String']>;
  whatsNextEnglish?: Maybe<Scalars['String']>;
  whatsNextFrench?: Maybe<Scalars['String']>;
  whatsNextGerman?: Maybe<Scalars['String']>;
  whatsNextSpanish?: Maybe<Scalars['String']>;
  whatsNextMandarin?: Maybe<Scalars['String']>;
  whatToExpectEnglish?: Maybe<Scalars['String']>;
  whatToExpectFrench?: Maybe<Scalars['String']>;
  whatToExpectGerman?: Maybe<Scalars['String']>;
  whatToExpectSpanish?: Maybe<Scalars['String']>;
  whatToExpectMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsMyWorkScreenInput = {
  id?: Maybe<Scalars['ID']>;
  emptyStateTitleEnglish?: Maybe<Scalars['String']>;
  emptyStateDescEnglish?: Maybe<Scalars['String']>;
  subtitleEnglish?: Maybe<Scalars['String']>;
  feedbackEnglish?: Maybe<Scalars['String']>;
  feedbackNotEligibleEnglish?: Maybe<Scalars['String']>;
  feedbackNotReceivedEnglish?: Maybe<Scalars['String']>;
  notStartedEnglish?: Maybe<Scalars['String']>;
  emptyStateTitleFrench?: Maybe<Scalars['String']>;
  emptyStateDescFrench?: Maybe<Scalars['String']>;
  subtitleFrench?: Maybe<Scalars['String']>;
  feedbackFrench?: Maybe<Scalars['String']>;
  feedbackNotEligibleFrench?: Maybe<Scalars['String']>;
  feedbackNotReceivedFrench?: Maybe<Scalars['String']>;
  notStartedFrench?: Maybe<Scalars['String']>;
  emptyStateTitleGerman?: Maybe<Scalars['String']>;
  emptyStateDescGerman?: Maybe<Scalars['String']>;
  subtitleGerman?: Maybe<Scalars['String']>;
  feedbackGerman?: Maybe<Scalars['String']>;
  feedbackNotEligibleGerman?: Maybe<Scalars['String']>;
  feedbackNotReceivedGerman?: Maybe<Scalars['String']>;
  notStartedGerman?: Maybe<Scalars['String']>;
  emptyStateTitleSpanish?: Maybe<Scalars['String']>;
  emptyStateDescSpanish?: Maybe<Scalars['String']>;
  subtitleSpanish?: Maybe<Scalars['String']>;
  feedbackSpanish?: Maybe<Scalars['String']>;
  feedbackNotEligibleSpanish?: Maybe<Scalars['String']>;
  feedbackNotReceivedSpanish?: Maybe<Scalars['String']>;
  notStartedSpanish?: Maybe<Scalars['String']>;
  emptyStateTitleMandarin?: Maybe<Scalars['String']>;
  emptyStateDescMandarin?: Maybe<Scalars['String']>;
  subtitleMandarin?: Maybe<Scalars['String']>;
  feedbackMandarin?: Maybe<Scalars['String']>;
  feedbackNotEligibleMandarin?: Maybe<Scalars['String']>;
  feedbackNotReceivedMandarin?: Maybe<Scalars['String']>;
  notStartedMandarin?: Maybe<Scalars['String']>;
  downloadContentTextEnglish?: Maybe<Scalars['String']>;
  downloadContentTextFrench?: Maybe<Scalars['String']>;
  downloadContentTextGerman?: Maybe<Scalars['String']>;
  downloadContentTextSpanish?: Maybe<Scalars['String']>;
  downloadContentTextMandarin?: Maybe<Scalars['String']>;
  myNotesEnglish?: Maybe<Scalars['String']>;
  myNotesSpanish?: Maybe<Scalars['String']>;
  myNotesMandarin?: Maybe<Scalars['String']>;
  myNotesFrench?: Maybe<Scalars['String']>;
  myNotesGerman?: Maybe<Scalars['String']>;
  moduleReportsEnglish?: Maybe<Scalars['String']>;
  moduleReportsMandarin?: Maybe<Scalars['String']>;
  moduleReportsSpanish?: Maybe<Scalars['String']>;
  moduleReportsFrench?: Maybe<Scalars['String']>;
  moduleReportsGerman?: Maybe<Scalars['String']>;
  documentsEnglish?: Maybe<Scalars['String']>;
  documentsSpanish?: Maybe<Scalars['String']>;
  documentsFrench?: Maybe<Scalars['String']>;
  documentsMandarin?: Maybe<Scalars['String']>;
  documentsGerman?: Maybe<Scalars['String']>;
  deleteHeadingEnglish?: Maybe<Scalars['String']>;
  deleteHeadingSpanish?: Maybe<Scalars['String']>;
  deleteHeadingGerman?: Maybe<Scalars['String']>;
  deleteHeadingMandarin?: Maybe<Scalars['String']>;
  deleteHeadingFrench?: Maybe<Scalars['String']>;
  deleteMessageEnglish?: Maybe<Scalars['String']>;
  deleteMessageSpanish?: Maybe<Scalars['String']>;
  deleteMessageGerman?: Maybe<Scalars['String']>;
  deleteMessageFrench?: Maybe<Scalars['String']>;
  deleteMessageMandarin?: Maybe<Scalars['String']>;
  recentNotesEnglish?: Maybe<Scalars['String']>;
  recentNotesSpanish?: Maybe<Scalars['String']>;
  recentNotesGerman?: Maybe<Scalars['String']>;
  recentNotesFrench?: Maybe<Scalars['String']>;
  recentNotesMandarin?: Maybe<Scalars['String']>;
  programmeHeadingEnglish?: Maybe<Scalars['String']>;
  programmeHeadingSpanish?: Maybe<Scalars['String']>;
  programmeHeadingFrench?: Maybe<Scalars['String']>;
  programmeHeadingMandarin?: Maybe<Scalars['String']>;
  programmeHeadingGerman?: Maybe<Scalars['String']>;
  noNotesHeadingEnglish?: Maybe<Scalars['String']>;
  noNotesHeadingSpanish?: Maybe<Scalars['String']>;
  noNotesHeadingFrench?: Maybe<Scalars['String']>;
  noNotesHeadingMandarin?: Maybe<Scalars['String']>;
  noNotesHeadingGerman?: Maybe<Scalars['String']>;
  noNotesSubHeadingEnglish?: Maybe<Scalars['String']>;
  noNotesSubHeadingFrench?: Maybe<Scalars['String']>;
  noNotesSubHeadingSpanish?: Maybe<Scalars['String']>;
  noNotesSubHeadingGerman?: Maybe<Scalars['String']>;
  noNotesSubHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsHeadingEnglish?: Maybe<Scalars['String']>;
  noModuleReportsHeadingSpanish?: Maybe<Scalars['String']>;
  noModuleReportsHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsHeadingFrench?: Maybe<Scalars['String']>;
  noModuleReportsHeadingGerman?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingEnglish?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingFrench?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingGerman?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingSpanish?: Maybe<Scalars['String']>;
  noDocumentsHeadingEnglish?: Maybe<Scalars['String']>;
  noDocumentsHeadingSpanish?: Maybe<Scalars['String']>;
  noDocumentsHeadingGerman?: Maybe<Scalars['String']>;
  noDocumentsHeadingMandarin?: Maybe<Scalars['String']>;
  noDocumentsHeadingFrench?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingEnglish?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingFrench?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingMandarin?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingGerman?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingSpanish?: Maybe<Scalars['String']>;
  sectionCompletedEnglish?: Maybe<Scalars['String']>;
  sectionCompletedSpanish?: Maybe<Scalars['String']>;
  sectionCompletedGerman?: Maybe<Scalars['String']>;
  sectionCompletedFrench?: Maybe<Scalars['String']>;
  sectionCompletedMandarin?: Maybe<Scalars['String']>;
  documentsUploadedEnglish?: Maybe<Scalars['String']>;
  documentsUploadedSpanish?: Maybe<Scalars['String']>;
  documentsUploadedFrench?: Maybe<Scalars['String']>;
  documentsUploadedMandarin?: Maybe<Scalars['String']>;
  documentsUploadedGerman?: Maybe<Scalars['String']>;
  uploadButtonEnglish?: Maybe<Scalars['String']>;
  uploadButtonFrench?: Maybe<Scalars['String']>;
  uploadButtonMandarin?: Maybe<Scalars['String']>;
  uploadButtonSpanish?: Maybe<Scalars['String']>;
  uploadButtonGerman?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsMyLibraryScreenInput = {
  id?: Maybe<Scalars['ID']>;
  allArticlesEnglish?: Maybe<Scalars['String']>;
  myBookmarksEnglish?: Maybe<Scalars['String']>;
  allArticlesFrench?: Maybe<Scalars['String']>;
  myBookmarksFrench?: Maybe<Scalars['String']>;
  allArticlesGerman?: Maybe<Scalars['String']>;
  myBookmarksGerman?: Maybe<Scalars['String']>;
  allArticlesSpanish?: Maybe<Scalars['String']>;
  myBookmarksSpanish?: Maybe<Scalars['String']>;
  allArticlesMandarin?: Maybe<Scalars['String']>;
  myBookmarksMandarin?: Maybe<Scalars['String']>;
  viewArticleEnglish?: Maybe<Scalars['String']>;
  viewArticleFrench?: Maybe<Scalars['String']>;
  viewArticleSpanish?: Maybe<Scalars['String']>;
  viewArticleGerman?: Maybe<Scalars['String']>;
  viewArticleMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsMyProfileScreenInput = {
  id?: Maybe<Scalars['ID']>;
  detailsEnglish?: Maybe<Scalars['String']>;
  settingsEnglish?: Maybe<Scalars['String']>;
  logoutEnglish?: Maybe<Scalars['String']>;
  joinEnglish?: Maybe<Scalars['String']>;
  detailsFrench?: Maybe<Scalars['String']>;
  settingsFrench?: Maybe<Scalars['String']>;
  logoutFrench?: Maybe<Scalars['String']>;
  joinFrench?: Maybe<Scalars['String']>;
  detailsGerman?: Maybe<Scalars['String']>;
  settingsGerman?: Maybe<Scalars['String']>;
  logoutGerman?: Maybe<Scalars['String']>;
  joinGerman?: Maybe<Scalars['String']>;
  detailsSpanish?: Maybe<Scalars['String']>;
  settingsSpanish?: Maybe<Scalars['String']>;
  logoutSpanish?: Maybe<Scalars['String']>;
  joinSpanish?: Maybe<Scalars['String']>;
  detailsMandarin?: Maybe<Scalars['String']>;
  settingsMandarin?: Maybe<Scalars['String']>;
  logoutMandarin?: Maybe<Scalars['String']>;
  joinMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsPersonalScreenInput = {
  id?: Maybe<Scalars['ID']>;
  changePhotoEnglish?: Maybe<Scalars['String']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']>;
  emailLabelEnglish?: Maybe<Scalars['String']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']>;
  divisionLabelEnglish?: Maybe<Scalars['String']>;
  editInfoButtonEnglish?: Maybe<Scalars['String']>;
  changePhotoFrench?: Maybe<Scalars['String']>;
  firstNameLabelFrench?: Maybe<Scalars['String']>;
  lastNameLabelFrench?: Maybe<Scalars['String']>;
  emailLabelFrench?: Maybe<Scalars['String']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']>;
  divisionLabelFrench?: Maybe<Scalars['String']>;
  editInfoButtonFrench?: Maybe<Scalars['String']>;
  changePhotoGerman?: Maybe<Scalars['String']>;
  firstNameLabelGerman?: Maybe<Scalars['String']>;
  lastNameLabelGerman?: Maybe<Scalars['String']>;
  emailLabelGerman?: Maybe<Scalars['String']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']>;
  divisionLabelGerman?: Maybe<Scalars['String']>;
  editInfoButtonGerman?: Maybe<Scalars['String']>;
  changePhotoSpanish?: Maybe<Scalars['String']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']>;
  emailLabelSpanish?: Maybe<Scalars['String']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']>;
  divisionLabelSpanish?: Maybe<Scalars['String']>;
  editInfoButtonSpanish?: Maybe<Scalars['String']>;
  changePhotoMandarin?: Maybe<Scalars['String']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']>;
  emailLabelMandarin?: Maybe<Scalars['String']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']>;
  divisionLabelMandarin?: Maybe<Scalars['String']>;
  editInfoButtonMandarin?: Maybe<Scalars['String']>;
  resetPasswordEnglish?: Maybe<Scalars['String']>;
  resetPasswordFrench?: Maybe<Scalars['String']>;
  resetPasswordSpanish?: Maybe<Scalars['String']>;
  resetPasswordGerman?: Maybe<Scalars['String']>;
  resetPasswordMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsMenuInput = {
  id?: Maybe<Scalars['ID']>;
  homeEnglish?: Maybe<Scalars['String']>;
  myProgrammeEnglish?: Maybe<Scalars['String']>;
  myWorkEnglish?: Maybe<Scalars['String']>;
  myLibraryEnglish?: Maybe<Scalars['String']>;
  myProfileEnglish?: Maybe<Scalars['String']>;
  helpAndSupportEnglish?: Maybe<Scalars['String']>;
  signOutEnglish?: Maybe<Scalars['String']>;
  homeFrench?: Maybe<Scalars['String']>;
  myProgrammeFrench?: Maybe<Scalars['String']>;
  myWorkFrench?: Maybe<Scalars['String']>;
  myLibraryFrench?: Maybe<Scalars['String']>;
  myProfileFrench?: Maybe<Scalars['String']>;
  helpAndSupportFrench?: Maybe<Scalars['String']>;
  signOutFrench?: Maybe<Scalars['String']>;
  homeGerman?: Maybe<Scalars['String']>;
  myProgrammeGerman?: Maybe<Scalars['String']>;
  myWorkGerman?: Maybe<Scalars['String']>;
  myLibraryGerman?: Maybe<Scalars['String']>;
  myProfileGerman?: Maybe<Scalars['String']>;
  helpAndSupportGerman?: Maybe<Scalars['String']>;
  signOutGerman?: Maybe<Scalars['String']>;
  homeSpanish?: Maybe<Scalars['String']>;
  myProgrammeSpanish?: Maybe<Scalars['String']>;
  myWorkSpanish?: Maybe<Scalars['String']>;
  myLibrarySpanish?: Maybe<Scalars['String']>;
  myProfileSpanish?: Maybe<Scalars['String']>;
  helpAndSupportSpanish?: Maybe<Scalars['String']>;
  signOutSpanish?: Maybe<Scalars['String']>;
  homeMandarin?: Maybe<Scalars['String']>;
  myProgrammeMandarin?: Maybe<Scalars['String']>;
  myWorkMandarin?: Maybe<Scalars['String']>;
  myLibraryMandarin?: Maybe<Scalars['String']>;
  myProfileMandarin?: Maybe<Scalars['String']>;
  helpAndSupportMandarin?: Maybe<Scalars['String']>;
  signOutMandarin?: Maybe<Scalars['String']>;
  aboutUsEnglish?: Maybe<Scalars['String']>;
  aboutUsFrench?: Maybe<Scalars['String']>;
  aboutUsGerman?: Maybe<Scalars['String']>;
  myNotesMandarin?: Maybe<Scalars['String']>;
  myNotesGerman?: Maybe<Scalars['String']>;
  myNotesSpanish?: Maybe<Scalars['String']>;
  myNotesEnglish?: Maybe<Scalars['String']>;
  myNotesFrench?: Maybe<Scalars['String']>;
  notificationsEnglish?: Maybe<Scalars['String']>;
  notificationsFrench?: Maybe<Scalars['String']>;
  notificationsGerman?: Maybe<Scalars['String']>;
  notificationsSpanish?: Maybe<Scalars['String']>;
  notificationsMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsSettingsScreenInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  saveButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  saveButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  saveButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  saveButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  saveButtonMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsHelpAndSupportInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  knowledgeBaseEnglish?: Maybe<Scalars['String']>;
  liveChatEnglish?: Maybe<Scalars['String']>;
  myTicketsEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  knowledgeBaseFrench?: Maybe<Scalars['String']>;
  liveChatFrench?: Maybe<Scalars['String']>;
  myTicketsFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  knowledgeBaseGerman?: Maybe<Scalars['String']>;
  liveChatGerman?: Maybe<Scalars['String']>;
  myTicketsGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  knowledgeBaseSpanish?: Maybe<Scalars['String']>;
  liveChatSpanish?: Maybe<Scalars['String']>;
  myTicketsSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  knowledgeBaseMandarin?: Maybe<Scalars['String']>;
  liveChatMandarin?: Maybe<Scalars['String']>;
  myTicketsMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsButtonInput = {
  id?: Maybe<Scalars['ID']>;
  backBtnsEnglish?: Maybe<Scalars['String']>;
  backBtnsFrench?: Maybe<Scalars['String']>;
  backBtnsGerman?: Maybe<Scalars['String']>;
  nextBtnsEnglish?: Maybe<Scalars['String']>;
  nextBtnsFrench?: Maybe<Scalars['String']>;
  nextBtnsGerman?: Maybe<Scalars['String']>;
  addMoreBtnsEnglish?: Maybe<Scalars['String']>;
  addMoreBtnsFrench?: Maybe<Scalars['String']>;
  addMoreBtnsGerman?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsProgrammeScreenInput = {
  id?: Maybe<Scalars['ID']>;
  changeButtonEnglish?: Maybe<Scalars['String']>;
  changeButtonFrench?: Maybe<Scalars['String']>;
  changeButtonGerman?: Maybe<Scalars['String']>;
  changeButtonSpanish?: Maybe<Scalars['String']>;
  changeButtonMandarin?: Maybe<Scalars['String']>;
  programmeOverviewEnglish?: Maybe<Scalars['String']>;
  programmeOverviewFrench?: Maybe<Scalars['String']>;
  programmeOverviewSpanish?: Maybe<Scalars['String']>;
  programmeOverviewGerman?: Maybe<Scalars['String']>;
  programmeOverviewMandarin?: Maybe<Scalars['String']>;
  programmeTextEnglish?: Maybe<Scalars['String']>;
  programmeTextFrench?: Maybe<Scalars['String']>;
  programmeTextSpanish?: Maybe<Scalars['String']>;
  programmeTextGerman?: Maybe<Scalars['String']>;
  programmeTextMandarin?: Maybe<Scalars['String']>;
  informationEnglish?: Maybe<Scalars['String']>;
  informationFrench?: Maybe<Scalars['String']>;
  informationGerman?: Maybe<Scalars['String']>;
  informationSpanish?: Maybe<Scalars['String']>;
  informationMandarin?: Maybe<Scalars['String']>;
  selectProgrammesTitleEnglish?: Maybe<Scalars['String']>;
  selectProgrammesTitleFrench?: Maybe<Scalars['String']>;
  selectProgrammesTitleGerman?: Maybe<Scalars['String']>;
  selectProgrammesTitleSpanish?: Maybe<Scalars['String']>;
  selectProgrammesTitleMandarin?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleEnglish?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleFrench?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleGerman?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleSpanish?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleMandarin?: Maybe<Scalars['String']>;
  selectButtonEnglish?: Maybe<Scalars['String']>;
  selectButtonFrench?: Maybe<Scalars['String']>;
  selectButtonGerman?: Maybe<Scalars['String']>;
  selectButtonSpanish?: Maybe<Scalars['String']>;
  selectButtonMandarin?: Maybe<Scalars['String']>;
  changeProgrammeTypeEnglish?: Maybe<Scalars['String']>;
  changeProgrammeTypeFrench?: Maybe<Scalars['String']>;
  changeProgrammeTypeGerman?: Maybe<Scalars['String']>;
  changeProgrammeTypeSpanish?: Maybe<Scalars['String']>;
  changeProgrammeTypeMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsFaqInput = {
  id?: Maybe<Scalars['ID']>;
  faqsEnglish?: Maybe<Array<Maybe<EditComponentTranslationsFaqsQuestionAnswerInput>>>;
  faqsFrench?: Maybe<Array<Maybe<EditComponentTranslationsFaqsFrenchInput>>>;
  faqsGerman?: Maybe<Array<Maybe<EditComponentTranslationsFaqsGermanInput>>>;
  faqsMandarin?: Maybe<Array<Maybe<EditComponentTranslationsFaqsMandarinInput>>>;
  faqsSpanish?: Maybe<Array<Maybe<EditComponentTranslationsFaqsSpanishInput>>>;
};

export type EditComponentTranslationsFaqsQuestionAnswerInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsFaqsFrenchInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsFaqsGermanInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsFaqsMandarinInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsFaqsSpanishInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsTermsOfServiceInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  textEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  textSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  textMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsPrivacyPolicyInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  textEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  textSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  textMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentTranslationsDashboardScreenInput = {
  id?: Maybe<Scalars['ID']>;
  myProgrammesEnglish?: Maybe<Scalars['String']>;
  myProgrammesFrench?: Maybe<Scalars['String']>;
  myProgrammesGerman?: Maybe<Scalars['String']>;
  myProgrammesSpanish?: Maybe<Scalars['String']>;
  myProgrammesMandarin?: Maybe<Scalars['String']>;
  suggestedTitleEnglish?: Maybe<Scalars['String']>;
  suggestedTitleFrench?: Maybe<Scalars['String']>;
  suggestedTitleSpanish?: Maybe<Scalars['String']>;
  suggestedTitleGerman?: Maybe<Scalars['String']>;
  suggestedTitleMandarin?: Maybe<Scalars['String']>;
  uploadTitleEnglish?: Maybe<Scalars['String']>;
  uploadTitleFrench?: Maybe<Scalars['String']>;
  uploadTitleSpanish?: Maybe<Scalars['String']>;
  uploadTitleGerman?: Maybe<Scalars['String']>;
  uploadTitleMandarin?: Maybe<Scalars['String']>;
  viewAllEnglish?: Maybe<Scalars['String']>;
  viewAllFrench?: Maybe<Scalars['String']>;
  viewAllMandarin?: Maybe<Scalars['String']>;
  viewAllSpanish?: Maybe<Scalars['String']>;
  viewAllGerman?: Maybe<Scalars['String']>;
  logOutDashboardEnglish?: Maybe<Scalars['String']>;
  logOutDashboardFrench?: Maybe<Scalars['String']>;
  logOutDashboardMandarin?: Maybe<Scalars['String']>;
  logOutDashboardSpanish?: Maybe<Scalars['String']>;
  logOutDashboardGerman?: Maybe<Scalars['String']>;
  notepadTextEnglish?: Maybe<Scalars['String']>;
  notepadTextFrench?: Maybe<Scalars['String']>;
  notepadTextMandarin?: Maybe<Scalars['String']>;
  notepadTextSpanish?: Maybe<Scalars['String']>;
  notepadTextGerman?: Maybe<Scalars['String']>;
};

export type CreateTypeFormCollectionInput = {
  data?: Maybe<TypeFormCollectionInput>;
};

export type TypeFormCollectionInput = {
  name?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  typeFormUrl?: Maybe<Scalars['String']>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  submissions?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateTypeFormCollectionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTypeFormCollectionInput>;
};

export type EditTypeFormCollectionInput = {
  name?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  typeFormUrl?: Maybe<Scalars['String']>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  submissions?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteTypeFormCollectionInput = {
  where?: Maybe<InputId>;
};

export type CreateUploadedReportInput = {
  data?: Maybe<UploadedReportInput>;
};

export type UploadedReportInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Uploadedreports_Type>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  report?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  submission?: Maybe<Scalars['ID']>;
  programme_submission?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateUploadedReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUploadedReportInput>;
};

export type EditUploadedReportInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Uploadedreports_Type>;
  sub_module_submission?: Maybe<Scalars['ID']>;
  report?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sectionOrModuleId?: Maybe<Scalars['String']>;
  submission?: Maybe<Scalars['ID']>;
  programme_submission?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteUploadedReportInput = {
  where?: Maybe<InputId>;
};

export type CreateUserUploadedDocumentInput = {
  data?: Maybe<UserUploadedDocumentInput>;
};

export type UserUploadedDocumentInput = {
  name?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  documents?: Maybe<Array<Maybe<ComponentQuestionTypesDocumentInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentQuestionTypesDocumentInput = {
  name?: Maybe<Scalars['String']>;
  document?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateUserUploadedDocumentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserUploadedDocumentInput>;
};

export type EditUserUploadedDocumentInput = {
  name?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  documents?: Maybe<Array<Maybe<EditComponentQuestionTypesDocumentInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentQuestionTypesDocumentInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  document?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteUserUploadedDocumentInput = {
  where?: Maybe<InputId>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  modulesRead?: Maybe<Scalars['JSON']>;
  homePromptsRead?: Maybe<Scalars['Boolean']>;
  programmePromptsRead?: Maybe<Scalars['Boolean']>;
  modulePromptsRead?: Maybe<Scalars['Boolean']>;
  bookmarks?: Maybe<Scalars['JSON']>;
  submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  report?: Maybe<Scalars['ID']>;
  company?: Maybe<Scalars['ID']>;
  articlesViewed?: Maybe<Scalars['JSON']>;
  postCard?: Maybe<Scalars['ID']>;
  timezone?: Maybe<ComponentOptionTimezoneInput>;
  certificate?: Maybe<Scalars['ID']>;
  loginAttempts?: Maybe<Scalars['Int']>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  feedForwardUrl?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['ID']>;
  region?: Maybe<Scalars['ID']>;
  sub_module_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  coach_submitted_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  loginWithSSO?: Maybe<Scalars['Boolean']>;
  programmeEvalutionEmailSent?: Maybe<Scalars['Boolean']>;
  updatedDetails?: Maybe<Scalars['Boolean']>;
  account_changes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user_uploaded_documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboarding?: Maybe<Scalars['Boolean']>;
  triggerReport?: Maybe<Scalars['Boolean']>;
  bookings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  clientId?: Maybe<Scalars['Long']>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  current_survey?: Maybe<Scalars['JSON']>;
  coach?: Maybe<Scalars['ID']>;
  three_60_form_id?: Maybe<Scalars['String']>;
  submodule_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentOptionTimezoneInput = {
  abbrev?: Maybe<Scalars['String']>;
  altName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  modulesRead?: Maybe<Scalars['JSON']>;
  homePromptsRead?: Maybe<Scalars['Boolean']>;
  programmePromptsRead?: Maybe<Scalars['Boolean']>;
  modulePromptsRead?: Maybe<Scalars['Boolean']>;
  bookmarks?: Maybe<Scalars['JSON']>;
  submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  report?: Maybe<Scalars['ID']>;
  company?: Maybe<Scalars['ID']>;
  articlesViewed?: Maybe<Scalars['JSON']>;
  postCard?: Maybe<Scalars['ID']>;
  timezone?: Maybe<EditComponentOptionTimezoneInput>;
  certificate?: Maybe<Scalars['ID']>;
  loginAttempts?: Maybe<Scalars['Int']>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programme_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  feedForwardUrl?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['ID']>;
  region?: Maybe<Scalars['ID']>;
  sub_module_submissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  programmes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  coach_submitted_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  loginWithSSO?: Maybe<Scalars['Boolean']>;
  programmeEvalutionEmailSent?: Maybe<Scalars['Boolean']>;
  updatedDetails?: Maybe<Scalars['Boolean']>;
  account_changes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user_uploaded_documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboarding?: Maybe<Scalars['Boolean']>;
  triggerReport?: Maybe<Scalars['Boolean']>;
  bookings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  clientId?: Maybe<Scalars['Long']>;
  respondents_answers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  current_survey?: Maybe<Scalars['JSON']>;
  coach?: Maybe<Scalars['ID']>;
  three_60_form_id?: Maybe<Scalars['String']>;
  submodule_reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentOptionTimezoneInput = {
  id?: Maybe<Scalars['ID']>;
  abbrev?: Maybe<Scalars['String']>;
  altName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};


export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type TranslationInput = {
  languageSelection?: Maybe<ComponentTranslationsLanguageSelectionInput>;
  welcomeScreen?: Maybe<ComponentTranslationsWelcomeScreenInput>;
  letsGetStartedScreen?: Maybe<ComponentTranslationsLetsGetStartedScreenInput>;
  whatToExpect?: Maybe<ComponentTranslationsWhatToExpectInput>;
  homeScreen?: Maybe<ComponentTranslationsHomeScreenInput>;
  myWorkScreen?: Maybe<ComponentTranslationsMyWorkScreenInput>;
  myLibraryScreen?: Maybe<ComponentTranslationsMyLibraryScreenInput>;
  myProfileScreen?: Maybe<ComponentTranslationsMyProfileScreenInput>;
  personalScreen?: Maybe<ComponentTranslationsPersonalScreenInput>;
  menu?: Maybe<ComponentTranslationsMenuInput>;
  settingsScreen?: Maybe<ComponentTranslationsSettingsScreenInput>;
  helpAndSupport?: Maybe<ComponentTranslationsHelpAndSupportInput>;
  aboutUs?: Maybe<ComponentTranslationsAboutUsInput>;
  buttons?: Maybe<ComponentTranslationsButtonInput>;
  programmesScreen?: Maybe<ComponentTranslationsProgrammeScreenInput>;
  faqs?: Maybe<ComponentTranslationsFaqInput>;
  termsofService?: Maybe<ComponentTranslationsTermsOfServiceInput>;
  privacyPolicy?: Maybe<ComponentTranslationsPrivacyPolicyInput>;
  dashboardScreen?: Maybe<ComponentTranslationsDashboardScreenInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentTranslationsHomeScreenInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  myProgrammeEnglish?: Maybe<Scalars['String']>;
  completedModulesEnglish?: Maybe<Scalars['String']>;
  noChangesEnglish?: Maybe<Scalars['String']>;
  changesUpEnglish?: Maybe<Scalars['String']>;
  changesDownEnglish?: Maybe<Scalars['String']>;
  viewModulesEnglish?: Maybe<Scalars['String']>;
  myLibraryEnglish?: Maybe<Scalars['String']>;
  viewedArticlesEnglish?: Maybe<Scalars['String']>;
  viewLibraryEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  myProgrammeFrench?: Maybe<Scalars['String']>;
  completedModulesFrench?: Maybe<Scalars['String']>;
  noChangesFrench?: Maybe<Scalars['String']>;
  changesUpFrench?: Maybe<Scalars['String']>;
  changesDownFrench?: Maybe<Scalars['String']>;
  viewModulesFrench?: Maybe<Scalars['String']>;
  myLibraryFrench?: Maybe<Scalars['String']>;
  viewedArticlesFrench?: Maybe<Scalars['String']>;
  viewLibraryFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  myProgrammeGerman?: Maybe<Scalars['String']>;
  completedModulesGerman?: Maybe<Scalars['String']>;
  noChangesGerman?: Maybe<Scalars['String']>;
  changesUpGerman?: Maybe<Scalars['String']>;
  changesDownGerman?: Maybe<Scalars['String']>;
  viewModulesGerman?: Maybe<Scalars['String']>;
  myLibraryGerman?: Maybe<Scalars['String']>;
  viewedArticlesGerman?: Maybe<Scalars['String']>;
  viewLibraryGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  myProgrammeSpanish?: Maybe<Scalars['String']>;
  completedModulesSpanish?: Maybe<Scalars['String']>;
  noChangesSpanish?: Maybe<Scalars['String']>;
  changesUpSpanish?: Maybe<Scalars['String']>;
  changesDownSpanish?: Maybe<Scalars['String']>;
  viewModulesSpanish?: Maybe<Scalars['String']>;
  myLibrarySpanish?: Maybe<Scalars['String']>;
  viewedArticlesSpanish?: Maybe<Scalars['String']>;
  viewLibrarySpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  myProgrammeMandarin?: Maybe<Scalars['String']>;
  completedModulesMandarin?: Maybe<Scalars['String']>;
  noChangesMandarin?: Maybe<Scalars['String']>;
  changesUpMandarin?: Maybe<Scalars['String']>;
  changesDownMandarin?: Maybe<Scalars['String']>;
  viewModulesMandarin?: Maybe<Scalars['String']>;
  myLibraryMandarin?: Maybe<Scalars['String']>;
  viewedArticlesMandarin?: Maybe<Scalars['String']>;
  viewLibraryMandarin?: Maybe<Scalars['String']>;
  welcomeEnglish?: Maybe<Scalars['String']>;
  welcomeFrench?: Maybe<Scalars['String']>;
  welcomeGerman?: Maybe<Scalars['String']>;
  welcomeSpanish?: Maybe<Scalars['String']>;
  welcomeMandarin?: Maybe<Scalars['String']>;
  programmeProgressEnglish?: Maybe<Scalars['String']>;
  programmeProgressFrench?: Maybe<Scalars['String']>;
  programmeProgressGerman?: Maybe<Scalars['String']>;
  programmeProgressSpanish?: Maybe<Scalars['String']>;
  programmeProgressMandarin?: Maybe<Scalars['String']>;
  whatsNextEnglish?: Maybe<Scalars['String']>;
  whatsNextFrench?: Maybe<Scalars['String']>;
  whatsNextGerman?: Maybe<Scalars['String']>;
  whatsNextSpanish?: Maybe<Scalars['String']>;
  whatsNextMandarin?: Maybe<Scalars['String']>;
  whatToExpectEnglish?: Maybe<Scalars['String']>;
  whatToExpectFrench?: Maybe<Scalars['String']>;
  whatToExpectGerman?: Maybe<Scalars['String']>;
  whatToExpectSpanish?: Maybe<Scalars['String']>;
  whatToExpectMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMyWorkScreenInput = {
  emptyStateTitleEnglish?: Maybe<Scalars['String']>;
  emptyStateDescEnglish?: Maybe<Scalars['String']>;
  subtitleEnglish?: Maybe<Scalars['String']>;
  feedbackEnglish?: Maybe<Scalars['String']>;
  feedbackNotEligibleEnglish?: Maybe<Scalars['String']>;
  feedbackNotReceivedEnglish?: Maybe<Scalars['String']>;
  notStartedEnglish?: Maybe<Scalars['String']>;
  emptyStateTitleFrench?: Maybe<Scalars['String']>;
  emptyStateDescFrench?: Maybe<Scalars['String']>;
  subtitleFrench?: Maybe<Scalars['String']>;
  feedbackFrench?: Maybe<Scalars['String']>;
  feedbackNotEligibleFrench?: Maybe<Scalars['String']>;
  feedbackNotReceivedFrench?: Maybe<Scalars['String']>;
  notStartedFrench?: Maybe<Scalars['String']>;
  emptyStateTitleGerman?: Maybe<Scalars['String']>;
  emptyStateDescGerman?: Maybe<Scalars['String']>;
  subtitleGerman?: Maybe<Scalars['String']>;
  feedbackGerman?: Maybe<Scalars['String']>;
  feedbackNotEligibleGerman?: Maybe<Scalars['String']>;
  feedbackNotReceivedGerman?: Maybe<Scalars['String']>;
  notStartedGerman?: Maybe<Scalars['String']>;
  emptyStateTitleSpanish?: Maybe<Scalars['String']>;
  emptyStateDescSpanish?: Maybe<Scalars['String']>;
  subtitleSpanish?: Maybe<Scalars['String']>;
  feedbackSpanish?: Maybe<Scalars['String']>;
  feedbackNotEligibleSpanish?: Maybe<Scalars['String']>;
  feedbackNotReceivedSpanish?: Maybe<Scalars['String']>;
  notStartedSpanish?: Maybe<Scalars['String']>;
  emptyStateTitleMandarin?: Maybe<Scalars['String']>;
  emptyStateDescMandarin?: Maybe<Scalars['String']>;
  subtitleMandarin?: Maybe<Scalars['String']>;
  feedbackMandarin?: Maybe<Scalars['String']>;
  feedbackNotEligibleMandarin?: Maybe<Scalars['String']>;
  feedbackNotReceivedMandarin?: Maybe<Scalars['String']>;
  notStartedMandarin?: Maybe<Scalars['String']>;
  downloadContentTextEnglish?: Maybe<Scalars['String']>;
  downloadContentTextFrench?: Maybe<Scalars['String']>;
  downloadContentTextGerman?: Maybe<Scalars['String']>;
  downloadContentTextSpanish?: Maybe<Scalars['String']>;
  downloadContentTextMandarin?: Maybe<Scalars['String']>;
  myNotesEnglish?: Maybe<Scalars['String']>;
  myNotesSpanish?: Maybe<Scalars['String']>;
  myNotesMandarin?: Maybe<Scalars['String']>;
  myNotesFrench?: Maybe<Scalars['String']>;
  myNotesGerman?: Maybe<Scalars['String']>;
  moduleReportsEnglish?: Maybe<Scalars['String']>;
  moduleReportsMandarin?: Maybe<Scalars['String']>;
  moduleReportsSpanish?: Maybe<Scalars['String']>;
  moduleReportsFrench?: Maybe<Scalars['String']>;
  moduleReportsGerman?: Maybe<Scalars['String']>;
  documentsEnglish?: Maybe<Scalars['String']>;
  documentsSpanish?: Maybe<Scalars['String']>;
  documentsFrench?: Maybe<Scalars['String']>;
  documentsMandarin?: Maybe<Scalars['String']>;
  documentsGerman?: Maybe<Scalars['String']>;
  deleteHeadingEnglish?: Maybe<Scalars['String']>;
  deleteHeadingSpanish?: Maybe<Scalars['String']>;
  deleteHeadingGerman?: Maybe<Scalars['String']>;
  deleteHeadingMandarin?: Maybe<Scalars['String']>;
  deleteHeadingFrench?: Maybe<Scalars['String']>;
  deleteMessageEnglish?: Maybe<Scalars['String']>;
  deleteMessageSpanish?: Maybe<Scalars['String']>;
  deleteMessageGerman?: Maybe<Scalars['String']>;
  deleteMessageFrench?: Maybe<Scalars['String']>;
  deleteMessageMandarin?: Maybe<Scalars['String']>;
  recentNotesEnglish?: Maybe<Scalars['String']>;
  recentNotesSpanish?: Maybe<Scalars['String']>;
  recentNotesGerman?: Maybe<Scalars['String']>;
  recentNotesFrench?: Maybe<Scalars['String']>;
  recentNotesMandarin?: Maybe<Scalars['String']>;
  programmeHeadingEnglish?: Maybe<Scalars['String']>;
  programmeHeadingSpanish?: Maybe<Scalars['String']>;
  programmeHeadingFrench?: Maybe<Scalars['String']>;
  programmeHeadingMandarin?: Maybe<Scalars['String']>;
  programmeHeadingGerman?: Maybe<Scalars['String']>;
  noNotesHeadingEnglish?: Maybe<Scalars['String']>;
  noNotesHeadingSpanish?: Maybe<Scalars['String']>;
  noNotesHeadingFrench?: Maybe<Scalars['String']>;
  noNotesHeadingMandarin?: Maybe<Scalars['String']>;
  noNotesHeadingGerman?: Maybe<Scalars['String']>;
  noNotesSubHeadingEnglish?: Maybe<Scalars['String']>;
  noNotesSubHeadingFrench?: Maybe<Scalars['String']>;
  noNotesSubHeadingSpanish?: Maybe<Scalars['String']>;
  noNotesSubHeadingGerman?: Maybe<Scalars['String']>;
  noNotesSubHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsHeadingEnglish?: Maybe<Scalars['String']>;
  noModuleReportsHeadingSpanish?: Maybe<Scalars['String']>;
  noModuleReportsHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsHeadingFrench?: Maybe<Scalars['String']>;
  noModuleReportsHeadingGerman?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingEnglish?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingFrench?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingMandarin?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingGerman?: Maybe<Scalars['String']>;
  noModuleReportsSubHeadingSpanish?: Maybe<Scalars['String']>;
  noDocumentsHeadingEnglish?: Maybe<Scalars['String']>;
  noDocumentsHeadingSpanish?: Maybe<Scalars['String']>;
  noDocumentsHeadingGerman?: Maybe<Scalars['String']>;
  noDocumentsHeadingMandarin?: Maybe<Scalars['String']>;
  noDocumentsHeadingFrench?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingEnglish?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingFrench?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingMandarin?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingGerman?: Maybe<Scalars['String']>;
  noDocumentsSubHeadingSpanish?: Maybe<Scalars['String']>;
  sectionCompletedEnglish?: Maybe<Scalars['String']>;
  sectionCompletedSpanish?: Maybe<Scalars['String']>;
  sectionCompletedGerman?: Maybe<Scalars['String']>;
  sectionCompletedFrench?: Maybe<Scalars['String']>;
  sectionCompletedMandarin?: Maybe<Scalars['String']>;
  documentsUploadedEnglish?: Maybe<Scalars['String']>;
  documentsUploadedSpanish?: Maybe<Scalars['String']>;
  documentsUploadedFrench?: Maybe<Scalars['String']>;
  documentsUploadedMandarin?: Maybe<Scalars['String']>;
  documentsUploadedGerman?: Maybe<Scalars['String']>;
  uploadButtonEnglish?: Maybe<Scalars['String']>;
  uploadButtonFrench?: Maybe<Scalars['String']>;
  uploadButtonMandarin?: Maybe<Scalars['String']>;
  uploadButtonSpanish?: Maybe<Scalars['String']>;
  uploadButtonGerman?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMyLibraryScreenInput = {
  allArticlesEnglish?: Maybe<Scalars['String']>;
  myBookmarksEnglish?: Maybe<Scalars['String']>;
  allArticlesFrench?: Maybe<Scalars['String']>;
  myBookmarksFrench?: Maybe<Scalars['String']>;
  allArticlesGerman?: Maybe<Scalars['String']>;
  myBookmarksGerman?: Maybe<Scalars['String']>;
  allArticlesSpanish?: Maybe<Scalars['String']>;
  myBookmarksSpanish?: Maybe<Scalars['String']>;
  allArticlesMandarin?: Maybe<Scalars['String']>;
  myBookmarksMandarin?: Maybe<Scalars['String']>;
  viewArticleEnglish?: Maybe<Scalars['String']>;
  viewArticleFrench?: Maybe<Scalars['String']>;
  viewArticleSpanish?: Maybe<Scalars['String']>;
  viewArticleGerman?: Maybe<Scalars['String']>;
  viewArticleMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMyProfileScreenInput = {
  detailsEnglish?: Maybe<Scalars['String']>;
  settingsEnglish?: Maybe<Scalars['String']>;
  logoutEnglish?: Maybe<Scalars['String']>;
  joinEnglish?: Maybe<Scalars['String']>;
  detailsFrench?: Maybe<Scalars['String']>;
  settingsFrench?: Maybe<Scalars['String']>;
  logoutFrench?: Maybe<Scalars['String']>;
  joinFrench?: Maybe<Scalars['String']>;
  detailsGerman?: Maybe<Scalars['String']>;
  settingsGerman?: Maybe<Scalars['String']>;
  logoutGerman?: Maybe<Scalars['String']>;
  joinGerman?: Maybe<Scalars['String']>;
  detailsSpanish?: Maybe<Scalars['String']>;
  settingsSpanish?: Maybe<Scalars['String']>;
  logoutSpanish?: Maybe<Scalars['String']>;
  joinSpanish?: Maybe<Scalars['String']>;
  detailsMandarin?: Maybe<Scalars['String']>;
  settingsMandarin?: Maybe<Scalars['String']>;
  logoutMandarin?: Maybe<Scalars['String']>;
  joinMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsPersonalScreenInput = {
  changePhotoEnglish?: Maybe<Scalars['String']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']>;
  emailLabelEnglish?: Maybe<Scalars['String']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']>;
  divisionLabelEnglish?: Maybe<Scalars['String']>;
  editInfoButtonEnglish?: Maybe<Scalars['String']>;
  changePhotoFrench?: Maybe<Scalars['String']>;
  firstNameLabelFrench?: Maybe<Scalars['String']>;
  lastNameLabelFrench?: Maybe<Scalars['String']>;
  emailLabelFrench?: Maybe<Scalars['String']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']>;
  divisionLabelFrench?: Maybe<Scalars['String']>;
  editInfoButtonFrench?: Maybe<Scalars['String']>;
  changePhotoGerman?: Maybe<Scalars['String']>;
  firstNameLabelGerman?: Maybe<Scalars['String']>;
  lastNameLabelGerman?: Maybe<Scalars['String']>;
  emailLabelGerman?: Maybe<Scalars['String']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']>;
  divisionLabelGerman?: Maybe<Scalars['String']>;
  editInfoButtonGerman?: Maybe<Scalars['String']>;
  changePhotoSpanish?: Maybe<Scalars['String']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']>;
  emailLabelSpanish?: Maybe<Scalars['String']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']>;
  divisionLabelSpanish?: Maybe<Scalars['String']>;
  editInfoButtonSpanish?: Maybe<Scalars['String']>;
  changePhotoMandarin?: Maybe<Scalars['String']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']>;
  emailLabelMandarin?: Maybe<Scalars['String']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']>;
  divisionLabelMandarin?: Maybe<Scalars['String']>;
  editInfoButtonMandarin?: Maybe<Scalars['String']>;
  resetPasswordEnglish?: Maybe<Scalars['String']>;
  resetPasswordFrench?: Maybe<Scalars['String']>;
  resetPasswordSpanish?: Maybe<Scalars['String']>;
  resetPasswordGerman?: Maybe<Scalars['String']>;
  resetPasswordMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsMenuInput = {
  homeEnglish?: Maybe<Scalars['String']>;
  myProgrammeEnglish?: Maybe<Scalars['String']>;
  myWorkEnglish?: Maybe<Scalars['String']>;
  myLibraryEnglish?: Maybe<Scalars['String']>;
  myProfileEnglish?: Maybe<Scalars['String']>;
  helpAndSupportEnglish?: Maybe<Scalars['String']>;
  signOutEnglish?: Maybe<Scalars['String']>;
  homeFrench?: Maybe<Scalars['String']>;
  myProgrammeFrench?: Maybe<Scalars['String']>;
  myWorkFrench?: Maybe<Scalars['String']>;
  myLibraryFrench?: Maybe<Scalars['String']>;
  myProfileFrench?: Maybe<Scalars['String']>;
  helpAndSupportFrench?: Maybe<Scalars['String']>;
  signOutFrench?: Maybe<Scalars['String']>;
  homeGerman?: Maybe<Scalars['String']>;
  myProgrammeGerman?: Maybe<Scalars['String']>;
  myWorkGerman?: Maybe<Scalars['String']>;
  myLibraryGerman?: Maybe<Scalars['String']>;
  myProfileGerman?: Maybe<Scalars['String']>;
  helpAndSupportGerman?: Maybe<Scalars['String']>;
  signOutGerman?: Maybe<Scalars['String']>;
  homeSpanish?: Maybe<Scalars['String']>;
  myProgrammeSpanish?: Maybe<Scalars['String']>;
  myWorkSpanish?: Maybe<Scalars['String']>;
  myLibrarySpanish?: Maybe<Scalars['String']>;
  myProfileSpanish?: Maybe<Scalars['String']>;
  helpAndSupportSpanish?: Maybe<Scalars['String']>;
  signOutSpanish?: Maybe<Scalars['String']>;
  homeMandarin?: Maybe<Scalars['String']>;
  myProgrammeMandarin?: Maybe<Scalars['String']>;
  myWorkMandarin?: Maybe<Scalars['String']>;
  myLibraryMandarin?: Maybe<Scalars['String']>;
  myProfileMandarin?: Maybe<Scalars['String']>;
  helpAndSupportMandarin?: Maybe<Scalars['String']>;
  signOutMandarin?: Maybe<Scalars['String']>;
  aboutUsEnglish?: Maybe<Scalars['String']>;
  aboutUsFrench?: Maybe<Scalars['String']>;
  aboutUsGerman?: Maybe<Scalars['String']>;
  myNotesMandarin?: Maybe<Scalars['String']>;
  myNotesGerman?: Maybe<Scalars['String']>;
  myNotesSpanish?: Maybe<Scalars['String']>;
  myNotesEnglish?: Maybe<Scalars['String']>;
  myNotesFrench?: Maybe<Scalars['String']>;
  notificationsEnglish?: Maybe<Scalars['String']>;
  notificationsFrench?: Maybe<Scalars['String']>;
  notificationsGerman?: Maybe<Scalars['String']>;
  notificationsSpanish?: Maybe<Scalars['String']>;
  notificationsMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsSettingsScreenInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  saveButtonEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  saveButtonFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  saveButtonGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  saveButtonSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  saveButtonMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsHelpAndSupportInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  knowledgeBaseEnglish?: Maybe<Scalars['String']>;
  liveChatEnglish?: Maybe<Scalars['String']>;
  myTicketsEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  knowledgeBaseFrench?: Maybe<Scalars['String']>;
  liveChatFrench?: Maybe<Scalars['String']>;
  myTicketsFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  knowledgeBaseGerman?: Maybe<Scalars['String']>;
  liveChatGerman?: Maybe<Scalars['String']>;
  myTicketsGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  knowledgeBaseSpanish?: Maybe<Scalars['String']>;
  liveChatSpanish?: Maybe<Scalars['String']>;
  myTicketsSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  knowledgeBaseMandarin?: Maybe<Scalars['String']>;
  liveChatMandarin?: Maybe<Scalars['String']>;
  myTicketsMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsButtonInput = {
  backBtnsEnglish?: Maybe<Scalars['String']>;
  backBtnsFrench?: Maybe<Scalars['String']>;
  backBtnsGerman?: Maybe<Scalars['String']>;
  nextBtnsEnglish?: Maybe<Scalars['String']>;
  nextBtnsFrench?: Maybe<Scalars['String']>;
  nextBtnsGerman?: Maybe<Scalars['String']>;
  addMoreBtnsEnglish?: Maybe<Scalars['String']>;
  addMoreBtnsFrench?: Maybe<Scalars['String']>;
  addMoreBtnsGerman?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsProgrammeScreenInput = {
  changeButtonEnglish?: Maybe<Scalars['String']>;
  changeButtonFrench?: Maybe<Scalars['String']>;
  changeButtonGerman?: Maybe<Scalars['String']>;
  changeButtonSpanish?: Maybe<Scalars['String']>;
  changeButtonMandarin?: Maybe<Scalars['String']>;
  programmeOverviewEnglish?: Maybe<Scalars['String']>;
  programmeOverviewFrench?: Maybe<Scalars['String']>;
  programmeOverviewSpanish?: Maybe<Scalars['String']>;
  programmeOverviewGerman?: Maybe<Scalars['String']>;
  programmeOverviewMandarin?: Maybe<Scalars['String']>;
  programmeTextEnglish?: Maybe<Scalars['String']>;
  programmeTextFrench?: Maybe<Scalars['String']>;
  programmeTextSpanish?: Maybe<Scalars['String']>;
  programmeTextGerman?: Maybe<Scalars['String']>;
  programmeTextMandarin?: Maybe<Scalars['String']>;
  informationEnglish?: Maybe<Scalars['String']>;
  informationFrench?: Maybe<Scalars['String']>;
  informationGerman?: Maybe<Scalars['String']>;
  informationSpanish?: Maybe<Scalars['String']>;
  informationMandarin?: Maybe<Scalars['String']>;
  selectProgrammesTitleEnglish?: Maybe<Scalars['String']>;
  selectProgrammesTitleFrench?: Maybe<Scalars['String']>;
  selectProgrammesTitleGerman?: Maybe<Scalars['String']>;
  selectProgrammesTitleSpanish?: Maybe<Scalars['String']>;
  selectProgrammesTitleMandarin?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleEnglish?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleFrench?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleGerman?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleSpanish?: Maybe<Scalars['String']>;
  selectProgrammesSubTitleMandarin?: Maybe<Scalars['String']>;
  selectButtonEnglish?: Maybe<Scalars['String']>;
  selectButtonFrench?: Maybe<Scalars['String']>;
  selectButtonGerman?: Maybe<Scalars['String']>;
  selectButtonSpanish?: Maybe<Scalars['String']>;
  selectButtonMandarin?: Maybe<Scalars['String']>;
  changeProgrammeTypeEnglish?: Maybe<Scalars['String']>;
  changeProgrammeTypeFrench?: Maybe<Scalars['String']>;
  changeProgrammeTypeGerman?: Maybe<Scalars['String']>;
  changeProgrammeTypeSpanish?: Maybe<Scalars['String']>;
  changeProgrammeTypeMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqInput = {
  faqsEnglish?: Maybe<Array<Maybe<ComponentTranslationsFaqsQuestionAnswerInput>>>;
  faqsFrench?: Maybe<Array<Maybe<ComponentTranslationsFaqsFrenchInput>>>;
  faqsGerman?: Maybe<Array<Maybe<ComponentTranslationsFaqsGermanInput>>>;
  faqsMandarin?: Maybe<Array<Maybe<ComponentTranslationsFaqsMandarinInput>>>;
  faqsSpanish?: Maybe<Array<Maybe<ComponentTranslationsFaqsSpanishInput>>>;
};

export type ComponentTranslationsFaqsQuestionAnswerInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsFrenchInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsGermanInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsMandarinInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsFaqsSpanishInput = {
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsTermsOfServiceInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  textEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  textSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  textMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsPrivacyPolicyInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  textEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  textFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  textGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  textSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  textMandarin?: Maybe<Scalars['String']>;
};

export type ComponentTranslationsDashboardScreenInput = {
  myProgrammesEnglish?: Maybe<Scalars['String']>;
  myProgrammesFrench?: Maybe<Scalars['String']>;
  myProgrammesGerman?: Maybe<Scalars['String']>;
  myProgrammesSpanish?: Maybe<Scalars['String']>;
  myProgrammesMandarin?: Maybe<Scalars['String']>;
  suggestedTitleEnglish?: Maybe<Scalars['String']>;
  suggestedTitleFrench?: Maybe<Scalars['String']>;
  suggestedTitleSpanish?: Maybe<Scalars['String']>;
  suggestedTitleGerman?: Maybe<Scalars['String']>;
  suggestedTitleMandarin?: Maybe<Scalars['String']>;
  uploadTitleEnglish?: Maybe<Scalars['String']>;
  uploadTitleFrench?: Maybe<Scalars['String']>;
  uploadTitleSpanish?: Maybe<Scalars['String']>;
  uploadTitleGerman?: Maybe<Scalars['String']>;
  uploadTitleMandarin?: Maybe<Scalars['String']>;
  viewAllEnglish?: Maybe<Scalars['String']>;
  viewAllFrench?: Maybe<Scalars['String']>;
  viewAllMandarin?: Maybe<Scalars['String']>;
  viewAllSpanish?: Maybe<Scalars['String']>;
  viewAllGerman?: Maybe<Scalars['String']>;
  logOutDashboardEnglish?: Maybe<Scalars['String']>;
  logOutDashboardFrench?: Maybe<Scalars['String']>;
  logOutDashboardMandarin?: Maybe<Scalars['String']>;
  logOutDashboardSpanish?: Maybe<Scalars['String']>;
  logOutDashboardGerman?: Maybe<Scalars['String']>;
  notepadTextEnglish?: Maybe<Scalars['String']>;
  notepadTextFrench?: Maybe<Scalars['String']>;
  notepadTextMandarin?: Maybe<Scalars['String']>;
  notepadTextSpanish?: Maybe<Scalars['String']>;
  notepadTextGerman?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentOptionOptionInput = {
  optionEnglish?: Maybe<Scalars['String']>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  optionFrench?: Maybe<Scalars['String']>;
  optionGerman?: Maybe<Scalars['String']>;
  optionSpanish?: Maybe<Scalars['String']>;
  optionMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentOptionOptionInput = {
  id?: Maybe<Scalars['ID']>;
  optionEnglish?: Maybe<Scalars['String']>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  optionFrench?: Maybe<Scalars['String']>;
  optionGerman?: Maybe<Scalars['String']>;
  optionSpanish?: Maybe<Scalars['String']>;
  optionMandarin?: Maybe<Scalars['String']>;
};

export type ComponentOptionSliderHeadingInput = {
  headingEnglish?: Maybe<Scalars['String']>;
  headingMandarin?: Maybe<Scalars['String']>;
  headingSpanish?: Maybe<Scalars['String']>;
  headingFrench?: Maybe<Scalars['String']>;
  headingGerman?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};

export type EditComponentOptionSliderHeadingInput = {
  id?: Maybe<Scalars['ID']>;
  headingEnglish?: Maybe<Scalars['String']>;
  headingMandarin?: Maybe<Scalars['String']>;
  headingSpanish?: Maybe<Scalars['String']>;
  headingFrench?: Maybe<Scalars['String']>;
  headingGerman?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};

export type ComponentOptionSliderQuestionInput = {
  questionPositiveEnglish?: Maybe<Scalars['String']>;
  questionPositiveGerman?: Maybe<Scalars['String']>;
  questionPositiveFrench?: Maybe<Scalars['String']>;
  questionPositiveMandarin?: Maybe<Scalars['String']>;
  questionPositiveSpanish?: Maybe<Scalars['String']>;
  questionNegativeFrench?: Maybe<Scalars['String']>;
  questionNegativeSpanish?: Maybe<Scalars['String']>;
  questionNegativeEnglish?: Maybe<Scalars['String']>;
  questionNegativeMandarin?: Maybe<Scalars['String']>;
  questionNegativeGerman?: Maybe<Scalars['String']>;
};

export type EditComponentOptionSliderQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  questionPositiveEnglish?: Maybe<Scalars['String']>;
  questionPositiveGerman?: Maybe<Scalars['String']>;
  questionPositiveFrench?: Maybe<Scalars['String']>;
  questionPositiveMandarin?: Maybe<Scalars['String']>;
  questionPositiveSpanish?: Maybe<Scalars['String']>;
  questionNegativeFrench?: Maybe<Scalars['String']>;
  questionNegativeSpanish?: Maybe<Scalars['String']>;
  questionNegativeEnglish?: Maybe<Scalars['String']>;
  questionNegativeMandarin?: Maybe<Scalars['String']>;
  questionNegativeGerman?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesCompetencyInput = {
  question?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  minNumber?: Maybe<Scalars['Long']>;
  maxNumber?: Maybe<Scalars['Long']>;
  miniLabel?: Maybe<Scalars['String']>;
  maxiLabel?: Maybe<Scalars['String']>;
  simpleQuestion?: Maybe<Scalars['Boolean']>;
};

export type EditComponentQuestionTypesCompetencyInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  minNumber?: Maybe<Scalars['Long']>;
  maxNumber?: Maybe<Scalars['Long']>;
  miniLabel?: Maybe<Scalars['String']>;
  maxiLabel?: Maybe<Scalars['String']>;
  simpleQuestion?: Maybe<Scalars['Boolean']>;
};

export type ComponentQuestionTypesCompetency2Input = {
  titleEnglish?: Maybe<Scalars['String']>;
  questionscompetency2?: Maybe<Array<Maybe<ComponentQuestionTypesQuestionscompetency2Input>>>;
  titleFrench?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesQuestionscompetency2Input = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  maxiNumber?: Maybe<Scalars['Long']>;
  maxiLabel?: Maybe<Scalars['String']>;
  simpleQuestion?: Maybe<Scalars['Boolean']>;
  miniNumber?: Maybe<Scalars['Long']>;
  miniLabel?: Maybe<Scalars['String']>;
  midiLabel?: Maybe<Scalars['String']>;
  textboxQuestion?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesCompetency2Input = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  questionscompetency2?: Maybe<Array<Maybe<EditComponentQuestionTypesQuestionscompetency2Input>>>;
  titleFrench?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesQuestionscompetency2Input = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  maxiNumber?: Maybe<Scalars['Long']>;
  maxiLabel?: Maybe<Scalars['String']>;
  simpleQuestion?: Maybe<Scalars['Boolean']>;
  miniNumber?: Maybe<Scalars['Long']>;
  miniLabel?: Maybe<Scalars['String']>;
  midiLabel?: Maybe<Scalars['String']>;
  textboxQuestion?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesFeedForward1Input = {
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesFeedForward1Input = {
  id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesFeedForward2Input = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesFeedForward2Input = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesGravitasGapInput = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color1?: Maybe<Scalars['String']>;
  color2?: Maybe<Scalars['String']>;
  color3?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesGravitasGapInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color1?: Maybe<Scalars['String']>;
  color2?: Maybe<Scalars['String']>;
  color3?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesGravitasScaleInput = {
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  questionOneFrench?: Maybe<Scalars['String']>;
  questionTwoFrench?: Maybe<Scalars['String']>;
  questionThreeFrench?: Maybe<Scalars['String']>;
  titleOneFrench?: Maybe<Scalars['String']>;
  titleTwoFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  questionOneGerman?: Maybe<Scalars['String']>;
  questionTwoGerman?: Maybe<Scalars['String']>;
  questionThreeGerman?: Maybe<Scalars['String']>;
  titleOneGerman?: Maybe<Scalars['String']>;
  titleTwoGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  questionOneSpanish?: Maybe<Scalars['String']>;
  questionTwoSpanish?: Maybe<Scalars['String']>;
  questionThreeSpanish?: Maybe<Scalars['String']>;
  titleOneSpanish?: Maybe<Scalars['String']>;
  titleTwoSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  questionOneMandarin?: Maybe<Scalars['String']>;
  questionTwoMandarin?: Maybe<Scalars['String']>;
  questionThreeMandarin?: Maybe<Scalars['String']>;
  titleOneMandarin?: Maybe<Scalars['String']>;
  titleTwoMandarin?: Maybe<Scalars['String']>;
  ratingInput?: Maybe<Array<Maybe<ComponentRatingInputRatingInputInput>>>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  questionOneEnglish?: Maybe<Scalars['String']>;
  questionTwoEnglish?: Maybe<Scalars['String']>;
  questionThreeEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
  titleOneEnglish?: Maybe<Scalars['String']>;
  titleTwoEnglish?: Maybe<Scalars['String']>;
};

export type ComponentRatingInputRatingInputInput = {
  labelOneEnglish?: Maybe<Scalars['String']>;
  labelTwoEnglish?: Maybe<Scalars['String']>;
  labelOneFrench?: Maybe<Scalars['String']>;
  labelTwoFrench?: Maybe<Scalars['String']>;
  labelOneGerman?: Maybe<Scalars['String']>;
  labelTwoGerman?: Maybe<Scalars['String']>;
  labelOneSpanish?: Maybe<Scalars['String']>;
  labelTwoSpanish?: Maybe<Scalars['String']>;
  labelOneMandarin?: Maybe<Scalars['String']>;
  labelTwoMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesGravitasScaleInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  questionOneFrench?: Maybe<Scalars['String']>;
  questionTwoFrench?: Maybe<Scalars['String']>;
  questionThreeFrench?: Maybe<Scalars['String']>;
  titleOneFrench?: Maybe<Scalars['String']>;
  titleTwoFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  questionOneGerman?: Maybe<Scalars['String']>;
  questionTwoGerman?: Maybe<Scalars['String']>;
  questionThreeGerman?: Maybe<Scalars['String']>;
  titleOneGerman?: Maybe<Scalars['String']>;
  titleTwoGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  questionOneSpanish?: Maybe<Scalars['String']>;
  questionTwoSpanish?: Maybe<Scalars['String']>;
  questionThreeSpanish?: Maybe<Scalars['String']>;
  titleOneSpanish?: Maybe<Scalars['String']>;
  titleTwoSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  questionOneMandarin?: Maybe<Scalars['String']>;
  questionTwoMandarin?: Maybe<Scalars['String']>;
  questionThreeMandarin?: Maybe<Scalars['String']>;
  titleOneMandarin?: Maybe<Scalars['String']>;
  titleTwoMandarin?: Maybe<Scalars['String']>;
  ratingInput?: Maybe<Array<Maybe<EditComponentRatingInputRatingInputInput>>>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  questionOneEnglish?: Maybe<Scalars['String']>;
  questionTwoEnglish?: Maybe<Scalars['String']>;
  questionThreeEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
  titleOneEnglish?: Maybe<Scalars['String']>;
  titleTwoEnglish?: Maybe<Scalars['String']>;
};

export type EditComponentRatingInputRatingInputInput = {
  id?: Maybe<Scalars['ID']>;
  labelOneEnglish?: Maybe<Scalars['String']>;
  labelTwoEnglish?: Maybe<Scalars['String']>;
  labelOneFrench?: Maybe<Scalars['String']>;
  labelTwoFrench?: Maybe<Scalars['String']>;
  labelOneGerman?: Maybe<Scalars['String']>;
  labelTwoGerman?: Maybe<Scalars['String']>;
  labelOneSpanish?: Maybe<Scalars['String']>;
  labelTwoSpanish?: Maybe<Scalars['String']>;
  labelOneMandarin?: Maybe<Scalars['String']>;
  labelTwoMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesGravitasSliderInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  positiveHeadingEnglish?: Maybe<Scalars['String']>;
  positiveHeadingGerman?: Maybe<Scalars['String']>;
  positiveHeadingMandarin?: Maybe<Scalars['String']>;
  positiveHeadingSpanish?: Maybe<Scalars['String']>;
  positiveHeadingFrench?: Maybe<Scalars['String']>;
  negativeHeadingEnglish?: Maybe<Scalars['String']>;
  negativeHeadingMandarin?: Maybe<Scalars['String']>;
  negativeHeadingSpanish?: Maybe<Scalars['String']>;
  negativeHeadingGerman?: Maybe<Scalars['String']>;
  negativeHeadingFrench?: Maybe<Scalars['String']>;
  sliderQuestions?: Maybe<Array<Maybe<ComponentOptionSliderQuestionInput>>>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  sliderHeadings?: Maybe<Array<Maybe<ComponentOptionSliderHeadingInput>>>;
};

export type EditComponentQuestionTypesGravitasSliderInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  positiveHeadingEnglish?: Maybe<Scalars['String']>;
  positiveHeadingGerman?: Maybe<Scalars['String']>;
  positiveHeadingMandarin?: Maybe<Scalars['String']>;
  positiveHeadingSpanish?: Maybe<Scalars['String']>;
  positiveHeadingFrench?: Maybe<Scalars['String']>;
  negativeHeadingEnglish?: Maybe<Scalars['String']>;
  negativeHeadingMandarin?: Maybe<Scalars['String']>;
  negativeHeadingSpanish?: Maybe<Scalars['String']>;
  negativeHeadingGerman?: Maybe<Scalars['String']>;
  negativeHeadingFrench?: Maybe<Scalars['String']>;
  sliderQuestions?: Maybe<Array<Maybe<EditComponentOptionSliderQuestionInput>>>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  sliderHeadings?: Maybe<Array<Maybe<EditComponentOptionSliderHeadingInput>>>;
};

export type ComponentQuestionTypesMultipleChoiceInput = {
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  option?: Maybe<Array<Maybe<ComponentOptionOptionInput>>>;
  numberOfAnswers?: Maybe<Scalars['Int']>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesMultipleChoiceInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  option?: Maybe<Array<Maybe<EditComponentOptionOptionInput>>>;
  numberOfAnswers?: Maybe<Scalars['Int']>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesNestedQuestionInput = {
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ComponentQuestionTypesSimpleQuestionInput>>>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSimpleQuestionInput = {
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  isNumeric?: Maybe<Scalars['Boolean']>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesNestedQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<EditComponentQuestionTypesSimpleQuestionInput>>>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesSimpleQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  isNumeric?: Maybe<Scalars['Boolean']>;
  viewPrevious?: Maybe<Scalars['Boolean']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesParticipantInput = {
  email?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesParticipantInput = {
  id?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSaboteurQuestionInput = {
  link?: Maybe<Scalars['String']>;
  labelEnglish?: Maybe<Scalars['String']>;
  skipProof?: Maybe<Scalars['Boolean']>;
  proof?: Maybe<Array<Maybe<Scalars['ID']>>>;
  labelFrench?: Maybe<Scalars['String']>;
  labelGerman?: Maybe<Scalars['String']>;
  labelSpanish?: Maybe<Scalars['String']>;
  labelMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesSaboteurQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  labelEnglish?: Maybe<Scalars['String']>;
  skipProof?: Maybe<Scalars['Boolean']>;
  proof?: Maybe<Array<Maybe<Scalars['ID']>>>;
  labelFrench?: Maybe<Scalars['String']>;
  labelGerman?: Maybe<Scalars['String']>;
  labelSpanish?: Maybe<Scalars['String']>;
  labelMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSaboteurVideoInput = {
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  SaboteurVideo?: Maybe<Array<Maybe<ComponentSaboteurVideoSaboteurVideoInput>>>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentSaboteurVideoSaboteurVideoInput = {
  videoTitleEnglish?: Maybe<Scalars['String']>;
  videoTitleFrench?: Maybe<Scalars['String']>;
  videoTitleGerman?: Maybe<Scalars['String']>;
  videoTitleSpanish?: Maybe<Scalars['String']>;
  videoTitleMandarin?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['ID']>;
  videoDescriptionEnglish?: Maybe<Scalars['String']>;
  videoDescriptionFrench?: Maybe<Scalars['String']>;
  videoDescriptionGerman?: Maybe<Scalars['String']>;
  videoDescriptionSpanish?: Maybe<Scalars['String']>;
  videoDescriptionMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesSaboteurVideoInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  SaboteurVideo?: Maybe<Array<Maybe<EditComponentSaboteurVideoSaboteurVideoInput>>>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type EditComponentSaboteurVideoSaboteurVideoInput = {
  id?: Maybe<Scalars['ID']>;
  videoTitleEnglish?: Maybe<Scalars['String']>;
  videoTitleFrench?: Maybe<Scalars['String']>;
  videoTitleGerman?: Maybe<Scalars['String']>;
  videoTitleSpanish?: Maybe<Scalars['String']>;
  videoTitleMandarin?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['ID']>;
  videoDescriptionEnglish?: Maybe<Scalars['String']>;
  videoDescriptionFrench?: Maybe<Scalars['String']>;
  videoDescriptionGerman?: Maybe<Scalars['String']>;
  videoDescriptionSpanish?: Maybe<Scalars['String']>;
  videoDescriptionMandarin?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSaboteurInput = {
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  labelEnglish?: Maybe<Scalars['String']>;
  labelFrench?: Maybe<Scalars['String']>;
  labelGerman?: Maybe<Scalars['String']>;
  labelSpanish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  saboteurQuestions?: Maybe<Array<Maybe<ComponentQuestionTypesSaboteurQuestionInput>>>;
};

export type EditComponentQuestionTypesSaboteurInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  labelEnglish?: Maybe<Scalars['String']>;
  labelFrench?: Maybe<Scalars['String']>;
  labelGerman?: Maybe<Scalars['String']>;
  labelSpanish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  saboteurQuestions?: Maybe<Array<Maybe<EditComponentQuestionTypesSaboteurQuestionInput>>>;
};

export type ComponentQuestionTypesSimpleReadOnlyInput = {
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  contentFrench?: Maybe<Scalars['String']>;
  contentGerman?: Maybe<Scalars['String']>;
  contentSpanish?: Maybe<Scalars['String']>;
  contentMandarin?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['ID']>;
  contentEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesSimpleReadOnlyInput = {
  id?: Maybe<Scalars['ID']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  contentFrench?: Maybe<Scalars['String']>;
  contentGerman?: Maybe<Scalars['String']>;
  contentSpanish?: Maybe<Scalars['String']>;
  contentMandarin?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['ID']>;
  contentEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleEnglish?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesSliderQuestionInput = {
  question?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesSliderQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesStakeholderMapInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  questionX?: Maybe<Scalars['String']>;
  questionY?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesStakeholderMapInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  questionX?: Maybe<Scalars['String']>;
  questionY?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesUploadDocumentInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesUploadDocumentInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesUploadQuestionInput = {
  file?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditComponentQuestionTypesUploadQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  file?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentQuestionTypesValuesBubbleInput = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesValuesBubbleInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesCharacterInput = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesValuesCharacterInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesGapInput = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesValuesGapInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentQuestionTypesValuesNestedInput = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ComponentQuestionTypesSimpleQuestionInput>>>;
};

export type EditComponentQuestionTypesValuesNestedInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<EditComponentQuestionTypesSimpleQuestionInput>>>;
};

export type ComponentQuestionTypesValuesSliderInput = {
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sliderQuestions?: Maybe<Array<Maybe<ComponentQuestionTypesSliderQuestionInput>>>;
};

export type EditComponentQuestionTypesValuesSliderInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sliderQuestions?: Maybe<Array<Maybe<EditComponentQuestionTypesSliderQuestionInput>>>;
};

export type ComponentQuestionTypesXyGraphInput = {
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  labelXEnglish?: Maybe<Scalars['String']>;
  labelYEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  labelXFrench?: Maybe<Scalars['String']>;
  labelYFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  labelXGerman?: Maybe<Scalars['String']>;
  labelYGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  labelXSpanish?: Maybe<Scalars['String']>;
  labelYSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  labelXMandarin?: Maybe<Scalars['String']>;
  labelYMandarin?: Maybe<Scalars['String']>;
};

export type EditComponentQuestionTypesXyGraphInput = {
  id?: Maybe<Scalars['ID']>;
  titleEnglish?: Maybe<Scalars['String']>;
  subTitleEnglish?: Maybe<Scalars['String']>;
  labelXEnglish?: Maybe<Scalars['String']>;
  labelYEnglish?: Maybe<Scalars['String']>;
  titleFrench?: Maybe<Scalars['String']>;
  subTitleFrench?: Maybe<Scalars['String']>;
  labelXFrench?: Maybe<Scalars['String']>;
  labelYFrench?: Maybe<Scalars['String']>;
  titleGerman?: Maybe<Scalars['String']>;
  subTitleGerman?: Maybe<Scalars['String']>;
  labelXGerman?: Maybe<Scalars['String']>;
  labelYGerman?: Maybe<Scalars['String']>;
  titleSpanish?: Maybe<Scalars['String']>;
  subTitleSpanish?: Maybe<Scalars['String']>;
  labelXSpanish?: Maybe<Scalars['String']>;
  labelYSpanish?: Maybe<Scalars['String']>;
  titleMandarin?: Maybe<Scalars['String']>;
  subTitleMandarin?: Maybe<Scalars['String']>;
  labelXMandarin?: Maybe<Scalars['String']>;
  labelYMandarin?: Maybe<Scalars['String']>;
};

export type ComponentSubmissionsSubModuleSubmissionInput = {
  section?: Maybe<Scalars['ID']>;
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswerInput>>>;
  progress?: Maybe<Scalars['Int']>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItemInput>>>;
  stakeholderChart?: Maybe<Scalars['ID']>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItemInput>>>;
  xYGraphChart?: Maybe<Scalars['ID']>;
  saboteurImage?: Maybe<Scalars['ID']>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristicInput>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<Scalars['ID']>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGapInput>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponentInput>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswerInput>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
};

export type EditComponentSubmissionsSubModuleSubmissionInput = {
  id?: Maybe<Scalars['ID']>;
  section?: Maybe<Scalars['ID']>;
  answers?: Maybe<Array<Maybe<EditComponentSubmissionsAnswerInput>>>;
  progress?: Maybe<Scalars['Int']>;
  gravitasScales?: Maybe<Array<Maybe<EditComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  stakeholderItems?: Maybe<Array<Maybe<EditComponentStakeholderMapItemStackholderMapItemInput>>>;
  stakeholderChart?: Maybe<Scalars['ID']>;
  xYGraphItems?: Maybe<Array<Maybe<EditComponentXyGraphItemXyGraphItemInput>>>;
  xYGraphChart?: Maybe<Scalars['ID']>;
  saboteurImage?: Maybe<Scalars['ID']>;
  characteristics?: Maybe<Array<Maybe<EditComponentSubmissionsCharacteristicInput>>>;
  sliderAnswers?: Maybe<Scalars['JSON']>;
  sliderImage?: Maybe<Scalars['ID']>;
  gapsAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsValuesGapInput>>>;
  saboteurSkipProofs?: Maybe<Array<Maybe<EditComponentSubmissionsSkipProofComponentInput>>>;
  competencyAnswers?: Maybe<Array<Maybe<EditComponentSubmissionsCompetencyAnswerInput>>>;
  emailSent?: Maybe<Scalars['Boolean']>;
};


export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type ModuleFragment = (
  { __typename?: 'Module' }
  & Pick<Module, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin'>
  & { cover?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'id' | 'url'>
  )> }
);

type Questions_ComponentQuestionTypesMultipleChoice_Fragment = (
  { __typename: 'ComponentQuestionTypesMultipleChoice' }
  & Pick<ComponentQuestionTypesMultipleChoice, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious' | 'numberOfAnswers'>
  & { option?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentOptionOption' }
    & Pick<ComponentOptionOption, 'id' | 'optionEnglish' | 'optionFrench' | 'optionGerman' | 'optionSpanish' | 'optionMandarin' | 'isCorrect'>
  )>>> }
);

type Questions_ComponentQuestionTypesSaboteur_Fragment = (
  { __typename: 'ComponentQuestionTypesSaboteur' }
  & Pick<ComponentQuestionTypesSaboteur, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
  & { saboteurQuestions?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
    & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
    & { proof?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )>>> }
  )>>> }
);

type Questions_ComponentQuestionTypesSimpleQuestion_Fragment = (
  { __typename: 'ComponentQuestionTypesSimpleQuestion' }
  & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin' | 'viewPrevious'>
);

type Questions_ComponentQuestionTypesXyGraph_Fragment = (
  { __typename: 'ComponentQuestionTypesXYGraph' }
  & Pick<ComponentQuestionTypesXyGraph, 'id' | 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
);

type Questions_ComponentQuestionTypesNestedQuestions_Fragment = (
  { __typename: 'ComponentQuestionTypesNestedQuestions' }
  & Pick<ComponentQuestionTypesNestedQuestions, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious'>
  & { questions?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
    & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
  )>>> }
);

type Questions_ComponentQuestionTypesGravitasScale_Fragment = (
  { __typename: 'ComponentQuestionTypesGravitasScale' }
  & Pick<ComponentQuestionTypesGravitasScale, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish'>
  & { ratingInput?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentRatingInputRatingInput' }
    & Pick<ComponentRatingInputRatingInput, 'id' | 'labelOneEnglish' | 'labelTwoEnglish'>
  )>>> }
);

type Questions_ComponentQuestionTypesStakeholderMap_Fragment = (
  { __typename: 'ComponentQuestionTypesStakeholderMap' }
  & Pick<ComponentQuestionTypesStakeholderMap, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleSpanish' | 'subTitleSpanish' | 'titleGerman' | 'subTitleGerman' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
);

type Questions_ComponentQuestionTypesSaboteurVideos_Fragment = (
  { __typename: 'ComponentQuestionTypesSaboteurVideos' }
  & Pick<ComponentQuestionTypesSaboteurVideos, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
  & { SaboteurVideo?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
    & Pick<ComponentSaboteurVideoSaboteurVideo, 'id' | 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin' | 'videoDescriptionEnglish' | 'videoDescriptionFrench' | 'videoDescriptionGerman' | 'videoDescriptionSpanish' | 'videoDescriptionMandarin'>
    & { video?: Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )> }
  )>>> }
);

type Questions_ComponentQuestionTypesValuesSliders_Fragment = { __typename: 'ComponentQuestionTypesValuesSliders' };

type Questions_ComponentQuestionTypesSimpleReadOnly_Fragment = { __typename: 'ComponentQuestionTypesSimpleReadOnly' };

type Questions_ComponentQuestionTypesValuesNested_Fragment = { __typename: 'ComponentQuestionTypesValuesNested' };

type Questions_ComponentQuestionTypesValuesGaps_Fragment = { __typename: 'ComponentQuestionTypesValuesGaps' };

type Questions_ComponentQuestionTypesUploadQuestion_Fragment = { __typename: 'ComponentQuestionTypesUploadQuestion' };

type Questions_ComponentQuestionTypesParticipant_Fragment = { __typename: 'ComponentQuestionTypesParticipant' };

type Questions_ComponentQuestionTypesValuesCharacters_Fragment = { __typename: 'ComponentQuestionTypesValuesCharacters' };

type Questions_ComponentQuestionTypesCompetency_Fragment = { __typename: 'ComponentQuestionTypesCompetency' };

type Questions_ComponentQuestionTypesValuesBubble_Fragment = { __typename: 'ComponentQuestionTypesValuesBubble' };

type Questions_ComponentQuestionTypesSliderQuestions_Fragment = { __typename: 'ComponentQuestionTypesSliderQuestions' };

type Questions_ComponentQuestionTypesFeedForward1_Fragment = (
  { __typename: 'ComponentQuestionTypesFeedForward1' }
  & Pick<ComponentQuestionTypesFeedForward1, 'id' | 'title' | 'question' | 'description'>
);

type Questions_ComponentQuestionTypesFeedForward2_Fragment = (
  { __typename: 'ComponentQuestionTypesFeedForward2' }
  & Pick<ComponentQuestionTypesFeedForward2, 'id' | 'title' | 'question' | 'description'>
);

type Questions_ComponentQuestionTypesCompetency2_Fragment = (
  { __typename: 'ComponentQuestionTypesCompetency2' }
  & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
  & { questionscompetency2?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
    & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel'>
  )>>> }
);

type Questions_ComponentQuestionTypesGravitasSliders_Fragment = { __typename: 'ComponentQuestionTypesGravitasSliders' };

type Questions_ComponentQuestionTypesUploadDocuments_Fragment = { __typename: 'ComponentQuestionTypesUploadDocuments' };

type Questions_ComponentQuestionTypesGravitasGap_Fragment = { __typename: 'ComponentQuestionTypesGravitasGap' };

export type QuestionsFragment = Questions_ComponentQuestionTypesMultipleChoice_Fragment | Questions_ComponentQuestionTypesSaboteur_Fragment | Questions_ComponentQuestionTypesSimpleQuestion_Fragment | Questions_ComponentQuestionTypesXyGraph_Fragment | Questions_ComponentQuestionTypesNestedQuestions_Fragment | Questions_ComponentQuestionTypesGravitasScale_Fragment | Questions_ComponentQuestionTypesStakeholderMap_Fragment | Questions_ComponentQuestionTypesSaboteurVideos_Fragment | Questions_ComponentQuestionTypesValuesSliders_Fragment | Questions_ComponentQuestionTypesSimpleReadOnly_Fragment | Questions_ComponentQuestionTypesValuesNested_Fragment | Questions_ComponentQuestionTypesValuesGaps_Fragment | Questions_ComponentQuestionTypesUploadQuestion_Fragment | Questions_ComponentQuestionTypesParticipant_Fragment | Questions_ComponentQuestionTypesValuesCharacters_Fragment | Questions_ComponentQuestionTypesCompetency_Fragment | Questions_ComponentQuestionTypesValuesBubble_Fragment | Questions_ComponentQuestionTypesSliderQuestions_Fragment | Questions_ComponentQuestionTypesFeedForward1_Fragment | Questions_ComponentQuestionTypesFeedForward2_Fragment | Questions_ComponentQuestionTypesCompetency2_Fragment | Questions_ComponentQuestionTypesGravitasSliders_Fragment | Questions_ComponentQuestionTypesUploadDocuments_Fragment | Questions_ComponentQuestionTypesGravitasGap_Fragment;

export type SectionFragment = (
  { __typename?: 'Section' }
  & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin'>
  & { cover?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'id' | 'url'>
  )> }
);

export type SubmissionFragment = (
  { __typename?: 'Submission' }
  & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'timeSpent'>
  & { language?: Maybe<(
    { __typename?: 'Language' }
    & Pick<Language, 'id' | 'name'>
  )> }
);

export type UploadFileFragment = (
  { __typename?: 'UploadFile' }
  & Pick<UploadFile, 'id' | 'created_at' | 'updated_at' | 'name' | 'alternativeText' | 'caption' | 'width' | 'height' | 'formats' | 'hash' | 'ext' | 'mime' | 'size' | 'url' | 'previewUrl' | 'provider'>
);

export type AddDocumentMutationVariables = {
  input: EditUserUploadedDocumentInput;
};


export type AddDocumentMutation = (
  { __typename?: 'Mutation' }
  & { addDocument: (
    { __typename?: 'UserUploadedDocument' }
    & Pick<UserUploadedDocument, 'name'>
  ) }
);

export type AddNoteMutationVariables = {
  input: EditNoteInput;
};


export type AddNoteMutation = (
  { __typename?: 'Mutation' }
  & { addNote: (
    { __typename?: 'Notes' }
    & Pick<Notes, 'note'>
  ) }
);

export type CreateAccountChangeMutationVariables = {
  input?: Maybe<CreateAccountChangeInput>;
};


export type CreateAccountChangeMutation = (
  { __typename?: 'Mutation' }
  & { createAccountChange?: Maybe<(
    { __typename?: 'createAccountChangePayload' }
    & { accountChange?: Maybe<(
      { __typename?: 'AccountChange' }
      & Pick<AccountChange, 'id'>
    )> }
  )> }
);

export type CreateBookingMutationVariables = {
  input?: Maybe<CreateBookingInput>;
};


export type CreateBookingMutation = (
  { __typename?: 'Mutation' }
  & { createBooking?: Maybe<(
    { __typename?: 'createBookingPayload' }
    & { booking?: Maybe<(
      { __typename?: 'Booking' }
      & Pick<Booking, 'id' | 'title'>
    )> }
  )> }
);

export type CreateProgrammeSubmissionMutationVariables = {
  input?: Maybe<CreateProgrammeSubmissionInput>;
};


export type CreateProgrammeSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { createProgrammeSubmission?: Maybe<(
    { __typename?: 'createProgrammeSubmissionPayload' }
    & { programmeSubmission?: Maybe<(
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'id'>
    )> }
  )> }
);

export type CreateSessionMutationVariables = {
  input?: Maybe<CreateCoachSessionInput>;
};


export type CreateSessionMutation = (
  { __typename?: 'Mutation' }
  & { createCoachSession?: Maybe<(
    { __typename?: 'createCoachSessionPayload' }
    & { coachSession?: Maybe<(
      { __typename?: 'CoachSession' }
      & Pick<CoachSession, 'title'>
    )> }
  )> }
);

export type DeletedNoteMutationVariables = {
  id: Scalars['ID'];
};


export type DeletedNoteMutation = (
  { __typename?: 'Mutation' }
  & { deletedNote?: Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'note'>
  )> }
);

export type GenerateCompetencyResponsesMutationVariables = {
  id: Scalars['ID'];
};


export type GenerateCompetencyResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateCompetencyResponses?: Maybe<(
    { __typename?: 'ProgrammeSubmissionResponse' }
    & Pick<ProgrammeSubmissionResponse, 'success'>
  )> }
);

export type GenerateMyMiniSectionSubmissionResponseMutationVariables = {
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['Int']>;
  secId?: Maybe<Scalars['Int']>;
};


export type GenerateMyMiniSectionSubmissionResponseMutation = (
  { __typename?: 'Mutation' }
  & { generateMyMiniSectionSubmissionResponse?: Maybe<(
    { __typename?: 'SubModuleSubmissionResponse' }
    & Pick<SubModuleSubmissionResponse, 'success'>
  )> }
);

export type GenerateMyProgrammeSubmissionResponsesMutationVariables = {
  id: Scalars['ID'];
};


export type GenerateMyProgrammeSubmissionResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateMyProgrammeSubmissionResponses?: Maybe<(
    { __typename?: 'ProgrammeSubmissionResponse' }
    & Pick<ProgrammeSubmissionResponse, 'success'>
  )> }
);

export type GenerateMySubModuleSubmissionComptencyResponsesMutationVariables = {
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['Int']>;
};


export type GenerateMySubModuleSubmissionComptencyResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateMySubModuleSubmissionComptencyResponses?: Maybe<(
    { __typename?: 'SubModuleSubmissionResponse' }
    & Pick<SubModuleSubmissionResponse, 'success'>
  )> }
);

export type GenerateMySubModuleSubmissionResponsesMutationVariables = {
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['Int']>;
};


export type GenerateMySubModuleSubmissionResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateMySubModuleSubmissionResponses?: Maybe<(
    { __typename?: 'SubModuleSubmissionResponse' }
    & Pick<SubModuleSubmissionResponse, 'success'>
  )> }
);

export type ResendMailMutationVariables = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};


export type ResendMailMutation = (
  { __typename?: 'Mutation' }
  & { resendMail?: Maybe<(
    { __typename?: 'EmailSent' }
    & Pick<EmailSent, 'success'>
  )> }
);

export type ResendProgrammeMailMutationVariables = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};


export type ResendProgrammeMailMutation = (
  { __typename?: 'Mutation' }
  & { resendProgrammeMail?: Maybe<(
    { __typename?: 'EmailSentProgramme' }
    & Pick<EmailSentProgramme, 'successed'>
  )> }
);

export type UpdateMySubModuleSubmissionMutationVariables = {
  id: Scalars['ID'];
  currentSection?: Maybe<Scalars['Int']>;
  isPdf?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  programmeSubmissionId?: Maybe<Scalars['ID']>;
  input: EditSubModuleSubmissionInput;
};


export type UpdateMySubModuleSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateMySubModuleSubmission: (
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'id' | 'view' | 'progress' | 'status' | 'timeSpent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, participants?: Maybe<Array<Maybe<(
      { __typename?: 'Participants' }
      & Pick<Participants, 'id' | 'name' | 'email' | 'type'>
    )>>>, submissionparticipants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id'>
      )> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>> }
    )>>> }
  ) }
);

export type UpdateNotificationMutationVariables = {
  id: Scalars['ID'];
  input?: Maybe<EditNotificationInput>;
};


export type UpdateNotificationMutation = (
  { __typename?: 'Mutation' }
  & { updateNotification?: Maybe<(
    { __typename?: 'updateNotificationPayload' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & Pick<Notification, 'id' | 'title' | 'timeStamp' | 'path' | 'read'>
    )> }
  )> }
);

export type UpdateMyProgrammeSubmissionMutationVariables = {
  id: Scalars['ID'];
  input: EditProgrammeSubmissionInput;
  isPdf?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};


export type UpdateMyProgrammeSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateMyProgrammeSubmissions: (
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'status' | 'progress' | 'selected'>
    & { programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'isCoaching' | 'notes' | 'deadline' | 'archive'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, programmeQuestions?: Maybe<Array<Maybe<(
        { __typename: 'ComponentQuestionTypesValuesNested' }
        & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesValuesBubble' } | { __typename: 'ComponentQuestionTypesValuesCharacters' } | { __typename: 'ComponentQuestionTypesValuesSliders' } | { __typename: 'ComponentQuestionTypesValuesGaps' } | { __typename: 'ComponentQuestionTypesSaboteurVideos' } | { __typename: 'ComponentQuestionTypesMultipleChoice' } | { __typename: 'ComponentQuestionTypesSaboteur' } | { __typename: 'ComponentQuestionTypesSimpleQuestion' } | { __typename: 'ComponentQuestionTypesXYGraph' } | { __typename: 'ComponentQuestionTypesNestedQuestions' } | { __typename: 'ComponentQuestionTypesUploadQuestion' } | { __typename: 'ComponentQuestionTypesGravitasScale' } | { __typename: 'ComponentQuestionTypesParticipant' } | { __typename: 'ComponentQuestionTypesStakeholderMap' } | { __typename: 'ComponentQuestionTypesFeedForward1' } | { __typename: 'ComponentQuestionTypesFeedForward2' } | { __typename: 'ComponentQuestionTypesSimpleReadOnly' } | { __typename: 'ComponentQuestionTypesCompetency2' } | { __typename: 'ComponentQuestionTypesCompetency' } | { __typename: 'ComponentQuestionTypesGravitasGap' } | { __typename: 'ComponentQuestionTypesSliderQuestions' } | { __typename: 'ComponentQuestionTypesGravitasSliders' }>>>, articles?: Maybe<Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>>, sub_modules?: Maybe<Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id' | 'nameEnglish' | 'descriptionEnglish'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'id'>
        )> }
      )>>> }
    )>, programmeResponses?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsProgrammeSubmissions' }
      & { answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteur?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsSaboteurComponent' }
        & Pick<ComponentSubmissionsSaboteurComponent, 'id'>
      )>>>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>> }
    )>>>, myNotes?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsNotes' }
      & Pick<ComponentSubmissionsNotes, 'id' | 'title' | 'description'>
      & { document?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  ) }
);

export type UpdateSessionMutationVariables = {
  id: Scalars['ID'];
  input?: Maybe<EditCoachSessionInput>;
};


export type UpdateSessionMutation = (
  { __typename?: 'Mutation' }
  & { updateCoachSession?: Maybe<(
    { __typename?: 'updateCoachSessionPayload' }
    & { coachSession?: Maybe<(
      { __typename?: 'CoachSession' }
      & Pick<CoachSession, 'id' | 'title' | 'status'>
      & { user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'id'>
      )> }
    )> }
  )> }
);

export type UpdateMySubmissionMutationVariables = {
  id: Scalars['ID'];
  currentSection?: Maybe<Scalars['Int']>;
  programmeSubmissionId?: Maybe<Scalars['ID']>;
  input: EditSubmissionInput;
};


export type UpdateMySubmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateMySubmission: (
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'timeSpent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>> }
    )>>> }
  ) }
);

export type UpdateSelfMutationVariables = {
  input: EditUserInput;
};


export type UpdateSelfMutation = (
  { __typename?: 'Mutation' }
  & { updateSelf: (
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'created_at' | 'updated_at' | 'email' | 'confirmed' | 'blocked' | 'phoneNumber' | 'onboarding' | 'firstName' | 'lastName' | 'jobTitle' | 'modulesRead' | 'homePromptsRead' | 'programmePromptsRead' | 'modulePromptsRead' | 'bookmarks' | 'articlesViewed' | 'updatedDetails'>
    & { profilePicture?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, division?: Maybe<(
      { __typename?: 'Division' }
      & Pick<Division, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleMandarin' | 'titleSpanish'>
    )>, report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name' | 'programmesTitle' | 'programmesSubTitle' | 'usersConfirmDetails'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, languageSelection?: Maybe<(
        { __typename?: 'ComponentTranslationsLanguageSelection' }
        & Pick<ComponentTranslationsLanguageSelection, 'id' | 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
      )>, welcomeScreen?: Maybe<(
        { __typename?: 'ComponentTranslationsWelcomeScreen' }
        & Pick<ComponentTranslationsWelcomeScreen, 'id' | 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
        & { videoEnglish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoFrench?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoGerman?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoMandarin?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoSpanish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>, letsGetStartedScreen?: Maybe<(
        { __typename?: 'ComponentTranslationsLetsGetStartedScreen' }
        & Pick<ComponentTranslationsLetsGetStartedScreen, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'firstNameLabelEnglish' | 'firstNameErrorEnglish' | 'lastNameLabelEnglish' | 'lastNameErrorEnglish' | 'jobTitleLabelEnglish' | 'jobTitleErrorEnglish' | 'divisionLabelEnglish' | 'divisionErrorEnglish' | 'timezoneLabelEnglish' | 'regionLabelEnglish' | 'regionErrorEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'subTitleFrench' | 'firstNameLabelFrench' | 'firstNameErrorFrench' | 'lastNameLabelFrench' | 'lastNameErrorFrench' | 'jobTitleLabelFrench' | 'jobTitleErrorFrench' | 'divisionLabelFrench' | 'divisionErrorFrench' | 'timezoneLabelFrench' | 'regionLabelFrench' | 'regionErrorFrench' | 'nextButtonFrench' | 'titleGerman' | 'subTitleGerman' | 'firstNameLabelGerman' | 'firstNameErrorGerman' | 'lastNameLabelGerman' | 'lastNameErrorGerman' | 'jobTitleLabelGerman' | 'jobTitleErrorGerman' | 'divisionLabelGerman' | 'divisionErrorGerman' | 'timezoneLabelGerman' | 'regionLabelGerman' | 'regionErrorGerman' | 'nextButtonGerman' | 'titleMandarin' | 'subTitleMandarin' | 'firstNameLabelMandarin' | 'firstNameErrorMandarin' | 'lastNameLabelMandarin' | 'lastNameErrorMandarin' | 'jobTitleLabelMandarin' | 'jobTitleErrorMandarin' | 'divisionLabelMandarin' | 'divisionErrorMandarin' | 'timezoneLabelMandarin' | 'regionLabelMandarin' | 'regionErrorMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'subTitleSpanish' | 'firstNameLabelSpanish' | 'firstNameErrorSpanish' | 'lastNameLabelSpanish' | 'lastNameErrorSpanish' | 'jobTitleLabelSpanish' | 'jobTitleErrorSpanish' | 'divisionLabelSpanish' | 'divisionErrorSpanish' | 'timezoneLabelSpanish' | 'regionLabelSpanish' | 'regionErrorSpanish' | 'nextButtonSpanish' | 'leftTitleEnglish' | 'leftSubtitleEnglish' | 'leftTitleSpanish' | 'leftSubtitleSpanish' | 'leftTitleMandarin' | 'leftSubTitleMandarin' | 'leftTitleFrench' | 'leftSubtitleFrench' | 'leftSubtitleGerman' | 'leftTitleGerman'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>, whatToExpect?: Maybe<(
        { __typename?: 'ComponentTranslationsWhatToExpect' }
        & Pick<ComponentTranslationsWhatToExpect, 'id' | 'titleEnglish' | 'bodyEnglish' | 'getStartedButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'getStartedButtonFrench' | 'titleGerman' | 'bodyGerman' | 'getStartedButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'getStartedButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'getStartedButtonSpanish'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>, aboutUs?: Maybe<(
        { __typename?: 'ComponentTranslationsAboutUs' }
        & Pick<ComponentTranslationsAboutUs, 'id' | 'textEnglish' | 'textFrench' | 'textGerman' | 'userGuidelinesTextEnglish' | 'userGuidelinesTextGerman' | 'userGuidelinesTextFrench'>
        & { userGuidelinesEnglish?: Maybe<Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>>>, userGuidelinesGerman?: Maybe<Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>>>, userGuidelinesFrench?: Maybe<Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>>> }
      )> }
    )>, submissions?: Maybe<Array<Maybe<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'id'>
    )>>>, programmes?: Maybe<Array<Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'name' | 'description' | 'start' | 'isCustomJourney' | 'position'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>>, region?: Maybe<(
      { __typename?: 'Region' }
      & Pick<Region, 'id' | 'nameEnglish' | 'nameFrench' | 'nameGerman' | 'nameSpanish' | 'nameMandarin'>
    )>, timezone?: Maybe<(
      { __typename?: 'ComponentOptionTimezone' }
      & Pick<ComponentOptionTimezone, 'abbrev' | 'altName' | 'label' | 'value'>
    )> }
  ) }
);

export type CheckResponsesFromTypeFormQueryVariables = {
  id: Scalars['ID'];
  sectionid?: Maybe<Scalars['Int']>;
};


export type CheckResponsesFromTypeFormQuery = (
  { __typename?: 'Query' }
  & { checkResponsesFromTypeForm?: Maybe<(
    { __typename?: 'Emails' }
    & Pick<Emails, 'emails'>
  )> }
);

export type CheckResponsesFromTypeFormProgrammeQueryVariables = {
  id: Scalars['ID'];
  sectionid?: Maybe<Scalars['Int']>;
};


export type CheckResponsesFromTypeFormProgrammeQuery = (
  { __typename?: 'Query' }
  & { checkResponsesFromTypeFormProgramme?: Maybe<(
    { __typename?: 'EmailsSent' }
    & Pick<EmailsSent, 'emails'>
  )> }
);

export type ConfirmMyAppointmentsMutationVariables = {
  appointmentScheduleId: Scalars['ID'];
  programmeSubmissionId: Scalars['ID'];
  subModule: Scalars['Boolean'];
};


export type ConfirmMyAppointmentsMutation = (
  { __typename?: 'Mutation' }
  & { confirmMyAppointments: (
    { __typename?: 'ConfirmAppointmentResponse' }
    & Pick<ConfirmAppointmentResponse, 'success' | 'message'>
  ) }
);

export type GetAllsectionReportQueryVariables = {
  id: Scalars['ID'];
};


export type GetAllsectionReportQuery = (
  { __typename?: 'Query' }
  & { getAllsectionReport?: Maybe<Array<Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
    & { report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>> }
);

export type GetArticlesQueryVariables = {
  where?: Maybe<Scalars['JSON']>;
  start?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
};


export type GetArticlesQuery = (
  { __typename?: 'Query' }
  & { articles?: Maybe<Array<Maybe<(
    { __typename?: 'Article' }
    & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'position' | 'datePublished' | 'readTime' | 'link'>
    & { companies?: Maybe<Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id'>
    )>>>, programmes?: Maybe<Array<Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id'>
    )>>>, image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )> }
  )>>> }
);

export type GetCoachSubmittedReportsQueryVariables = {
  where: Scalars['JSON'];
  sort: Scalars['String'];
  limit: Scalars['Int'];
};


export type GetCoachSubmittedReportsQuery = (
  { __typename?: 'Query' }
  & { coachSubmittedReports?: Maybe<Array<Maybe<(
    { __typename?: 'CoachSubmittedReports' }
    & Pick<CoachSubmittedReports, 'id' | 'name'>
    & { notesId?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSaboteurComponent' }
      & Pick<ComponentSubmissionsSaboteurComponent, 'name'>
      & { saboteurProofValue?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )>>> }
);

export type GetCompanyQueryVariables = {
  id: Scalars['ID'];
};


export type GetCompanyQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & { programmes?: Maybe<Array<Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'name' | 'description' | 'start' | 'isCustomJourney' | 'showTimeline' | 'position'>
      & { programme_types?: Maybe<Array<Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id'>
        & { programme_submissions?: Maybe<Array<Maybe<(
          { __typename?: 'ProgrammeSubmission' }
          & Pick<ProgrammeSubmission, 'id'>
          & { user?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & Pick<UsersPermissionsUser, 'id'>
          )>, programme?: Maybe<(
            { __typename?: 'Programmes' }
            & Pick<Programmes, 'id' | 'isCustomJourney' | 'showTimeline'>
            & { logo?: Maybe<(
              { __typename?: 'UploadFile' }
              & Pick<UploadFile, 'id' | 'url'>
            )> }
          )> }
        )>>> }
      )>>> }
    )>>> }
  )> }
);

export type GetCompanyDivisionsQueryVariables = {
  where?: Maybe<Scalars['JSON']>;
};


export type GetCompanyDivisionsQuery = (
  { __typename?: 'Query' }
  & { divisions?: Maybe<Array<Maybe<(
    { __typename?: 'Division' }
    & Pick<Division, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'created_at' | 'updated_at'>
  )>>> }
);

export type GetCompanyRegionsQueryVariables = {
  where?: Maybe<Scalars['JSON']>;
};


export type GetCompanyRegionsQuery = (
  { __typename?: 'Query' }
  & { regions?: Maybe<Array<Maybe<(
    { __typename?: 'Region' }
    & Pick<Region, 'id' | 'nameEnglish' | 'nameFrench' | 'nameGerman' | 'nameSpanish' | 'nameMandarin' | 'created_at' | 'updated_at'>
  )>>> }
);

export type GetDivisionsQueryVariables = {};


export type GetDivisionsQuery = (
  { __typename?: 'Query' }
  & { divisions?: Maybe<Array<Maybe<(
    { __typename?: 'Division' }
    & Pick<Division, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'created_at' | 'updated_at'>
  )>>> }
);

export type GetFirstFourNotesQueryVariables = {};


export type GetFirstFourNotesQuery = (
  { __typename?: 'Query' }
  & { getFirstFourNotes?: Maybe<Array<Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'id' | 'name' | 'note' | 'sectionOrSubmissionId' | 'created_at'>
    & { document?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>>>, programme?: Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'name'>
    )>, notesId?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSaboteurComponent' }
      & { saboteurProofValue?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url' | 'name'>
      )> }
    )>>>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & { sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'nameEnglish'>
      )> }
    )> }
  )>>> }
);

export type GetFirstTwelveArticlesQueryVariables = {};


export type GetFirstTwelveArticlesQuery = (
  { __typename?: 'Query' }
  & { getFirstTwelveArticles?: Maybe<Array<Maybe<(
    { __typename?: 'Article' }
    & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'position' | 'datePublished' | 'readTime' | 'link'>
    & { companies?: Maybe<Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id'>
    )>>>, image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )> }
  )>>> }
);

export type GetInviteQueryVariables = {
  where?: Maybe<Scalars['JSON']>;
};


export type GetInviteQuery = (
  { __typename?: 'Query' }
  & { invites?: Maybe<Array<Maybe<(
    { __typename?: 'Invite' }
    & Pick<Invite, 'email'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )> }
  )>>> }
);

export type GetLanguagesQueryVariables = {
  where?: Maybe<Scalars['JSON']>;
};


export type GetLanguagesQuery = (
  { __typename?: 'Query' }
  & { languages?: Maybe<Array<Maybe<(
    { __typename?: 'Language' }
    & Pick<Language, 'id' | 'name'>
    & { image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, companies?: Maybe<Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>> }
  )>>> }
);

export type GetModuleQueryVariables = {
  id: Scalars['ID'];
};


export type GetModuleQuery = (
  { __typename?: 'Query' }
  & { module?: Maybe<(
    { __typename?: 'Module' }
    & Pick<Module, 'id' | 'nameEnglish' | 'nameFrench' | 'nameSpanish' | 'nameGerman' | 'nameMandarin' | 'descriptionEnglish' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionMandarin' | 'descriptionSpanish'>
    & { cover?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, sections?: Maybe<Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'position' | 'archive'>
      & { videoEnglish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoGerman?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoSpanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoMandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoFrench?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesMultipleChoice' }
        & Questions_ComponentQuestionTypesMultipleChoice_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteur' }
        & Questions_ComponentQuestionTypesSaboteur_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Questions_ComponentQuestionTypesSimpleQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesXYGraph' }
        & Questions_ComponentQuestionTypesXyGraph_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesNestedQuestions' }
        & Questions_ComponentQuestionTypesNestedQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasScale' }
        & Questions_ComponentQuestionTypesGravitasScale_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesStakeholderMap' }
        & Questions_ComponentQuestionTypesStakeholderMap_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteurVideos' }
        & Questions_ComponentQuestionTypesSaboteurVideos_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesSliders' }
        & Questions_ComponentQuestionTypesValuesSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleReadOnly' }
        & Questions_ComponentQuestionTypesSimpleReadOnly_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesNested' }
        & Questions_ComponentQuestionTypesValuesNested_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesGaps' }
        & Questions_ComponentQuestionTypesValuesGaps_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadQuestion' }
        & Questions_ComponentQuestionTypesUploadQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesParticipant' }
        & Questions_ComponentQuestionTypesParticipant_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesCharacters' }
        & Questions_ComponentQuestionTypesValuesCharacters_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency' }
        & Questions_ComponentQuestionTypesCompetency_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesBubble' }
        & Questions_ComponentQuestionTypesValuesBubble_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Questions_ComponentQuestionTypesSliderQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward1' }
        & Questions_ComponentQuestionTypesFeedForward1_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward2' }
        & Questions_ComponentQuestionTypesFeedForward2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency2' }
        & Questions_ComponentQuestionTypesCompetency2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasSliders' }
        & Questions_ComponentQuestionTypesGravitasSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadDocuments' }
        & Questions_ComponentQuestionTypesUploadDocuments_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasGap' }
        & Questions_ComponentQuestionTypesGravitasGap_Fragment
      )>>> }
    )>>> }
  )> }
);

export type GetModulesQueryVariables = {};


export type GetModulesQuery = (
  { __typename?: 'Query' }
  & { modules?: Maybe<Array<Maybe<(
    { __typename?: 'Module' }
    & Pick<Module, 'id' | 'nameEnglish' | 'nameFrench' | 'nameSpanish' | 'nameGerman' | 'nameMandarin' | 'descriptionEnglish' | 'descriptionFrench' | 'descriptionSpanish' | 'descriptionGerman' | 'descriptionMandarin'>
    & { cover?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, sections?: Maybe<Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'archive'>
      & { videoEnglish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoFrench?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoSpanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoGerman?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoMandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesMultipleChoice' }
        & Questions_ComponentQuestionTypesMultipleChoice_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteur' }
        & Questions_ComponentQuestionTypesSaboteur_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Questions_ComponentQuestionTypesSimpleQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesXYGraph' }
        & Questions_ComponentQuestionTypesXyGraph_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesNestedQuestions' }
        & Questions_ComponentQuestionTypesNestedQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasScale' }
        & Questions_ComponentQuestionTypesGravitasScale_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesStakeholderMap' }
        & Questions_ComponentQuestionTypesStakeholderMap_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteurVideos' }
        & Questions_ComponentQuestionTypesSaboteurVideos_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesSliders' }
        & Questions_ComponentQuestionTypesValuesSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleReadOnly' }
        & Questions_ComponentQuestionTypesSimpleReadOnly_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesNested' }
        & Questions_ComponentQuestionTypesValuesNested_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesGaps' }
        & Questions_ComponentQuestionTypesValuesGaps_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadQuestion' }
        & Questions_ComponentQuestionTypesUploadQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesParticipant' }
        & Questions_ComponentQuestionTypesParticipant_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesCharacters' }
        & Questions_ComponentQuestionTypesValuesCharacters_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency' }
        & Questions_ComponentQuestionTypesCompetency_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesBubble' }
        & Questions_ComponentQuestionTypesValuesBubble_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Questions_ComponentQuestionTypesSliderQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward1' }
        & Questions_ComponentQuestionTypesFeedForward1_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward2' }
        & Questions_ComponentQuestionTypesFeedForward2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency2' }
        & Questions_ComponentQuestionTypesCompetency2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasSliders' }
        & Questions_ComponentQuestionTypesGravitasSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadDocuments' }
        & Questions_ComponentQuestionTypesUploadDocuments_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasGap' }
        & Questions_ComponentQuestionTypesGravitasGap_Fragment
      )>>> }
    )>>> }
  )>>> }
);

export type GetMyBookingsQueryVariables = {
  where: Scalars['JSON'];
  sort: Scalars['String'];
  limit: Scalars['Int'];
};


export type GetMyBookingsQuery = (
  { __typename?: 'Query' }
  & { bookings?: Maybe<Array<Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'description' | 'duration' | 'date' | 'confirmed' | 'eventId' | 'cancelled' | 'organiser' | 'location' | 'isUpdated' | 'end'>
  )>>> }
);

export type GetMyCoachSessionsQueryVariables = {
  where: Scalars['JSON'];
};


export type GetMyCoachSessionsQuery = (
  { __typename?: 'Query' }
  & { coachSessions?: Maybe<Array<Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'id' | 'title' | 'status'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id'>
    )>, programme_submission?: Maybe<(
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'id'>
    )>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'id'>
    )>, appointment?: Maybe<(
      { __typename?: 'Appointments' }
      & Pick<Appointments, 'appointmentUrl' | 'appointmentStartDate' | 'appointmentEndDate' | 'status'>
    )> }
  )>>> }
);

export type GetMyNotificationsQueryVariables = {
  where: Scalars['JSON'];
};


export type GetMyNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications?: Maybe<Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'created_at' | 'updated_at' | 'title' | 'timeStamp' | 'path' | 'read'>
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id'>
    )>>> }
  )>>> }
);

export type GetMySubModuleReportQueryVariables = {
  where: Scalars['JSON'];
  sort: Scalars['String'];
  limit: Scalars['Int'];
};


export type GetMySubModuleReportQuery = (
  { __typename?: 'Query' }
  & { reports?: Maybe<Array<Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
    & { report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & { section?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsSectionSubmission' }
        & Pick<ComponentSubmissionsSectionSubmission, 'progress'>
        & { section?: Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'titleEnglish'>
        )> }
      )>>>, sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id'>
        & { programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'id' | 'title'>
          & { programmes?: Maybe<Array<Maybe<(
            { __typename?: 'Programmes' }
            & Pick<Programmes, 'name'>
          )>>> }
        )> }
      )> }
    )> }
  )>>> }
);

export type GetMySubModuleSubmissionsReportsQueryVariables = {};


export type GetMySubModuleSubmissionsReportsQuery = (
  { __typename?: 'Query' }
  & { getMySubModuleSubmissionsReports?: Maybe<Array<Maybe<(
    { __typename?: 'SubModuleSubmissionReport' }
    & Pick<SubModuleSubmissionReport, 'id'>
    & { sub_module: (
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'position'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'position' | 'isCoaching' | 'isSubModule' | 'notes' | 'showArticle' | 'showSession' | 'showParticipants' | 'competencySurvey' | 'feedForwardSurvey' | 'deadline'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, articles?: Maybe<Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'url'>
          )> }
        )>>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'id' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'id' | 'url' | 'name'>
          )> }
        )>, events?: Maybe<Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'id' | 'name' | 'link'>
        )>>> }
      )> }
    ), reports: Array<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )> }
  )>>> }
);

export type GetMySubModuleNotesQueryVariables = {
  where: Scalars['JSON'];
  sort: Scalars['String'];
  limit: Scalars['Int'];
};


export type GetMySubModuleNotesQuery = (
  { __typename?: 'Query' }
  & { notes?: Maybe<Array<Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'id' | 'name' | 'note' | 'sectionOrSubmissionId' | 'created_at'>
    & { document?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>>>, programme?: Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'name'>
    )>, notesId?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSaboteurComponent' }
      & { saboteurProofValue?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url' | 'name'>
      )> }
    )>>>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & { sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'nameEnglish'>
      )> }
    )> }
  )>>> }
);

export type GetMyUploadedReportQueryVariables = {
  where: Scalars['JSON'];
  sort: Scalars['String'];
  limit: Scalars['Int'];
};


export type GetMyUploadedReportQuery = (
  { __typename?: 'Query' }
  & { uploadedReports?: Maybe<Array<Maybe<(
    { __typename?: 'UploadedReports' }
    & Pick<UploadedReports, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
    & { report?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url' | 'created_at'>
    )>>> }
  )>>> }
);

export type GetMyWorkQueryVariables = {};


export type GetMyWorkQuery = (
  { __typename?: 'Query' }
  & { getMySubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'timeSpent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
        & { videoEnglish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoFrench?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoGerman?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoSpanish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoMandarin?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesMultipleChoice' }
          & Questions_ComponentQuestionTypesMultipleChoice_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSaboteur' }
          & Questions_ComponentQuestionTypesSaboteur_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Questions_ComponentQuestionTypesSimpleQuestion_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesXYGraph' }
          & Questions_ComponentQuestionTypesXyGraph_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesNestedQuestions' }
          & Questions_ComponentQuestionTypesNestedQuestions_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesGravitasScale' }
          & Questions_ComponentQuestionTypesGravitasScale_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesStakeholderMap' }
          & Questions_ComponentQuestionTypesStakeholderMap_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSaboteurVideos' }
          & Questions_ComponentQuestionTypesSaboteurVideos_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesSliders' }
          & Questions_ComponentQuestionTypesValuesSliders_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSimpleReadOnly' }
          & Questions_ComponentQuestionTypesSimpleReadOnly_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesNested' }
          & Questions_ComponentQuestionTypesValuesNested_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesGaps' }
          & Questions_ComponentQuestionTypesValuesGaps_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesUploadQuestion' }
          & Questions_ComponentQuestionTypesUploadQuestion_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesParticipant' }
          & Questions_ComponentQuestionTypesParticipant_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesCharacters' }
          & Questions_ComponentQuestionTypesValuesCharacters_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesCompetency' }
          & Questions_ComponentQuestionTypesCompetency_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesBubble' }
          & Questions_ComponentQuestionTypesValuesBubble_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSliderQuestions' }
          & Questions_ComponentQuestionTypesSliderQuestions_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesFeedForward1' }
          & Questions_ComponentQuestionTypesFeedForward1_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesFeedForward2' }
          & Questions_ComponentQuestionTypesFeedForward2_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesCompetency2' }
          & Questions_ComponentQuestionTypesCompetency2_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesGravitasSliders' }
          & Questions_ComponentQuestionTypesGravitasSliders_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesUploadDocuments' }
          & Questions_ComponentQuestionTypesUploadDocuments_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesGravitasGap' }
          & Questions_ComponentQuestionTypesGravitasGap_Fragment
        )>>> }
      )>>> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id'>
      & { answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
        & { videoEnglish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoFrench?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoGerman?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoSpanish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoMandarin?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesMultipleChoice' }
          & Questions_ComponentQuestionTypesMultipleChoice_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSaboteur' }
          & Questions_ComponentQuestionTypesSaboteur_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Questions_ComponentQuestionTypesSimpleQuestion_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesXYGraph' }
          & Questions_ComponentQuestionTypesXyGraph_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesNestedQuestions' }
          & Questions_ComponentQuestionTypesNestedQuestions_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesGravitasScale' }
          & Questions_ComponentQuestionTypesGravitasScale_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesStakeholderMap' }
          & Questions_ComponentQuestionTypesStakeholderMap_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSaboteurVideos' }
          & Questions_ComponentQuestionTypesSaboteurVideos_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesSliders' }
          & Questions_ComponentQuestionTypesValuesSliders_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSimpleReadOnly' }
          & Questions_ComponentQuestionTypesSimpleReadOnly_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesNested' }
          & Questions_ComponentQuestionTypesValuesNested_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesGaps' }
          & Questions_ComponentQuestionTypesValuesGaps_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesUploadQuestion' }
          & Questions_ComponentQuestionTypesUploadQuestion_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesParticipant' }
          & Questions_ComponentQuestionTypesParticipant_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesCharacters' }
          & Questions_ComponentQuestionTypesValuesCharacters_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesCompetency' }
          & Questions_ComponentQuestionTypesCompetency_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesValuesBubble' }
          & Questions_ComponentQuestionTypesValuesBubble_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesSliderQuestions' }
          & Questions_ComponentQuestionTypesSliderQuestions_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesFeedForward1' }
          & Questions_ComponentQuestionTypesFeedForward1_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesFeedForward2' }
          & Questions_ComponentQuestionTypesFeedForward2_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesCompetency2' }
          & Questions_ComponentQuestionTypesCompetency2_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesGravitasSliders' }
          & Questions_ComponentQuestionTypesGravitasSliders_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesUploadDocuments' }
          & Questions_ComponentQuestionTypesUploadDocuments_Fragment
        ) | (
          { __typename?: 'ComponentQuestionTypesGravitasGap' }
          & Questions_ComponentQuestionTypesGravitasGap_Fragment
        )>>> }
      )> }
    )>>> }
  )>>> }
);

export type GetSubModuleSubmissionQueryVariables = {
  id: Scalars['ID'];
};


export type GetSubModuleSubmissionQuery = (
  { __typename?: 'Query' }
  & { subModuleSubmission?: Maybe<(
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'id' | 'view' | 'progress' | 'status' | 'timeSpent'>
    & { feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'id'>
    )>, competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'id'>
    )>, competency_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsCompetencyParticipants' }
      & Pick<ComponentSubmissionsCompetencyParticipants, 'name' | 'email'>
    )>>>, participants?: Maybe<Array<Maybe<(
      { __typename?: 'Participants' }
      & Pick<Participants, 'id' | 'name' | 'email' | 'type'>
    )>>>, submissionparticipants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress' | 'sliderAnswers'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'steps' | 'response'>
      )>>>, uploadDocuments?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsUploadDocuments' }
        & { saboteurProofValue?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id'>
        )> }
      )>>> }
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'position' | 'archive'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'position' | 'isCoaching' | 'isSubModule' | 'notes' | 'showArticle' | 'showSession' | 'showParticipants' | 'competencySurvey' | 'feedForwardSurvey' | 'deadline'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, articles?: Maybe<Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'url'>
          )> }
        )>>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'id' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'id' | 'url' | 'name'>
          )> }
        )>, events?: Maybe<Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'id' | 'name' | 'link'>
        )>>> }
      )> }
    )>, reports?: Maybe<Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )> }
);

export type GetNewTypeformFeedResponsesQueryVariables = {};


export type GetNewTypeformFeedResponsesQuery = (
  { __typename?: 'Query' }
  & { getNewTypeformFeedResponses?: Maybe<(
    { __typename?: 'CheckConfirmed' }
    & Pick<CheckConfirmed, 'success'>
  )> }
);

export type GetNotificationsQueryVariables = {};


export type GetNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications?: Maybe<Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'created_at' | 'updated_at' | 'title' | 'timeStamp' | 'path' | 'read'>
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id'>
    )>>> }
  )>>> }
);

export type GetOrderedSubmissionsQueryVariables = {
  programme: Scalars['ID'];
};


export type GetOrderedSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getOrderedSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'OrderedSubmissions' }
    & { programmeSubmission: (
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'id' | 'progress'>
      & { programme?: Maybe<(
        { __typename?: 'Programmes' }
        & Pick<Programmes, 'id' | 'name' | 'description'>
        & { logo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id' | 'title' | 'isSubModule' | 'archive' | 'position'>
        & { sub_modules?: Maybe<Array<Maybe<(
          { __typename?: 'SubModule' }
          & Pick<SubModule, 'id' | 'nameEnglish' | 'nameFrench' | 'nameSpanish' | 'nameMandarin' | 'nameGerman' | 'position'>
          & { sections?: Maybe<Array<Maybe<(
            { __typename?: 'Section' }
            & Pick<Section, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'position'>
          )>>> }
        )>>> }
      )> }
    ), subModuleSubmissions: Array<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'id' | 'view' | 'progress'>
      & { sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'position'>
        & { sections?: Maybe<Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'position'>
        )>>> }
      )>, section?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsSectionSubmission' }
        & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
        & { section?: Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'id'>
        )> }
      )>>> }
    )> }
  )>>> }
);

export type GetProgammeReportsGroupedQueryVariables = {};


export type GetProgammeReportsGroupedQuery = (
  { __typename?: 'Query' }
  & { getProgammeReportsGrouped?: Maybe<Array<Maybe<(
    { __typename?: 'ReportsGrouped' }
    & Pick<ReportsGrouped, 'companyName'>
    & { programmeType?: Maybe<Array<Maybe<(
      { __typename?: 'ProgrammeTypeReport' }
      & Pick<ProgrammeTypeReport, 'programmeType' | 'programmeName'>
      & { sections?: Maybe<Array<Maybe<(
        { __typename?: 'SectionReport' }
        & Pick<SectionReport, 'programmeName' | 'programmeType' | 'name'>
        & { report?: Maybe<(
          { __typename?: 'ReportDetail' }
          & Pick<ReportDetail, 'id' | 'url'>
        )> }
      )>>> }
    )>>> }
  )>>> }
);

export type GetProgrammeQueryVariables = {
  id: Scalars['ID'];
};


export type GetProgrammeQuery = (
  { __typename?: 'Query' }
  & { programme?: Maybe<(
    { __typename?: 'Programmes' }
    & Pick<Programmes, 'id' | 'name' | 'description' | 'whatToExpect' | 'completion'>
    & { logo?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )> }
  )> }
);

export type GetProgrammeProgrammeSubmissionsQueryVariables = {
  where: Scalars['JSON'];
  limit?: Maybe<Scalars['Int']>;
};


export type GetProgrammeProgrammeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { programmeSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'progress'>
    & { programme?: Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'name' | 'description'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'id' | 'title' | 'isSubModule' | 'archive' | 'position'>
      & { sub_modules?: Maybe<Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id' | 'nameEnglish' | 'nameFrench' | 'nameSpanish' | 'nameMandarin' | 'nameGerman' | 'position'>
        & { sections?: Maybe<Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin'>
        )>>> }
      )>>> }
    )> }
  )>>> }
);

export type GetMyProgrammeSubmissionQueryVariables = {
  id: Scalars['ID'];
};


export type GetMyProgrammeSubmissionQuery = (
  { __typename?: 'Query' }
  & { programmeSubmission?: Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'status' | 'progress' | 'selected'>
    & { competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'id' | 'url'>
    )>, feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'id' | 'url'>
    )>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'showParticipants' | 'isCoaching' | 'isSubModule' | 'notes' | 'deadline'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, programmeQuestions?: Maybe<Array<Maybe<(
        { __typename: 'ComponentQuestionTypesValuesNested' }
        & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question' | 'description'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesValuesBubble' } | { __typename: 'ComponentQuestionTypesValuesCharacters' } | { __typename: 'ComponentQuestionTypesValuesSliders' } | { __typename: 'ComponentQuestionTypesValuesGaps' } | { __typename: 'ComponentQuestionTypesSaboteurVideos' } | { __typename: 'ComponentQuestionTypesMultipleChoice' } | { __typename: 'ComponentQuestionTypesSaboteur' } | { __typename: 'ComponentQuestionTypesSimpleQuestion' } | { __typename: 'ComponentQuestionTypesXYGraph' } | { __typename: 'ComponentQuestionTypesNestedQuestions' } | { __typename: 'ComponentQuestionTypesUploadQuestion' } | { __typename: 'ComponentQuestionTypesGravitasScale' } | { __typename: 'ComponentQuestionTypesParticipant' } | { __typename: 'ComponentQuestionTypesStakeholderMap' } | { __typename: 'ComponentQuestionTypesFeedForward1' } | { __typename: 'ComponentQuestionTypesFeedForward2' } | { __typename: 'ComponentQuestionTypesSimpleReadOnly' } | (
        { __typename: 'ComponentQuestionTypesCompetency2' }
        & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
        & { questionscompetency2?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
          & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesCompetency' } | { __typename: 'ComponentQuestionTypesGravitasGap' } | { __typename: 'ComponentQuestionTypesSliderQuestions' } | { __typename: 'ComponentQuestionTypesGravitasSliders' }>>>, articles?: Maybe<Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>>, events?: Maybe<Array<Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'name' | 'link' | 'sessionId'>
      )>>>, sub_modules?: Maybe<Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id' | 'nameEnglish' | 'descriptionEnglish'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'id'>
        )> }
      )>>> }
    )>, programmeResponses?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsProgrammeSubmissions' }
      & { answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'question' | 'rating' | 'response' | 'steps' | 'textboxQuestion'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>> }
    )>>>, participants?: Maybe<Array<Maybe<(
      { __typename?: 'Participants' }
      & Pick<Participants, 'id' | 'name' | 'email' | 'type'>
    )>>>, submissionparticipants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, myNotes?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsNotes' }
      & Pick<ComponentSubmissionsNotes, 'id' | 'title' | 'description'>
      & { document?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )> }
);

export type GetProgrammesQueryVariables = {};


export type GetProgrammesQuery = (
  { __typename?: 'Query' }
  & { programmes?: Maybe<Array<Maybe<(
    { __typename?: 'Programmes' }
    & Pick<Programmes, 'id' | 'name' | 'description'>
    & { logo?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, programme_types?: Maybe<Array<Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'title'>
      & { sub_modules?: Maybe<Array<Maybe<(
        { __typename?: 'SubModule' }
        & { sections?: Maybe<Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'titleEnglish'>
        )>>> }
      )>>> }
    )>>> }
  )>>> }
);

export type GetRegionsQueryVariables = {};


export type GetRegionsQuery = (
  { __typename?: 'Query' }
  & { regions?: Maybe<Array<Maybe<(
    { __typename?: 'Region' }
    & Pick<Region, 'id' | 'nameEnglish' | 'nameFrench' | 'nameGerman' | 'nameSpanish' | 'nameMandarin' | 'created_at' | 'updated_at'>
  )>>> }
);

export type GetReportsGroupedQueryVariables = {};


export type GetReportsGroupedQuery = (
  { __typename?: 'Query' }
  & { getReportsGrouped?: Maybe<Array<Maybe<(
    { __typename?: 'ReportsGrouped' }
    & Pick<ReportsGrouped, 'companyName'>
    & { programmeType?: Maybe<Array<Maybe<(
      { __typename?: 'ProgrammeTypeReport' }
      & Pick<ProgrammeTypeReport, 'programmeType' | 'programmeName'>
      & { sections?: Maybe<Array<Maybe<(
        { __typename?: 'SectionReport' }
        & Pick<SectionReport, 'programmeName' | 'programmeType' | 'name'>
        & { report?: Maybe<(
          { __typename?: 'ReportDetail' }
          & Pick<ReportDetail, 'id' | 'url'>
        )> }
      )>>> }
    )>>> }
  )>>> }
);

export type GetSectionQueryVariables = {
  id: Scalars['ID'];
};


export type GetSectionQuery = (
  { __typename?: 'Query' }
  & { section?: Maybe<(
    { __typename?: 'Section' }
    & Pick<Section, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'getStartedText' | 'Notes' | 'showSession'>
    & { cover?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, videoEnglish?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, questions?: Maybe<Array<Maybe<(
      { __typename: 'ComponentQuestionTypesMultipleChoice' }
      & Pick<ComponentQuestionTypesMultipleChoice, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious' | 'numberOfAnswers'>
      & { option?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionOption' }
        & Pick<ComponentOptionOption, 'id' | 'optionEnglish' | 'optionFrench' | 'optionGerman' | 'optionSpanish' | 'optionMandarin' | 'isCorrect'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSaboteur' }
      & Pick<ComponentQuestionTypesSaboteur, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish'>
      & { saboteurQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
        & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
        & { proof?: Maybe<Array<Maybe<(
          { __typename?: 'UploadFile' }
          & UploadFileFragment
        )>>> }
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSimpleQuestion' }
      & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
    ) | (
      { __typename: 'ComponentQuestionTypesXYGraph' }
      & Pick<ComponentQuestionTypesXyGraph, 'id' | 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
    ) | (
      { __typename: 'ComponentQuestionTypesNestedQuestions' }
      & Pick<ComponentQuestionTypesNestedQuestions, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasScale' }
      & Pick<ComponentQuestionTypesGravitasScale, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish'>
      & { ratingInput?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentRatingInputRatingInput' }
        & Pick<ComponentRatingInputRatingInput, 'id' | 'labelOneEnglish' | 'labelTwoEnglish'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesStakeholderMap' }
      & Pick<ComponentQuestionTypesStakeholderMap, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleSpanish' | 'subTitleSpanish' | 'titleGerman' | 'subTitleGerman' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
    ) | (
      { __typename: 'ComponentQuestionTypesSaboteurVideos' }
      & Pick<ComponentQuestionTypesSaboteurVideos, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
      & { SaboteurVideo?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
        & Pick<ComponentSaboteurVideoSaboteurVideo, 'id' | 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin'>
        & { video?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url' | 'id'>
        )> }
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesSliders' }
      & Pick<ComponentQuestionTypesValuesSliders, 'id' | 'title' | 'question' | 'description'>
      & { sliderQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Pick<ComponentQuestionTypesSliderQuestions, 'id' | 'question' | 'color'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSimpleReadOnly' }
      & Pick<ComponentQuestionTypesSimpleReadOnly, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleMandarin' | 'titleSpanish' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentMandarin' | 'contentSpanish'>
      & { photo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesNested' }
      & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question' | 'description'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesGaps' }
      & Pick<ComponentQuestionTypesValuesGaps, 'id' | 'title' | 'question' | 'description'>
    ) | { __typename: 'ComponentQuestionTypesUploadQuestion' } | { __typename: 'ComponentQuestionTypesParticipant' } | (
      { __typename: 'ComponentQuestionTypesValuesCharacters' }
      & Pick<ComponentQuestionTypesValuesCharacters, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesCompetency' }
      & Pick<ComponentQuestionTypesCompetency, 'id' | 'title' | 'question' | 'minNumber' | 'maxNumber' | 'miniLabel' | 'maxiLabel' | 'simpleQuestion'>
    ) | (
      { __typename: 'ComponentQuestionTypesValuesBubble' }
      & Pick<ComponentQuestionTypesValuesBubble, 'id' | 'title' | 'question' | 'description'>
    ) | { __typename: 'ComponentQuestionTypesSliderQuestions' } | (
      { __typename: 'ComponentQuestionTypesFeedForward1' }
      & Pick<ComponentQuestionTypesFeedForward1, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesFeedForward2' }
      & Pick<ComponentQuestionTypesFeedForward2, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesCompetency2' }
      & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
      & { questionscompetency2?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
        & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasSliders' }
      & Pick<ComponentQuestionTypesGravitasSliders, 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'positiveHeadingEnglish' | 'positiveHeadingFrench' | 'positiveHeadingSpanish' | 'positiveHeadingMandarin' | 'positiveHeadingGerman' | 'negativeHeadingEnglish' | 'negativeHeadingFrench' | 'negativeHeadingSpanish' | 'negativeHeadingMandarin' | 'negativeHeadingGerman'>
      & { sliderQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionSliderQuestions' }
        & Pick<ComponentOptionSliderQuestions, 'questionPositiveEnglish' | 'questionPositiveGerman' | 'questionPositiveMandarin' | 'questionPositiveSpanish' | 'questionPositiveFrench' | 'questionNegativeEnglish' | 'questionNegativeGerman' | 'questionNegativeFrench' | 'questionNegativeMandarin' | 'questionNegativeSpanish'>
      )>>>, sliderHeadings?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionSliderHeadings' }
        & Pick<ComponentOptionSliderHeadings, 'headingEnglish' | 'headingSpanish' | 'headingGerman' | 'headingFrench' | 'rating' | 'color'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesUploadDocuments' }
      & Pick<ComponentQuestionTypesUploadDocuments, 'id' | 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish'>
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasGap' }
      & Pick<ComponentQuestionTypesGravitasGap, 'id' | 'title' | 'question' | 'description' | 'color1' | 'color2' | 'color3'>
    )>>>, events?: Maybe<Array<Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'name' | 'link' | 'sessionId'>
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id'>
      & { programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id' | 'title'>
      )> }
    )> }
  )> }
);

export type GetSectionsQueryVariables = {};


export type GetSectionsQuery = (
  { __typename?: 'Query' }
  & { sections?: Maybe<Array<Maybe<(
    { __typename?: 'Section' }
    & Pick<Section, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin' | 'showSession' | 'archive'>
    & { videoEnglish?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, videoFrench?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, videoGerman?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, videoSpanish?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, videoMandarin?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, questions?: Maybe<Array<Maybe<(
      { __typename: 'ComponentQuestionTypesMultipleChoice' }
      & Pick<ComponentQuestionTypesMultipleChoice, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'numberOfAnswers'>
      & { option?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionOption' }
        & Pick<ComponentOptionOption, 'id' | 'optionEnglish' | 'optionFrench' | 'optionGerman' | 'optionSpanish' | 'optionMandarin' | 'isCorrect'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSaboteur' }
      & Pick<ComponentQuestionTypesSaboteur, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish'>
      & { saboteurQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
        & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
        & { proof?: Maybe<Array<Maybe<(
          { __typename?: 'UploadFile' }
          & UploadFileFragment
        )>>> }
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSimpleQuestion' }
      & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
    ) | (
      { __typename: 'ComponentQuestionTypesXYGraph' }
      & Pick<ComponentQuestionTypesXyGraph, 'id' | 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
    ) | (
      { __typename: 'ComponentQuestionTypesNestedQuestions' }
      & Pick<ComponentQuestionTypesNestedQuestions, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasScale' }
      & Pick<ComponentQuestionTypesGravitasScale, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish' | 'titleFrench' | 'subTitleFrench' | 'questionOneFrench' | 'questionTwoFrench' | 'questionThreeFrench' | 'titleOneFrench' | 'titleTwoFrench' | 'titleGerman' | 'subTitleGerman' | 'questionOneGerman' | 'questionTwoGerman' | 'questionThreeGerman' | 'titleOneGerman' | 'titleTwoGerman' | 'titleSpanish' | 'subTitleSpanish' | 'questionOneSpanish' | 'questionTwoSpanish' | 'questionThreeSpanish' | 'titleOneSpanish' | 'titleTwoSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'questionOneMandarin' | 'questionTwoMandarin' | 'questionThreeMandarin' | 'titleOneMandarin' | 'titleTwoMandarin'>
      & { ratingInput?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentRatingInputRatingInput' }
        & Pick<ComponentRatingInputRatingInput, 'id' | 'labelOneEnglish' | 'labelTwoEnglish' | 'labelOneFrench' | 'labelTwoFrench' | 'labelOneGerman' | 'labelTwoGerman' | 'labelOneSpanish' | 'labelTwoSpanish' | 'labelOneMandarin' | 'labelTwoMandarin'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesStakeholderMap' }
      & Pick<ComponentQuestionTypesStakeholderMap, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
    ) | (
      { __typename: 'ComponentQuestionTypesSaboteurVideos' }
      & Pick<ComponentQuestionTypesSaboteurVideos, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
      & { SaboteurVideo?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
        & Pick<ComponentSaboteurVideoSaboteurVideo, 'id' | 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin'>
        & { video?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url' | 'id'>
        )> }
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesSliders' }
      & Pick<ComponentQuestionTypesValuesSliders, 'id' | 'title' | 'question' | 'description'>
      & { sliderQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Pick<ComponentQuestionTypesSliderQuestions, 'id' | 'question' | 'color'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSimpleReadOnly' }
      & Pick<ComponentQuestionTypesSimpleReadOnly, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleMandarin' | 'titleSpanish' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentMandarin' | 'contentSpanish'>
      & { photo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesNested' }
      & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question' | 'description'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesGaps' }
      & Pick<ComponentQuestionTypesValuesGaps, 'id' | 'title' | 'question' | 'description'>
    ) | { __typename: 'ComponentQuestionTypesUploadQuestion' } | { __typename: 'ComponentQuestionTypesParticipant' } | (
      { __typename: 'ComponentQuestionTypesValuesCharacters' }
      & Pick<ComponentQuestionTypesValuesCharacters, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesCompetency' }
      & Pick<ComponentQuestionTypesCompetency, 'id' | 'title' | 'question' | 'minNumber' | 'maxNumber' | 'miniLabel' | 'maxiLabel' | 'simpleQuestion'>
    ) | (
      { __typename: 'ComponentQuestionTypesValuesBubble' }
      & Pick<ComponentQuestionTypesValuesBubble, 'id' | 'title' | 'question' | 'description'>
    ) | { __typename: 'ComponentQuestionTypesSliderQuestions' } | (
      { __typename: 'ComponentQuestionTypesFeedForward1' }
      & Pick<ComponentQuestionTypesFeedForward1, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesFeedForward2' }
      & Pick<ComponentQuestionTypesFeedForward2, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesCompetency2' }
      & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
      & { questionscompetency2?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
        & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasSliders' }
      & Pick<ComponentQuestionTypesGravitasSliders, 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'positiveHeadingEnglish' | 'positiveHeadingFrench' | 'positiveHeadingSpanish' | 'positiveHeadingMandarin' | 'positiveHeadingGerman' | 'negativeHeadingEnglish' | 'negativeHeadingFrench' | 'negativeHeadingSpanish' | 'negativeHeadingMandarin' | 'negativeHeadingGerman'>
      & { sliderQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionSliderQuestions' }
        & Pick<ComponentOptionSliderQuestions, 'questionPositiveEnglish' | 'questionPositiveGerman' | 'questionPositiveMandarin' | 'questionPositiveSpanish' | 'questionPositiveFrench' | 'questionNegativeEnglish' | 'questionNegativeGerman' | 'questionNegativeFrench' | 'questionNegativeMandarin' | 'questionNegativeSpanish'>
      )>>>, sliderHeadings?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionSliderHeadings' }
        & Pick<ComponentOptionSliderHeadings, 'headingEnglish' | 'headingSpanish' | 'headingGerman' | 'headingFrench' | 'headingMandarin' | 'color' | 'rating'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesUploadDocuments' }
      & Pick<ComponentQuestionTypesUploadDocuments, 'id' | 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish'>
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasGap' }
      & Pick<ComponentQuestionTypesGravitasGap, 'id' | 'title' | 'question' | 'description' | 'color1' | 'color2' | 'color3'>
    )>>>, events?: Maybe<Array<Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'name' | 'link' | 'sessionId'>
    )>>> }
  )>>> }
);

export type GetCoachSessionsQueryVariables = {};


export type GetCoachSessionsQuery = (
  { __typename?: 'Query' }
  & { coachSessions?: Maybe<Array<Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'id' | 'title' | 'status'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id'>
    )>, programme_submission?: Maybe<(
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'id'>
    )>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'id'>
    )>, appointment?: Maybe<(
      { __typename?: 'Appointments' }
      & Pick<Appointments, 'appointmentUrl' | 'appointmentStartDate' | 'appointmentEndDate' | 'status'>
    )> }
  )>>> }
);

export type GetSubModuleQueryVariables = {
  id: Scalars['ID'];
};


export type GetSubModuleQuery = (
  { __typename?: 'Query' }
  & { subModule?: Maybe<(
    { __typename?: 'SubModule' }
    & Pick<SubModule, 'id' | 'nameEnglish' | 'nameFrench' | 'nameSpanish' | 'nameGerman' | 'nameMandarin' | 'descriptionEnglish' | 'descriptionFrench' | 'descriptionSpanish' | 'descriptionGerman' | 'descriptionMandarin'>
    & { cover?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, sections?: Maybe<Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'position' | 'archive'>
      & { videoEnglish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoGerman?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoSpanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoMandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoFrench?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesMultipleChoice' }
        & Questions_ComponentQuestionTypesMultipleChoice_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteur' }
        & Questions_ComponentQuestionTypesSaboteur_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Questions_ComponentQuestionTypesSimpleQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesXYGraph' }
        & Questions_ComponentQuestionTypesXyGraph_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesNestedQuestions' }
        & Questions_ComponentQuestionTypesNestedQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasScale' }
        & Questions_ComponentQuestionTypesGravitasScale_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesStakeholderMap' }
        & Questions_ComponentQuestionTypesStakeholderMap_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteurVideos' }
        & Questions_ComponentQuestionTypesSaboteurVideos_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesSliders' }
        & Questions_ComponentQuestionTypesValuesSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleReadOnly' }
        & Questions_ComponentQuestionTypesSimpleReadOnly_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesNested' }
        & Questions_ComponentQuestionTypesValuesNested_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesGaps' }
        & Questions_ComponentQuestionTypesValuesGaps_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadQuestion' }
        & Questions_ComponentQuestionTypesUploadQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesParticipant' }
        & Questions_ComponentQuestionTypesParticipant_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesCharacters' }
        & Questions_ComponentQuestionTypesValuesCharacters_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency' }
        & Questions_ComponentQuestionTypesCompetency_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesBubble' }
        & Questions_ComponentQuestionTypesValuesBubble_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Questions_ComponentQuestionTypesSliderQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward1' }
        & Questions_ComponentQuestionTypesFeedForward1_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward2' }
        & Questions_ComponentQuestionTypesFeedForward2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency2' }
        & Questions_ComponentQuestionTypesCompetency2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasSliders' }
        & Questions_ComponentQuestionTypesGravitasSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadDocuments' }
        & Questions_ComponentQuestionTypesUploadDocuments_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasGap' }
        & Questions_ComponentQuestionTypesGravitasGap_Fragment
      )>>> }
    )>>>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'position' | 'isCoaching' | 'isSubModule' | 'notes' | 'showArticle' | 'showSession' | 'showParticipants' | 'competencySurvey' | 'feedForwardSurvey' | 'deadline'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, articles?: Maybe<Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>>, modal?: Maybe<(
        { __typename?: 'Modal' }
        & Pick<Modal, 'id' | 'title' | 'subtitle' | 'message'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url' | 'name'>
        )> }
      )>, events?: Maybe<Array<Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'name' | 'link'>
      )>>> }
    )> }
  )> }
);

export type GetMySubModuleSubmissionQueryVariables = {
  id: Scalars['ID'];
};


export type GetMySubModuleSubmissionQuery = (
  { __typename?: 'Query' }
  & { subModuleSubmission?: Maybe<(
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'id' | 'view' | 'progress' | 'status' | 'timeSpent'>
    & { participants?: Maybe<Array<Maybe<(
      { __typename?: 'Participants' }
      & Pick<Participants, 'id' | 'name' | 'email' | 'type'>
    )>>>, submissionparticipants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'id'>
    )>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'position' | 'archive'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'position' | 'isCoaching' | 'isSubModule' | 'notes' | 'showArticle' | 'showSession' | 'showParticipants' | 'competencySurvey' | 'feedForwardSurvey' | 'deadline' | 'showStatistics'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, articles?: Maybe<Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'url'>
          )> }
        )>>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'id' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'id' | 'url' | 'name'>
          )> }
        )>, events?: Maybe<Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'id' | 'name' | 'link'>
        )>>> }
      )> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress' | 'sliderAnswers'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'steps' | 'response'>
      )>>>, uploadDocuments?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsUploadDocuments' }
        & { saboteurProofValue?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id'>
        )> }
      )>>> }
    )>>>, reports?: Maybe<Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )> }
);

export type GetSubModulesQueryVariables = {
  where: Scalars['JSON'];
};


export type GetSubModulesQuery = (
  { __typename?: 'Query' }
  & { subModules?: Maybe<Array<Maybe<(
    { __typename?: 'SubModule' }
    & Pick<SubModule, 'id' | 'nameEnglish' | 'nameFrench' | 'nameGerman' | 'nameSpanish' | 'nameMandarin' | 'descriptionEnglish' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionSpanish' | 'descriptionMandarin'>
    & { cover?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, sections?: Maybe<Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin' | 'archive'>
      & { videoEnglish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoFrench?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoGerman?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoSpanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoMandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesMultipleChoice' }
        & Questions_ComponentQuestionTypesMultipleChoice_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteur' }
        & Questions_ComponentQuestionTypesSaboteur_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Questions_ComponentQuestionTypesSimpleQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesXYGraph' }
        & Questions_ComponentQuestionTypesXyGraph_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesNestedQuestions' }
        & Questions_ComponentQuestionTypesNestedQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasScale' }
        & Questions_ComponentQuestionTypesGravitasScale_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesStakeholderMap' }
        & Questions_ComponentQuestionTypesStakeholderMap_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSaboteurVideos' }
        & Questions_ComponentQuestionTypesSaboteurVideos_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesSliders' }
        & Questions_ComponentQuestionTypesValuesSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSimpleReadOnly' }
        & Questions_ComponentQuestionTypesSimpleReadOnly_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesNested' }
        & Questions_ComponentQuestionTypesValuesNested_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesGaps' }
        & Questions_ComponentQuestionTypesValuesGaps_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadQuestion' }
        & Questions_ComponentQuestionTypesUploadQuestion_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesParticipant' }
        & Questions_ComponentQuestionTypesParticipant_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesCharacters' }
        & Questions_ComponentQuestionTypesValuesCharacters_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency' }
        & Questions_ComponentQuestionTypesCompetency_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesValuesBubble' }
        & Questions_ComponentQuestionTypesValuesBubble_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Questions_ComponentQuestionTypesSliderQuestions_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward1' }
        & Questions_ComponentQuestionTypesFeedForward1_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesFeedForward2' }
        & Questions_ComponentQuestionTypesFeedForward2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesCompetency2' }
        & Questions_ComponentQuestionTypesCompetency2_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasSliders' }
        & Questions_ComponentQuestionTypesGravitasSliders_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesUploadDocuments' }
        & Questions_ComponentQuestionTypesUploadDocuments_Fragment
      ) | (
        { __typename?: 'ComponentQuestionTypesGravitasGap' }
        & Questions_ComponentQuestionTypesGravitasGap_Fragment
      )>>> }
    )>>> }
  )>>> }
);

export type GetSectionReportQueryVariables = {
  id: Scalars['ID'];
};


export type GetSectionReportQuery = (
  { __typename?: 'Query' }
  & { getSectionReport: (
    { __typename?: 'Report' }
    & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
    & { report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  ) }
);

export type GetMySubmissionQueryVariables = {
  id: Scalars['ID'];
};


export type GetMySubmissionQuery = (
  { __typename?: 'Query' }
  & { submission?: Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'timeSpent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>>> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>> }
    )>>>, reports?: Maybe<Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )> }
);

export type GetSubmissionReportGroupedQueryVariables = {};


export type GetSubmissionReportGroupedQuery = (
  { __typename?: 'Query' }
  & { getSubmissionReportGrouped?: Maybe<Array<Maybe<(
    { __typename?: 'ReportsSubmissionGrouped' }
    & Pick<ReportsSubmissionGrouped, 'id' | 'name' | 'type' | 'created_by' | 'updated_by' | 'programmeType' | 'sub_module_submission' | 'notification'>
    & { report?: Maybe<(
      { __typename?: 'ReportDetail' }
      & Pick<ReportDetail, 'id' | 'url'>
    )> }
  )>>> }
);

export type GetTranslationsQueryVariables = {};


export type GetTranslationsQuery = (
  { __typename?: 'Query' }
  & { translation?: Maybe<(
    { __typename?: 'Translations' }
    & Pick<Translations, 'id'>
    & { menu?: Maybe<(
      { __typename?: 'ComponentTranslationsMenu' }
      & Pick<ComponentTranslationsMenu, 'id' | 'homeEnglish' | 'myProgrammeEnglish' | 'myWorkEnglish' | 'myLibraryEnglish' | 'myProfileEnglish' | 'helpAndSupportEnglish' | 'signOutEnglish' | 'homeFrench' | 'myProgrammeFrench' | 'myWorkFrench' | 'myLibraryFrench' | 'myProfileFrench' | 'helpAndSupportFrench' | 'signOutFrench' | 'homeGerman' | 'myProgrammeGerman' | 'myWorkGerman' | 'myLibraryGerman' | 'myProfileGerman' | 'helpAndSupportGerman' | 'signOutGerman' | 'homeSpanish' | 'myProgrammeSpanish' | 'myWorkSpanish' | 'myLibrarySpanish' | 'myProfileSpanish' | 'helpAndSupportSpanish' | 'signOutSpanish' | 'homeMandarin' | 'myProgrammeMandarin' | 'myWorkMandarin' | 'myLibraryMandarin' | 'myProfileMandarin' | 'helpAndSupportMandarin' | 'signOutMandarin' | 'aboutUsEnglish' | 'aboutUsGerman' | 'aboutUsFrench' | 'myNotesEnglish' | 'myNotesGerman' | 'myNotesFrench' | 'myNotesSpanish' | 'myNotesMandarin' | 'notificationsEnglish' | 'notificationsGerman' | 'notificationsFrench' | 'notificationsSpanish' | 'notificationsMandarin'>
    )>, languageSelection?: Maybe<(
      { __typename?: 'ComponentTranslationsLanguageSelection' }
      & Pick<ComponentTranslationsLanguageSelection, 'id' | 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
    )>, welcomeScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsWelcomeScreen' }
      & Pick<ComponentTranslationsWelcomeScreen, 'id' | 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
      & { videoEnglish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoFrench?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoGerman?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoMandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, videoSpanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>, letsGetStartedScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsLetsGetStartedScreen' }
      & Pick<ComponentTranslationsLetsGetStartedScreen, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'firstNameLabelEnglish' | 'firstNameErrorEnglish' | 'lastNameLabelEnglish' | 'lastNameErrorEnglish' | 'jobTitleLabelEnglish' | 'jobTitleErrorEnglish' | 'divisionLabelEnglish' | 'divisionErrorEnglish' | 'timezoneLabelEnglish' | 'regionLabelEnglish' | 'regionErrorEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'subTitleFrench' | 'firstNameLabelFrench' | 'firstNameErrorFrench' | 'lastNameLabelFrench' | 'lastNameErrorFrench' | 'jobTitleLabelFrench' | 'jobTitleErrorFrench' | 'divisionLabelFrench' | 'divisionErrorFrench' | 'timezoneLabelFrench' | 'regionLabelFrench' | 'regionErrorFrench' | 'nextButtonFrench' | 'titleGerman' | 'subTitleGerman' | 'firstNameLabelGerman' | 'firstNameErrorGerman' | 'lastNameLabelGerman' | 'lastNameErrorGerman' | 'jobTitleLabelGerman' | 'jobTitleErrorGerman' | 'divisionLabelGerman' | 'divisionErrorGerman' | 'timezoneLabelGerman' | 'regionLabelGerman' | 'regionErrorGerman' | 'nextButtonGerman' | 'titleMandarin' | 'subTitleMandarin' | 'firstNameLabelMandarin' | 'firstNameErrorMandarin' | 'lastNameLabelMandarin' | 'lastNameErrorMandarin' | 'jobTitleLabelMandarin' | 'jobTitleErrorMandarin' | 'divisionLabelMandarin' | 'divisionErrorMandarin' | 'timezoneLabelMandarin' | 'regionLabelMandarin' | 'regionErrorMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'subTitleSpanish' | 'firstNameLabelSpanish' | 'firstNameErrorSpanish' | 'lastNameLabelSpanish' | 'lastNameErrorSpanish' | 'jobTitleLabelSpanish' | 'jobTitleErrorSpanish' | 'divisionLabelSpanish' | 'divisionErrorSpanish' | 'timezoneLabelSpanish' | 'regionLabelSpanish' | 'regionErrorSpanish' | 'nextButtonSpanish' | 'leftTitleEnglish' | 'leftSubtitleEnglish' | 'leftTitleSpanish' | 'leftSubtitleSpanish' | 'leftTitleMandarin' | 'leftSubTitleMandarin' | 'leftTitleFrench' | 'leftSubtitleFrench' | 'leftSubtitleGerman' | 'leftTitleGerman' | 'havingTroubleEnglish' | 'havingTroubleGerman' | 'havingTroubleFrench' | 'havingTroubleMandarin' | 'havingTroubleSpanish' | 'getHelpButtonEnglish' | 'getHelpButtonSpanish' | 'getHelpButtonFrench' | 'getHelpButtonGerman' | 'getHelpButtonMandarin'>
      & { image?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>, whatToExpect?: Maybe<(
      { __typename?: 'ComponentTranslationsWhatToExpect' }
      & Pick<ComponentTranslationsWhatToExpect, 'id' | 'titleEnglish' | 'bodyEnglish' | 'getStartedButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'getStartedButtonFrench' | 'titleGerman' | 'bodyGerman' | 'getStartedButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'getStartedButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'getStartedButtonSpanish'>
      & { image?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>, homeScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsHomeScreen' }
      & Pick<ComponentTranslationsHomeScreen, 'id' | 'titleEnglish' | 'myProgrammeEnglish' | 'completedModulesEnglish' | 'noChangesEnglish' | 'changesUpEnglish' | 'changesDownEnglish' | 'viewModulesEnglish' | 'myLibraryEnglish' | 'viewedArticlesEnglish' | 'viewLibraryEnglish' | 'titleFrench' | 'myProgrammeFrench' | 'completedModulesFrench' | 'noChangesFrench' | 'changesUpFrench' | 'changesDownFrench' | 'viewModulesFrench' | 'myLibraryFrench' | 'viewedArticlesFrench' | 'viewLibraryFrench' | 'titleGerman' | 'myProgrammeGerman' | 'completedModulesGerman' | 'noChangesGerman' | 'changesUpGerman' | 'changesDownGerman' | 'viewModulesGerman' | 'myLibraryGerman' | 'viewedArticlesGerman' | 'viewLibraryGerman' | 'titleSpanish' | 'myProgrammeSpanish' | 'completedModulesSpanish' | 'noChangesSpanish' | 'changesUpSpanish' | 'changesDownSpanish' | 'viewModulesSpanish' | 'myLibrarySpanish' | 'viewedArticlesSpanish' | 'viewLibrarySpanish' | 'titleMandarin' | 'myProgrammeMandarin' | 'completedModulesMandarin' | 'noChangesMandarin' | 'changesUpMandarin' | 'changesDownMandarin' | 'viewModulesMandarin' | 'myLibraryMandarin' | 'viewedArticlesMandarin' | 'viewLibraryMandarin' | 'welcomeEnglish' | 'welcomeFrench' | 'welcomeGerman' | 'welcomeSpanish' | 'welcomeMandarin' | 'programmeProgressEnglish' | 'programmeProgressFrench' | 'programmeProgressGerman' | 'programmeProgressSpanish' | 'programmeProgressMandarin' | 'whatsNextEnglish' | 'whatsNextFrench' | 'whatsNextGerman' | 'whatsNextSpanish' | 'whatsNextMandarin' | 'whatToExpectEnglish' | 'whatToExpectFrench' | 'whatToExpectGerman' | 'whatToExpectSpanish' | 'whatToExpectMandarin'>
    )>, myWorkScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsMyWorkScreen' }
      & Pick<ComponentTranslationsMyWorkScreen, 'id' | 'emptyStateTitleEnglish' | 'emptyStateDescEnglish' | 'subtitleEnglish' | 'feedbackEnglish' | 'feedbackNotEligibleEnglish' | 'feedbackNotReceivedEnglish' | 'notStartedEnglish' | 'emptyStateTitleFrench' | 'emptyStateDescFrench' | 'subtitleFrench' | 'feedbackFrench' | 'feedbackNotEligibleFrench' | 'feedbackNotReceivedFrench' | 'notStartedFrench' | 'emptyStateTitleGerman' | 'emptyStateDescGerman' | 'subtitleGerman' | 'feedbackGerman' | 'feedbackNotEligibleGerman' | 'feedbackNotReceivedGerman' | 'notStartedGerman' | 'emptyStateTitleSpanish' | 'emptyStateDescSpanish' | 'subtitleSpanish' | 'feedbackSpanish' | 'feedbackNotEligibleSpanish' | 'feedbackNotReceivedSpanish' | 'notStartedSpanish' | 'emptyStateTitleMandarin' | 'emptyStateDescMandarin' | 'subtitleMandarin' | 'feedbackMandarin' | 'feedbackNotEligibleMandarin' | 'feedbackNotReceivedMandarin' | 'notStartedMandarin' | 'downloadContentTextEnglish' | 'downloadContentTextFrench' | 'downloadContentTextGerman' | 'downloadContentTextSpanish' | 'downloadContentTextMandarin' | 'myNotesEnglish' | 'myNotesSpanish' | 'myNotesFrench' | 'myNotesGerman' | 'myNotesMandarin' | 'moduleReportsEnglish' | 'moduleReportsSpanish' | 'moduleReportsFrench' | 'moduleReportsGerman' | 'moduleReportsMandarin' | 'documentsEnglish' | 'documentsSpanish' | 'documentsMandarin' | 'documentsFrench'>
    )>, myLibraryScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsMyLibraryScreen' }
      & Pick<ComponentTranslationsMyLibraryScreen, 'id' | 'allArticlesEnglish' | 'myBookmarksEnglish' | 'allArticlesFrench' | 'myBookmarksFrench' | 'allArticlesGerman' | 'myBookmarksGerman' | 'allArticlesSpanish' | 'myBookmarksSpanish' | 'allArticlesMandarin' | 'myBookmarksMandarin' | 'viewArticleEnglish' | 'viewArticleFrench' | 'viewArticleGerman' | 'viewArticleSpanish' | 'viewArticleMandarin'>
    )>, myProfileScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsMyProfileScreen' }
      & Pick<ComponentTranslationsMyProfileScreen, 'id' | 'detailsEnglish' | 'settingsEnglish' | 'logoutEnglish' | 'joinEnglish' | 'detailsFrench' | 'settingsFrench' | 'logoutFrench' | 'joinFrench' | 'detailsGerman' | 'settingsGerman' | 'logoutGerman' | 'joinGerman' | 'detailsSpanish' | 'settingsSpanish' | 'logoutSpanish' | 'joinSpanish' | 'detailsMandarin' | 'settingsMandarin' | 'logoutMandarin'>
    )>, personalScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsPersonalScreen' }
      & Pick<ComponentTranslationsPersonalScreen, 'id' | 'changePhotoEnglish' | 'firstNameLabelEnglish' | 'lastNameLabelEnglish' | 'emailLabelEnglish' | 'jobTitleLabelEnglish' | 'divisionLabelEnglish' | 'editInfoButtonEnglish' | 'changePhotoFrench' | 'firstNameLabelFrench' | 'lastNameLabelFrench' | 'emailLabelFrench' | 'jobTitleLabelFrench' | 'divisionLabelFrench' | 'editInfoButtonFrench' | 'changePhotoGerman' | 'firstNameLabelGerman' | 'lastNameLabelGerman' | 'emailLabelGerman' | 'jobTitleLabelGerman' | 'divisionLabelGerman' | 'editInfoButtonGerman' | 'changePhotoSpanish' | 'firstNameLabelSpanish' | 'lastNameLabelSpanish' | 'emailLabelSpanish' | 'jobTitleLabelSpanish' | 'divisionLabelSpanish' | 'editInfoButtonSpanish' | 'changePhotoMandarin' | 'firstNameLabelMandarin' | 'lastNameLabelMandarin' | 'emailLabelMandarin' | 'jobTitleLabelMandarin' | 'divisionLabelMandarin' | 'editInfoButtonMandarin' | 'resetPasswordEnglish' | 'resetPasswordFrench' | 'resetPasswordGerman' | 'resetPasswordSpanish' | 'resetPasswordMandarin'>
    )>, settingsScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsSettingsScreen' }
      & Pick<ComponentTranslationsSettingsScreen, 'id' | 'titleEnglish' | 'saveButtonEnglish' | 'titleFrench' | 'saveButtonFrench' | 'titleGerman' | 'saveButtonGerman' | 'titleSpanish' | 'saveButtonSpanish' | 'titleMandarin' | 'saveButtonMandarin'>
    )>, helpAndSupport?: Maybe<(
      { __typename?: 'ComponentTranslationsHelpAndSupport' }
      & Pick<ComponentTranslationsHelpAndSupport, 'id' | 'titleEnglish' | 'knowledgeBaseEnglish' | 'liveChatEnglish' | 'myTicketsEnglish' | 'titleFrench' | 'knowledgeBaseFrench' | 'liveChatFrench' | 'myTicketsFrench' | 'titleGerman' | 'knowledgeBaseGerman' | 'liveChatGerman' | 'myTicketsGerman' | 'titleSpanish' | 'knowledgeBaseSpanish' | 'liveChatSpanish' | 'myTicketsSpanish' | 'titleMandarin' | 'knowledgeBaseMandarin' | 'liveChatMandarin' | 'myTicketsMandarin'>
    )>, aboutUs?: Maybe<(
      { __typename?: 'ComponentTranslationsAboutUs' }
      & Pick<ComponentTranslationsAboutUs, 'id' | 'textEnglish' | 'textFrench' | 'textGerman' | 'userGuidelinesTextEnglish' | 'userGuidelinesTextGerman' | 'userGuidelinesTextFrench'>
      & { userGuidelinesEnglish?: Maybe<Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>>>, userGuidelinesGerman?: Maybe<Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>>>, userGuidelinesFrench?: Maybe<Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>>> }
    )>, buttons?: Maybe<(
      { __typename?: 'ComponentTranslationsButtons' }
      & Pick<ComponentTranslationsButtons, 'id' | 'backBtnsEnglish' | 'backBtnsFrench' | 'backBtnsGerman' | 'nextBtnsEnglish' | 'nextBtnsFrench' | 'nextBtnsGerman' | 'addMoreBtnsEnglish' | 'addMoreBtnsFrench' | 'addMoreBtnsGerman'>
    )>, programmesScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsProgrammeScreen' }
      & Pick<ComponentTranslationsProgrammeScreen, 'id' | 'changeButtonEnglish' | 'changeButtonFrench' | 'changeButtonGerman' | 'changeButtonSpanish' | 'changeButtonMandarin' | 'programmeOverviewEnglish' | 'programmeOverviewFrench' | 'programmeOverviewGerman' | 'programmeOverviewSpanish' | 'programmeOverviewMandarin' | 'programmeTextEnglish' | 'programmeTextFrench' | 'programmeTextGerman' | 'programmeTextSpanish' | 'programmeTextMandarin' | 'informationEnglish' | 'informationFrench' | 'informationGerman' | 'informationSpanish' | 'informationMandarin' | 'selectProgrammesTitleEnglish' | 'selectProgrammesTitleFrench' | 'selectProgrammesTitleGerman' | 'selectProgrammesTitleSpanish' | 'selectProgrammesTitleMandarin' | 'selectProgrammesSubTitleEnglish' | 'selectProgrammesSubTitleFrench' | 'selectProgrammesSubTitleGerman' | 'selectProgrammesSubTitleSpanish' | 'selectProgrammesSubTitleMandarin' | 'selectButtonEnglish' | 'selectButtonFrench' | 'selectButtonGerman' | 'selectButtonSpanish' | 'selectButtonMandarin' | 'changeProgrammeTypeEnglish' | 'changeProgrammeTypeFrench' | 'changeProgrammeTypeGerman' | 'changeProgrammeTypeSpanish' | 'changeProgrammeTypeMandarin'>
    )>, faqs?: Maybe<(
      { __typename?: 'ComponentTranslationsFaqs' }
      & { faqsEnglish?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsQuestionAnswer' }
        & Pick<ComponentTranslationsFaqsQuestionAnswer, 'question' | 'answer'>
      )>>>, faqsFrench?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsFrench' }
        & Pick<ComponentTranslationsFaqsFrench, 'question' | 'answer'>
      )>>>, faqsGerman?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsGerman' }
        & Pick<ComponentTranslationsFaqsGerman, 'question' | 'answer'>
      )>>>, faqsMandarin?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsMandarin' }
        & Pick<ComponentTranslationsFaqsMandarin, 'question' | 'answer'>
      )>>>, faqsSpanish?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsSpanish' }
        & Pick<ComponentTranslationsFaqsSpanish, 'question' | 'answer'>
      )>>> }
    )>, dashboardScreen?: Maybe<(
      { __typename?: 'ComponentTranslationsDashboardScreen' }
      & Pick<ComponentTranslationsDashboardScreen, 'id' | 'myProgrammesEnglish' | 'myProgrammesFrench' | 'myProgrammesGerman' | 'myProgrammesSpanish' | 'myProgrammesMandarin' | 'suggestedTitleEnglish' | 'suggestedTitleFrench' | 'suggestedTitleGerman' | 'suggestedTitleSpanish' | 'suggestedTitleMandarin' | 'uploadTitleEnglish' | 'uploadTitleFrench' | 'uploadTitleGerman' | 'uploadTitleSpanish' | 'uploadTitleMandarin' | 'viewAllEnglish' | 'viewAllFrench' | 'viewAllGerman' | 'viewAllSpanish' | 'viewAllMandarin' | 'logOutDashboardEnglish' | 'logOutDashboardFrench' | 'logOutDashboardGerman' | 'logOutDashboardSpanish' | 'logOutDashboardMandarin' | 'notepadTextEnglish' | 'notepadTextFrench' | 'notepadTextGerman' | 'notepadTextSpanish' | 'notepadTextMandarin'>
    )> }
  )> }
);

export type GetTypeformCompetencyResponsesQueryVariables = {};


export type GetTypeformCompetencyResponsesQuery = (
  { __typename?: 'Query' }
  & { getTypeformCompetencyResponses?: Maybe<(
    { __typename?: 'CheckConfirmed' }
    & Pick<CheckConfirmed, 'success'>
  )> }
);

export type GetUserUploadedDocumentQueryVariables = {
  where: Scalars['JSON'];
  sort: Scalars['String'];
  limit: Scalars['Int'];
};


export type GetUserUploadedDocumentQuery = (
  { __typename?: 'Query' }
  & { userUploadedDocuments?: Maybe<Array<Maybe<(
    { __typename?: 'UserUploadedDocument' }
    & Pick<UserUploadedDocument, 'id' | 'name'>
    & { documents?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentQuestionTypesDocuments' }
      & Pick<ComponentQuestionTypesDocuments, 'id' | 'name'>
      & { document?: Maybe<Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>>> }
    )>>> }
  )>>> }
);

export type GetUserProgrammeSubmissionsQueryVariables = {};


export type GetUserProgrammeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMyProgrammeSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'status' | 'progress'>
    & { programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'id' | 'title' | 'isSubModule'>
      & { sub_modules?: Maybe<Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id' | 'nameEnglish'>
        & { sections?: Maybe<Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'id' | 'titleEnglish'>
        )>>> }
      )>>> }
    )>, programme?: Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'name' | 'position' | 'start'>
    )> }
  )>>> }
);

export type GetMyProgrammeSubmissionsQueryVariables = {};


export type GetMyProgrammeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMyProgrammeSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'status' | 'progress' | 'selected'>
    & { competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'id' | 'url'>
    )>, feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'id' | 'url'>
    )>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'id' | 'programmeTypeInstructions' | 'title' | 'description' | 'position' | 'isCoaching' | 'isSubModule' | 'notes' | 'showArticle' | 'showSession' | 'showParticipants' | 'competencySurvey' | 'feedForwardSurvey' | 'deadline' | 'archive'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, programmeQuestions?: Maybe<Array<Maybe<(
        { __typename: 'ComponentQuestionTypesValuesNested' }
        & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question' | 'description'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesValuesBubble' }
        & Pick<ComponentQuestionTypesValuesBubble, 'id' | 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesValuesCharacters' }
        & Pick<ComponentQuestionTypesValuesCharacters, 'id' | 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesValuesSliders' }
        & Pick<ComponentQuestionTypesValuesSliders, 'id' | 'title' | 'question' | 'description'>
        & { sliderQuestions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSliderQuestions' }
          & Pick<ComponentQuestionTypesSliderQuestions, 'id' | 'question' | 'color'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesValuesGaps' }
        & Pick<ComponentQuestionTypesValuesGaps, 'id' | 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesSaboteurVideos' }
        & Pick<ComponentQuestionTypesSaboteurVideos, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
        & { SaboteurVideo?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
          & Pick<ComponentSaboteurVideoSaboteurVideo, 'id' | 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin'>
          & { video?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'url' | 'id'>
          )> }
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesMultipleChoice' }
        & Pick<ComponentQuestionTypesMultipleChoice, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'numberOfAnswers'>
        & { option?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionOption' }
          & Pick<ComponentOptionOption, 'id' | 'optionEnglish' | 'isCorrect'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesSaboteur' }
        & Pick<ComponentQuestionTypesSaboteur, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish'>
        & { saboteurQuestions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
          & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
          & { proof?: Maybe<Array<Maybe<(
            { __typename?: 'UploadFile' }
            & UploadFileFragment
          )>>> }
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
      ) | (
        { __typename: 'ComponentQuestionTypesXYGraph' }
        & Pick<ComponentQuestionTypesXyGraph, 'id' | 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
      ) | (
        { __typename: 'ComponentQuestionTypesNestedQuestions' }
        & Pick<ComponentQuestionTypesNestedQuestions, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesUploadQuestion' } | (
        { __typename: 'ComponentQuestionTypesGravitasScale' }
        & Pick<ComponentQuestionTypesGravitasScale, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish'>
        & { ratingInput?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentRatingInputRatingInput' }
          & Pick<ComponentRatingInputRatingInput, 'id' | 'labelOneEnglish' | 'labelTwoEnglish'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesParticipant' } | (
        { __typename: 'ComponentQuestionTypesStakeholderMap' }
        & Pick<ComponentQuestionTypesStakeholderMap, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleSpanish' | 'subTitleSpanish' | 'titleGerman' | 'subTitleGerman' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
      ) | (
        { __typename: 'ComponentQuestionTypesFeedForward1' }
        & Pick<ComponentQuestionTypesFeedForward1, 'id' | 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesFeedForward2' }
        & Pick<ComponentQuestionTypesFeedForward2, 'id' | 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesSimpleReadOnly' }
        & Pick<ComponentQuestionTypesSimpleReadOnly, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleMandarin' | 'titleSpanish' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentMandarin' | 'contentSpanish'>
        & { photo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      ) | (
        { __typename: 'ComponentQuestionTypesCompetency2' }
        & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
        & { questionscompetency2?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
          & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesCompetency' }
        & Pick<ComponentQuestionTypesCompetency, 'id' | 'title' | 'question' | 'minNumber' | 'maxNumber' | 'miniLabel' | 'maxiLabel' | 'simpleQuestion'>
      ) | (
        { __typename: 'ComponentQuestionTypesGravitasGap' }
        & Pick<ComponentQuestionTypesGravitasGap, 'id' | 'title' | 'question' | 'description' | 'color1' | 'color2' | 'color3'>
      ) | { __typename: 'ComponentQuestionTypesSliderQuestions' } | (
        { __typename: 'ComponentQuestionTypesGravitasSliders' }
        & Pick<ComponentQuestionTypesGravitasSliders, 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'positiveHeadingEnglish' | 'positiveHeadingFrench' | 'positiveHeadingSpanish' | 'positiveHeadingMandarin' | 'positiveHeadingGerman' | 'negativeHeadingEnglish' | 'negativeHeadingFrench' | 'negativeHeadingSpanish' | 'negativeHeadingMandarin' | 'negativeHeadingGerman'>
        & { sliderQuestions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionSliderQuestions' }
          & Pick<ComponentOptionSliderQuestions, 'questionPositiveEnglish' | 'questionPositiveGerman' | 'questionPositiveMandarin' | 'questionPositiveSpanish' | 'questionPositiveFrench' | 'questionNegativeEnglish' | 'questionNegativeGerman' | 'questionNegativeFrench' | 'questionNegativeMandarin' | 'questionNegativeSpanish'>
        )>>>, sliderHeadings?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionSliderHeadings' }
          & Pick<ComponentOptionSliderHeadings, 'headingEnglish' | 'headingSpanish' | 'headingGerman' | 'headingFrench' | 'headingMandarin' | 'color' | 'rating'>
        )>>> }
      )>>>, articles?: Maybe<Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>>, modal?: Maybe<(
        { __typename?: 'Modal' }
        & Pick<Modal, 'id' | 'title' | 'subtitle' | 'message'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url' | 'name'>
        )> }
      )>, events?: Maybe<Array<Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'name' | 'link' | 'sessionId'>
      )>>>, sub_modules?: Maybe<Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'id' | 'nameEnglish' | 'descriptionEnglish'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'id'>
        )> }
      )>>> }
    )>, programmeResponses?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsProgrammeSubmissions' }
      & Pick<ComponentSubmissionsProgrammeSubmissions, 'sliderAnswers'>
      & { answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'isSimpleQuestion' | 'response' | 'steps'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>> }
    )>>>, myNotes?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsNotes' }
      & Pick<ComponentSubmissionsNotes, 'id' | 'title' | 'description'>
      & { document?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>>, participants?: Maybe<Array<Maybe<(
      { __typename?: 'Participants' }
      & Pick<Participants, 'id' | 'name' | 'email' | 'type'>
    )>>>, submissionparticipants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, programme_report?: Maybe<(
      { __typename?: 'ProgrammeReport' }
      & Pick<ProgrammeReport, 'id' | 'name'>
      & { report?: Maybe<Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url' | 'name'>
      )>>> }
    )>, programme?: Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'isCustomJourney' | 'showTimeline' | 'programmeTitle'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )> }
  )>>> }
);

export type GetMySubModuleSubmissionsQueryVariables = {};


export type GetMySubModuleSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMySubModuleSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'id' | 'view' | 'progress' | 'status' | 'timeSpent'>
    & { feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'id'>
    )>, competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'id'>
    )>, competency_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsCompetencyParticipants' }
      & Pick<ComponentSubmissionsCompetencyParticipants, 'name' | 'email'>
    )>>>, participants?: Maybe<Array<Maybe<(
      { __typename?: 'Participants' }
      & Pick<Participants, 'id' | 'name' | 'email' | 'type'>
    )>>>, submissionparticipants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress' | 'sliderAnswers'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'steps' | 'response'>
      )>>>, uploadDocuments?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsUploadDocuments' }
        & { saboteurProofValue?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id'>
        )> }
      )>>> }
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin' | 'position' | 'archive'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'id' | 'title' | 'description' | 'position' | 'isCoaching' | 'isSubModule' | 'notes' | 'showArticle' | 'showSession' | 'showParticipants' | 'competencySurvey' | 'feedForwardSurvey' | 'deadline'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, articles?: Maybe<Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'id' | 'created_at' | 'updated_at' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentSpanish' | 'contentMandarin' | 'datePublished' | 'readTime' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'url'>
          )> }
        )>>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'id' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'id' | 'url' | 'name'>
          )> }
        )>, events?: Maybe<Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'id' | 'name' | 'link'>
        )>>> }
      )> }
    )>, reports?: Maybe<Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )>>> }
);

export type GetMySubmissionsQueryVariables = {};


export type GetMySubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMySubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'timeSpent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'id' | 'nameFrench' | 'nameGerman' | 'nameEnglish' | 'nameSpanish' | 'nameMandarin' | 'descriptionFrench' | 'descriptionGerman' | 'descriptionEnglish' | 'descriptionSpanish' | 'descriptionMandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, sections?: Maybe<Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'id' | 'titleFrench' | 'titleGerman' | 'titleEnglish' | 'titleSpanish' | 'titleMandarin' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleEnglish' | 'subTitleSpanish' | 'subTitleMandarin'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>>> }
    )>, reports?: Maybe<Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'sectionOrModuleId'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )>>> }
);

export type UserQueryVariables = {
  id: Scalars['ID'];
};


export type UserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'jobTitle' | 'confirmed' | 'blocked' | 'phoneNumber' | 'bookmarks' | 'modulesRead' | 'homePromptsRead' | 'programmePromptsRead' | 'modulePromptsRead' | 'articlesViewed' | 'feedForwardUrl'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name' | 'usersConfirmDetails'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, languageSelection?: Maybe<(
        { __typename?: 'ComponentTranslationsLanguageSelection' }
        & Pick<ComponentTranslationsLanguageSelection, 'id' | 'titleEnglish' | 'titleFrench' | 'titleSpanish' | 'titleGerman' | 'titleMandarin' | 'bodyEnglish' | 'bodyFrench' | 'bodySpanish' | 'bodyGerman' | 'bodyMandarin' | 'nextButtonEnglish' | 'nextButtonFrench' | 'nextButtonSpanish' | 'nextButtonGerman' | 'nextButtonMandarin'>
      )>, welcomeScreen?: Maybe<(
        { __typename?: 'ComponentTranslationsWelcomeScreen' }
        & Pick<ComponentTranslationsWelcomeScreen, 'id' | 'titleEnglish' | 'titleFrench' | 'titleSpanish' | 'titleGerman' | 'titleMandarin' | 'bodyEnglish' | 'bodyFrench' | 'bodySpanish' | 'bodyGerman' | 'bodyMandarin' | 'nextButtonEnglish' | 'nextButtonFrench' | 'nextButtonSpanish' | 'nextButtonGerman' | 'nextButtonMandarin'>
        & { videoEnglish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoFrench?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoSpanish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoGerman?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )>, videoMandarin?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>, letsGetStartedScreen?: Maybe<(
        { __typename?: 'ComponentTranslationsLetsGetStartedScreen' }
        & Pick<ComponentTranslationsLetsGetStartedScreen, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'firstNameLabelEnglish' | 'firstNameErrorEnglish' | 'lastNameLabelEnglish' | 'lastNameErrorEnglish' | 'jobTitleLabelEnglish' | 'jobTitleErrorEnglish' | 'divisionLabelEnglish' | 'divisionErrorEnglish' | 'timezoneLabelEnglish' | 'regionLabelEnglish' | 'regionErrorEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'subTitleFrench' | 'firstNameLabelFrench' | 'firstNameErrorFrench' | 'lastNameLabelFrench' | 'lastNameErrorFrench' | 'jobTitleLabelFrench' | 'jobTitleErrorFrench' | 'divisionLabelFrench' | 'divisionErrorFrench' | 'timezoneLabelFrench' | 'regionLabelFrench' | 'regionErrorFrench' | 'nextButtonFrench' | 'titleGerman' | 'subTitleGerman' | 'firstNameLabelGerman' | 'firstNameErrorGerman' | 'lastNameLabelGerman' | 'lastNameErrorGerman' | 'jobTitleLabelGerman' | 'jobTitleErrorGerman' | 'divisionLabelGerman' | 'divisionErrorGerman' | 'timezoneLabelGerman' | 'regionLabelGerman' | 'regionErrorGerman' | 'nextButtonGerman' | 'titleMandarin' | 'subTitleMandarin' | 'firstNameLabelMandarin' | 'firstNameErrorMandarin' | 'lastNameLabelMandarin' | 'lastNameErrorMandarin' | 'jobTitleLabelMandarin' | 'jobTitleErrorMandarin' | 'divisionLabelMandarin' | 'divisionErrorMandarin' | 'timezoneLabelMandarin' | 'regionLabelMandarin' | 'regionErrorMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'subTitleSpanish' | 'firstNameLabelSpanish' | 'firstNameErrorSpanish' | 'lastNameLabelSpanish' | 'lastNameErrorSpanish' | 'jobTitleLabelSpanish' | 'jobTitleErrorSpanish' | 'divisionLabelSpanish' | 'divisionErrorSpanish' | 'timezoneLabelSpanish' | 'regionLabelSpanish' | 'regionErrorSpanish' | 'nextButtonSpanish' | 'leftTitleEnglish' | 'leftSubtitleEnglish' | 'leftTitleSpanish' | 'leftSubtitleSpanish' | 'leftTitleMandarin' | 'leftSubTitleMandarin' | 'leftTitleFrench' | 'leftSubtitleFrench' | 'leftSubtitleGerman' | 'leftTitleGerman' | 'havingTroubleEnglish' | 'havingTroubleGerman' | 'havingTroubleFrench' | 'havingTroubleMandarin' | 'havingTroubleSpanish' | 'getHelpButtonEnglish' | 'getHelpButtonSpanish' | 'getHelpButtonFrench' | 'getHelpButtonGerman' | 'getHelpButtonMandarin'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )>, whatToExpect?: Maybe<(
        { __typename?: 'ComponentTranslationsWhatToExpect' }
        & Pick<ComponentTranslationsWhatToExpect, 'id' | 'titleEnglish' | 'bodyEnglish' | 'getStartedButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'getStartedButtonFrench' | 'titleGerman' | 'bodyGerman' | 'getStartedButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'getStartedButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'getStartedButtonSpanish'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'id' | 'url'>
        )> }
      )> }
    )>, division?: Maybe<(
      { __typename?: 'Division' }
      & Pick<Division, 'id'>
    )>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, profilePicture?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, role?: Maybe<(
      { __typename?: 'UsersPermissionsRole' }
      & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
    )>, certificate?: Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )>, programmes?: Maybe<Array<Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'name' | 'description' | 'start' | 'isCustomJourney' | 'position'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, programme_types?: Maybe<Array<Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'title'>
        & { sub_modules?: Maybe<Array<Maybe<(
          { __typename?: 'SubModule' }
          & { sections?: Maybe<Array<Maybe<(
            { __typename?: 'Section' }
            & Pick<Section, 'titleEnglish'>
          )>>> }
        )>>> }
      )>>> }
    )>>> }
  )> }
);

export type UsersQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<Array<Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'jobTitle' | 'confirmed' | 'blocked' | 'phoneNumber' | 'bookmarks' | 'modulesRead' | 'homePromptsRead' | 'programmePromptsRead' | 'modulePromptsRead' | 'articlesViewed'>
    & { division?: Maybe<(
      { __typename?: 'Division' }
      & Pick<Division, 'id'>
    )>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name'>
    )>, profilePicture?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, role?: Maybe<(
      { __typename?: 'UsersPermissionsRole' }
      & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
    )>, programmes?: Maybe<Array<Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'id' | 'name' | 'description' | 'start' | 'isCustomJourney' | 'position'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )>>> }
);

export const ModuleFragmentDoc = gql`
    fragment module on Module {
  id
  nameFrench
  nameGerman
  nameEnglish
  nameSpanish
  nameMandarin
  descriptionFrench
  descriptionGerman
  descriptionEnglish
  descriptionSpanish
  descriptionMandarin
  cover {
    id
    url
  }
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFile {
  id
  created_at
  updated_at
  name
  alternativeText
  caption
  width
  height
  formats
  hash
  ext
  mime
  size
  url
  previewUrl
  provider
}
    `;
export const QuestionsFragmentDoc = gql`
    fragment questions on SectionQuestionsDynamicZone {
  __typename
  ... on ComponentQuestionTypesSimpleQuestion {
    id
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    subTitleEnglish
    subTitleFrench
    subTitleGerman
    subTitleSpanish
    subTitleMandarin
    viewPrevious
  }
  ... on ComponentQuestionTypesCompetency2 {
    titleEnglish
    titleFrench
    titleMandarin
    questionscompetency2 {
      title
      question
      maxiNumber
      miniNumber
      simpleQuestion
      miniLabel
      maxiLabel
    }
  }
  ... on ComponentQuestionTypesXYGraph {
    id
    labelXEnglish
    labelYEnglish
    titleEnglish
    subTitleEnglish
    labelXFrench
    labelYFrench
    titleFrench
    subTitleFrench
    labelXGerman
    labelYGerman
    titleGerman
    subTitleGerman
    labelXSpanish
    labelYSpanish
    titleSpanish
    subTitleSpanish
    labelXMandarin
    labelYMandarin
    titleMandarin
    subTitleMandarin
  }
  ... on ComponentQuestionTypesMultipleChoice {
    id
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    viewPrevious
    option {
      id
      optionEnglish
      optionFrench
      optionGerman
      optionSpanish
      optionMandarin
      isCorrect
    }
    numberOfAnswers
  }
  ... on ComponentQuestionTypesFeedForward1 {
    id
    title
    question
    description
  }
  ... on ComponentQuestionTypesFeedForward2 {
    id
    title
    question
    description
  }
  ... on ComponentQuestionTypesSaboteur {
    id
    titleEnglish
    subTitleEnglish
    titleFrench
    subTitleFrench
    titleGerman
    subTitleGerman
    titleSpanish
    subTitleSpanish
    titleMandarin
    subTitleMandarin
    saboteurQuestions {
      link
      skipProof
      labelEnglish
      labelFrench
      labelGerman
      labelSpanish
      labelMandarin
      proof {
        ...uploadFile
      }
      labelFrench
      labelGerman
      labelSpanish
      labelMandarin
    }
  }
  ... on ComponentQuestionTypesNestedQuestions {
    id
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    viewPrevious
    questions {
      id
      titleEnglish
      subTitleEnglish
      titleFrench
      subTitleFrench
      titleGerman
      subTitleGerman
      titleSpanish
      subTitleSpanish
      titleMandarin
      subTitleMandarin
      isNumeric
    }
  }
  ... on ComponentQuestionTypesGravitasScale {
    id
    titleEnglish
    subTitleEnglish
    questionOneEnglish
    questionTwoEnglish
    questionThreeEnglish
    titleOneEnglish
    titleTwoEnglish
    ratingInput {
      id
      labelOneEnglish
      labelTwoEnglish
    }
  }
  ... on ComponentQuestionTypesStakeholderMap {
    id
    titleEnglish
    subTitleEnglish
    titleFrench
    subTitleFrench
    titleSpanish
    subTitleSpanish
    titleGerman
    subTitleGerman
    titleMandarin
    subTitleMandarin
    questionX
    questionY
  }
  ... on ComponentQuestionTypesSaboteurVideos {
    id
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    subTitleEnglish
    subTitleFrench
    subTitleGerman
    subTitleSpanish
    subTitleMandarin
    SaboteurVideo {
      id
      videoTitleEnglish
      videoTitleFrench
      videoTitleGerman
      videoTitleSpanish
      videoTitleMandarin
      video {
        ...uploadFile
      }
      videoDescriptionEnglish
      videoDescriptionFrench
      videoDescriptionGerman
      videoDescriptionSpanish
      videoDescriptionMandarin
    }
  }
}
    ${UploadFileFragmentDoc}`;
export const SectionFragmentDoc = gql`
    fragment section on Section {
  id
  titleFrench
  titleGerman
  titleEnglish
  titleSpanish
  titleMandarin
  subTitleFrench
  subTitleGerman
  subTitleEnglish
  subTitleSpanish
  subTitleMandarin
  cover {
    id
    url
  }
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment submission on Submission {
  id
  views
  progress
  status
  timeSpent
  language {
    id
    name
  }
}
    `;
export const AddDocumentDocument = gql`
    mutation addDocument($input: editUserUploadedDocumentInput!) {
  addDocument(input: $input) {
    name
  }
}
    `;
export type AddDocumentMutationFn = ApolloReactCommon.MutationFunction<AddDocumentMutation, AddDocumentMutationVariables>;
export type AddDocumentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddDocumentMutation, AddDocumentMutationVariables>, 'mutation'>;

    export const AddDocumentComponent = (props: AddDocumentComponentProps) => (
      <ApolloReactComponents.Mutation<AddDocumentMutation, AddDocumentMutationVariables> mutation={AddDocumentDocument} {...props} />
    );
    
export type AddDocumentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddDocumentMutation, AddDocumentMutationVariables>
    } & TChildProps;
export function withAddDocument<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddDocumentMutation,
  AddDocumentMutationVariables,
  AddDocumentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddDocumentMutation, AddDocumentMutationVariables, AddDocumentProps<TChildProps, TDataName>>(AddDocumentDocument, {
      alias: 'addDocument',
      ...operationOptions
    });
};

/**
 * __useAddDocumentMutation__
 *
 * To run a mutation, you first call `useAddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentMutation, { data, loading, error }] = useAddDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDocumentMutation, AddDocumentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddDocumentMutation, AddDocumentMutationVariables>(AddDocumentDocument, baseOptions);
      }
export type AddDocumentMutationHookResult = ReturnType<typeof useAddDocumentMutation>;
export type AddDocumentMutationResult = ApolloReactCommon.MutationResult<AddDocumentMutation>;
export type AddDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<AddDocumentMutation, AddDocumentMutationVariables>;
export const AddNoteDocument = gql`
    mutation addNote($input: editNoteInput!) {
  addNote(input: $input) {
    note
  }
}
    `;
export type AddNoteMutationFn = ApolloReactCommon.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;
export type AddNoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddNoteMutation, AddNoteMutationVariables>, 'mutation'>;

    export const AddNoteComponent = (props: AddNoteComponentProps) => (
      <ApolloReactComponents.Mutation<AddNoteMutation, AddNoteMutationVariables> mutation={AddNoteDocument} {...props} />
    );
    
export type AddNoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddNoteMutation, AddNoteMutationVariables>
    } & TChildProps;
export function withAddNote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddNoteMutation,
  AddNoteMutationVariables,
  AddNoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddNoteMutation, AddNoteMutationVariables, AddNoteProps<TChildProps, TDataName>>(AddNoteDocument, {
      alias: 'addNote',
      ...operationOptions
    });
};

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, baseOptions);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = ApolloReactCommon.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const CreateAccountChangeDocument = gql`
    mutation createAccountChange($input: createAccountChangeInput) {
  createAccountChange(input: $input) {
    accountChange {
      id
    }
  }
}
    `;
export type CreateAccountChangeMutationFn = ApolloReactCommon.MutationFunction<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>;
export type CreateAccountChangeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>, 'mutation'>;

    export const CreateAccountChangeComponent = (props: CreateAccountChangeComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAccountChangeMutation, CreateAccountChangeMutationVariables> mutation={CreateAccountChangeDocument} {...props} />
    );
    
export type CreateAccountChangeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>
    } & TChildProps;
export function withCreateAccountChange<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAccountChangeMutation,
  CreateAccountChangeMutationVariables,
  CreateAccountChangeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAccountChangeMutation, CreateAccountChangeMutationVariables, CreateAccountChangeProps<TChildProps, TDataName>>(CreateAccountChangeDocument, {
      alias: 'createAccountChange',
      ...operationOptions
    });
};

/**
 * __useCreateAccountChangeMutation__
 *
 * To run a mutation, you first call `useCreateAccountChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountChangeMutation, { data, loading, error }] = useCreateAccountChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>(CreateAccountChangeDocument, baseOptions);
      }
export type CreateAccountChangeMutationHookResult = ReturnType<typeof useCreateAccountChangeMutation>;
export type CreateAccountChangeMutationResult = ApolloReactCommon.MutationResult<CreateAccountChangeMutation>;
export type CreateAccountChangeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>;
export const CreateBookingDocument = gql`
    mutation createBooking($input: createBookingInput) {
  createBooking(input: $input) {
    booking {
      id
      title
    }
  }
}
    `;
export type CreateBookingMutationFn = ApolloReactCommon.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;
export type CreateBookingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBookingMutation, CreateBookingMutationVariables>, 'mutation'>;

    export const CreateBookingComponent = (props: CreateBookingComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBookingMutation, CreateBookingMutationVariables> mutation={CreateBookingDocument} {...props} />
    );
    
export type CreateBookingProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>
    } & TChildProps;
export function withCreateBooking<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBookingMutation,
  CreateBookingMutationVariables,
  CreateBookingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBookingMutation, CreateBookingMutationVariables, CreateBookingProps<TChildProps, TDataName>>(CreateBookingDocument, {
      alias: 'createBooking',
      ...operationOptions
    });
};

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, baseOptions);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = ApolloReactCommon.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const CreateProgrammeSubmissionDocument = gql`
    mutation createProgrammeSubmission($input: createProgrammeSubmissionInput) {
  createProgrammeSubmission(input: $input) {
    programmeSubmission {
      id
    }
  }
}
    `;
export type CreateProgrammeSubmissionMutationFn = ApolloReactCommon.MutationFunction<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>;
export type CreateProgrammeSubmissionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>, 'mutation'>;

    export const CreateProgrammeSubmissionComponent = (props: CreateProgrammeSubmissionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables> mutation={CreateProgrammeSubmissionDocument} {...props} />
    );
    
export type CreateProgrammeSubmissionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>
    } & TChildProps;
export function withCreateProgrammeSubmission<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateProgrammeSubmissionMutation,
  CreateProgrammeSubmissionMutationVariables,
  CreateProgrammeSubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables, CreateProgrammeSubmissionProps<TChildProps, TDataName>>(CreateProgrammeSubmissionDocument, {
      alias: 'createProgrammeSubmission',
      ...operationOptions
    });
};

/**
 * __useCreateProgrammeSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateProgrammeSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgrammeSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgrammeSubmissionMutation, { data, loading, error }] = useCreateProgrammeSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgrammeSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>(CreateProgrammeSubmissionDocument, baseOptions);
      }
export type CreateProgrammeSubmissionMutationHookResult = ReturnType<typeof useCreateProgrammeSubmissionMutation>;
export type CreateProgrammeSubmissionMutationResult = ApolloReactCommon.MutationResult<CreateProgrammeSubmissionMutation>;
export type CreateProgrammeSubmissionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>;
export const CreateSessionDocument = gql`
    mutation createSession($input: createCoachSessionInput) {
  createCoachSession(input: $input) {
    coachSession {
      title
    }
  }
}
    `;
export type CreateSessionMutationFn = ApolloReactCommon.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;
export type CreateSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSessionMutation, CreateSessionMutationVariables>, 'mutation'>;

    export const CreateSessionComponent = (props: CreateSessionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSessionMutation, CreateSessionMutationVariables> mutation={CreateSessionDocument} {...props} />
    );
    
export type CreateSessionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>
    } & TChildProps;
export function withCreateSession<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSessionMutation,
  CreateSessionMutationVariables,
  CreateSessionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSessionMutation, CreateSessionMutationVariables, CreateSessionProps<TChildProps, TDataName>>(CreateSessionDocument, {
      alias: 'createSession',
      ...operationOptions
    });
};

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, baseOptions);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = ApolloReactCommon.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const DeletedNoteDocument = gql`
    mutation deletedNote($id: ID!) {
  deletedNote(id: $id) {
    note
  }
}
    `;
export type DeletedNoteMutationFn = ApolloReactCommon.MutationFunction<DeletedNoteMutation, DeletedNoteMutationVariables>;
export type DeletedNoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeletedNoteMutation, DeletedNoteMutationVariables>, 'mutation'>;

    export const DeletedNoteComponent = (props: DeletedNoteComponentProps) => (
      <ApolloReactComponents.Mutation<DeletedNoteMutation, DeletedNoteMutationVariables> mutation={DeletedNoteDocument} {...props} />
    );
    
export type DeletedNoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeletedNoteMutation, DeletedNoteMutationVariables>
    } & TChildProps;
export function withDeletedNote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeletedNoteMutation,
  DeletedNoteMutationVariables,
  DeletedNoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeletedNoteMutation, DeletedNoteMutationVariables, DeletedNoteProps<TChildProps, TDataName>>(DeletedNoteDocument, {
      alias: 'deletedNote',
      ...operationOptions
    });
};

/**
 * __useDeletedNoteMutation__
 *
 * To run a mutation, you first call `useDeletedNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletedNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletedNoteMutation, { data, loading, error }] = useDeletedNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletedNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletedNoteMutation, DeletedNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletedNoteMutation, DeletedNoteMutationVariables>(DeletedNoteDocument, baseOptions);
      }
export type DeletedNoteMutationHookResult = ReturnType<typeof useDeletedNoteMutation>;
export type DeletedNoteMutationResult = ApolloReactCommon.MutationResult<DeletedNoteMutation>;
export type DeletedNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletedNoteMutation, DeletedNoteMutationVariables>;
export const GenerateCompetencyResponsesDocument = gql`
    mutation generateCompetencyResponses($id: ID!) {
  generateCompetencyResponses(id: $id) {
    success
  }
}
    `;
export type GenerateCompetencyResponsesMutationFn = ApolloReactCommon.MutationFunction<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>;
export type GenerateCompetencyResponsesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>, 'mutation'>;

    export const GenerateCompetencyResponsesComponent = (props: GenerateCompetencyResponsesComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables> mutation={GenerateCompetencyResponsesDocument} {...props} />
    );
    
export type GenerateCompetencyResponsesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>
    } & TChildProps;
export function withGenerateCompetencyResponses<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateCompetencyResponsesMutation,
  GenerateCompetencyResponsesMutationVariables,
  GenerateCompetencyResponsesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables, GenerateCompetencyResponsesProps<TChildProps, TDataName>>(GenerateCompetencyResponsesDocument, {
      alias: 'generateCompetencyResponses',
      ...operationOptions
    });
};

/**
 * __useGenerateCompetencyResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateCompetencyResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompetencyResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCompetencyResponsesMutation, { data, loading, error }] = useGenerateCompetencyResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateCompetencyResponsesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>(GenerateCompetencyResponsesDocument, baseOptions);
      }
export type GenerateCompetencyResponsesMutationHookResult = ReturnType<typeof useGenerateCompetencyResponsesMutation>;
export type GenerateCompetencyResponsesMutationResult = ApolloReactCommon.MutationResult<GenerateCompetencyResponsesMutation>;
export type GenerateCompetencyResponsesMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>;
export const GenerateMyMiniSectionSubmissionResponseDocument = gql`
    mutation generateMyMiniSectionSubmissionResponse($id: ID!, $sectionId: Int, $secId: Int) {
  generateMyMiniSectionSubmissionResponse(id: $id, sectionId: $sectionId, secId: $secId) {
    success
  }
}
    `;
export type GenerateMyMiniSectionSubmissionResponseMutationFn = ApolloReactCommon.MutationFunction<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>;
export type GenerateMyMiniSectionSubmissionResponseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>, 'mutation'>;

    export const GenerateMyMiniSectionSubmissionResponseComponent = (props: GenerateMyMiniSectionSubmissionResponseComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables> mutation={GenerateMyMiniSectionSubmissionResponseDocument} {...props} />
    );
    
export type GenerateMyMiniSectionSubmissionResponseProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>
    } & TChildProps;
export function withGenerateMyMiniSectionSubmissionResponse<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateMyMiniSectionSubmissionResponseMutation,
  GenerateMyMiniSectionSubmissionResponseMutationVariables,
  GenerateMyMiniSectionSubmissionResponseProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables, GenerateMyMiniSectionSubmissionResponseProps<TChildProps, TDataName>>(GenerateMyMiniSectionSubmissionResponseDocument, {
      alias: 'generateMyMiniSectionSubmissionResponse',
      ...operationOptions
    });
};

/**
 * __useGenerateMyMiniSectionSubmissionResponseMutation__
 *
 * To run a mutation, you first call `useGenerateMyMiniSectionSubmissionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyMiniSectionSubmissionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyMiniSectionSubmissionResponseMutation, { data, loading, error }] = useGenerateMyMiniSectionSubmissionResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *      secId: // value for 'secId'
 *   },
 * });
 */
export function useGenerateMyMiniSectionSubmissionResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>(GenerateMyMiniSectionSubmissionResponseDocument, baseOptions);
      }
export type GenerateMyMiniSectionSubmissionResponseMutationHookResult = ReturnType<typeof useGenerateMyMiniSectionSubmissionResponseMutation>;
export type GenerateMyMiniSectionSubmissionResponseMutationResult = ApolloReactCommon.MutationResult<GenerateMyMiniSectionSubmissionResponseMutation>;
export type GenerateMyMiniSectionSubmissionResponseMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>;
export const GenerateMyProgrammeSubmissionResponsesDocument = gql`
    mutation generateMyProgrammeSubmissionResponses($id: ID!) {
  generateMyProgrammeSubmissionResponses(id: $id) {
    success
  }
}
    `;
export type GenerateMyProgrammeSubmissionResponsesMutationFn = ApolloReactCommon.MutationFunction<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>;
export type GenerateMyProgrammeSubmissionResponsesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>, 'mutation'>;

    export const GenerateMyProgrammeSubmissionResponsesComponent = (props: GenerateMyProgrammeSubmissionResponsesComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables> mutation={GenerateMyProgrammeSubmissionResponsesDocument} {...props} />
    );
    
export type GenerateMyProgrammeSubmissionResponsesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>
    } & TChildProps;
export function withGenerateMyProgrammeSubmissionResponses<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateMyProgrammeSubmissionResponsesMutation,
  GenerateMyProgrammeSubmissionResponsesMutationVariables,
  GenerateMyProgrammeSubmissionResponsesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables, GenerateMyProgrammeSubmissionResponsesProps<TChildProps, TDataName>>(GenerateMyProgrammeSubmissionResponsesDocument, {
      alias: 'generateMyProgrammeSubmissionResponses',
      ...operationOptions
    });
};

/**
 * __useGenerateMyProgrammeSubmissionResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateMyProgrammeSubmissionResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyProgrammeSubmissionResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyProgrammeSubmissionResponsesMutation, { data, loading, error }] = useGenerateMyProgrammeSubmissionResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateMyProgrammeSubmissionResponsesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>(GenerateMyProgrammeSubmissionResponsesDocument, baseOptions);
      }
export type GenerateMyProgrammeSubmissionResponsesMutationHookResult = ReturnType<typeof useGenerateMyProgrammeSubmissionResponsesMutation>;
export type GenerateMyProgrammeSubmissionResponsesMutationResult = ApolloReactCommon.MutationResult<GenerateMyProgrammeSubmissionResponsesMutation>;
export type GenerateMyProgrammeSubmissionResponsesMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>;
export const GenerateMySubModuleSubmissionComptencyResponsesDocument = gql`
    mutation generateMySubModuleSubmissionComptencyResponses($id: ID!, $sectionId: Int) {
  generateMySubModuleSubmissionComptencyResponses(id: $id, sectionId: $sectionId) {
    success
  }
}
    `;
export type GenerateMySubModuleSubmissionComptencyResponsesMutationFn = ApolloReactCommon.MutationFunction<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>;
export type GenerateMySubModuleSubmissionComptencyResponsesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>, 'mutation'>;

    export const GenerateMySubModuleSubmissionComptencyResponsesComponent = (props: GenerateMySubModuleSubmissionComptencyResponsesComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables> mutation={GenerateMySubModuleSubmissionComptencyResponsesDocument} {...props} />
    );
    
export type GenerateMySubModuleSubmissionComptencyResponsesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>
    } & TChildProps;
export function withGenerateMySubModuleSubmissionComptencyResponses<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateMySubModuleSubmissionComptencyResponsesMutation,
  GenerateMySubModuleSubmissionComptencyResponsesMutationVariables,
  GenerateMySubModuleSubmissionComptencyResponsesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables, GenerateMySubModuleSubmissionComptencyResponsesProps<TChildProps, TDataName>>(GenerateMySubModuleSubmissionComptencyResponsesDocument, {
      alias: 'generateMySubModuleSubmissionComptencyResponses',
      ...operationOptions
    });
};

/**
 * __useGenerateMySubModuleSubmissionComptencyResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateMySubModuleSubmissionComptencyResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMySubModuleSubmissionComptencyResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMySubModuleSubmissionComptencyResponsesMutation, { data, loading, error }] = useGenerateMySubModuleSubmissionComptencyResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGenerateMySubModuleSubmissionComptencyResponsesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>(GenerateMySubModuleSubmissionComptencyResponsesDocument, baseOptions);
      }
export type GenerateMySubModuleSubmissionComptencyResponsesMutationHookResult = ReturnType<typeof useGenerateMySubModuleSubmissionComptencyResponsesMutation>;
export type GenerateMySubModuleSubmissionComptencyResponsesMutationResult = ApolloReactCommon.MutationResult<GenerateMySubModuleSubmissionComptencyResponsesMutation>;
export type GenerateMySubModuleSubmissionComptencyResponsesMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>;
export const GenerateMySubModuleSubmissionResponsesDocument = gql`
    mutation generateMySubModuleSubmissionResponses($id: ID!, $sectionId: Int) {
  generateMySubModuleSubmissionResponses(id: $id, sectionId: $sectionId) {
    success
  }
}
    `;
export type GenerateMySubModuleSubmissionResponsesMutationFn = ApolloReactCommon.MutationFunction<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>;
export type GenerateMySubModuleSubmissionResponsesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>, 'mutation'>;

    export const GenerateMySubModuleSubmissionResponsesComponent = (props: GenerateMySubModuleSubmissionResponsesComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables> mutation={GenerateMySubModuleSubmissionResponsesDocument} {...props} />
    );
    
export type GenerateMySubModuleSubmissionResponsesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>
    } & TChildProps;
export function withGenerateMySubModuleSubmissionResponses<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateMySubModuleSubmissionResponsesMutation,
  GenerateMySubModuleSubmissionResponsesMutationVariables,
  GenerateMySubModuleSubmissionResponsesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables, GenerateMySubModuleSubmissionResponsesProps<TChildProps, TDataName>>(GenerateMySubModuleSubmissionResponsesDocument, {
      alias: 'generateMySubModuleSubmissionResponses',
      ...operationOptions
    });
};

/**
 * __useGenerateMySubModuleSubmissionResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateMySubModuleSubmissionResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMySubModuleSubmissionResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMySubModuleSubmissionResponsesMutation, { data, loading, error }] = useGenerateMySubModuleSubmissionResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGenerateMySubModuleSubmissionResponsesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>(GenerateMySubModuleSubmissionResponsesDocument, baseOptions);
      }
export type GenerateMySubModuleSubmissionResponsesMutationHookResult = ReturnType<typeof useGenerateMySubModuleSubmissionResponsesMutation>;
export type GenerateMySubModuleSubmissionResponsesMutationResult = ApolloReactCommon.MutationResult<GenerateMySubModuleSubmissionResponsesMutation>;
export type GenerateMySubModuleSubmissionResponsesMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>;
export const ResendMailDocument = gql`
    mutation resendMail($id: ID!, $name: String, $email: String) {
  resendMail(id: $id, name: $name, email: $email) {
    success
  }
}
    `;
export type ResendMailMutationFn = ApolloReactCommon.MutationFunction<ResendMailMutation, ResendMailMutationVariables>;
export type ResendMailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResendMailMutation, ResendMailMutationVariables>, 'mutation'>;

    export const ResendMailComponent = (props: ResendMailComponentProps) => (
      <ApolloReactComponents.Mutation<ResendMailMutation, ResendMailMutationVariables> mutation={ResendMailDocument} {...props} />
    );
    
export type ResendMailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResendMailMutation, ResendMailMutationVariables>
    } & TChildProps;
export function withResendMail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResendMailMutation,
  ResendMailMutationVariables,
  ResendMailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResendMailMutation, ResendMailMutationVariables, ResendMailProps<TChildProps, TDataName>>(ResendMailDocument, {
      alias: 'resendMail',
      ...operationOptions
    });
};

/**
 * __useResendMailMutation__
 *
 * To run a mutation, you first call `useResendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMailMutation, { data, loading, error }] = useResendMailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendMailMutation, ResendMailMutationVariables>) {
        return ApolloReactHooks.useMutation<ResendMailMutation, ResendMailMutationVariables>(ResendMailDocument, baseOptions);
      }
export type ResendMailMutationHookResult = ReturnType<typeof useResendMailMutation>;
export type ResendMailMutationResult = ApolloReactCommon.MutationResult<ResendMailMutation>;
export type ResendMailMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendMailMutation, ResendMailMutationVariables>;
export const ResendProgrammeMailDocument = gql`
    mutation resendProgrammeMail($id: ID!, $name: String, $email: String) {
  resendProgrammeMail(id: $id, name: $name, email: $email) {
    successed
  }
}
    `;
export type ResendProgrammeMailMutationFn = ApolloReactCommon.MutationFunction<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>;
export type ResendProgrammeMailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>, 'mutation'>;

    export const ResendProgrammeMailComponent = (props: ResendProgrammeMailComponentProps) => (
      <ApolloReactComponents.Mutation<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables> mutation={ResendProgrammeMailDocument} {...props} />
    );
    
export type ResendProgrammeMailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>
    } & TChildProps;
export function withResendProgrammeMail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResendProgrammeMailMutation,
  ResendProgrammeMailMutationVariables,
  ResendProgrammeMailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables, ResendProgrammeMailProps<TChildProps, TDataName>>(ResendProgrammeMailDocument, {
      alias: 'resendProgrammeMail',
      ...operationOptions
    });
};

/**
 * __useResendProgrammeMailMutation__
 *
 * To run a mutation, you first call `useResendProgrammeMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendProgrammeMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendProgrammeMailMutation, { data, loading, error }] = useResendProgrammeMailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendProgrammeMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>) {
        return ApolloReactHooks.useMutation<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>(ResendProgrammeMailDocument, baseOptions);
      }
export type ResendProgrammeMailMutationHookResult = ReturnType<typeof useResendProgrammeMailMutation>;
export type ResendProgrammeMailMutationResult = ApolloReactCommon.MutationResult<ResendProgrammeMailMutation>;
export type ResendProgrammeMailMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>;
export const UpdateMySubModuleSubmissionDocument = gql`
    mutation updateMySubModuleSubmission($id: ID!, $currentSection: Int, $isPdf: Boolean, $name: String, $programmeSubmissionId: ID, $input: editSubModuleSubmissionInput!) {
  updateMySubModuleSubmission(id: $id, isPdf: $isPdf, name: $name, currentSection: $currentSection, programmeSubmissionId: $programmeSubmissionId, input: $input) {
    id
    view
    progress
    status
    timeSpent
    language {
      id
      name
    }
    participants {
      id
      name
      email
      type
    }
    submissionparticipants {
      id
      name
      email
    }
    sub_module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      cover {
        id
        url
      }
      programme_type {
        id
      }
    }
    section {
      id
      progress
      section {
        id
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
      }
    }
  }
}
    `;
export type UpdateMySubModuleSubmissionMutationFn = ApolloReactCommon.MutationFunction<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>;
export type UpdateMySubModuleSubmissionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>, 'mutation'>;

    export const UpdateMySubModuleSubmissionComponent = (props: UpdateMySubModuleSubmissionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables> mutation={UpdateMySubModuleSubmissionDocument} {...props} />
    );
    
export type UpdateMySubModuleSubmissionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>
    } & TChildProps;
export function withUpdateMySubModuleSubmission<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMySubModuleSubmissionMutation,
  UpdateMySubModuleSubmissionMutationVariables,
  UpdateMySubModuleSubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables, UpdateMySubModuleSubmissionProps<TChildProps, TDataName>>(UpdateMySubModuleSubmissionDocument, {
      alias: 'updateMySubModuleSubmission',
      ...operationOptions
    });
};

/**
 * __useUpdateMySubModuleSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMySubModuleSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySubModuleSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySubModuleSubmissionMutation, { data, loading, error }] = useUpdateMySubModuleSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentSection: // value for 'currentSection'
 *      isPdf: // value for 'isPdf'
 *      name: // value for 'name'
 *      programmeSubmissionId: // value for 'programmeSubmissionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMySubModuleSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>(UpdateMySubModuleSubmissionDocument, baseOptions);
      }
export type UpdateMySubModuleSubmissionMutationHookResult = ReturnType<typeof useUpdateMySubModuleSubmissionMutation>;
export type UpdateMySubModuleSubmissionMutationResult = ApolloReactCommon.MutationResult<UpdateMySubModuleSubmissionMutation>;
export type UpdateMySubModuleSubmissionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($id: ID!, $input: editNotificationInput) {
  updateNotification(input: {where: {id: $id}, data: $input}) {
    notification {
      id
      title
      timeStamp
      path
      read
    }
  }
}
    `;
export type UpdateNotificationMutationFn = ApolloReactCommon.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export type UpdateNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>, 'mutation'>;

    export const UpdateNotificationComponent = (props: UpdateNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateNotificationMutation, UpdateNotificationMutationVariables> mutation={UpdateNotificationDocument} {...props} />
    );
    
export type UpdateNotificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>
    } & TChildProps;
export function withUpdateNotification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables,
  UpdateNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateNotificationMutation, UpdateNotificationMutationVariables, UpdateNotificationProps<TChildProps, TDataName>>(UpdateNotificationDocument, {
      alias: 'updateNotification',
      ...operationOptions
    });
};

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, baseOptions);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = ApolloReactCommon.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const UpdateMyProgrammeSubmissionDocument = gql`
    mutation updateMyProgrammeSubmission($id: ID!, $input: editProgrammeSubmissionInput!, $isPdf: Boolean, $name: String) {
  updateMyProgrammeSubmissions(id: $id, isPdf: $isPdf, name: $name, input: $input) {
    id
    status
    progress
    programme_type {
      id
      title
      description
      cover {
        id
        url
      }
      isCoaching
      notes
      deadline
      programmeQuestions {
        __typename
        ... on ComponentQuestionTypesValuesNested {
          id
          title
          question
          questions {
            id
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
          }
        }
      }
      articles {
        id
        created_at
        updated_at
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        contentEnglish
        contentFrench
        contentGerman
        contentSpanish
        contentMandarin
        image {
          url
        }
        datePublished
        readTime
        link
      }
      sub_modules {
        id
        nameEnglish
        descriptionEnglish
        cover {
          id
          url
        }
        programme_type {
          id
        }
      }
      archive
    }
    programmeResponses {
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      saboteur {
        id
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
    }
    myNotes {
      id
      title
      description
      document {
        id
        url
      }
    }
    selected
  }
}
    `;
export type UpdateMyProgrammeSubmissionMutationFn = ApolloReactCommon.MutationFunction<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>;
export type UpdateMyProgrammeSubmissionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>, 'mutation'>;

    export const UpdateMyProgrammeSubmissionComponent = (props: UpdateMyProgrammeSubmissionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables> mutation={UpdateMyProgrammeSubmissionDocument} {...props} />
    );
    
export type UpdateMyProgrammeSubmissionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>
    } & TChildProps;
export function withUpdateMyProgrammeSubmission<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMyProgrammeSubmissionMutation,
  UpdateMyProgrammeSubmissionMutationVariables,
  UpdateMyProgrammeSubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables, UpdateMyProgrammeSubmissionProps<TChildProps, TDataName>>(UpdateMyProgrammeSubmissionDocument, {
      alias: 'updateMyProgrammeSubmission',
      ...operationOptions
    });
};

/**
 * __useUpdateMyProgrammeSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMyProgrammeSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProgrammeSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProgrammeSubmissionMutation, { data, loading, error }] = useUpdateMyProgrammeSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      isPdf: // value for 'isPdf'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMyProgrammeSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>(UpdateMyProgrammeSubmissionDocument, baseOptions);
      }
export type UpdateMyProgrammeSubmissionMutationHookResult = ReturnType<typeof useUpdateMyProgrammeSubmissionMutation>;
export type UpdateMyProgrammeSubmissionMutationResult = ApolloReactCommon.MutationResult<UpdateMyProgrammeSubmissionMutation>;
export type UpdateMyProgrammeSubmissionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation updateSession($id: ID!, $input: editCoachSessionInput) {
  updateCoachSession(input: {where: {id: $id}, data: $input}) {
    coachSession {
      id
      title
      status
      user {
        id
      }
    }
  }
}
    `;
export type UpdateSessionMutationFn = ApolloReactCommon.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;
export type UpdateSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSessionMutation, UpdateSessionMutationVariables>, 'mutation'>;

    export const UpdateSessionComponent = (props: UpdateSessionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSessionMutation, UpdateSessionMutationVariables> mutation={UpdateSessionDocument} {...props} />
    );
    
export type UpdateSessionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>
    } & TChildProps;
export function withUpdateSession<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSessionMutation,
  UpdateSessionMutationVariables,
  UpdateSessionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSessionMutation, UpdateSessionMutationVariables, UpdateSessionProps<TChildProps, TDataName>>(UpdateSessionDocument, {
      alias: 'updateSession',
      ...operationOptions
    });
};

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, baseOptions);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = ApolloReactCommon.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const UpdateMySubmissionDocument = gql`
    mutation updateMySubmission($id: ID!, $currentSection: Int, $programmeSubmissionId: ID, $input: editSubmissionInput!) {
  updateMySubmission(id: $id, currentSection: $currentSection, programmeSubmissionId: $programmeSubmissionId, input: $input) {
    id
    views
    progress
    status
    timeSpent
    language {
      id
      name
    }
    module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
    }
    section {
      id
      progress
      section {
        id
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
      }
    }
  }
}
    `;
export type UpdateMySubmissionMutationFn = ApolloReactCommon.MutationFunction<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>;
export type UpdateMySubmissionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>, 'mutation'>;

    export const UpdateMySubmissionComponent = (props: UpdateMySubmissionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables> mutation={UpdateMySubmissionDocument} {...props} />
    );
    
export type UpdateMySubmissionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>
    } & TChildProps;
export function withUpdateMySubmission<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMySubmissionMutation,
  UpdateMySubmissionMutationVariables,
  UpdateMySubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables, UpdateMySubmissionProps<TChildProps, TDataName>>(UpdateMySubmissionDocument, {
      alias: 'updateMySubmission',
      ...operationOptions
    });
};

/**
 * __useUpdateMySubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMySubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySubmissionMutation, { data, loading, error }] = useUpdateMySubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentSection: // value for 'currentSection'
 *      programmeSubmissionId: // value for 'programmeSubmissionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMySubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>(UpdateMySubmissionDocument, baseOptions);
      }
export type UpdateMySubmissionMutationHookResult = ReturnType<typeof useUpdateMySubmissionMutation>;
export type UpdateMySubmissionMutationResult = ApolloReactCommon.MutationResult<UpdateMySubmissionMutation>;
export type UpdateMySubmissionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>;
export const UpdateSelfDocument = gql`
    mutation updateSelf($input: editUserInput!) {
  updateSelf(user: $input) {
    id
    created_at
    updated_at
    email
    confirmed
    blocked
    phoneNumber
    onboarding
    profilePicture {
      id
      url
    }
    language {
      id
      name
    }
    firstName
    lastName
    jobTitle
    division {
      id
      titleFrench
      titleGerman
      titleEnglish
      titleMandarin
      titleSpanish
    }
    modulesRead
    homePromptsRead
    programmePromptsRead
    modulePromptsRead
    bookmarks
    articlesViewed
    report {
      id
      url
    }
    company {
      id
      name
      logo {
        id
        url
      }
      languageSelection {
        id
        titleEnglish
        bodyEnglish
        nextButtonEnglish
        titleFrench
        bodyFrench
        nextButtonFrench
        titleGerman
        bodyGerman
        nextButtonGerman
        titleMandarin
        bodyMandarin
        nextButtonMandarin
        titleSpanish
        bodySpanish
        nextButtonSpanish
      }
      welcomeScreen {
        id
        titleEnglish
        bodyEnglish
        videoEnglish {
          id
          url
        }
        nextButtonEnglish
        titleFrench
        bodyFrench
        videoFrench {
          id
          url
        }
        nextButtonFrench
        titleGerman
        bodyGerman
        videoGerman {
          id
          url
        }
        nextButtonGerman
        titleMandarin
        bodyMandarin
        videoMandarin {
          id
          url
        }
        nextButtonMandarin
        titleSpanish
        bodySpanish
        videoSpanish {
          id
          url
        }
        nextButtonSpanish
      }
      letsGetStartedScreen {
        id
        titleEnglish
        subTitleEnglish
        firstNameLabelEnglish
        firstNameErrorEnglish
        lastNameLabelEnglish
        lastNameErrorEnglish
        jobTitleLabelEnglish
        jobTitleErrorEnglish
        divisionLabelEnglish
        divisionErrorEnglish
        timezoneLabelEnglish
        regionLabelEnglish
        regionErrorEnglish
        image {
          id
          url
        }
        nextButtonEnglish
        titleFrench
        subTitleFrench
        firstNameLabelFrench
        firstNameErrorFrench
        lastNameLabelFrench
        lastNameErrorFrench
        jobTitleLabelFrench
        jobTitleErrorFrench
        divisionLabelFrench
        divisionErrorFrench
        timezoneLabelFrench
        regionLabelFrench
        regionErrorFrench
        nextButtonFrench
        titleGerman
        subTitleGerman
        firstNameLabelGerman
        firstNameErrorGerman
        lastNameLabelGerman
        lastNameErrorGerman
        jobTitleLabelGerman
        jobTitleErrorGerman
        divisionLabelGerman
        divisionErrorGerman
        timezoneLabelGerman
        regionLabelGerman
        regionErrorGerman
        nextButtonGerman
        titleMandarin
        subTitleMandarin
        firstNameLabelMandarin
        firstNameErrorMandarin
        lastNameLabelMandarin
        lastNameErrorMandarin
        jobTitleLabelMandarin
        jobTitleErrorMandarin
        divisionLabelMandarin
        divisionErrorMandarin
        timezoneLabelMandarin
        regionLabelMandarin
        regionErrorMandarin
        nextButtonMandarin
        titleSpanish
        subTitleSpanish
        firstNameLabelSpanish
        firstNameErrorSpanish
        lastNameLabelSpanish
        lastNameErrorSpanish
        jobTitleLabelSpanish
        jobTitleErrorSpanish
        divisionLabelSpanish
        divisionErrorSpanish
        timezoneLabelSpanish
        regionLabelSpanish
        regionErrorSpanish
        nextButtonSpanish
        leftTitleEnglish
        leftSubtitleEnglish
        leftTitleSpanish
        leftSubtitleSpanish
        leftTitleMandarin
        leftSubTitleMandarin
        leftTitleFrench
        leftSubtitleFrench
        leftSubtitleGerman
        leftTitleGerman
      }
      whatToExpect {
        id
        titleEnglish
        bodyEnglish
        image {
          id
          url
        }
        getStartedButtonEnglish
        titleFrench
        bodyFrench
        getStartedButtonFrench
        titleGerman
        bodyGerman
        getStartedButtonGerman
        titleMandarin
        bodyMandarin
        getStartedButtonMandarin
        titleSpanish
        bodySpanish
        getStartedButtonSpanish
      }
      aboutUs {
        id
        textEnglish
        textFrench
        textGerman
        userGuidelinesTextEnglish
        userGuidelinesTextGerman
        userGuidelinesTextFrench
        userGuidelinesEnglish {
          id
          url
        }
        userGuidelinesGerman {
          id
          url
        }
        userGuidelinesFrench {
          id
          url
        }
      }
      programmesTitle
      programmesSubTitle
      usersConfirmDetails
    }
    submissions {
      id
    }
    programmes {
      id
      name
      description
      start
      isCustomJourney
      position
      logo {
        id
        url
      }
    }
    updatedDetails
    region {
      id
      nameEnglish
      nameFrench
      nameGerman
      nameSpanish
      nameMandarin
    }
    timezone {
      abbrev
      altName
      label
      value
    }
  }
}
    `;
export type UpdateSelfMutationFn = ApolloReactCommon.MutationFunction<UpdateSelfMutation, UpdateSelfMutationVariables>;
export type UpdateSelfComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSelfMutation, UpdateSelfMutationVariables>, 'mutation'>;

    export const UpdateSelfComponent = (props: UpdateSelfComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSelfMutation, UpdateSelfMutationVariables> mutation={UpdateSelfDocument} {...props} />
    );
    
export type UpdateSelfProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSelfMutation, UpdateSelfMutationVariables>
    } & TChildProps;
export function withUpdateSelf<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSelfMutation,
  UpdateSelfMutationVariables,
  UpdateSelfProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSelfMutation, UpdateSelfMutationVariables, UpdateSelfProps<TChildProps, TDataName>>(UpdateSelfDocument, {
      alias: 'updateSelf',
      ...operationOptions
    });
};

/**
 * __useUpdateSelfMutation__
 *
 * To run a mutation, you first call `useUpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelfMutation, { data, loading, error }] = useUpdateSelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSelfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSelfMutation, UpdateSelfMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSelfMutation, UpdateSelfMutationVariables>(UpdateSelfDocument, baseOptions);
      }
export type UpdateSelfMutationHookResult = ReturnType<typeof useUpdateSelfMutation>;
export type UpdateSelfMutationResult = ApolloReactCommon.MutationResult<UpdateSelfMutation>;
export type UpdateSelfMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSelfMutation, UpdateSelfMutationVariables>;
export const CheckResponsesFromTypeFormDocument = gql`
    query checkResponsesFromTypeForm($id: ID!, $sectionid: Int) {
  checkResponsesFromTypeForm(id: $id, sectionid: $sectionid) {
    emails
  }
}
    `;
export type CheckResponsesFromTypeFormComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>, 'query'> & ({ variables: CheckResponsesFromTypeFormQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CheckResponsesFromTypeFormComponent = (props: CheckResponsesFromTypeFormComponentProps) => (
      <ApolloReactComponents.Query<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables> query={CheckResponsesFromTypeFormDocument} {...props} />
    );
    
export type CheckResponsesFromTypeFormProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>
    } & TChildProps;
export function withCheckResponsesFromTypeForm<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CheckResponsesFromTypeFormQuery,
  CheckResponsesFromTypeFormQueryVariables,
  CheckResponsesFromTypeFormProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables, CheckResponsesFromTypeFormProps<TChildProps, TDataName>>(CheckResponsesFromTypeFormDocument, {
      alias: 'checkResponsesFromTypeForm',
      ...operationOptions
    });
};

/**
 * __useCheckResponsesFromTypeFormQuery__
 *
 * To run a query within a React component, call `useCheckResponsesFromTypeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckResponsesFromTypeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckResponsesFromTypeFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sectionid: // value for 'sectionid'
 *   },
 * });
 */
export function useCheckResponsesFromTypeFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>(CheckResponsesFromTypeFormDocument, baseOptions);
      }
export function useCheckResponsesFromTypeFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>(CheckResponsesFromTypeFormDocument, baseOptions);
        }
export type CheckResponsesFromTypeFormQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormQuery>;
export type CheckResponsesFromTypeFormLazyQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormLazyQuery>;
export type CheckResponsesFromTypeFormQueryResult = ApolloReactCommon.QueryResult<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>;
export const CheckResponsesFromTypeFormProgrammeDocument = gql`
    query checkResponsesFromTypeFormProgramme($id: ID!, $sectionid: Int) {
  checkResponsesFromTypeFormProgramme(id: $id, sectionid: $sectionid) {
    emails
  }
}
    `;
export type CheckResponsesFromTypeFormProgrammeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>, 'query'> & ({ variables: CheckResponsesFromTypeFormProgrammeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CheckResponsesFromTypeFormProgrammeComponent = (props: CheckResponsesFromTypeFormProgrammeComponentProps) => (
      <ApolloReactComponents.Query<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables> query={CheckResponsesFromTypeFormProgrammeDocument} {...props} />
    );
    
export type CheckResponsesFromTypeFormProgrammeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>
    } & TChildProps;
export function withCheckResponsesFromTypeFormProgramme<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CheckResponsesFromTypeFormProgrammeQuery,
  CheckResponsesFromTypeFormProgrammeQueryVariables,
  CheckResponsesFromTypeFormProgrammeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables, CheckResponsesFromTypeFormProgrammeProps<TChildProps, TDataName>>(CheckResponsesFromTypeFormProgrammeDocument, {
      alias: 'checkResponsesFromTypeFormProgramme',
      ...operationOptions
    });
};

/**
 * __useCheckResponsesFromTypeFormProgrammeQuery__
 *
 * To run a query within a React component, call `useCheckResponsesFromTypeFormProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckResponsesFromTypeFormProgrammeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckResponsesFromTypeFormProgrammeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sectionid: // value for 'sectionid'
 *   },
 * });
 */
export function useCheckResponsesFromTypeFormProgrammeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>(CheckResponsesFromTypeFormProgrammeDocument, baseOptions);
      }
export function useCheckResponsesFromTypeFormProgrammeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>(CheckResponsesFromTypeFormProgrammeDocument, baseOptions);
        }
export type CheckResponsesFromTypeFormProgrammeQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormProgrammeQuery>;
export type CheckResponsesFromTypeFormProgrammeLazyQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormProgrammeLazyQuery>;
export type CheckResponsesFromTypeFormProgrammeQueryResult = ApolloReactCommon.QueryResult<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>;
export const ConfirmMyAppointmentsDocument = gql`
    mutation confirmMyAppointments($appointmentScheduleId: ID!, $programmeSubmissionId: ID!, $subModule: Boolean!) {
  confirmMyAppointments(appointmentScheduleId: $appointmentScheduleId, programmeSubmissionId: $programmeSubmissionId, subModule: $subModule) {
    success
    message
  }
}
    `;
export type ConfirmMyAppointmentsMutationFn = ApolloReactCommon.MutationFunction<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>;
export type ConfirmMyAppointmentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>, 'mutation'>;

    export const ConfirmMyAppointmentsComponent = (props: ConfirmMyAppointmentsComponentProps) => (
      <ApolloReactComponents.Mutation<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables> mutation={ConfirmMyAppointmentsDocument} {...props} />
    );
    
export type ConfirmMyAppointmentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>
    } & TChildProps;
export function withConfirmMyAppointments<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ConfirmMyAppointmentsMutation,
  ConfirmMyAppointmentsMutationVariables,
  ConfirmMyAppointmentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables, ConfirmMyAppointmentsProps<TChildProps, TDataName>>(ConfirmMyAppointmentsDocument, {
      alias: 'confirmMyAppointments',
      ...operationOptions
    });
};

/**
 * __useConfirmMyAppointmentsMutation__
 *
 * To run a mutation, you first call `useConfirmMyAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMyAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMyAppointmentsMutation, { data, loading, error }] = useConfirmMyAppointmentsMutation({
 *   variables: {
 *      appointmentScheduleId: // value for 'appointmentScheduleId'
 *      programmeSubmissionId: // value for 'programmeSubmissionId'
 *      subModule: // value for 'subModule'
 *   },
 * });
 */
export function useConfirmMyAppointmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>) {
        return ApolloReactHooks.useMutation<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>(ConfirmMyAppointmentsDocument, baseOptions);
      }
export type ConfirmMyAppointmentsMutationHookResult = ReturnType<typeof useConfirmMyAppointmentsMutation>;
export type ConfirmMyAppointmentsMutationResult = ApolloReactCommon.MutationResult<ConfirmMyAppointmentsMutation>;
export type ConfirmMyAppointmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>;
export const GetAllsectionReportDocument = gql`
    query getAllsectionReport($id: ID!) {
  getAllsectionReport(id: $id) {
    id
    name
    type
    report {
      id
      url
    }
    sectionOrModuleId
  }
}
    `;
export type GetAllsectionReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>, 'query'> & ({ variables: GetAllsectionReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAllsectionReportComponent = (props: GetAllsectionReportComponentProps) => (
      <ApolloReactComponents.Query<GetAllsectionReportQuery, GetAllsectionReportQueryVariables> query={GetAllsectionReportDocument} {...props} />
    );
    
export type GetAllsectionReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>
    } & TChildProps;
export function withGetAllsectionReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllsectionReportQuery,
  GetAllsectionReportQueryVariables,
  GetAllsectionReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllsectionReportQuery, GetAllsectionReportQueryVariables, GetAllsectionReportProps<TChildProps, TDataName>>(GetAllsectionReportDocument, {
      alias: 'getAllsectionReport',
      ...operationOptions
    });
};

/**
 * __useGetAllsectionReportQuery__
 *
 * To run a query within a React component, call `useGetAllsectionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllsectionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllsectionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllsectionReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>(GetAllsectionReportDocument, baseOptions);
      }
export function useGetAllsectionReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>(GetAllsectionReportDocument, baseOptions);
        }
export type GetAllsectionReportQueryHookResult = ReturnType<typeof useGetAllsectionReportQuery>;
export type GetAllsectionReportLazyQueryHookResult = ReturnType<typeof useGetAllsectionReportLazyQuery>;
export type GetAllsectionReportQueryResult = ApolloReactCommon.QueryResult<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>;
export const GetArticlesDocument = gql`
    query getArticles($where: JSON, $start: Int, $limit: Int!) {
  articles(where: $where, start: $start, limit: $limit) {
    id
    created_at
    updated_at
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    contentEnglish
    contentFrench
    contentGerman
    contentSpanish
    contentMandarin
    position
    companies {
      id
    }
    programmes {
      id
    }
    image {
      url
    }
    datePublished
    readTime
    link
  }
}
    `;
export type GetArticlesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetArticlesQuery, GetArticlesQueryVariables>, 'query'> & ({ variables: GetArticlesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetArticlesComponent = (props: GetArticlesComponentProps) => (
      <ApolloReactComponents.Query<GetArticlesQuery, GetArticlesQueryVariables> query={GetArticlesDocument} {...props} />
    );
    
export type GetArticlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetArticlesQuery, GetArticlesQueryVariables>
    } & TChildProps;
export function withGetArticles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetArticlesQuery,
  GetArticlesQueryVariables,
  GetArticlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetArticlesQuery, GetArticlesQueryVariables, GetArticlesProps<TChildProps, TDataName>>(GetArticlesDocument, {
      alias: 'getArticles',
      ...operationOptions
    });
};

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, baseOptions);
      }
export function useGetArticlesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, baseOptions);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesQueryResult = ApolloReactCommon.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export const GetCoachSubmittedReportsDocument = gql`
    query getCoachSubmittedReports($where: JSON!, $sort: String!, $limit: Int!) {
  coachSubmittedReports(where: $where, sort: $sort, limit: $limit) {
    id
    name
    notesId {
      name
      saboteurProofValue {
        id
        url
      }
    }
  }
}
    `;
export type GetCoachSubmittedReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>, 'query'> & ({ variables: GetCoachSubmittedReportsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCoachSubmittedReportsComponent = (props: GetCoachSubmittedReportsComponentProps) => (
      <ApolloReactComponents.Query<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables> query={GetCoachSubmittedReportsDocument} {...props} />
    );
    
export type GetCoachSubmittedReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>
    } & TChildProps;
export function withGetCoachSubmittedReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCoachSubmittedReportsQuery,
  GetCoachSubmittedReportsQueryVariables,
  GetCoachSubmittedReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables, GetCoachSubmittedReportsProps<TChildProps, TDataName>>(GetCoachSubmittedReportsDocument, {
      alias: 'getCoachSubmittedReports',
      ...operationOptions
    });
};

/**
 * __useGetCoachSubmittedReportsQuery__
 *
 * To run a query within a React component, call `useGetCoachSubmittedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSubmittedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSubmittedReportsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachSubmittedReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>(GetCoachSubmittedReportsDocument, baseOptions);
      }
export function useGetCoachSubmittedReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>(GetCoachSubmittedReportsDocument, baseOptions);
        }
export type GetCoachSubmittedReportsQueryHookResult = ReturnType<typeof useGetCoachSubmittedReportsQuery>;
export type GetCoachSubmittedReportsLazyQueryHookResult = ReturnType<typeof useGetCoachSubmittedReportsLazyQuery>;
export type GetCoachSubmittedReportsQueryResult = ApolloReactCommon.QueryResult<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  company(id: $id) {
    programmes {
      id
      name
      description
      start
      programme_types {
        id
        programme_submissions {
          id
          user {
            id
          }
          programme {
            id
            isCustomJourney
            showTimeline
            logo {
              id
              url
            }
          }
        }
      }
      isCustomJourney
      showTimeline
      position
    }
  }
}
    `;
export type GetCompanyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCompanyQuery, GetCompanyQueryVariables>, 'query'> & ({ variables: GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCompanyComponent = (props: GetCompanyComponentProps) => (
      <ApolloReactComponents.Query<GetCompanyQuery, GetCompanyQueryVariables> query={GetCompanyDocument} {...props} />
    );
    
export type GetCompanyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanyQuery, GetCompanyQueryVariables>
    } & TChildProps;
export function withGetCompany<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanyQuery,
  GetCompanyQueryVariables,
  GetCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanyQuery, GetCompanyQueryVariables, GetCompanyProps<TChildProps, TDataName>>(GetCompanyDocument, {
      alias: 'getCompany',
      ...operationOptions
    });
};

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
      }
export function useGetCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = ApolloReactCommon.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyDivisionsDocument = gql`
    query getCompanyDivisions($where: JSON) {
  divisions(where: $where) {
    id
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    created_at
    updated_at
  }
}
    `;
export type GetCompanyDivisionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>, 'query'>;

    export const GetCompanyDivisionsComponent = (props: GetCompanyDivisionsComponentProps) => (
      <ApolloReactComponents.Query<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables> query={GetCompanyDivisionsDocument} {...props} />
    );
    
export type GetCompanyDivisionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>
    } & TChildProps;
export function withGetCompanyDivisions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanyDivisionsQuery,
  GetCompanyDivisionsQueryVariables,
  GetCompanyDivisionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables, GetCompanyDivisionsProps<TChildProps, TDataName>>(GetCompanyDivisionsDocument, {
      alias: 'getCompanyDivisions',
      ...operationOptions
    });
};

/**
 * __useGetCompanyDivisionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDivisionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCompanyDivisionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>(GetCompanyDivisionsDocument, baseOptions);
      }
export function useGetCompanyDivisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>(GetCompanyDivisionsDocument, baseOptions);
        }
export type GetCompanyDivisionsQueryHookResult = ReturnType<typeof useGetCompanyDivisionsQuery>;
export type GetCompanyDivisionsLazyQueryHookResult = ReturnType<typeof useGetCompanyDivisionsLazyQuery>;
export type GetCompanyDivisionsQueryResult = ApolloReactCommon.QueryResult<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>;
export const GetCompanyRegionsDocument = gql`
    query getCompanyRegions($where: JSON) {
  regions(where: $where) {
    id
    nameEnglish
    nameFrench
    nameGerman
    nameSpanish
    nameMandarin
    created_at
    updated_at
  }
}
    `;
export type GetCompanyRegionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>, 'query'>;

    export const GetCompanyRegionsComponent = (props: GetCompanyRegionsComponentProps) => (
      <ApolloReactComponents.Query<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables> query={GetCompanyRegionsDocument} {...props} />
    );
    
export type GetCompanyRegionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>
    } & TChildProps;
export function withGetCompanyRegions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanyRegionsQuery,
  GetCompanyRegionsQueryVariables,
  GetCompanyRegionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables, GetCompanyRegionsProps<TChildProps, TDataName>>(GetCompanyRegionsDocument, {
      alias: 'getCompanyRegions',
      ...operationOptions
    });
};

/**
 * __useGetCompanyRegionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRegionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCompanyRegionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>(GetCompanyRegionsDocument, baseOptions);
      }
export function useGetCompanyRegionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>(GetCompanyRegionsDocument, baseOptions);
        }
export type GetCompanyRegionsQueryHookResult = ReturnType<typeof useGetCompanyRegionsQuery>;
export type GetCompanyRegionsLazyQueryHookResult = ReturnType<typeof useGetCompanyRegionsLazyQuery>;
export type GetCompanyRegionsQueryResult = ApolloReactCommon.QueryResult<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>;
export const GetDivisionsDocument = gql`
    query getDivisions {
  divisions {
    id
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    created_at
    updated_at
  }
}
    `;
export type GetDivisionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDivisionsQuery, GetDivisionsQueryVariables>, 'query'>;

    export const GetDivisionsComponent = (props: GetDivisionsComponentProps) => (
      <ApolloReactComponents.Query<GetDivisionsQuery, GetDivisionsQueryVariables> query={GetDivisionsDocument} {...props} />
    );
    
export type GetDivisionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDivisionsQuery, GetDivisionsQueryVariables>
    } & TChildProps;
export function withGetDivisions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDivisionsQuery,
  GetDivisionsQueryVariables,
  GetDivisionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDivisionsQuery, GetDivisionsQueryVariables, GetDivisionsProps<TChildProps, TDataName>>(GetDivisionsDocument, {
      alias: 'getDivisions',
      ...operationOptions
    });
};

/**
 * __useGetDivisionsQuery__
 *
 * To run a query within a React component, call `useGetDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDivisionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDivisionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, baseOptions);
      }
export function useGetDivisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, baseOptions);
        }
export type GetDivisionsQueryHookResult = ReturnType<typeof useGetDivisionsQuery>;
export type GetDivisionsLazyQueryHookResult = ReturnType<typeof useGetDivisionsLazyQuery>;
export type GetDivisionsQueryResult = ApolloReactCommon.QueryResult<GetDivisionsQuery, GetDivisionsQueryVariables>;
export const GetFirstFourNotesDocument = gql`
    query getFirstFourNotes {
  getFirstFourNotes {
    id
    name
    note
    document {
      id
      url
    }
    programme {
      name
    }
    notesId {
      saboteurProofValue {
        id
        url
        name
      }
    }
    sub_module_submission {
      sub_module {
        nameEnglish
      }
    }
    sectionOrSubmissionId
    created_at
  }
}
    `;
export type GetFirstFourNotesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>, 'query'>;

    export const GetFirstFourNotesComponent = (props: GetFirstFourNotesComponentProps) => (
      <ApolloReactComponents.Query<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables> query={GetFirstFourNotesDocument} {...props} />
    );
    
export type GetFirstFourNotesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>
    } & TChildProps;
export function withGetFirstFourNotes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFirstFourNotesQuery,
  GetFirstFourNotesQueryVariables,
  GetFirstFourNotesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables, GetFirstFourNotesProps<TChildProps, TDataName>>(GetFirstFourNotesDocument, {
      alias: 'getFirstFourNotes',
      ...operationOptions
    });
};

/**
 * __useGetFirstFourNotesQuery__
 *
 * To run a query within a React component, call `useGetFirstFourNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstFourNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstFourNotesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFirstFourNotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>(GetFirstFourNotesDocument, baseOptions);
      }
export function useGetFirstFourNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>(GetFirstFourNotesDocument, baseOptions);
        }
export type GetFirstFourNotesQueryHookResult = ReturnType<typeof useGetFirstFourNotesQuery>;
export type GetFirstFourNotesLazyQueryHookResult = ReturnType<typeof useGetFirstFourNotesLazyQuery>;
export type GetFirstFourNotesQueryResult = ApolloReactCommon.QueryResult<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>;
export const GetFirstTwelveArticlesDocument = gql`
    query getFirstTwelveArticles {
  getFirstTwelveArticles {
    id
    created_at
    updated_at
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    contentEnglish
    contentFrench
    contentGerman
    contentSpanish
    contentMandarin
    position
    companies {
      id
    }
    image {
      url
    }
    datePublished
    readTime
    link
  }
}
    `;
export type GetFirstTwelveArticlesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>, 'query'>;

    export const GetFirstTwelveArticlesComponent = (props: GetFirstTwelveArticlesComponentProps) => (
      <ApolloReactComponents.Query<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables> query={GetFirstTwelveArticlesDocument} {...props} />
    );
    
export type GetFirstTwelveArticlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>
    } & TChildProps;
export function withGetFirstTwelveArticles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFirstTwelveArticlesQuery,
  GetFirstTwelveArticlesQueryVariables,
  GetFirstTwelveArticlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables, GetFirstTwelveArticlesProps<TChildProps, TDataName>>(GetFirstTwelveArticlesDocument, {
      alias: 'getFirstTwelveArticles',
      ...operationOptions
    });
};

/**
 * __useGetFirstTwelveArticlesQuery__
 *
 * To run a query within a React component, call `useGetFirstTwelveArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstTwelveArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstTwelveArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFirstTwelveArticlesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>(GetFirstTwelveArticlesDocument, baseOptions);
      }
export function useGetFirstTwelveArticlesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>(GetFirstTwelveArticlesDocument, baseOptions);
        }
export type GetFirstTwelveArticlesQueryHookResult = ReturnType<typeof useGetFirstTwelveArticlesQuery>;
export type GetFirstTwelveArticlesLazyQueryHookResult = ReturnType<typeof useGetFirstTwelveArticlesLazyQuery>;
export type GetFirstTwelveArticlesQueryResult = ApolloReactCommon.QueryResult<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>;
export const GetInviteDocument = gql`
    query getInvite($where: JSON) {
  invites(where: $where) {
    email
    company {
      id
      name
    }
  }
}
    `;
export type GetInviteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInviteQuery, GetInviteQueryVariables>, 'query'>;

    export const GetInviteComponent = (props: GetInviteComponentProps) => (
      <ApolloReactComponents.Query<GetInviteQuery, GetInviteQueryVariables> query={GetInviteDocument} {...props} />
    );
    
export type GetInviteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInviteQuery, GetInviteQueryVariables>
    } & TChildProps;
export function withGetInvite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInviteQuery,
  GetInviteQueryVariables,
  GetInviteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInviteQuery, GetInviteQueryVariables, GetInviteProps<TChildProps, TDataName>>(GetInviteDocument, {
      alias: 'getInvite',
      ...operationOptions
    });
};

/**
 * __useGetInviteQuery__
 *
 * To run a query within a React component, call `useGetInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetInviteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInviteQuery, GetInviteQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInviteQuery, GetInviteQueryVariables>(GetInviteDocument, baseOptions);
      }
export function useGetInviteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInviteQuery, GetInviteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInviteQuery, GetInviteQueryVariables>(GetInviteDocument, baseOptions);
        }
export type GetInviteQueryHookResult = ReturnType<typeof useGetInviteQuery>;
export type GetInviteLazyQueryHookResult = ReturnType<typeof useGetInviteLazyQuery>;
export type GetInviteQueryResult = ApolloReactCommon.QueryResult<GetInviteQuery, GetInviteQueryVariables>;
export const GetLanguagesDocument = gql`
    query getLanguages($where: JSON) {
  languages(where: $where) {
    id
    name
    image {
      url
    }
    companies {
      id
      name
    }
  }
}
    `;
export type GetLanguagesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetLanguagesQuery, GetLanguagesQueryVariables>, 'query'>;

    export const GetLanguagesComponent = (props: GetLanguagesComponentProps) => (
      <ApolloReactComponents.Query<GetLanguagesQuery, GetLanguagesQueryVariables> query={GetLanguagesDocument} {...props} />
    );
    
export type GetLanguagesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetLanguagesQuery, GetLanguagesQueryVariables>
    } & TChildProps;
export function withGetLanguages<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetLanguagesQuery,
  GetLanguagesQueryVariables,
  GetLanguagesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetLanguagesQuery, GetLanguagesQueryVariables, GetLanguagesProps<TChildProps, TDataName>>(GetLanguagesDocument, {
      alias: 'getLanguages',
      ...operationOptions
    });
};

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, baseOptions);
      }
export function useGetLanguagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, baseOptions);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesQueryResult = ApolloReactCommon.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetModuleDocument = gql`
    query getModule($id: ID!) {
  module(id: $id) {
    id
    nameEnglish
    nameFrench
    nameSpanish
    nameGerman
    nameMandarin
    descriptionEnglish
    descriptionFrench
    descriptionGerman
    descriptionMandarin
    descriptionSpanish
    cover {
      id
      url
    }
    sections {
      id
      titleFrench
      titleGerman
      titleEnglish
      titleSpanish
      titleMandarin
      subTitleFrench
      subTitleGerman
      subTitleEnglish
      subTitleSpanish
      subTitleMandarin
      videoEnglish {
        id
        url
      }
      videoGerman {
        id
        url
      }
      videoSpanish {
        id
        url
      }
      videoMandarin {
        id
        url
      }
      videoFrench {
        id
        url
      }
      cover {
        id
        url
      }
      questions {
        ...questions
      }
      position
      archive
    }
  }
}
    ${QuestionsFragmentDoc}`;
export type GetModuleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetModuleQuery, GetModuleQueryVariables>, 'query'> & ({ variables: GetModuleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetModuleComponent = (props: GetModuleComponentProps) => (
      <ApolloReactComponents.Query<GetModuleQuery, GetModuleQueryVariables> query={GetModuleDocument} {...props} />
    );
    
export type GetModuleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetModuleQuery, GetModuleQueryVariables>
    } & TChildProps;
export function withGetModule<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetModuleQuery,
  GetModuleQueryVariables,
  GetModuleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetModuleQuery, GetModuleQueryVariables, GetModuleProps<TChildProps, TDataName>>(GetModuleDocument, {
      alias: 'getModule',
      ...operationOptions
    });
};

/**
 * __useGetModuleQuery__
 *
 * To run a query within a React component, call `useGetModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModuleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, baseOptions);
      }
export function useGetModuleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, baseOptions);
        }
export type GetModuleQueryHookResult = ReturnType<typeof useGetModuleQuery>;
export type GetModuleLazyQueryHookResult = ReturnType<typeof useGetModuleLazyQuery>;
export type GetModuleQueryResult = ApolloReactCommon.QueryResult<GetModuleQuery, GetModuleQueryVariables>;
export const GetModulesDocument = gql`
    query getModules {
  modules {
    id
    nameEnglish
    nameFrench
    nameSpanish
    nameGerman
    nameMandarin
    descriptionEnglish
    descriptionFrench
    descriptionSpanish
    descriptionGerman
    descriptionMandarin
    cover {
      id
      url
    }
    sections {
      id
      titleFrench
      titleGerman
      titleEnglish
      titleSpanish
      titleMandarin
      subTitleFrench
      subTitleGerman
      subTitleEnglish
      subTitleSpanish
      subTitleMandarin
      videoEnglish {
        id
        url
      }
      videoFrench {
        id
        url
      }
      videoSpanish {
        id
        url
      }
      videoGerman {
        id
        url
      }
      videoMandarin {
        id
        url
      }
      questions {
        ...questions
      }
      archive
    }
  }
}
    ${QuestionsFragmentDoc}`;
export type GetModulesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetModulesQuery, GetModulesQueryVariables>, 'query'>;

    export const GetModulesComponent = (props: GetModulesComponentProps) => (
      <ApolloReactComponents.Query<GetModulesQuery, GetModulesQueryVariables> query={GetModulesDocument} {...props} />
    );
    
export type GetModulesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetModulesQuery, GetModulesQueryVariables>
    } & TChildProps;
export function withGetModules<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetModulesQuery,
  GetModulesQueryVariables,
  GetModulesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetModulesQuery, GetModulesQueryVariables, GetModulesProps<TChildProps, TDataName>>(GetModulesDocument, {
      alias: 'getModules',
      ...operationOptions
    });
};

/**
 * __useGetModulesQuery__
 *
 * To run a query within a React component, call `useGetModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, baseOptions);
      }
export function useGetModulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, baseOptions);
        }
export type GetModulesQueryHookResult = ReturnType<typeof useGetModulesQuery>;
export type GetModulesLazyQueryHookResult = ReturnType<typeof useGetModulesLazyQuery>;
export type GetModulesQueryResult = ApolloReactCommon.QueryResult<GetModulesQuery, GetModulesQueryVariables>;
export const GetMyBookingsDocument = gql`
    query getMyBookings($where: JSON!, $sort: String!, $limit: Int!) {
  bookings(where: $where, sort: $sort, limit: $limit) {
    id
    title
    description
    duration
    date
    confirmed
    eventId
    cancelled
    organiser
    location
    isUpdated
    end
  }
}
    `;
export type GetMyBookingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>, 'query'> & ({ variables: GetMyBookingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMyBookingsComponent = (props: GetMyBookingsComponentProps) => (
      <ApolloReactComponents.Query<GetMyBookingsQuery, GetMyBookingsQueryVariables> query={GetMyBookingsDocument} {...props} />
    );
    
export type GetMyBookingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyBookingsQuery, GetMyBookingsQueryVariables>
    } & TChildProps;
export function withGetMyBookings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyBookingsQuery,
  GetMyBookingsQueryVariables,
  GetMyBookingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyBookingsQuery, GetMyBookingsQueryVariables, GetMyBookingsProps<TChildProps, TDataName>>(GetMyBookingsDocument, {
      alias: 'getMyBookings',
      ...operationOptions
    });
};

/**
 * __useGetMyBookingsQuery__
 *
 * To run a query within a React component, call `useGetMyBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBookingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyBookingsQuery, GetMyBookingsQueryVariables>(GetMyBookingsDocument, baseOptions);
      }
export function useGetMyBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyBookingsQuery, GetMyBookingsQueryVariables>(GetMyBookingsDocument, baseOptions);
        }
export type GetMyBookingsQueryHookResult = ReturnType<typeof useGetMyBookingsQuery>;
export type GetMyBookingsLazyQueryHookResult = ReturnType<typeof useGetMyBookingsLazyQuery>;
export type GetMyBookingsQueryResult = ApolloReactCommon.QueryResult<GetMyBookingsQuery, GetMyBookingsQueryVariables>;
export const GetMyCoachSessionsDocument = gql`
    query getMyCoachSessions($where: JSON!) {
  coachSessions(where: $where) {
    id
    title
    status
    user {
      id
    }
    programme_submission {
      id
    }
    sub_module_submission {
      id
    }
    appointment {
      appointmentUrl
      appointmentStartDate
      appointmentEndDate
      status
    }
  }
}
    `;
export type GetMyCoachSessionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>, 'query'> & ({ variables: GetMyCoachSessionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMyCoachSessionsComponent = (props: GetMyCoachSessionsComponentProps) => (
      <ApolloReactComponents.Query<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables> query={GetMyCoachSessionsDocument} {...props} />
    );
    
export type GetMyCoachSessionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>
    } & TChildProps;
export function withGetMyCoachSessions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyCoachSessionsQuery,
  GetMyCoachSessionsQueryVariables,
  GetMyCoachSessionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables, GetMyCoachSessionsProps<TChildProps, TDataName>>(GetMyCoachSessionsDocument, {
      alias: 'getMyCoachSessions',
      ...operationOptions
    });
};

/**
 * __useGetMyCoachSessionsQuery__
 *
 * To run a query within a React component, call `useGetMyCoachSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoachSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCoachSessionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMyCoachSessionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>(GetMyCoachSessionsDocument, baseOptions);
      }
export function useGetMyCoachSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>(GetMyCoachSessionsDocument, baseOptions);
        }
export type GetMyCoachSessionsQueryHookResult = ReturnType<typeof useGetMyCoachSessionsQuery>;
export type GetMyCoachSessionsLazyQueryHookResult = ReturnType<typeof useGetMyCoachSessionsLazyQuery>;
export type GetMyCoachSessionsQueryResult = ApolloReactCommon.QueryResult<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>;
export const GetMyNotificationsDocument = gql`
    query getMyNotifications($where: JSON!) {
  notifications(where: $where) {
    id
    created_at
    updated_at
    title
    timeStamp
    path
    read
    users {
      id
    }
  }
}
    `;
export type GetMyNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>, 'query'> & ({ variables: GetMyNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMyNotificationsComponent = (props: GetMyNotificationsComponentProps) => (
      <ApolloReactComponents.Query<GetMyNotificationsQuery, GetMyNotificationsQueryVariables> query={GetMyNotificationsDocument} {...props} />
    );
    
export type GetMyNotificationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>
    } & TChildProps;
export function withGetMyNotifications<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyNotificationsQuery,
  GetMyNotificationsQueryVariables,
  GetMyNotificationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyNotificationsQuery, GetMyNotificationsQueryVariables, GetMyNotificationsProps<TChildProps, TDataName>>(GetMyNotificationsDocument, {
      alias: 'getMyNotifications',
      ...operationOptions
    });
};

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, baseOptions);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, baseOptions);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsQueryResult = ApolloReactCommon.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const GetMySubModuleReportDocument = gql`
    query getMySubModuleReport($where: JSON!, $sort: String!, $limit: Int!) {
  reports(where: $where, sort: $sort, limit: $limit) {
    id
    name
    type
    report {
      id
      url
    }
    sectionOrModuleId
    sub_module_submission {
      section {
        progress
        section {
          titleEnglish
        }
      }
      sub_module {
        id
        programme_type {
          id
          title
          programmes {
            name
          }
        }
      }
    }
  }
}
    `;
export type GetMySubModuleReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>, 'query'> & ({ variables: GetMySubModuleReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMySubModuleReportComponent = (props: GetMySubModuleReportComponentProps) => (
      <ApolloReactComponents.Query<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables> query={GetMySubModuleReportDocument} {...props} />
    );
    
export type GetMySubModuleReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>
    } & TChildProps;
export function withGetMySubModuleReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubModuleReportQuery,
  GetMySubModuleReportQueryVariables,
  GetMySubModuleReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables, GetMySubModuleReportProps<TChildProps, TDataName>>(GetMySubModuleReportDocument, {
      alias: 'getMySubModuleReport',
      ...operationOptions
    });
};

/**
 * __useGetMySubModuleReportQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleReportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMySubModuleReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>(GetMySubModuleReportDocument, baseOptions);
      }
export function useGetMySubModuleReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>(GetMySubModuleReportDocument, baseOptions);
        }
export type GetMySubModuleReportQueryHookResult = ReturnType<typeof useGetMySubModuleReportQuery>;
export type GetMySubModuleReportLazyQueryHookResult = ReturnType<typeof useGetMySubModuleReportLazyQuery>;
export type GetMySubModuleReportQueryResult = ApolloReactCommon.QueryResult<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>;
export const GetMySubModuleSubmissionsReportsDocument = gql`
    query getMySubModuleSubmissionsReports {
  getMySubModuleSubmissionsReports {
    id
    sub_module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleFrench
        titleGerman
        titleEnglish
        titleSpanish
        titleMandarin
        subTitleFrench
        subTitleGerman
        subTitleEnglish
        subTitleSpanish
        subTitleMandarin
        cover {
          id
          url
        }
        position
      }
      position
      programme_type {
        id
        title
        description
        position
        cover {
          id
          url
        }
        isCoaching
        isSubModule
        notes
        showArticle
        showSession
        showParticipants
        competencySurvey
        feedForwardSurvey
        deadline
        articles {
          id
          created_at
          updated_at
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          contentEnglish
          contentFrench
          contentGerman
          contentSpanish
          contentMandarin
          image {
            url
          }
          datePublished
          readTime
          link
        }
        modal {
          id
          title
          subtitle
          message
          image {
            id
            url
            name
          }
        }
        events {
          id
          name
          link
        }
      }
    }
    reports {
      id
      name
      type
      report {
        id
        url
      }
      sectionOrModuleId
    }
  }
}
    `;
export type GetMySubModuleSubmissionsReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>, 'query'>;

    export const GetMySubModuleSubmissionsReportsComponent = (props: GetMySubModuleSubmissionsReportsComponentProps) => (
      <ApolloReactComponents.Query<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables> query={GetMySubModuleSubmissionsReportsDocument} {...props} />
    );
    
export type GetMySubModuleSubmissionsReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>
    } & TChildProps;
export function withGetMySubModuleSubmissionsReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubModuleSubmissionsReportsQuery,
  GetMySubModuleSubmissionsReportsQueryVariables,
  GetMySubModuleSubmissionsReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables, GetMySubModuleSubmissionsReportsProps<TChildProps, TDataName>>(GetMySubModuleSubmissionsReportsDocument, {
      alias: 'getMySubModuleSubmissionsReports',
      ...operationOptions
    });
};

/**
 * __useGetMySubModuleSubmissionsReportsQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleSubmissionsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleSubmissionsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleSubmissionsReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubModuleSubmissionsReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>(GetMySubModuleSubmissionsReportsDocument, baseOptions);
      }
export function useGetMySubModuleSubmissionsReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>(GetMySubModuleSubmissionsReportsDocument, baseOptions);
        }
export type GetMySubModuleSubmissionsReportsQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsReportsQuery>;
export type GetMySubModuleSubmissionsReportsLazyQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsReportsLazyQuery>;
export type GetMySubModuleSubmissionsReportsQueryResult = ApolloReactCommon.QueryResult<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>;
export const GetMySubModuleNotesDocument = gql`
    query getMySubModuleNotes($where: JSON!, $sort: String!, $limit: Int!) {
  notes(where: $where, sort: $sort, limit: $limit) {
    id
    name
    note
    document {
      id
      url
    }
    programme {
      name
    }
    notesId {
      saboteurProofValue {
        id
        url
        name
      }
    }
    sub_module_submission {
      sub_module {
        nameEnglish
      }
    }
    sectionOrSubmissionId
    created_at
  }
}
    `;
export type GetMySubModuleNotesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>, 'query'> & ({ variables: GetMySubModuleNotesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMySubModuleNotesComponent = (props: GetMySubModuleNotesComponentProps) => (
      <ApolloReactComponents.Query<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables> query={GetMySubModuleNotesDocument} {...props} />
    );
    
export type GetMySubModuleNotesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>
    } & TChildProps;
export function withGetMySubModuleNotes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubModuleNotesQuery,
  GetMySubModuleNotesQueryVariables,
  GetMySubModuleNotesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables, GetMySubModuleNotesProps<TChildProps, TDataName>>(GetMySubModuleNotesDocument, {
      alias: 'getMySubModuleNotes',
      ...operationOptions
    });
};

/**
 * __useGetMySubModuleNotesQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleNotesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMySubModuleNotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>(GetMySubModuleNotesDocument, baseOptions);
      }
export function useGetMySubModuleNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>(GetMySubModuleNotesDocument, baseOptions);
        }
export type GetMySubModuleNotesQueryHookResult = ReturnType<typeof useGetMySubModuleNotesQuery>;
export type GetMySubModuleNotesLazyQueryHookResult = ReturnType<typeof useGetMySubModuleNotesLazyQuery>;
export type GetMySubModuleNotesQueryResult = ApolloReactCommon.QueryResult<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>;
export const GetMyUploadedReportDocument = gql`
    query getMyUploadedReport($where: JSON!, $sort: String!, $limit: Int!) {
  uploadedReports(where: $where, sort: $sort, limit: $limit) {
    id
    name
    type
    report {
      id
      url
      created_at
    }
    sectionOrModuleId
  }
}
    `;
export type GetMyUploadedReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>, 'query'> & ({ variables: GetMyUploadedReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMyUploadedReportComponent = (props: GetMyUploadedReportComponentProps) => (
      <ApolloReactComponents.Query<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables> query={GetMyUploadedReportDocument} {...props} />
    );
    
export type GetMyUploadedReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>
    } & TChildProps;
export function withGetMyUploadedReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyUploadedReportQuery,
  GetMyUploadedReportQueryVariables,
  GetMyUploadedReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables, GetMyUploadedReportProps<TChildProps, TDataName>>(GetMyUploadedReportDocument, {
      alias: 'getMyUploadedReport',
      ...operationOptions
    });
};

/**
 * __useGetMyUploadedReportQuery__
 *
 * To run a query within a React component, call `useGetMyUploadedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUploadedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUploadedReportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyUploadedReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>(GetMyUploadedReportDocument, baseOptions);
      }
export function useGetMyUploadedReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>(GetMyUploadedReportDocument, baseOptions);
        }
export type GetMyUploadedReportQueryHookResult = ReturnType<typeof useGetMyUploadedReportQuery>;
export type GetMyUploadedReportLazyQueryHookResult = ReturnType<typeof useGetMyUploadedReportLazyQuery>;
export type GetMyUploadedReportQueryResult = ApolloReactCommon.QueryResult<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>;
export const GetMyWorkDocument = gql`
    query getMyWork {
  getMySubmissions {
    id
    views
    progress
    status
    timeSpent
    language {
      id
      name
    }
    module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
        videoEnglish {
          id
          url
        }
        videoFrench {
          id
          url
        }
        videoGerman {
          id
          url
        }
        videoSpanish {
          id
          url
        }
        videoMandarin {
          id
          url
        }
        questions {
          ...questions
        }
      }
    }
    section {
      id
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
      }
      section {
        id
        created_at
        updated_at
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
        videoEnglish {
          id
          url
        }
        videoFrench {
          id
          url
        }
        videoGerman {
          id
          url
        }
        videoSpanish {
          id
          url
        }
        videoMandarin {
          id
          url
        }
        questions {
          ...questions
        }
      }
    }
  }
}
    ${QuestionsFragmentDoc}`;
export type GetMyWorkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyWorkQuery, GetMyWorkQueryVariables>, 'query'>;

    export const GetMyWorkComponent = (props: GetMyWorkComponentProps) => (
      <ApolloReactComponents.Query<GetMyWorkQuery, GetMyWorkQueryVariables> query={GetMyWorkDocument} {...props} />
    );
    
export type GetMyWorkProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyWorkQuery, GetMyWorkQueryVariables>
    } & TChildProps;
export function withGetMyWork<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyWorkQuery,
  GetMyWorkQueryVariables,
  GetMyWorkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyWorkQuery, GetMyWorkQueryVariables, GetMyWorkProps<TChildProps, TDataName>>(GetMyWorkDocument, {
      alias: 'getMyWork',
      ...operationOptions
    });
};

/**
 * __useGetMyWorkQuery__
 *
 * To run a query within a React component, call `useGetMyWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWorkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyWorkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyWorkQuery, GetMyWorkQueryVariables>(GetMyWorkDocument, baseOptions);
      }
export function useGetMyWorkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyWorkQuery, GetMyWorkQueryVariables>(GetMyWorkDocument, baseOptions);
        }
export type GetMyWorkQueryHookResult = ReturnType<typeof useGetMyWorkQuery>;
export type GetMyWorkLazyQueryHookResult = ReturnType<typeof useGetMyWorkLazyQuery>;
export type GetMyWorkQueryResult = ApolloReactCommon.QueryResult<GetMyWorkQuery, GetMyWorkQueryVariables>;
export const GetSubModuleSubmissionDocument = gql`
    query getSubModuleSubmission($id: ID!) {
  subModuleSubmission(id: $id) {
    id
    view
    progress
    status
    timeSpent
    feedfoward_url {
      id
    }
    competency_url {
      id
    }
    competency_participants {
      name
      email
    }
    participants {
      id
      name
      email
      type
    }
    submissionparticipants {
      id
      name
      email
    }
    language {
      id
      name
    }
    section {
      id
      progress
      section {
        id
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        steps
        response
      }
      uploadDocuments {
        saboteurProofValue {
          id
        }
      }
    }
    sub_module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleFrench
        titleGerman
        titleEnglish
        titleSpanish
        titleMandarin
        subTitleFrench
        subTitleGerman
        subTitleEnglish
        subTitleSpanish
        subTitleMandarin
        cover {
          id
          url
        }
        position
        archive
      }
      position
      programme_type {
        id
        title
        description
        position
        cover {
          id
          url
        }
        isCoaching
        isSubModule
        notes
        showArticle
        showSession
        showParticipants
        competencySurvey
        feedForwardSurvey
        deadline
        articles {
          id
          created_at
          updated_at
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          contentEnglish
          contentFrench
          contentGerman
          contentSpanish
          contentMandarin
          image {
            url
          }
          datePublished
          readTime
          link
        }
        modal {
          id
          title
          subtitle
          message
          image {
            id
            url
            name
          }
        }
        events {
          id
          name
          link
        }
      }
    }
    reports {
      id
      name
      type
      report {
        id
        url
      }
      sectionOrModuleId
    }
  }
}
    `;
export type GetSubModuleSubmissionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>, 'query'> & ({ variables: GetSubModuleSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubModuleSubmissionComponent = (props: GetSubModuleSubmissionComponentProps) => (
      <ApolloReactComponents.Query<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables> query={GetSubModuleSubmissionDocument} {...props} />
    );
    
export type GetSubModuleSubmissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>
    } & TChildProps;
export function withGetSubModuleSubmission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubModuleSubmissionQuery,
  GetSubModuleSubmissionQueryVariables,
  GetSubModuleSubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables, GetSubModuleSubmissionProps<TChildProps, TDataName>>(GetSubModuleSubmissionDocument, {
      alias: 'getSubModuleSubmission',
      ...operationOptions
    });
};

/**
 * __useGetSubModuleSubmissionQuery__
 *
 * To run a query within a React component, call `useGetSubModuleSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubModuleSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubModuleSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubModuleSubmissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>(GetSubModuleSubmissionDocument, baseOptions);
      }
export function useGetSubModuleSubmissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>(GetSubModuleSubmissionDocument, baseOptions);
        }
export type GetSubModuleSubmissionQueryHookResult = ReturnType<typeof useGetSubModuleSubmissionQuery>;
export type GetSubModuleSubmissionLazyQueryHookResult = ReturnType<typeof useGetSubModuleSubmissionLazyQuery>;
export type GetSubModuleSubmissionQueryResult = ApolloReactCommon.QueryResult<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>;
export const GetNewTypeformFeedResponsesDocument = gql`
    query getNewTypeformFeedResponses {
  getNewTypeformFeedResponses {
    success
  }
}
    `;
export type GetNewTypeformFeedResponsesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>, 'query'>;

    export const GetNewTypeformFeedResponsesComponent = (props: GetNewTypeformFeedResponsesComponentProps) => (
      <ApolloReactComponents.Query<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables> query={GetNewTypeformFeedResponsesDocument} {...props} />
    );
    
export type GetNewTypeformFeedResponsesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>
    } & TChildProps;
export function withGetNewTypeformFeedResponses<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNewTypeformFeedResponsesQuery,
  GetNewTypeformFeedResponsesQueryVariables,
  GetNewTypeformFeedResponsesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables, GetNewTypeformFeedResponsesProps<TChildProps, TDataName>>(GetNewTypeformFeedResponsesDocument, {
      alias: 'getNewTypeformFeedResponses',
      ...operationOptions
    });
};

/**
 * __useGetNewTypeformFeedResponsesQuery__
 *
 * To run a query within a React component, call `useGetNewTypeformFeedResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewTypeformFeedResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewTypeformFeedResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewTypeformFeedResponsesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>(GetNewTypeformFeedResponsesDocument, baseOptions);
      }
export function useGetNewTypeformFeedResponsesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>(GetNewTypeformFeedResponsesDocument, baseOptions);
        }
export type GetNewTypeformFeedResponsesQueryHookResult = ReturnType<typeof useGetNewTypeformFeedResponsesQuery>;
export type GetNewTypeformFeedResponsesLazyQueryHookResult = ReturnType<typeof useGetNewTypeformFeedResponsesLazyQuery>;
export type GetNewTypeformFeedResponsesQueryResult = ApolloReactCommon.QueryResult<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications {
  notifications {
    id
    created_at
    updated_at
    title
    timeStamp
    path
    read
    users {
      id
    }
  }
}
    `;
export type GetNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationsQuery, GetNotificationsQueryVariables>, 'query'>;

    export const GetNotificationsComponent = (props: GetNotificationsComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationsQuery, GetNotificationsQueryVariables> query={GetNotificationsDocument} {...props} />
    );
    
export type GetNotificationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNotificationsQuery, GetNotificationsQueryVariables>
    } & TChildProps;
export function withGetNotifications<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNotificationsQuery,
  GetNotificationsQueryVariables,
  GetNotificationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNotificationsQuery, GetNotificationsQueryVariables, GetNotificationsProps<TChildProps, TDataName>>(GetNotificationsDocument, {
      alias: 'getNotifications',
      ...operationOptions
    });
};

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, baseOptions);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, baseOptions);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = ApolloReactCommon.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetOrderedSubmissionsDocument = gql`
    query getOrderedSubmissions($programme: ID!) {
  getOrderedSubmissions(programme: $programme) {
    programmeSubmission {
      id
      progress
      programme {
        id
        name
        description
        logo {
          url
        }
      }
      programme_type {
        id
        title
        isSubModule
        sub_modules {
          id
          nameEnglish
          nameFrench
          nameSpanish
          nameMandarin
          nameGerman
          sections {
            id
            titleEnglish
            titleFrench
            titleGerman
            titleSpanish
            titleMandarin
            position
          }
          position
        }
        archive
        position
      }
    }
    subModuleSubmissions {
      id
      view
      progress
      sub_module {
        id
        nameFrench
        nameGerman
        nameEnglish
        nameSpanish
        nameMandarin
        sections {
          id
          titleFrench
          titleGerman
          titleEnglish
          titleSpanish
          titleMandarin
          position
        }
        position
      }
      section {
        id
        progress
        section {
          id
        }
      }
    }
  }
}
    `;
export type GetOrderedSubmissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>, 'query'> & ({ variables: GetOrderedSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOrderedSubmissionsComponent = (props: GetOrderedSubmissionsComponentProps) => (
      <ApolloReactComponents.Query<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables> query={GetOrderedSubmissionsDocument} {...props} />
    );
    
export type GetOrderedSubmissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>
    } & TChildProps;
export function withGetOrderedSubmissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrderedSubmissionsQuery,
  GetOrderedSubmissionsQueryVariables,
  GetOrderedSubmissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables, GetOrderedSubmissionsProps<TChildProps, TDataName>>(GetOrderedSubmissionsDocument, {
      alias: 'getOrderedSubmissions',
      ...operationOptions
    });
};

/**
 * __useGetOrderedSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetOrderedSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderedSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderedSubmissionsQuery({
 *   variables: {
 *      programme: // value for 'programme'
 *   },
 * });
 */
export function useGetOrderedSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>(GetOrderedSubmissionsDocument, baseOptions);
      }
export function useGetOrderedSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>(GetOrderedSubmissionsDocument, baseOptions);
        }
export type GetOrderedSubmissionsQueryHookResult = ReturnType<typeof useGetOrderedSubmissionsQuery>;
export type GetOrderedSubmissionsLazyQueryHookResult = ReturnType<typeof useGetOrderedSubmissionsLazyQuery>;
export type GetOrderedSubmissionsQueryResult = ApolloReactCommon.QueryResult<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>;
export const GetProgammeReportsGroupedDocument = gql`
    query getProgammeReportsGrouped {
  getProgammeReportsGrouped {
    companyName
    programmeType {
      programmeType
      programmeName
      sections {
        programmeName
        programmeType
        name
        report {
          id
          url
        }
      }
    }
  }
}
    `;
export type GetProgammeReportsGroupedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>, 'query'>;

    export const GetProgammeReportsGroupedComponent = (props: GetProgammeReportsGroupedComponentProps) => (
      <ApolloReactComponents.Query<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables> query={GetProgammeReportsGroupedDocument} {...props} />
    );
    
export type GetProgammeReportsGroupedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>
    } & TChildProps;
export function withGetProgammeReportsGrouped<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgammeReportsGroupedQuery,
  GetProgammeReportsGroupedQueryVariables,
  GetProgammeReportsGroupedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables, GetProgammeReportsGroupedProps<TChildProps, TDataName>>(GetProgammeReportsGroupedDocument, {
      alias: 'getProgammeReportsGrouped',
      ...operationOptions
    });
};

/**
 * __useGetProgammeReportsGroupedQuery__
 *
 * To run a query within a React component, call `useGetProgammeReportsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgammeReportsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgammeReportsGroupedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgammeReportsGroupedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>(GetProgammeReportsGroupedDocument, baseOptions);
      }
export function useGetProgammeReportsGroupedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>(GetProgammeReportsGroupedDocument, baseOptions);
        }
export type GetProgammeReportsGroupedQueryHookResult = ReturnType<typeof useGetProgammeReportsGroupedQuery>;
export type GetProgammeReportsGroupedLazyQueryHookResult = ReturnType<typeof useGetProgammeReportsGroupedLazyQuery>;
export type GetProgammeReportsGroupedQueryResult = ApolloReactCommon.QueryResult<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>;
export const GetProgrammeDocument = gql`
    query getProgramme($id: ID!) {
  programme(id: $id) {
    id
    name
    description
    logo {
      url
    }
    whatToExpect
    completion
  }
}
    `;
export type GetProgrammeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgrammeQuery, GetProgrammeQueryVariables>, 'query'> & ({ variables: GetProgrammeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProgrammeComponent = (props: GetProgrammeComponentProps) => (
      <ApolloReactComponents.Query<GetProgrammeQuery, GetProgrammeQueryVariables> query={GetProgrammeDocument} {...props} />
    );
    
export type GetProgrammeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgrammeQuery, GetProgrammeQueryVariables>
    } & TChildProps;
export function withGetProgramme<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgrammeQuery,
  GetProgrammeQueryVariables,
  GetProgrammeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgrammeQuery, GetProgrammeQueryVariables, GetProgrammeProps<TChildProps, TDataName>>(GetProgrammeDocument, {
      alias: 'getProgramme',
      ...operationOptions
    });
};

/**
 * __useGetProgrammeQuery__
 *
 * To run a query within a React component, call `useGetProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgrammeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProgrammeQuery, GetProgrammeQueryVariables>(GetProgrammeDocument, baseOptions);
      }
export function useGetProgrammeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProgrammeQuery, GetProgrammeQueryVariables>(GetProgrammeDocument, baseOptions);
        }
export type GetProgrammeQueryHookResult = ReturnType<typeof useGetProgrammeQuery>;
export type GetProgrammeLazyQueryHookResult = ReturnType<typeof useGetProgrammeLazyQuery>;
export type GetProgrammeQueryResult = ApolloReactCommon.QueryResult<GetProgrammeQuery, GetProgrammeQueryVariables>;
export const GetProgrammeProgrammeSubmissionsDocument = gql`
    query getProgrammeProgrammeSubmissions($where: JSON!, $limit: Int) {
  programmeSubmissions(where: $where, limit: $limit) {
    id
    progress
    programme {
      id
      name
      description
      logo {
        url
      }
    }
    programme_type {
      id
      title
      isSubModule
      sub_modules {
        id
        nameEnglish
        nameFrench
        nameSpanish
        nameMandarin
        nameGerman
        sections {
          id
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
        }
        position
      }
      archive
      position
    }
  }
}
    `;
export type GetProgrammeProgrammeSubmissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>, 'query'> & ({ variables: GetProgrammeProgrammeSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProgrammeProgrammeSubmissionsComponent = (props: GetProgrammeProgrammeSubmissionsComponentProps) => (
      <ApolloReactComponents.Query<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables> query={GetProgrammeProgrammeSubmissionsDocument} {...props} />
    );
    
export type GetProgrammeProgrammeSubmissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>
    } & TChildProps;
export function withGetProgrammeProgrammeSubmissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgrammeProgrammeSubmissionsQuery,
  GetProgrammeProgrammeSubmissionsQueryVariables,
  GetProgrammeProgrammeSubmissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables, GetProgrammeProgrammeSubmissionsProps<TChildProps, TDataName>>(GetProgrammeProgrammeSubmissionsDocument, {
      alias: 'getProgrammeProgrammeSubmissions',
      ...operationOptions
    });
};

/**
 * __useGetProgrammeProgrammeSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetProgrammeProgrammeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammeProgrammeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammeProgrammeSubmissionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProgrammeProgrammeSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>(GetProgrammeProgrammeSubmissionsDocument, baseOptions);
      }
export function useGetProgrammeProgrammeSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>(GetProgrammeProgrammeSubmissionsDocument, baseOptions);
        }
export type GetProgrammeProgrammeSubmissionsQueryHookResult = ReturnType<typeof useGetProgrammeProgrammeSubmissionsQuery>;
export type GetProgrammeProgrammeSubmissionsLazyQueryHookResult = ReturnType<typeof useGetProgrammeProgrammeSubmissionsLazyQuery>;
export type GetProgrammeProgrammeSubmissionsQueryResult = ApolloReactCommon.QueryResult<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>;
export const GetMyProgrammeSubmissionDocument = gql`
    query getMyProgrammeSubmission($id: ID!) {
  programmeSubmission(id: $id) {
    id
    status
    progress
    competency_url {
      id
      url
    }
    feedfoward_url {
      id
      url
    }
    programme_type {
      id
      title
      description
      showParticipants
      cover {
        id
        url
      }
      isCoaching
      isSubModule
      notes
      deadline
      programmeQuestions {
        __typename
        ... on ComponentQuestionTypesValuesNested {
          id
          title
          question
          description
          questions {
            id
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
          }
        }
        ... on ComponentQuestionTypesCompetency2 {
          titleEnglish
          titleFrench
          titleMandarin
          questionscompetency2 {
            title
            question
            maxiNumber
            miniNumber
            simpleQuestion
            miniLabel
            maxiLabel
            midiLabel
            textboxQuestion
          }
        }
      }
      articles {
        id
        created_at
        updated_at
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        contentEnglish
        contentFrench
        contentGerman
        contentSpanish
        contentMandarin
        image {
          url
        }
        datePublished
        readTime
        link
      }
      events {
        id
        name
        link
        sessionId
      }
      sub_modules {
        id
        nameEnglish
        descriptionEnglish
        cover {
          id
          url
        }
        programme_type {
          id
        }
      }
    }
    programmeResponses {
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      competencyAnswers {
        question
        rating
        response
        steps
        textboxQuestion
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
    }
    participants {
      id
      name
      email
      type
    }
    submissionparticipants {
      id
      name
      email
    }
    myNotes {
      id
      title
      description
      document {
        id
        url
      }
    }
    selected
  }
}
    `;
export type GetMyProgrammeSubmissionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>, 'query'> & ({ variables: GetMyProgrammeSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMyProgrammeSubmissionComponent = (props: GetMyProgrammeSubmissionComponentProps) => (
      <ApolloReactComponents.Query<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables> query={GetMyProgrammeSubmissionDocument} {...props} />
    );
    
export type GetMyProgrammeSubmissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>
    } & TChildProps;
export function withGetMyProgrammeSubmission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyProgrammeSubmissionQuery,
  GetMyProgrammeSubmissionQueryVariables,
  GetMyProgrammeSubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables, GetMyProgrammeSubmissionProps<TChildProps, TDataName>>(GetMyProgrammeSubmissionDocument, {
      alias: 'getMyProgrammeSubmission',
      ...operationOptions
    });
};

/**
 * __useGetMyProgrammeSubmissionQuery__
 *
 * To run a query within a React component, call `useGetMyProgrammeSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProgrammeSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProgrammeSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyProgrammeSubmissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>(GetMyProgrammeSubmissionDocument, baseOptions);
      }
export function useGetMyProgrammeSubmissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>(GetMyProgrammeSubmissionDocument, baseOptions);
        }
export type GetMyProgrammeSubmissionQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionQuery>;
export type GetMyProgrammeSubmissionLazyQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionLazyQuery>;
export type GetMyProgrammeSubmissionQueryResult = ApolloReactCommon.QueryResult<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>;
export const GetProgrammesDocument = gql`
    query getProgrammes {
  programmes {
    id
    name
    description
    logo {
      url
    }
    programme_types {
      title
      sub_modules {
        sections {
          titleEnglish
        }
      }
    }
  }
}
    `;
export type GetProgrammesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProgrammesQuery, GetProgrammesQueryVariables>, 'query'>;

    export const GetProgrammesComponent = (props: GetProgrammesComponentProps) => (
      <ApolloReactComponents.Query<GetProgrammesQuery, GetProgrammesQueryVariables> query={GetProgrammesDocument} {...props} />
    );
    
export type GetProgrammesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProgrammesQuery, GetProgrammesQueryVariables>
    } & TChildProps;
export function withGetProgrammes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProgrammesQuery,
  GetProgrammesQueryVariables,
  GetProgrammesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProgrammesQuery, GetProgrammesQueryVariables, GetProgrammesProps<TChildProps, TDataName>>(GetProgrammesDocument, {
      alias: 'getProgrammes',
      ...operationOptions
    });
};

/**
 * __useGetProgrammesQuery__
 *
 * To run a query within a React component, call `useGetProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgrammesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProgrammesQuery, GetProgrammesQueryVariables>(GetProgrammesDocument, baseOptions);
      }
export function useGetProgrammesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProgrammesQuery, GetProgrammesQueryVariables>(GetProgrammesDocument, baseOptions);
        }
export type GetProgrammesQueryHookResult = ReturnType<typeof useGetProgrammesQuery>;
export type GetProgrammesLazyQueryHookResult = ReturnType<typeof useGetProgrammesLazyQuery>;
export type GetProgrammesQueryResult = ApolloReactCommon.QueryResult<GetProgrammesQuery, GetProgrammesQueryVariables>;
export const GetRegionsDocument = gql`
    query getRegions {
  regions {
    id
    nameEnglish
    nameFrench
    nameGerman
    nameSpanish
    nameMandarin
    created_at
    updated_at
  }
}
    `;
export type GetRegionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRegionsQuery, GetRegionsQueryVariables>, 'query'>;

    export const GetRegionsComponent = (props: GetRegionsComponentProps) => (
      <ApolloReactComponents.Query<GetRegionsQuery, GetRegionsQueryVariables> query={GetRegionsDocument} {...props} />
    );
    
export type GetRegionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRegionsQuery, GetRegionsQueryVariables>
    } & TChildProps;
export function withGetRegions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRegionsQuery,
  GetRegionsQueryVariables,
  GetRegionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRegionsQuery, GetRegionsQueryVariables, GetRegionsProps<TChildProps, TDataName>>(GetRegionsDocument, {
      alias: 'getRegions',
      ...operationOptions
    });
};

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, baseOptions);
      }
export function useGetRegionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, baseOptions);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = ApolloReactCommon.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetReportsGroupedDocument = gql`
    query getReportsGrouped {
  getReportsGrouped {
    companyName
    programmeType {
      programmeType
      programmeName
      sections {
        programmeName
        programmeType
        name
        report {
          id
          url
        }
      }
    }
  }
}
    `;
export type GetReportsGroupedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>, 'query'>;

    export const GetReportsGroupedComponent = (props: GetReportsGroupedComponentProps) => (
      <ApolloReactComponents.Query<GetReportsGroupedQuery, GetReportsGroupedQueryVariables> query={GetReportsGroupedDocument} {...props} />
    );
    
export type GetReportsGroupedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>
    } & TChildProps;
export function withGetReportsGrouped<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetReportsGroupedQuery,
  GetReportsGroupedQueryVariables,
  GetReportsGroupedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetReportsGroupedQuery, GetReportsGroupedQueryVariables, GetReportsGroupedProps<TChildProps, TDataName>>(GetReportsGroupedDocument, {
      alias: 'getReportsGrouped',
      ...operationOptions
    });
};

/**
 * __useGetReportsGroupedQuery__
 *
 * To run a query within a React component, call `useGetReportsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsGroupedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsGroupedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>) {
        return ApolloReactHooks.useQuery<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>(GetReportsGroupedDocument, baseOptions);
      }
export function useGetReportsGroupedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>(GetReportsGroupedDocument, baseOptions);
        }
export type GetReportsGroupedQueryHookResult = ReturnType<typeof useGetReportsGroupedQuery>;
export type GetReportsGroupedLazyQueryHookResult = ReturnType<typeof useGetReportsGroupedLazyQuery>;
export type GetReportsGroupedQueryResult = ApolloReactCommon.QueryResult<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>;
export const GetSectionDocument = gql`
    query getSection($id: ID!) {
  section(id: $id) {
    id
    titleEnglish
    subTitleEnglish
    getStartedText
    Notes
    cover {
      id
      url
    }
    videoEnglish {
      id
      url
    }
    questions {
      __typename
      ... on ComponentQuestionTypesValuesNested {
        id
        title
        question
        description
        questions {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
        }
      }
      ... on ComponentQuestionTypesValuesCharacters {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesValuesBubble {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesValuesSliders {
        id
        title
        question
        description
        sliderQuestions {
          id
          question
          color
        }
      }
      ... on ComponentQuestionTypesValuesGaps {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesSimpleQuestion {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
      }
      ... on ComponentQuestionTypesXYGraph {
        id
        labelXEnglish
        labelYEnglish
        titleEnglish
        subTitleEnglish
        labelXFrench
        labelYFrench
        titleFrench
        subTitleFrench
        labelXGerman
        labelYGerman
        titleGerman
        subTitleGerman
        labelXSpanish
        labelYSpanish
        titleSpanish
        subTitleSpanish
        labelXMandarin
        labelYMandarin
        titleMandarin
        subTitleMandarin
      }
      ... on ComponentQuestionTypesMultipleChoice {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        viewPrevious
        option {
          id
          optionEnglish
          optionFrench
          optionGerman
          optionSpanish
          optionMandarin
          isCorrect
        }
        numberOfAnswers
      }
      ... on ComponentQuestionTypesSaboteur {
        id
        titleEnglish
        subTitleEnglish
        titleFrench
        subTitleFrench
        titleGerman
        subTitleGerman
        titleSpanish
        subTitleSpanish
        titleMandarin
        subTitleMandarin
        saboteurQuestions {
          link
          skipProof
          labelEnglish
          labelFrench
          labelGerman
          labelSpanish
          labelMandarin
          proof {
            ...uploadFile
          }
        }
        labelEnglish
        labelFrench
        labelGerman
        labelSpanish
      }
      ... on ComponentQuestionTypesNestedQuestions {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        viewPrevious
        questions {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          isNumeric
        }
      }
      ... on ComponentQuestionTypesGravitasScale {
        id
        titleEnglish
        subTitleEnglish
        questionOneEnglish
        questionTwoEnglish
        questionThreeEnglish
        titleOneEnglish
        titleTwoEnglish
        ratingInput {
          id
          labelOneEnglish
          labelTwoEnglish
        }
      }
      ... on ComponentQuestionTypesStakeholderMap {
        id
        titleEnglish
        subTitleEnglish
        titleFrench
        subTitleFrench
        titleSpanish
        subTitleSpanish
        titleGerman
        subTitleGerman
        titleMandarin
        subTitleMandarin
        questionX
        questionY
      }
      ... on ComponentQuestionTypesSaboteurVideos {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
        SaboteurVideo {
          id
          videoTitleEnglish
          videoTitleFrench
          videoTitleGerman
          videoTitleSpanish
          videoTitleMandarin
          video {
            url
            id
          }
        }
      }
      ... on ComponentQuestionTypesFeedForward1 {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesFeedForward2 {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesSimpleReadOnly {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleMandarin
        titleSpanish
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleMandarin
        subTitleSpanish
        contentEnglish
        contentFrench
        contentGerman
        contentMandarin
        contentSpanish
        photo {
          id
          url
        }
      }
      ... on ComponentQuestionTypesCompetency {
        id
        title
        question
        minNumber
        maxNumber
        miniLabel
        maxiLabel
        simpleQuestion
      }
      ... on ComponentQuestionTypesCompetency2 {
        titleEnglish
        titleFrench
        titleMandarin
        questionscompetency2 {
          title
          question
          maxiNumber
          miniNumber
          simpleQuestion
          miniLabel
          maxiLabel
          midiLabel
          textboxQuestion
        }
      }
      ... on ComponentQuestionTypesUploadDocuments {
        id
        titleEnglish
        titleFrench
        titleMandarin
        titleSpanish
        titleGerman
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleMandarin
        subTitleSpanish
      }
      ... on ComponentQuestionTypesGravitasGap {
        id
        title
        question
        description
        color1
        color2
        color3
      }
      ... on ComponentQuestionTypesGravitasSliders {
        titleEnglish
        titleFrench
        titleMandarin
        titleSpanish
        titleGerman
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        positiveHeadingEnglish
        positiveHeadingFrench
        positiveHeadingSpanish
        positiveHeadingMandarin
        positiveHeadingGerman
        negativeHeadingEnglish
        negativeHeadingFrench
        negativeHeadingSpanish
        negativeHeadingMandarin
        negativeHeadingGerman
        sliderQuestions {
          questionPositiveEnglish
          questionPositiveGerman
          questionPositiveMandarin
          questionPositiveSpanish
          questionPositiveFrench
          questionNegativeEnglish
          questionNegativeGerman
          questionNegativeFrench
          questionNegativeMandarin
          questionNegativeSpanish
        }
        sliderHeadings {
          headingEnglish
          headingSpanish
          headingGerman
          headingFrench
          rating
          color
        }
      }
    }
    events {
      id
      name
      link
      sessionId
    }
    showSession
    sub_module {
      id
      programme_type {
        id
        title
      }
    }
  }
}
    ${UploadFileFragmentDoc}`;
export type GetSectionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSectionQuery, GetSectionQueryVariables>, 'query'> & ({ variables: GetSectionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSectionComponent = (props: GetSectionComponentProps) => (
      <ApolloReactComponents.Query<GetSectionQuery, GetSectionQueryVariables> query={GetSectionDocument} {...props} />
    );
    
export type GetSectionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSectionQuery, GetSectionQueryVariables>
    } & TChildProps;
export function withGetSection<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSectionQuery,
  GetSectionQueryVariables,
  GetSectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSectionQuery, GetSectionQueryVariables, GetSectionProps<TChildProps, TDataName>>(GetSectionDocument, {
      alias: 'getSection',
      ...operationOptions
    });
};

/**
 * __useGetSectionQuery__
 *
 * To run a query within a React component, call `useGetSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSectionQuery, GetSectionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, baseOptions);
      }
export function useGetSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectionQuery, GetSectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, baseOptions);
        }
export type GetSectionQueryHookResult = ReturnType<typeof useGetSectionQuery>;
export type GetSectionLazyQueryHookResult = ReturnType<typeof useGetSectionLazyQuery>;
export type GetSectionQueryResult = ApolloReactCommon.QueryResult<GetSectionQuery, GetSectionQueryVariables>;
export const GetSectionsDocument = gql`
    query getSections {
  sections {
    id
    titleEnglish
    subTitleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    subTitleFrench
    subTitleGerman
    subTitleSpanish
    subTitleMandarin
    videoEnglish {
      id
      url
    }
    videoFrench {
      id
      url
    }
    videoGerman {
      id
      url
    }
    videoSpanish {
      id
      url
    }
    videoMandarin {
      id
      url
    }
    questions {
      __typename
      ... on ComponentQuestionTypesValuesNested {
        id
        title
        question
        description
        questions {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
        }
      }
      ... on ComponentQuestionTypesValuesCharacters {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesValuesBubble {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesValuesSliders {
        id
        title
        question
        description
        sliderQuestions {
          id
          question
          color
        }
      }
      ... on ComponentQuestionTypesValuesGaps {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesSimpleQuestion {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
      }
      ... on ComponentQuestionTypesXYGraph {
        id
        labelXEnglish
        labelYEnglish
        titleEnglish
        subTitleEnglish
        labelXFrench
        labelYFrench
        titleFrench
        subTitleFrench
        labelXGerman
        labelYGerman
        titleGerman
        subTitleGerman
        labelXSpanish
        labelYSpanish
        titleSpanish
        subTitleSpanish
        labelXMandarin
        labelYMandarin
        titleMandarin
        subTitleMandarin
      }
      ... on ComponentQuestionTypesMultipleChoice {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        option {
          id
          optionEnglish
          optionFrench
          optionGerman
          optionSpanish
          optionMandarin
          isCorrect
        }
        numberOfAnswers
      }
      ... on ComponentQuestionTypesSaboteur {
        id
        titleEnglish
        subTitleEnglish
        titleFrench
        subTitleFrench
        titleGerman
        subTitleGerman
        titleSpanish
        subTitleSpanish
        titleMandarin
        subTitleMandarin
        saboteurQuestions {
          link
          skipProof
          labelEnglish
          labelFrench
          labelGerman
          labelSpanish
          labelMandarin
          proof {
            ...uploadFile
          }
        }
        labelEnglish
        labelFrench
        labelGerman
        labelSpanish
      }
      ... on ComponentQuestionTypesNestedQuestions {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        questions {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          isNumeric
        }
      }
      ... on ComponentQuestionTypesGravitasScale {
        id
        titleEnglish
        subTitleEnglish
        questionOneEnglish
        questionTwoEnglish
        questionThreeEnglish
        titleOneEnglish
        titleTwoEnglish
        titleFrench
        subTitleFrench
        questionOneFrench
        questionTwoFrench
        questionThreeFrench
        titleOneFrench
        titleTwoFrench
        titleGerman
        subTitleGerman
        questionOneGerman
        questionTwoGerman
        questionThreeGerman
        titleOneGerman
        titleTwoGerman
        titleSpanish
        subTitleSpanish
        questionOneSpanish
        questionTwoSpanish
        questionThreeSpanish
        titleOneSpanish
        titleTwoSpanish
        titleMandarin
        subTitleMandarin
        questionOneMandarin
        questionTwoMandarin
        questionThreeMandarin
        titleOneMandarin
        titleTwoMandarin
        ratingInput {
          id
          labelOneEnglish
          labelTwoEnglish
          labelOneFrench
          labelTwoFrench
          labelOneGerman
          labelTwoGerman
          labelOneSpanish
          labelTwoSpanish
          labelOneMandarin
          labelTwoMandarin
        }
      }
      ... on ComponentQuestionTypesStakeholderMap {
        id
        titleEnglish
        subTitleEnglish
        titleFrench
        subTitleFrench
        titleGerman
        subTitleGerman
        titleSpanish
        subTitleSpanish
        titleMandarin
        subTitleMandarin
        questionX
        questionY
      }
      ... on ComponentQuestionTypesSaboteurVideos {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
        SaboteurVideo {
          id
          videoTitleEnglish
          videoTitleFrench
          videoTitleGerman
          videoTitleSpanish
          videoTitleMandarin
          video {
            url
            id
          }
        }
      }
      ... on ComponentQuestionTypesFeedForward1 {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesFeedForward2 {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesSimpleReadOnly {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleMandarin
        titleSpanish
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleMandarin
        subTitleSpanish
        contentEnglish
        contentFrench
        contentGerman
        contentMandarin
        contentSpanish
        photo {
          id
          url
        }
      }
      ... on ComponentQuestionTypesCompetency {
        id
        title
        question
        minNumber
        maxNumber
        miniLabel
        maxiLabel
        simpleQuestion
      }
      ... on ComponentQuestionTypesUploadDocuments {
        id
        titleEnglish
        titleFrench
        titleMandarin
        titleSpanish
        titleGerman
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleMandarin
        subTitleSpanish
      }
      ... on ComponentQuestionTypesGravitasGap {
        id
        title
        question
        description
        color1
        color2
        color3
      }
      ... on ComponentQuestionTypesGravitasSliders {
        titleEnglish
        titleFrench
        titleMandarin
        titleSpanish
        titleGerman
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        positiveHeadingEnglish
        positiveHeadingFrench
        positiveHeadingSpanish
        positiveHeadingMandarin
        positiveHeadingGerman
        negativeHeadingEnglish
        negativeHeadingFrench
        negativeHeadingSpanish
        negativeHeadingMandarin
        negativeHeadingGerman
        sliderQuestions {
          questionPositiveEnglish
          questionPositiveGerman
          questionPositiveMandarin
          questionPositiveSpanish
          questionPositiveFrench
          questionNegativeEnglish
          questionNegativeGerman
          questionNegativeFrench
          questionNegativeMandarin
          questionNegativeSpanish
        }
        sliderHeadings {
          headingEnglish
          headingSpanish
          headingGerman
          headingFrench
          headingMandarin
          color
          rating
        }
      }
      ... on ComponentQuestionTypesCompetency2 {
        titleEnglish
        titleFrench
        titleMandarin
        questionscompetency2 {
          title
          question
          maxiNumber
          miniNumber
          simpleQuestion
          miniLabel
          maxiLabel
          midiLabel
          textboxQuestion
        }
      }
    }
    events {
      id
      name
      link
      sessionId
    }
    showSession
    archive
  }
}
    ${UploadFileFragmentDoc}`;
export type GetSectionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSectionsQuery, GetSectionsQueryVariables>, 'query'>;

    export const GetSectionsComponent = (props: GetSectionsComponentProps) => (
      <ApolloReactComponents.Query<GetSectionsQuery, GetSectionsQueryVariables> query={GetSectionsDocument} {...props} />
    );
    
export type GetSectionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSectionsQuery, GetSectionsQueryVariables>
    } & TChildProps;
export function withGetSections<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSectionsQuery,
  GetSectionsQueryVariables,
  GetSectionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSectionsQuery, GetSectionsQueryVariables, GetSectionsProps<TChildProps, TDataName>>(GetSectionsDocument, {
      alias: 'getSections',
      ...operationOptions
    });
};

/**
 * __useGetSectionsQuery__
 *
 * To run a query within a React component, call `useGetSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSectionsQuery, GetSectionsQueryVariables>(GetSectionsDocument, baseOptions);
      }
export function useGetSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSectionsQuery, GetSectionsQueryVariables>(GetSectionsDocument, baseOptions);
        }
export type GetSectionsQueryHookResult = ReturnType<typeof useGetSectionsQuery>;
export type GetSectionsLazyQueryHookResult = ReturnType<typeof useGetSectionsLazyQuery>;
export type GetSectionsQueryResult = ApolloReactCommon.QueryResult<GetSectionsQuery, GetSectionsQueryVariables>;
export const GetCoachSessionsDocument = gql`
    query getCoachSessions {
  coachSessions {
    id
    title
    status
    user {
      id
    }
    programme_submission {
      id
    }
    sub_module_submission {
      id
    }
    appointment {
      appointmentUrl
      appointmentStartDate
      appointmentEndDate
      status
    }
  }
}
    `;
export type GetCoachSessionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>, 'query'>;

    export const GetCoachSessionsComponent = (props: GetCoachSessionsComponentProps) => (
      <ApolloReactComponents.Query<GetCoachSessionsQuery, GetCoachSessionsQueryVariables> query={GetCoachSessionsDocument} {...props} />
    );
    
export type GetCoachSessionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>
    } & TChildProps;
export function withGetCoachSessions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCoachSessionsQuery,
  GetCoachSessionsQueryVariables,
  GetCoachSessionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCoachSessionsQuery, GetCoachSessionsQueryVariables, GetCoachSessionsProps<TChildProps, TDataName>>(GetCoachSessionsDocument, {
      alias: 'getCoachSessions',
      ...operationOptions
    });
};

/**
 * __useGetCoachSessionsQuery__
 *
 * To run a query within a React component, call `useGetCoachSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoachSessionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>(GetCoachSessionsDocument, baseOptions);
      }
export function useGetCoachSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>(GetCoachSessionsDocument, baseOptions);
        }
export type GetCoachSessionsQueryHookResult = ReturnType<typeof useGetCoachSessionsQuery>;
export type GetCoachSessionsLazyQueryHookResult = ReturnType<typeof useGetCoachSessionsLazyQuery>;
export type GetCoachSessionsQueryResult = ApolloReactCommon.QueryResult<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>;
export const GetSubModuleDocument = gql`
    query getSubModule($id: ID!) {
  subModule(id: $id) {
    id
    nameEnglish
    nameFrench
    nameSpanish
    nameGerman
    nameMandarin
    descriptionEnglish
    descriptionFrench
    descriptionSpanish
    descriptionGerman
    descriptionMandarin
    cover {
      id
      url
    }
    sections {
      id
      titleFrench
      titleGerman
      titleEnglish
      titleSpanish
      titleMandarin
      subTitleFrench
      subTitleGerman
      subTitleEnglish
      subTitleSpanish
      subTitleMandarin
      videoEnglish {
        id
        url
      }
      videoGerman {
        id
        url
      }
      videoSpanish {
        id
        url
      }
      videoMandarin {
        id
        url
      }
      videoFrench {
        id
        url
      }
      cover {
        id
        url
      }
      questions {
        ...questions
      }
      position
      archive
    }
    programme_type {
      id
      title
      description
      position
      cover {
        id
        url
      }
      isCoaching
      isSubModule
      notes
      showArticle
      showSession
      showParticipants
      competencySurvey
      feedForwardSurvey
      deadline
      articles {
        id
        created_at
        updated_at
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        contentEnglish
        contentFrench
        contentGerman
        contentSpanish
        contentMandarin
        image {
          url
        }
        datePublished
        readTime
        link
      }
      modal {
        id
        title
        subtitle
        message
        image {
          id
          url
          name
        }
      }
      events {
        id
        name
        link
      }
    }
  }
}
    ${QuestionsFragmentDoc}`;
export type GetSubModuleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubModuleQuery, GetSubModuleQueryVariables>, 'query'> & ({ variables: GetSubModuleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubModuleComponent = (props: GetSubModuleComponentProps) => (
      <ApolloReactComponents.Query<GetSubModuleQuery, GetSubModuleQueryVariables> query={GetSubModuleDocument} {...props} />
    );
    
export type GetSubModuleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubModuleQuery, GetSubModuleQueryVariables>
    } & TChildProps;
export function withGetSubModule<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubModuleQuery,
  GetSubModuleQueryVariables,
  GetSubModuleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubModuleQuery, GetSubModuleQueryVariables, GetSubModuleProps<TChildProps, TDataName>>(GetSubModuleDocument, {
      alias: 'getSubModule',
      ...operationOptions
    });
};

/**
 * __useGetSubModuleQuery__
 *
 * To run a query within a React component, call `useGetSubModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubModuleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubModuleQuery, GetSubModuleQueryVariables>(GetSubModuleDocument, baseOptions);
      }
export function useGetSubModuleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubModuleQuery, GetSubModuleQueryVariables>(GetSubModuleDocument, baseOptions);
        }
export type GetSubModuleQueryHookResult = ReturnType<typeof useGetSubModuleQuery>;
export type GetSubModuleLazyQueryHookResult = ReturnType<typeof useGetSubModuleLazyQuery>;
export type GetSubModuleQueryResult = ApolloReactCommon.QueryResult<GetSubModuleQuery, GetSubModuleQueryVariables>;
export const GetMySubModuleSubmissionDocument = gql`
    query getMySubModuleSubmission($id: ID!) {
  subModuleSubmission(id: $id) {
    id
    view
    progress
    status
    timeSpent
    participants {
      id
      name
      email
      type
    }
    submissionparticipants {
      id
      name
      email
    }
    feedfoward_url {
      id
    }
    language {
      id
      name
    }
    sub_module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleFrench
        titleGerman
        titleEnglish
        titleSpanish
        titleMandarin
        subTitleFrench
        subTitleGerman
        subTitleEnglish
        subTitleSpanish
        subTitleMandarin
        cover {
          id
          url
        }
        position
        archive
      }
      position
      programme_type {
        id
        title
        description
        position
        cover {
          id
          url
        }
        isCoaching
        isSubModule
        notes
        showArticle
        showSession
        showParticipants
        competencySurvey
        feedForwardSurvey
        deadline
        articles {
          id
          created_at
          updated_at
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          contentEnglish
          contentFrench
          contentGerman
          contentSpanish
          contentMandarin
          image {
            url
          }
          datePublished
          readTime
          link
        }
        modal {
          id
          title
          subtitle
          message
          image {
            id
            url
            name
          }
        }
        events {
          id
          name
          link
        }
        showStatistics
      }
    }
    section {
      id
      progress
      section {
        id
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        steps
        response
      }
      uploadDocuments {
        saboteurProofValue {
          id
        }
      }
    }
    reports {
      id
      name
      type
      report {
        id
        url
      }
      sectionOrModuleId
    }
  }
}
    `;
export type GetMySubModuleSubmissionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>, 'query'> & ({ variables: GetMySubModuleSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMySubModuleSubmissionComponent = (props: GetMySubModuleSubmissionComponentProps) => (
      <ApolloReactComponents.Query<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables> query={GetMySubModuleSubmissionDocument} {...props} />
    );
    
export type GetMySubModuleSubmissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>
    } & TChildProps;
export function withGetMySubModuleSubmission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubModuleSubmissionQuery,
  GetMySubModuleSubmissionQueryVariables,
  GetMySubModuleSubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables, GetMySubModuleSubmissionProps<TChildProps, TDataName>>(GetMySubModuleSubmissionDocument, {
      alias: 'getMySubModuleSubmission',
      ...operationOptions
    });
};

/**
 * __useGetMySubModuleSubmissionQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMySubModuleSubmissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>(GetMySubModuleSubmissionDocument, baseOptions);
      }
export function useGetMySubModuleSubmissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>(GetMySubModuleSubmissionDocument, baseOptions);
        }
export type GetMySubModuleSubmissionQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionQuery>;
export type GetMySubModuleSubmissionLazyQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionLazyQuery>;
export type GetMySubModuleSubmissionQueryResult = ApolloReactCommon.QueryResult<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>;
export const GetSubModulesDocument = gql`
    query getSubModules($where: JSON!) {
  subModules(where: $where) {
    id
    nameEnglish
    nameFrench
    nameGerman
    nameSpanish
    nameMandarin
    descriptionEnglish
    descriptionFrench
    descriptionGerman
    descriptionSpanish
    descriptionMandarin
    cover {
      id
      url
    }
    sections {
      id
      titleEnglish
      titleFrench
      titleGerman
      titleSpanish
      titleMandarin
      subTitleEnglish
      subTitleFrench
      subTitleGerman
      subTitleSpanish
      subTitleMandarin
      videoEnglish {
        id
        url
      }
      videoFrench {
        id
        url
      }
      videoGerman {
        id
        url
      }
      videoSpanish {
        id
        url
      }
      videoMandarin {
        id
        url
      }
      questions {
        ...questions
      }
      archive
    }
  }
}
    ${QuestionsFragmentDoc}`;
export type GetSubModulesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubModulesQuery, GetSubModulesQueryVariables>, 'query'> & ({ variables: GetSubModulesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubModulesComponent = (props: GetSubModulesComponentProps) => (
      <ApolloReactComponents.Query<GetSubModulesQuery, GetSubModulesQueryVariables> query={GetSubModulesDocument} {...props} />
    );
    
export type GetSubModulesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubModulesQuery, GetSubModulesQueryVariables>
    } & TChildProps;
export function withGetSubModules<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubModulesQuery,
  GetSubModulesQueryVariables,
  GetSubModulesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubModulesQuery, GetSubModulesQueryVariables, GetSubModulesProps<TChildProps, TDataName>>(GetSubModulesDocument, {
      alias: 'getSubModules',
      ...operationOptions
    });
};

/**
 * __useGetSubModulesQuery__
 *
 * To run a query within a React component, call `useGetSubModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubModulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSubModulesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubModulesQuery, GetSubModulesQueryVariables>(GetSubModulesDocument, baseOptions);
      }
export function useGetSubModulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubModulesQuery, GetSubModulesQueryVariables>(GetSubModulesDocument, baseOptions);
        }
export type GetSubModulesQueryHookResult = ReturnType<typeof useGetSubModulesQuery>;
export type GetSubModulesLazyQueryHookResult = ReturnType<typeof useGetSubModulesLazyQuery>;
export type GetSubModulesQueryResult = ApolloReactCommon.QueryResult<GetSubModulesQuery, GetSubModulesQueryVariables>;
export const GetSectionReportDocument = gql`
    query getSectionReport($id: ID!) {
  getSectionReport(id: $id) {
    id
    name
    type
    report {
      id
      url
    }
    sectionOrModuleId
  }
}
    `;
export type GetSectionReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSectionReportQuery, GetSectionReportQueryVariables>, 'query'> & ({ variables: GetSectionReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSectionReportComponent = (props: GetSectionReportComponentProps) => (
      <ApolloReactComponents.Query<GetSectionReportQuery, GetSectionReportQueryVariables> query={GetSectionReportDocument} {...props} />
    );
    
export type GetSectionReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSectionReportQuery, GetSectionReportQueryVariables>
    } & TChildProps;
export function withGetSectionReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSectionReportQuery,
  GetSectionReportQueryVariables,
  GetSectionReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSectionReportQuery, GetSectionReportQueryVariables, GetSectionReportProps<TChildProps, TDataName>>(GetSectionReportDocument, {
      alias: 'getSectionReport',
      ...operationOptions
    });
};

/**
 * __useGetSectionReportQuery__
 *
 * To run a query within a React component, call `useGetSectionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSectionReportQuery, GetSectionReportQueryVariables>(GetSectionReportDocument, baseOptions);
      }
export function useGetSectionReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSectionReportQuery, GetSectionReportQueryVariables>(GetSectionReportDocument, baseOptions);
        }
export type GetSectionReportQueryHookResult = ReturnType<typeof useGetSectionReportQuery>;
export type GetSectionReportLazyQueryHookResult = ReturnType<typeof useGetSectionReportLazyQuery>;
export type GetSectionReportQueryResult = ApolloReactCommon.QueryResult<GetSectionReportQuery, GetSectionReportQueryVariables>;
export const GetMySubmissionDocument = gql`
    query getMySubmission($id: ID!) {
  submission(id: $id) {
    id
    views
    progress
    status
    timeSpent
    language {
      id
      name
    }
    module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleFrench
        titleGerman
        titleEnglish
        titleSpanish
        titleMandarin
        subTitleFrench
        subTitleGerman
        subTitleEnglish
        subTitleSpanish
        subTitleMandarin
        cover {
          id
          url
        }
      }
      position
    }
    section {
      id
      progress
      section {
        id
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
    }
    reports {
      id
      name
      type
      report {
        id
        url
      }
      sectionOrModuleId
    }
  }
}
    `;
export type GetMySubmissionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>, 'query'> & ({ variables: GetMySubmissionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMySubmissionComponent = (props: GetMySubmissionComponentProps) => (
      <ApolloReactComponents.Query<GetMySubmissionQuery, GetMySubmissionQueryVariables> query={GetMySubmissionDocument} {...props} />
    );
    
export type GetMySubmissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubmissionQuery, GetMySubmissionQueryVariables>
    } & TChildProps;
export function withGetMySubmission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubmissionQuery,
  GetMySubmissionQueryVariables,
  GetMySubmissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubmissionQuery, GetMySubmissionQueryVariables, GetMySubmissionProps<TChildProps, TDataName>>(GetMySubmissionDocument, {
      alias: 'getMySubmission',
      ...operationOptions
    });
};

/**
 * __useGetMySubmissionQuery__
 *
 * To run a query within a React component, call `useGetMySubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMySubmissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubmissionQuery, GetMySubmissionQueryVariables>(GetMySubmissionDocument, baseOptions);
      }
export function useGetMySubmissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubmissionQuery, GetMySubmissionQueryVariables>(GetMySubmissionDocument, baseOptions);
        }
export type GetMySubmissionQueryHookResult = ReturnType<typeof useGetMySubmissionQuery>;
export type GetMySubmissionLazyQueryHookResult = ReturnType<typeof useGetMySubmissionLazyQuery>;
export type GetMySubmissionQueryResult = ApolloReactCommon.QueryResult<GetMySubmissionQuery, GetMySubmissionQueryVariables>;
export const GetSubmissionReportGroupedDocument = gql`
    query getSubmissionReportGrouped {
  getSubmissionReportGrouped {
    id
    name
    type
    created_by
    updated_by
    programmeType
    sub_module_submission
    notification
    report {
      id
      url
    }
  }
}
    `;
export type GetSubmissionReportGroupedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>, 'query'>;

    export const GetSubmissionReportGroupedComponent = (props: GetSubmissionReportGroupedComponentProps) => (
      <ApolloReactComponents.Query<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables> query={GetSubmissionReportGroupedDocument} {...props} />
    );
    
export type GetSubmissionReportGroupedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>
    } & TChildProps;
export function withGetSubmissionReportGrouped<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubmissionReportGroupedQuery,
  GetSubmissionReportGroupedQueryVariables,
  GetSubmissionReportGroupedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables, GetSubmissionReportGroupedProps<TChildProps, TDataName>>(GetSubmissionReportGroupedDocument, {
      alias: 'getSubmissionReportGrouped',
      ...operationOptions
    });
};

/**
 * __useGetSubmissionReportGroupedQuery__
 *
 * To run a query within a React component, call `useGetSubmissionReportGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionReportGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionReportGroupedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmissionReportGroupedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>(GetSubmissionReportGroupedDocument, baseOptions);
      }
export function useGetSubmissionReportGroupedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>(GetSubmissionReportGroupedDocument, baseOptions);
        }
export type GetSubmissionReportGroupedQueryHookResult = ReturnType<typeof useGetSubmissionReportGroupedQuery>;
export type GetSubmissionReportGroupedLazyQueryHookResult = ReturnType<typeof useGetSubmissionReportGroupedLazyQuery>;
export type GetSubmissionReportGroupedQueryResult = ApolloReactCommon.QueryResult<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>;
export const GetTranslationsDocument = gql`
    query getTranslations {
  translation {
    id
    menu {
      id
      homeEnglish
      myProgrammeEnglish
      myWorkEnglish
      myLibraryEnglish
      myProfileEnglish
      helpAndSupportEnglish
      signOutEnglish
      homeFrench
      myProgrammeFrench
      myWorkFrench
      myLibraryFrench
      myProfileFrench
      helpAndSupportFrench
      signOutFrench
      homeGerman
      myProgrammeGerman
      myWorkGerman
      myLibraryGerman
      myProfileGerman
      helpAndSupportGerman
      signOutGerman
      homeSpanish
      myProgrammeSpanish
      myWorkSpanish
      myLibrarySpanish
      myProfileSpanish
      helpAndSupportSpanish
      signOutSpanish
      homeMandarin
      myProgrammeMandarin
      myWorkMandarin
      myLibraryMandarin
      myProfileMandarin
      helpAndSupportMandarin
      signOutMandarin
      aboutUsEnglish
      aboutUsGerman
      aboutUsFrench
      myNotesEnglish
      myNotesGerman
      myNotesFrench
      myNotesSpanish
      myNotesMandarin
      notificationsEnglish
      notificationsGerman
      notificationsFrench
      notificationsSpanish
      notificationsMandarin
    }
    languageSelection {
      id
      titleEnglish
      bodyEnglish
      nextButtonEnglish
      titleFrench
      bodyFrench
      nextButtonFrench
      titleGerman
      bodyGerman
      nextButtonGerman
      titleMandarin
      bodyMandarin
      nextButtonMandarin
      titleSpanish
      bodySpanish
      nextButtonSpanish
    }
    welcomeScreen {
      id
      titleEnglish
      bodyEnglish
      videoEnglish {
        id
        url
      }
      nextButtonEnglish
      titleFrench
      bodyFrench
      videoFrench {
        id
        url
      }
      nextButtonFrench
      titleGerman
      bodyGerman
      videoGerman {
        id
        url
      }
      nextButtonGerman
      titleMandarin
      bodyMandarin
      videoMandarin {
        id
        url
      }
      nextButtonMandarin
      titleSpanish
      bodySpanish
      videoSpanish {
        id
        url
      }
      nextButtonSpanish
    }
    letsGetStartedScreen {
      id
      titleEnglish
      subTitleEnglish
      firstNameLabelEnglish
      firstNameErrorEnglish
      lastNameLabelEnglish
      lastNameErrorEnglish
      jobTitleLabelEnglish
      jobTitleErrorEnglish
      divisionLabelEnglish
      divisionErrorEnglish
      timezoneLabelEnglish
      regionLabelEnglish
      regionErrorEnglish
      image {
        id
        url
      }
      nextButtonEnglish
      titleFrench
      subTitleFrench
      firstNameLabelFrench
      firstNameErrorFrench
      lastNameLabelFrench
      lastNameErrorFrench
      jobTitleLabelFrench
      jobTitleErrorFrench
      divisionLabelFrench
      divisionErrorFrench
      timezoneLabelFrench
      regionLabelFrench
      regionErrorFrench
      nextButtonFrench
      titleGerman
      subTitleGerman
      firstNameLabelGerman
      firstNameErrorGerman
      lastNameLabelGerman
      lastNameErrorGerman
      jobTitleLabelGerman
      jobTitleErrorGerman
      divisionLabelGerman
      divisionErrorGerman
      timezoneLabelGerman
      regionLabelGerman
      regionErrorGerman
      nextButtonGerman
      titleMandarin
      subTitleMandarin
      firstNameLabelMandarin
      firstNameErrorMandarin
      lastNameLabelMandarin
      lastNameErrorMandarin
      jobTitleLabelMandarin
      jobTitleErrorMandarin
      divisionLabelMandarin
      divisionErrorMandarin
      timezoneLabelMandarin
      regionLabelMandarin
      regionErrorMandarin
      nextButtonMandarin
      titleSpanish
      subTitleSpanish
      firstNameLabelSpanish
      firstNameErrorSpanish
      lastNameLabelSpanish
      lastNameErrorSpanish
      jobTitleLabelSpanish
      jobTitleErrorSpanish
      divisionLabelSpanish
      divisionErrorSpanish
      timezoneLabelSpanish
      regionLabelSpanish
      regionErrorSpanish
      nextButtonSpanish
      leftTitleEnglish
      leftSubtitleEnglish
      leftTitleSpanish
      leftSubtitleSpanish
      leftTitleMandarin
      leftSubTitleMandarin
      leftTitleFrench
      leftSubtitleFrench
      leftSubtitleGerman
      leftTitleGerman
      havingTroubleEnglish
      havingTroubleGerman
      havingTroubleFrench
      havingTroubleMandarin
      havingTroubleSpanish
      getHelpButtonEnglish
      getHelpButtonSpanish
      getHelpButtonFrench
      getHelpButtonGerman
      getHelpButtonMandarin
    }
    whatToExpect {
      id
      titleEnglish
      bodyEnglish
      image {
        id
        url
      }
      getStartedButtonEnglish
      titleFrench
      bodyFrench
      getStartedButtonFrench
      titleGerman
      bodyGerman
      getStartedButtonGerman
      titleMandarin
      bodyMandarin
      getStartedButtonMandarin
      titleSpanish
      bodySpanish
      getStartedButtonSpanish
    }
    homeScreen {
      id
      titleEnglish
      myProgrammeEnglish
      completedModulesEnglish
      noChangesEnglish
      changesUpEnglish
      changesDownEnglish
      viewModulesEnglish
      myLibraryEnglish
      viewedArticlesEnglish
      viewLibraryEnglish
      titleFrench
      myProgrammeFrench
      completedModulesFrench
      noChangesFrench
      changesUpFrench
      changesDownFrench
      viewModulesFrench
      myLibraryFrench
      viewedArticlesFrench
      viewLibraryFrench
      titleGerman
      myProgrammeGerman
      completedModulesGerman
      noChangesGerman
      changesUpGerman
      changesDownGerman
      viewModulesGerman
      myLibraryGerman
      viewedArticlesGerman
      viewLibraryGerman
      titleSpanish
      myProgrammeSpanish
      completedModulesSpanish
      noChangesSpanish
      changesUpSpanish
      changesDownSpanish
      viewModulesSpanish
      myLibrarySpanish
      viewedArticlesSpanish
      viewLibrarySpanish
      titleMandarin
      myProgrammeMandarin
      completedModulesMandarin
      noChangesMandarin
      changesUpMandarin
      changesDownMandarin
      viewModulesMandarin
      myLibraryMandarin
      viewedArticlesMandarin
      viewLibraryMandarin
      welcomeEnglish
      welcomeFrench
      welcomeGerman
      welcomeSpanish
      welcomeMandarin
      programmeProgressEnglish
      programmeProgressFrench
      programmeProgressGerman
      programmeProgressSpanish
      programmeProgressMandarin
      whatsNextEnglish
      whatsNextFrench
      whatsNextGerman
      whatsNextSpanish
      whatsNextMandarin
      whatToExpectEnglish
      whatToExpectFrench
      whatToExpectGerman
      whatToExpectSpanish
      whatToExpectMandarin
    }
    myWorkScreen {
      id
      emptyStateTitleEnglish
      emptyStateDescEnglish
      subtitleEnglish
      feedbackEnglish
      feedbackNotEligibleEnglish
      feedbackNotReceivedEnglish
      notStartedEnglish
      emptyStateTitleFrench
      emptyStateDescFrench
      subtitleFrench
      feedbackFrench
      feedbackNotEligibleFrench
      feedbackNotReceivedFrench
      notStartedFrench
      emptyStateTitleGerman
      emptyStateDescGerman
      subtitleGerman
      feedbackGerman
      feedbackNotEligibleGerman
      feedbackNotReceivedGerman
      notStartedGerman
      emptyStateTitleSpanish
      emptyStateDescSpanish
      subtitleSpanish
      feedbackSpanish
      feedbackNotEligibleSpanish
      feedbackNotReceivedSpanish
      notStartedSpanish
      emptyStateTitleMandarin
      emptyStateDescMandarin
      subtitleMandarin
      feedbackMandarin
      feedbackNotEligibleMandarin
      feedbackNotReceivedMandarin
      notStartedMandarin
      downloadContentTextEnglish
      downloadContentTextFrench
      downloadContentTextGerman
      downloadContentTextSpanish
      downloadContentTextMandarin
      myNotesEnglish
      myNotesSpanish
      myNotesFrench
      myNotesGerman
      myNotesMandarin
      moduleReportsEnglish
      moduleReportsSpanish
      moduleReportsFrench
      moduleReportsGerman
      moduleReportsMandarin
      documentsEnglish
      documentsSpanish
      documentsMandarin
      documentsSpanish
      documentsFrench
    }
    myLibraryScreen {
      id
      allArticlesEnglish
      myBookmarksEnglish
      allArticlesFrench
      myBookmarksFrench
      allArticlesGerman
      myBookmarksGerman
      allArticlesSpanish
      myBookmarksSpanish
      allArticlesMandarin
      myBookmarksMandarin
      viewArticleEnglish
      viewArticleFrench
      viewArticleGerman
      viewArticleSpanish
      viewArticleMandarin
    }
    myProfileScreen {
      id
      detailsEnglish
      settingsEnglish
      logoutEnglish
      joinEnglish
      detailsFrench
      settingsFrench
      logoutFrench
      joinFrench
      detailsGerman
      settingsGerman
      logoutGerman
      joinGerman
      detailsSpanish
      settingsSpanish
      logoutSpanish
      joinSpanish
      detailsMandarin
      settingsMandarin
      logoutMandarin
    }
    personalScreen {
      id
      changePhotoEnglish
      firstNameLabelEnglish
      lastNameLabelEnglish
      emailLabelEnglish
      jobTitleLabelEnglish
      divisionLabelEnglish
      editInfoButtonEnglish
      changePhotoFrench
      firstNameLabelFrench
      lastNameLabelFrench
      emailLabelFrench
      jobTitleLabelFrench
      divisionLabelFrench
      editInfoButtonFrench
      changePhotoGerman
      firstNameLabelGerman
      lastNameLabelGerman
      emailLabelGerman
      jobTitleLabelGerman
      divisionLabelGerman
      editInfoButtonGerman
      changePhotoSpanish
      firstNameLabelSpanish
      lastNameLabelSpanish
      emailLabelSpanish
      jobTitleLabelSpanish
      divisionLabelSpanish
      editInfoButtonSpanish
      changePhotoMandarin
      firstNameLabelMandarin
      lastNameLabelMandarin
      emailLabelMandarin
      jobTitleLabelMandarin
      divisionLabelMandarin
      editInfoButtonMandarin
      resetPasswordEnglish
      resetPasswordFrench
      resetPasswordGerman
      resetPasswordSpanish
      resetPasswordMandarin
    }
    settingsScreen {
      id
      titleEnglish
      saveButtonEnglish
      titleFrench
      saveButtonFrench
      titleGerman
      saveButtonGerman
      titleSpanish
      saveButtonSpanish
      titleMandarin
      saveButtonMandarin
    }
    helpAndSupport {
      id
      titleEnglish
      knowledgeBaseEnglish
      liveChatEnglish
      myTicketsEnglish
      titleFrench
      knowledgeBaseFrench
      liveChatFrench
      myTicketsFrench
      titleGerman
      knowledgeBaseGerman
      liveChatGerman
      myTicketsGerman
      titleSpanish
      knowledgeBaseSpanish
      liveChatSpanish
      myTicketsSpanish
      titleMandarin
      knowledgeBaseMandarin
      liveChatMandarin
      myTicketsMandarin
    }
    aboutUs {
      id
      textEnglish
      textFrench
      textGerman
      userGuidelinesTextEnglish
      userGuidelinesTextGerman
      userGuidelinesTextFrench
      userGuidelinesEnglish {
        id
        url
      }
      userGuidelinesGerman {
        id
        url
      }
      userGuidelinesFrench {
        id
        url
      }
    }
    buttons {
      id
      backBtnsEnglish
      backBtnsFrench
      backBtnsGerman
      nextBtnsEnglish
      nextBtnsFrench
      nextBtnsGerman
      addMoreBtnsEnglish
      addMoreBtnsFrench
      addMoreBtnsGerman
    }
    programmesScreen {
      id
      changeButtonEnglish
      changeButtonFrench
      changeButtonGerman
      changeButtonSpanish
      changeButtonMandarin
      programmeOverviewEnglish
      programmeOverviewFrench
      programmeOverviewGerman
      programmeOverviewSpanish
      programmeOverviewMandarin
      programmeTextEnglish
      programmeTextFrench
      programmeTextGerman
      programmeTextSpanish
      programmeTextMandarin
      informationEnglish
      informationFrench
      informationGerman
      informationSpanish
      informationMandarin
      selectProgrammesTitleEnglish
      selectProgrammesTitleFrench
      selectProgrammesTitleGerman
      selectProgrammesTitleSpanish
      selectProgrammesTitleMandarin
      selectProgrammesSubTitleEnglish
      selectProgrammesSubTitleFrench
      selectProgrammesSubTitleGerman
      selectProgrammesSubTitleSpanish
      selectProgrammesSubTitleMandarin
      selectButtonEnglish
      selectButtonFrench
      selectButtonGerman
      selectButtonSpanish
      selectButtonMandarin
      changeProgrammeTypeEnglish
      changeProgrammeTypeFrench
      changeProgrammeTypeGerman
      changeProgrammeTypeSpanish
      changeProgrammeTypeMandarin
    }
    faqs {
      faqsEnglish {
        question
        answer
      }
      faqsFrench {
        question
        answer
      }
      faqsGerman {
        question
        answer
      }
      faqsMandarin {
        question
        answer
      }
      faqsSpanish {
        question
        answer
      }
    }
    dashboardScreen {
      id
      myProgrammesEnglish
      myProgrammesFrench
      myProgrammesGerman
      myProgrammesSpanish
      myProgrammesMandarin
      suggestedTitleEnglish
      suggestedTitleFrench
      suggestedTitleGerman
      suggestedTitleSpanish
      suggestedTitleMandarin
      uploadTitleEnglish
      uploadTitleFrench
      uploadTitleGerman
      uploadTitleSpanish
      uploadTitleMandarin
      viewAllEnglish
      viewAllFrench
      viewAllGerman
      viewAllSpanish
      viewAllMandarin
      logOutDashboardEnglish
      logOutDashboardFrench
      logOutDashboardGerman
      logOutDashboardSpanish
      logOutDashboardMandarin
      notepadTextEnglish
      notepadTextFrench
      notepadTextGerman
      notepadTextSpanish
      notepadTextMandarin
    }
  }
}
    `;
export type GetTranslationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTranslationsQuery, GetTranslationsQueryVariables>, 'query'>;

    export const GetTranslationsComponent = (props: GetTranslationsComponentProps) => (
      <ApolloReactComponents.Query<GetTranslationsQuery, GetTranslationsQueryVariables> query={GetTranslationsDocument} {...props} />
    );
    
export type GetTranslationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTranslationsQuery, GetTranslationsQueryVariables>
    } & TChildProps;
export function withGetTranslations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTranslationsQuery,
  GetTranslationsQueryVariables,
  GetTranslationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTranslationsQuery, GetTranslationsQueryVariables, GetTranslationsProps<TChildProps, TDataName>>(GetTranslationsDocument, {
      alias: 'getTranslations',
      ...operationOptions
    });
};

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, baseOptions);
      }
export function useGetTranslationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, baseOptions);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsQueryResult = ApolloReactCommon.QueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export const GetTypeformCompetencyResponsesDocument = gql`
    query getTypeformCompetencyResponses {
  getTypeformCompetencyResponses {
    success
  }
}
    `;
export type GetTypeformCompetencyResponsesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>, 'query'>;

    export const GetTypeformCompetencyResponsesComponent = (props: GetTypeformCompetencyResponsesComponentProps) => (
      <ApolloReactComponents.Query<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables> query={GetTypeformCompetencyResponsesDocument} {...props} />
    );
    
export type GetTypeformCompetencyResponsesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>
    } & TChildProps;
export function withGetTypeformCompetencyResponses<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTypeformCompetencyResponsesQuery,
  GetTypeformCompetencyResponsesQueryVariables,
  GetTypeformCompetencyResponsesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables, GetTypeformCompetencyResponsesProps<TChildProps, TDataName>>(GetTypeformCompetencyResponsesDocument, {
      alias: 'getTypeformCompetencyResponses',
      ...operationOptions
    });
};

/**
 * __useGetTypeformCompetencyResponsesQuery__
 *
 * To run a query within a React component, call `useGetTypeformCompetencyResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTypeformCompetencyResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTypeformCompetencyResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTypeformCompetencyResponsesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>(GetTypeformCompetencyResponsesDocument, baseOptions);
      }
export function useGetTypeformCompetencyResponsesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>(GetTypeformCompetencyResponsesDocument, baseOptions);
        }
export type GetTypeformCompetencyResponsesQueryHookResult = ReturnType<typeof useGetTypeformCompetencyResponsesQuery>;
export type GetTypeformCompetencyResponsesLazyQueryHookResult = ReturnType<typeof useGetTypeformCompetencyResponsesLazyQuery>;
export type GetTypeformCompetencyResponsesQueryResult = ApolloReactCommon.QueryResult<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>;
export const GetUserUploadedDocumentDocument = gql`
    query getUserUploadedDocument($where: JSON!, $sort: String!, $limit: Int!) {
  userUploadedDocuments(where: $where, sort: $sort, limit: $limit) {
    id
    name
    documents {
      id
      name
      document {
        id
        url
      }
    }
  }
}
    `;
export type GetUserUploadedDocumentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>, 'query'> & ({ variables: GetUserUploadedDocumentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserUploadedDocumentComponent = (props: GetUserUploadedDocumentComponentProps) => (
      <ApolloReactComponents.Query<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables> query={GetUserUploadedDocumentDocument} {...props} />
    );
    
export type GetUserUploadedDocumentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>
    } & TChildProps;
export function withGetUserUploadedDocument<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserUploadedDocumentQuery,
  GetUserUploadedDocumentQueryVariables,
  GetUserUploadedDocumentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables, GetUserUploadedDocumentProps<TChildProps, TDataName>>(GetUserUploadedDocumentDocument, {
      alias: 'getUserUploadedDocument',
      ...operationOptions
    });
};

/**
 * __useGetUserUploadedDocumentQuery__
 *
 * To run a query within a React component, call `useGetUserUploadedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUploadedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUploadedDocumentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserUploadedDocumentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>(GetUserUploadedDocumentDocument, baseOptions);
      }
export function useGetUserUploadedDocumentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>(GetUserUploadedDocumentDocument, baseOptions);
        }
export type GetUserUploadedDocumentQueryHookResult = ReturnType<typeof useGetUserUploadedDocumentQuery>;
export type GetUserUploadedDocumentLazyQueryHookResult = ReturnType<typeof useGetUserUploadedDocumentLazyQuery>;
export type GetUserUploadedDocumentQueryResult = ApolloReactCommon.QueryResult<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>;
export const GetUserProgrammeSubmissionsDocument = gql`
    query getUserProgrammeSubmissions {
  getMyProgrammeSubmissions {
    id
    status
    progress
    programme_type {
      id
      title
      isSubModule
      sub_modules {
        id
        nameEnglish
        sections {
          id
          titleEnglish
        }
      }
    }
    programme {
      id
      name
      position
      start
    }
  }
}
    `;
export type GetUserProgrammeSubmissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>, 'query'>;

    export const GetUserProgrammeSubmissionsComponent = (props: GetUserProgrammeSubmissionsComponentProps) => (
      <ApolloReactComponents.Query<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables> query={GetUserProgrammeSubmissionsDocument} {...props} />
    );
    
export type GetUserProgrammeSubmissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>
    } & TChildProps;
export function withGetUserProgrammeSubmissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserProgrammeSubmissionsQuery,
  GetUserProgrammeSubmissionsQueryVariables,
  GetUserProgrammeSubmissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables, GetUserProgrammeSubmissionsProps<TChildProps, TDataName>>(GetUserProgrammeSubmissionsDocument, {
      alias: 'getUserProgrammeSubmissions',
      ...operationOptions
    });
};

/**
 * __useGetUserProgrammeSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetUserProgrammeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProgrammeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProgrammeSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProgrammeSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>(GetUserProgrammeSubmissionsDocument, baseOptions);
      }
export function useGetUserProgrammeSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>(GetUserProgrammeSubmissionsDocument, baseOptions);
        }
export type GetUserProgrammeSubmissionsQueryHookResult = ReturnType<typeof useGetUserProgrammeSubmissionsQuery>;
export type GetUserProgrammeSubmissionsLazyQueryHookResult = ReturnType<typeof useGetUserProgrammeSubmissionsLazyQuery>;
export type GetUserProgrammeSubmissionsQueryResult = ApolloReactCommon.QueryResult<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>;
export const GetMyProgrammeSubmissionsDocument = gql`
    query getMyProgrammeSubmissions {
  getMyProgrammeSubmissions {
    id
    status
    progress
    competency_url {
      id
      url
    }
    feedfoward_url {
      id
      url
    }
    programme_type {
      id
      programmeTypeInstructions
      title
      description
      position
      cover {
        id
        url
      }
      isCoaching
      isSubModule
      notes
      showArticle
      showSession
      showParticipants
      competencySurvey
      feedForwardSurvey
      deadline
      programmeQuestions {
        __typename
        ... on ComponentQuestionTypesValuesNested {
          id
          title
          question
          description
          questions {
            id
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
          }
        }
        ... on ComponentQuestionTypesValuesCharacters {
          id
          title
          question
          description
        }
        ... on ComponentQuestionTypesValuesBubble {
          id
          title
          question
          description
        }
        ... on ComponentQuestionTypesValuesSliders {
          id
          title
          question
          description
          sliderQuestions {
            id
            question
            color
          }
        }
        ... on ComponentQuestionTypesValuesGaps {
          id
          title
          question
          description
        }
        ... on ComponentQuestionTypesSimpleQuestion {
          id
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          subTitleEnglish
          subTitleFrench
          subTitleGerman
          subTitleSpanish
          subTitleMandarin
        }
        ... on ComponentQuestionTypesXYGraph {
          id
          labelXEnglish
          labelYEnglish
          titleEnglish
          subTitleEnglish
          labelXFrench
          labelYFrench
          titleFrench
          subTitleFrench
          labelXGerman
          labelYGerman
          titleGerman
          subTitleGerman
          labelXSpanish
          labelYSpanish
          titleSpanish
          subTitleSpanish
          labelXMandarin
          labelYMandarin
          titleMandarin
          subTitleMandarin
        }
        ... on ComponentQuestionTypesMultipleChoice {
          id
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          option {
            id
            optionEnglish
            isCorrect
          }
          numberOfAnswers
        }
        ... on ComponentQuestionTypesSaboteur {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          saboteurQuestions {
            link
            skipProof
            labelEnglish
            labelFrench
            labelGerman
            labelSpanish
            labelMandarin
            proof {
              ...uploadFile
            }
          }
          labelEnglish
          labelFrench
          labelGerman
          labelSpanish
        }
        ... on ComponentQuestionTypesNestedQuestions {
          id
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          questions {
            id
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
            isNumeric
          }
        }
        ... on ComponentQuestionTypesGravitasScale {
          id
          titleEnglish
          subTitleEnglish
          questionOneEnglish
          questionTwoEnglish
          questionThreeEnglish
          titleOneEnglish
          titleTwoEnglish
          ratingInput {
            id
            labelOneEnglish
            labelTwoEnglish
          }
        }
        ... on ComponentQuestionTypesStakeholderMap {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleSpanish
          subTitleSpanish
          titleGerman
          subTitleGerman
          titleMandarin
          subTitleMandarin
          questionX
          questionY
        }
        ... on ComponentQuestionTypesSaboteurVideos {
          id
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          subTitleEnglish
          subTitleFrench
          subTitleGerman
          subTitleSpanish
          subTitleMandarin
          SaboteurVideo {
            id
            videoTitleEnglish
            videoTitleFrench
            videoTitleGerman
            videoTitleSpanish
            videoTitleMandarin
            video {
              url
              id
            }
          }
        }
        ... on ComponentQuestionTypesFeedForward1 {
          id
          title
          question
          description
        }
        ... on ComponentQuestionTypesFeedForward2 {
          id
          title
          question
          description
        }
        ... on ComponentQuestionTypesSimpleReadOnly {
          id
          titleEnglish
          titleFrench
          titleGerman
          titleMandarin
          titleSpanish
          subTitleEnglish
          subTitleFrench
          subTitleGerman
          subTitleMandarin
          subTitleSpanish
          contentEnglish
          contentFrench
          contentGerman
          contentMandarin
          contentSpanish
          photo {
            id
            url
          }
        }
        ... on ComponentQuestionTypesCompetency {
          id
          title
          question
          minNumber
          maxNumber
          miniLabel
          maxiLabel
          simpleQuestion
        }
        ... on ComponentQuestionTypesCompetency2 {
          titleEnglish
          titleFrench
          titleMandarin
          questionscompetency2 {
            title
            question
            maxiNumber
            miniNumber
            simpleQuestion
            miniLabel
            maxiLabel
            midiLabel
            textboxQuestion
          }
        }
        ... on ComponentQuestionTypesGravitasGap {
          id
          title
          question
          description
          color1
          color2
          color3
        }
        ... on ComponentQuestionTypesGravitasSliders {
          titleEnglish
          titleFrench
          titleMandarin
          titleSpanish
          titleGerman
          subTitleEnglish
          subTitleFrench
          subTitleGerman
          positiveHeadingEnglish
          positiveHeadingFrench
          positiveHeadingSpanish
          positiveHeadingMandarin
          positiveHeadingGerman
          negativeHeadingEnglish
          negativeHeadingFrench
          negativeHeadingSpanish
          negativeHeadingMandarin
          negativeHeadingGerman
          sliderQuestions {
            questionPositiveEnglish
            questionPositiveGerman
            questionPositiveMandarin
            questionPositiveSpanish
            questionPositiveFrench
            questionNegativeEnglish
            questionNegativeGerman
            questionNegativeFrench
            questionNegativeMandarin
            questionNegativeSpanish
          }
          sliderHeadings {
            headingEnglish
            headingSpanish
            headingGerman
            headingFrench
            headingMandarin
            color
            rating
          }
        }
      }
      articles {
        id
        created_at
        updated_at
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        contentEnglish
        contentFrench
        contentGerman
        contentSpanish
        contentMandarin
        image {
          url
        }
        datePublished
        readTime
        link
      }
      modal {
        id
        title
        subtitle
        message
        image {
          id
          url
          name
        }
      }
      events {
        id
        name
        link
        sessionId
      }
      sub_modules {
        id
        nameEnglish
        descriptionEnglish
        cover {
          id
          url
        }
        programme_type {
          id
        }
      }
      archive
    }
    programmeResponses {
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        isSimpleQuestion
        response
        steps
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
    }
    myNotes {
      id
      title
      description
      document {
        id
        url
      }
    }
    participants {
      id
      name
      email
      type
    }
    submissionparticipants {
      id
      name
      email
    }
    programme_report {
      id
      name
      report {
        id
        url
        name
      }
    }
    programme {
      id
      isCustomJourney
      showTimeline
      programmeTitle
      logo {
        id
        url
      }
    }
    selected
  }
}
    ${UploadFileFragmentDoc}`;
export type GetMyProgrammeSubmissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>, 'query'>;

    export const GetMyProgrammeSubmissionsComponent = (props: GetMyProgrammeSubmissionsComponentProps) => (
      <ApolloReactComponents.Query<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables> query={GetMyProgrammeSubmissionsDocument} {...props} />
    );
    
export type GetMyProgrammeSubmissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>
    } & TChildProps;
export function withGetMyProgrammeSubmissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMyProgrammeSubmissionsQuery,
  GetMyProgrammeSubmissionsQueryVariables,
  GetMyProgrammeSubmissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables, GetMyProgrammeSubmissionsProps<TChildProps, TDataName>>(GetMyProgrammeSubmissionsDocument, {
      alias: 'getMyProgrammeSubmissions',
      ...operationOptions
    });
};

/**
 * __useGetMyProgrammeSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetMyProgrammeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProgrammeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProgrammeSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProgrammeSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>(GetMyProgrammeSubmissionsDocument, baseOptions);
      }
export function useGetMyProgrammeSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>(GetMyProgrammeSubmissionsDocument, baseOptions);
        }
export type GetMyProgrammeSubmissionsQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionsQuery>;
export type GetMyProgrammeSubmissionsLazyQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionsLazyQuery>;
export type GetMyProgrammeSubmissionsQueryResult = ApolloReactCommon.QueryResult<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>;
export const GetMySubModuleSubmissionsDocument = gql`
    query getMySubModuleSubmissions {
  getMySubModuleSubmissions {
    id
    view
    progress
    status
    timeSpent
    feedfoward_url {
      id
    }
    competency_url {
      id
    }
    competency_participants {
      name
      email
    }
    participants {
      id
      name
      email
      type
    }
    submissionparticipants {
      id
      name
      email
    }
    language {
      id
      name
    }
    section {
      id
      progress
      section {
        id
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        id
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
      xYGraphChart {
        id
        url
      }
      saboteurImage {
        id
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        steps
        response
      }
      uploadDocuments {
        saboteurProofValue {
          id
        }
      }
    }
    sub_module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleFrench
        titleGerman
        titleEnglish
        titleSpanish
        titleMandarin
        subTitleFrench
        subTitleGerman
        subTitleEnglish
        subTitleSpanish
        subTitleMandarin
        cover {
          id
          url
        }
        position
        archive
      }
      position
      programme_type {
        id
        title
        description
        position
        cover {
          id
          url
        }
        isCoaching
        isSubModule
        notes
        showArticle
        showSession
        showParticipants
        competencySurvey
        feedForwardSurvey
        deadline
        articles {
          id
          created_at
          updated_at
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          contentEnglish
          contentFrench
          contentGerman
          contentSpanish
          contentMandarin
          image {
            url
          }
          datePublished
          readTime
          link
        }
        modal {
          id
          title
          subtitle
          message
          image {
            id
            url
            name
          }
        }
        events {
          id
          name
          link
        }
      }
    }
    reports {
      id
      name
      type
      report {
        id
        url
      }
      sectionOrModuleId
    }
  }
}
    `;
export type GetMySubModuleSubmissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>, 'query'>;

    export const GetMySubModuleSubmissionsComponent = (props: GetMySubModuleSubmissionsComponentProps) => (
      <ApolloReactComponents.Query<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables> query={GetMySubModuleSubmissionsDocument} {...props} />
    );
    
export type GetMySubModuleSubmissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>
    } & TChildProps;
export function withGetMySubModuleSubmissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubModuleSubmissionsQuery,
  GetMySubModuleSubmissionsQueryVariables,
  GetMySubModuleSubmissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables, GetMySubModuleSubmissionsProps<TChildProps, TDataName>>(GetMySubModuleSubmissionsDocument, {
      alias: 'getMySubModuleSubmissions',
      ...operationOptions
    });
};

/**
 * __useGetMySubModuleSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubModuleSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>(GetMySubModuleSubmissionsDocument, baseOptions);
      }
export function useGetMySubModuleSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>(GetMySubModuleSubmissionsDocument, baseOptions);
        }
export type GetMySubModuleSubmissionsQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsQuery>;
export type GetMySubModuleSubmissionsLazyQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsLazyQuery>;
export type GetMySubModuleSubmissionsQueryResult = ApolloReactCommon.QueryResult<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>;
export const GetMySubmissionsDocument = gql`
    query getMySubmissions {
  getMySubmissions {
    id
    views
    progress
    status
    timeSpent
    language {
      id
      name
    }
    module {
      id
      nameFrench
      nameGerman
      nameEnglish
      nameSpanish
      nameMandarin
      descriptionFrench
      descriptionGerman
      descriptionEnglish
      descriptionSpanish
      descriptionMandarin
      cover {
        id
        url
      }
      sections {
        id
        titleFrench
        titleGerman
        titleEnglish
        titleSpanish
        titleMandarin
        subTitleFrench
        subTitleGerman
        subTitleEnglish
        subTitleSpanish
        subTitleMandarin
        cover {
          id
          url
        }
      }
      position
    }
    reports {
      id
      name
      type
      report {
        id
        url
      }
      sectionOrModuleId
    }
  }
}
    `;
export type GetMySubmissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>, 'query'>;

    export const GetMySubmissionsComponent = (props: GetMySubmissionsComponentProps) => (
      <ApolloReactComponents.Query<GetMySubmissionsQuery, GetMySubmissionsQueryVariables> query={GetMySubmissionsDocument} {...props} />
    );
    
export type GetMySubmissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>
    } & TChildProps;
export function withGetMySubmissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMySubmissionsQuery,
  GetMySubmissionsQueryVariables,
  GetMySubmissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMySubmissionsQuery, GetMySubmissionsQueryVariables, GetMySubmissionsProps<TChildProps, TDataName>>(GetMySubmissionsDocument, {
      alias: 'getMySubmissions',
      ...operationOptions
    });
};

/**
 * __useGetMySubmissionsQuery__
 *
 * To run a query within a React component, call `useGetMySubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>(GetMySubmissionsDocument, baseOptions);
      }
export function useGetMySubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>(GetMySubmissionsDocument, baseOptions);
        }
export type GetMySubmissionsQueryHookResult = ReturnType<typeof useGetMySubmissionsQuery>;
export type GetMySubmissionsLazyQueryHookResult = ReturnType<typeof useGetMySubmissionsLazyQuery>;
export type GetMySubmissionsQueryResult = ApolloReactCommon.QueryResult<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>;
export const UserDocument = gql`
    query user($id: ID!) {
  user(id: $id) {
    id
    username
    firstName
    lastName
    email
    company {
      id
      name
      logo {
        id
        url
      }
      languageSelection {
        id
        titleEnglish
        titleFrench
        titleSpanish
        titleGerman
        titleMandarin
        bodyEnglish
        bodyFrench
        bodySpanish
        bodyGerman
        bodyMandarin
        nextButtonEnglish
        nextButtonFrench
        nextButtonSpanish
        nextButtonGerman
        nextButtonMandarin
      }
      welcomeScreen {
        id
        titleEnglish
        titleFrench
        titleSpanish
        titleGerman
        titleMandarin
        bodyEnglish
        bodyFrench
        bodySpanish
        bodyGerman
        bodyMandarin
        videoEnglish {
          id
          url
        }
        videoFrench {
          id
          url
        }
        videoSpanish {
          id
          url
        }
        videoGerman {
          id
          url
        }
        videoMandarin {
          id
          url
        }
        nextButtonEnglish
        nextButtonFrench
        nextButtonSpanish
        nextButtonGerman
        nextButtonMandarin
      }
      letsGetStartedScreen {
        id
        titleEnglish
        subTitleEnglish
        firstNameLabelEnglish
        firstNameErrorEnglish
        lastNameLabelEnglish
        lastNameErrorEnglish
        jobTitleLabelEnglish
        jobTitleErrorEnglish
        divisionLabelEnglish
        divisionErrorEnglish
        timezoneLabelEnglish
        regionLabelEnglish
        regionErrorEnglish
        image {
          id
          url
        }
        nextButtonEnglish
        titleFrench
        subTitleFrench
        firstNameLabelFrench
        firstNameErrorFrench
        lastNameLabelFrench
        lastNameErrorFrench
        jobTitleLabelFrench
        jobTitleErrorFrench
        divisionLabelFrench
        divisionErrorFrench
        timezoneLabelFrench
        regionLabelFrench
        regionErrorFrench
        nextButtonFrench
        titleGerman
        subTitleGerman
        firstNameLabelGerman
        firstNameErrorGerman
        lastNameLabelGerman
        lastNameErrorGerman
        jobTitleLabelGerman
        jobTitleErrorGerman
        divisionLabelGerman
        divisionErrorGerman
        timezoneLabelGerman
        regionLabelGerman
        regionErrorGerman
        nextButtonGerman
        titleMandarin
        subTitleMandarin
        firstNameLabelMandarin
        firstNameErrorMandarin
        lastNameLabelMandarin
        lastNameErrorMandarin
        jobTitleLabelMandarin
        jobTitleErrorMandarin
        divisionLabelMandarin
        divisionErrorMandarin
        timezoneLabelMandarin
        regionLabelMandarin
        regionErrorMandarin
        nextButtonMandarin
        titleSpanish
        subTitleSpanish
        firstNameLabelSpanish
        firstNameErrorSpanish
        lastNameLabelSpanish
        lastNameErrorSpanish
        jobTitleLabelSpanish
        jobTitleErrorSpanish
        divisionLabelSpanish
        divisionErrorSpanish
        timezoneLabelSpanish
        regionLabelSpanish
        regionErrorSpanish
        nextButtonSpanish
        leftTitleEnglish
        leftSubtitleEnglish
        leftTitleSpanish
        leftSubtitleSpanish
        leftTitleMandarin
        leftSubTitleMandarin
        leftTitleFrench
        leftSubtitleFrench
        leftSubtitleGerman
        leftTitleGerman
        havingTroubleEnglish
        havingTroubleGerman
        havingTroubleFrench
        havingTroubleMandarin
        havingTroubleSpanish
        getHelpButtonEnglish
        getHelpButtonSpanish
        getHelpButtonFrench
        getHelpButtonGerman
        getHelpButtonMandarin
      }
      whatToExpect {
        id
        titleEnglish
        bodyEnglish
        image {
          id
          url
        }
        getStartedButtonEnglish
        titleFrench
        bodyFrench
        getStartedButtonFrench
        titleGerman
        bodyGerman
        getStartedButtonGerman
        titleMandarin
        bodyMandarin
        getStartedButtonMandarin
        titleSpanish
        bodySpanish
        getStartedButtonSpanish
      }
      usersConfirmDetails
    }
    division {
      id
    }
    language {
      id
      name
    }
    jobTitle
    confirmed
    blocked
    phoneNumber
    language {
      id
      name
    }
    profilePicture {
      url
    }
    role {
      id
      name
      description
      type
    }
    bookmarks
    modulesRead
    homePromptsRead
    programmePromptsRead
    modulePromptsRead
    articlesViewed
    certificate {
      ...uploadFile
    }
    feedForwardUrl
    programmes {
      id
      name
      description
      start
      isCustomJourney
      position
      logo {
        id
        url
      }
      programme_types {
        title
        sub_modules {
          sections {
            titleEnglish
          }
        }
      }
    }
  }
}
    ${UploadFileFragmentDoc}`;
export type UserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserQuery, UserQueryVariables>, 'query'> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserComponent = (props: UserComponentProps) => (
      <ApolloReactComponents.Query<UserQuery, UserQueryVariables> query={UserDocument} {...props} />
    );
    
export type UserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserQuery, UserQueryVariables>
    } & TChildProps;
export function withUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserQuery,
  UserQueryVariables,
  UserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserQuery, UserQueryVariables, UserProps<TChildProps, TDataName>>(UserDocument, {
      alias: 'user',
      ...operationOptions
    });
};

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, baseOptions);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, baseOptions);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users($sort: String, $limit: Int, $start: Int, $where: JSON) {
  users(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    username
    firstName
    lastName
    email
    division {
      id
    }
    jobTitle
    confirmed
    blocked
    phoneNumber
    language {
      id
      name
    }
    profilePicture {
      url
    }
    role {
      id
      name
      description
      type
    }
    bookmarks
    modulesRead
    homePromptsRead
    programmePromptsRead
    modulePromptsRead
    articlesViewed
    programmes {
      id
      name
      description
      start
      isCustomJourney
      position
      logo {
        id
        url
      }
    }
  }
}
    `;
export type UsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UsersQuery, UsersQueryVariables>, 'query'>;

    export const UsersComponent = (props: UsersComponentProps) => (
      <ApolloReactComponents.Query<UsersQuery, UsersQueryVariables> query={UsersDocument} {...props} />
    );
    
export type UsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UsersQuery, UsersQueryVariables>
    } & TChildProps;
export function withUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UsersQuery,
  UsersQueryVariables,
  UsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UsersQuery, UsersQueryVariables, UsersProps<TChildProps, TDataName>>(UsersDocument, {
      alias: 'users',
      ...operationOptions
    });
};

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = ApolloReactCommon.QueryResult<UsersQuery, UsersQueryVariables>;